export const messages = {
  "it": {
    "offline.prepTask": "Rendi disponibile il viaggio offline",
    "offline.prepHint": "Facoltativo: scarica il viaggio per consultarlo senza connessione.",
    "offline.manage": "Gestisci disponibilità offline",
    "offline.notEnabled": "Download offline non attivato",
    "offline.modeTitle": "Che cosa vuoi salvare sul telefono?",
    "offline.modeData": "Dati e documenti del viaggio",
    "offline.modeDataHint": "Itinerario, prenotazioni, Info Utili, checklist, appunti, biglietti e documenti, senza album fotografico.",
    "offline.modePhotos": "Dati, documenti e foto del viaggio",
    "offline.modePhotosHint": "Tutti i dati del viaggio, più le fotografie salvate nell’album.",
    "offline.estimate": "Spazio stimato: {size}",
    "offline.estimateNote": "Stima indicativa: le dimensioni delle fotografie possono variare. Il download è facoltativo.",
    "offline.automatic": "Ogni modifica viene salvata automaticamente. Puoi continuare a usare le normali sezioni del viaggio.",
    "offline.integratedNavigation": "Non esiste una seconda versione del viaggio: le stesse sezioni rimangono disponibili anche senza Internet.",
    "offline.changeOptions": "Salva la nuova scelta",
    "offline.downloadNoConnection": "Per attivare il download iniziale serve una connessione Internet.",
    "offline.cacheIncomplete": "Dati salvati; alcuni allegati non sono ancora disponibili. Mundely ritenterà automaticamente.",
    "offline.autoSync": "Aggiornamento automatico attivo per la copia offline.",
    "offline.someFilesPending": "{count} allegati non ancora disponibili offline: saranno ritentati automaticamente quando possibile.",
    "offline.openWhenOffline": "Sei offline: apri la copia salvata del viaggio.",
    "offline.waitForSync": "Attendi la sincronizzazione del viaggio prima di scaricare una nuova copia. Quella già salvata rimane consultabile.",
    "offline.title": "Viaggio offline",
    "offline.boardingPasses": "Carte d’imbarco",
    "offline.premiumOnly": "Disponibile nel piano Completo",
    "offline.premiumDescription": "Il download e la consultazione del viaggio offline sono riservati al piano Completo.",
    "offline.description": "Scegli cosa conservare offline. Dopo il download iniziale Mundely aggiorna automaticamente la copia locale.",
    "offline.privateWarning": "I documenti scaricati rimangono su questo dispositivo. Proteggi il telefono; eliminando l’app potresti perdere le copie offline.",
    "offline.selectFiles": "Allegati da conservare offline",
    "offline.noAttachments": "Nessun allegato del viaggio disponibile. Puoi comunque scaricare tutti i dati del viaggio.",
    "offline.available": "Copia offline disponibile",
    "offline.attachments": "allegati",
    "offline.showContents": "Consulta offline",
    "offline.hideContents": "Nascondi contenuti",
    "offline.snapshotReadOnly": "Copia locale in sola lettura. Le modifiche vengono aggiornate automaticamente quando salvi.",
    "offline.mapLimit": "Sono disponibili indirizzi e coordinate dei luoghi salvati. Le mappe interattive, le tessere cartografiche e la navigazione non sono disponibili senza connessione.",
    "offline.saveAttachment": "Salva allegato sul dispositivo",
    "offline.attachmentNotDownloaded": "Allegato non incluso nella copia offline",
    "offline.progress": "Download: {done} di {total}",
    "offline.update": "Aggiorna copia offline",
    "offline.download": "Scarica viaggio offline",
    "offline.delete": "Elimina copia",
    "offline.confirmDelete": "Eliminare la copia offline di questo viaggio dal dispositivo?",
    "offline.saved": "Copia offline pronta.",
    "offline.removed": "Copia offline eliminata.",
    "offline.storageError": "Impossibile accedere alla memoria offline del dispositivo.",
    "offline.fileSaved": "Allegato salvato nei file del dispositivo.",
    "offline.fileSaveError": "Impossibile salvare l’allegato.",
    "trip.intel.reviewRecords": "Apri sezione",
    "trip.intel.less": "Riduci la risposta",
    "trip.intel.more": "Mostra tutta la risposta",
    "trip.intel.agentAnswer": "Risposta dell’agente",
    "trip.intel.assistantQuestionTitle": "Scegli cosa vuoi ottimizzare",
    "trip.intel.preparationQuestionTitle": "Scegli cosa vuoi verificare",
    "trip.intel.assistantOtherQuestion": "Oppure chiedi qualcosa di specifico",
    "trip.intel.preparationOtherQuestion": "Oppure chiedi una verifica specifica",
    "trip.intel.assistantInputPlaceholder": "Es. abbiamo già 3 notti da parenti e 2 in hotel: come organizzo meglio il resto?",
    "trip.intel.preparationInputPlaceholder": "Es. devo fare un check-in prima del prossimo volo o del prossimo alloggio?",
    "trip.intel.followupTitle": "Vuoi approfondire questa risposta?",
    "trip.intel.followupResultTitle": "Approfondimento",
    "trip.intel.followupPlaceholder": "Es. su quale tratta rischio di più di essere stretto con i tempi?",
    "trip.intel.sendFollowup": "Chiedi un approfondimento",
    "trip.intel.openSection.itinerary": "Apri Itinerario",
    "trip.intel.openSection.hotels": "Apri Alloggi",
    "trip.intel.openSection.documents": "Apri Documenti",
    "trip.intel.openSection.checklist": "Apri Checklist",
    "trip.intel.openSection.boardingPass": "Apri Voli e boarding pass",
    "trip.intel.openSection.experiences": "Apri Esperienze",
    "trip.intel.openSection.expenses": "Apri Spese",
    "trip.intel.homeAssistantEyebrow": "Suggerimenti per il viaggio",
    "trip.intel.homePrepEyebrow": "Controlli per il viaggio",
    "trip.intel.homeAssistantAfter": "Rivedi spese, ricordi e attività da chiudere dopo il viaggio.",
    "trip.intel.homeAssistantDuring": "Adatta le prossime tappe agli orari e ai cambi di programma.",
    "trip.intel.homeAssistantStays": "Hai {count} notti senza alloggio indicato: trova una soluzione coerente con l’itinerario.",
    "trip.intel.homeAssistantPlan": "Hai già {count} tappe registrate: scopri come organizzarle meglio.",
    "trip.intel.homeAssistantStart": "Costruisci un itinerario su misura, tappa dopo tappa.",
    "trip.intel.homePrepStays": "{count} notti senza sistemazione indicata: verifica prima di partire.",
    "trip.intel.homePrepOverlaps": "{count} notti con alloggi sovrapposti: controlla date e prenotazioni.",
    "trip.intel.homePrepChecklist": "{count} elementi della checklist sono ancora da completare.",
    "trip.intel.homePrepReadyReview": "Controlla documenti, check-in e dettagli pratici della destinazione.",
    "trip.intel.homePrepDetails": "Verifica orari, riferimenti delle prenotazioni e indirizzi salvati prima della partenza.",
    "trip.intel.homeAssistantRoute": "Raggruppa le visite vicine e lascia spazio per le pause e gli spostamenti.",
    "trip.intel.homeAssistantMemories": "Raccogli i luoghi preferiti e le idee da conservare per il prossimo viaggio.",
    "trip.intel.qVisit": "Cosa vale davvero la pena vedere?",
    "trip.intel.qVisitDesc": "Luoghi, quartieri o esperienze coerenti con il viaggio",
    "trip.intel.qOptimize": "Come posso migliorare l’itinerario?",
    "trip.intel.qOptimizeDesc": "Ordine delle tappe, tempi e distribuzione delle giornate",
    "trip.intel.qStays": "Come conviene gestire gli alloggi?",
    "trip.intel.qStaysDesc": "Notti, cambi struttura e soluzioni più comode",
    "trip.intel.qTransfer": "Come organizzo meglio gli spostamenti?",
    "trip.intel.qTransferDesc": "Collegamenti tra tappe, tempi e passaggi più critici",
    "trip.intel.qActivities": "Quali attività si adattano meglio al mio viaggio?",
    "trip.intel.qActivitiesDesc": "Esperienze da inserire in base a mete, ritmo e periodo",
    "trip.intel.qSavings": "Dove posso ottimizzare il budget?",
    "trip.intel.qSavingsDesc": "Risparmio su trasporti, attività, zone o scelte pratiche",
    "trip.intel.qPending": "Cosa devo ancora completare prima di partire?",
    "trip.intel.qPendingDesc": "Panoramica delle cose mancanti o da ricontrollare",
    "trip.intel.qConnections": "I collegamenti tra le tappe reggono davvero?",
    "trip.intel.qConnectionsDesc": "Orari, coincidenze e margini tra spostamenti e check-in",
    "trip.intel.qDocuments": "Documenti e requisiti: è tutto in regola?",
    "trip.intel.qDocumentsDesc": "Passaporto, visto, ingresso, assicurazione e documenti utili",
    "trip.intel.qInconsistencies": "Ci sono date o prenotazioni da ricontrollare?",
    "trip.intel.qInconsistenciesDesc": "Notti, date, sovrapposizioni e riferimenti da verificare",
    "trip.intel.qEssentials": "Ho davvero tutto il necessario per questa meta?",
    "trip.intel.qEssentialsDesc": "Prese, meteo, salute, bagaglio e necessità pratiche",
    "trip.intel.qCheckins": "Quali check-in o conferme mi mancano?",
    "trip.intel.qCheckinsDesc": "Voli, alloggi, finestre utili e passaggi online da fare",
    "trip.intel.workletAssistantLead": "Organizza meglio il tuo viaggio",
    "trip.intel.workletAssistantHint": "Chiedi un consiglio mirato, con esempi e dati del tuo itinerario.",
    "trip.intel.workletPreparationLead": "Controlla cosa manca davvero",
    "trip.intel.workletPreparationHint": "{count} elementi di checklist ancora aperti. Verifica per argomento.",
    "trip.intel.workletIssues": "{count} aspetti da chiarire nei pernottamenti",
    "trip.intel.statusNoGaps": "Nessuna lacuna tra le notti registrate: le prenotazioni restano da verificare.",
    "trip.intel.auditWhole": "Analizza tutto il viaggio",
    "trip.intel.scopeLabel": "Cosa vuoi analizzare?",
    "trip.intel.scopeWhole": "Intero viaggio",
    "trip.intel.scopeStays": "Alloggi e pernottamenti",
    "trip.intel.scopeTransport": "Spostamenti e collegamenti",
    "trip.intel.scopeDocuments": "Documenti",
    "trip.intel.scopeActivities": "Attività e checklist",
    "trip.intel.analysis": "Analisi",
    "trip.intel.nextSteps": "Prossimi passi",
    "trip.intel.criticalIssues": "Criticità",
    "trip.intel.statusAccommodation": "Alloggi",
    "trip.intel.statusTransport": "Trasporti",
    "trip.intel.statusDocuments": "Documenti",
    "trip.intel.statusActivities": "Attività",
    "trip.intel.transportSummary": "{flights} voli · {transfers} trasferimenti",
    "trip.intel.documentsDetail": "Documenti presenti, validità da verificare",
    "trip.intel.activitiesDetail": "{checklist} elementi personali di checklist ancora aperti",
    "trip.intel.invalidHotelDatesTitle": "Alloggi con date da sistemare",
    "trip.intel.overlapTitle": "Sovrapposizioni da controllare",
    "trip.intel.notBookingConfirmed": "Questo dato non conferma che gli alloggi siano prenotati.",
    "trip.intel.recordedCoverage": "Notti con sistemazione indicata",
    "trip.intel.recorded": "Indicato",
    "trip.intel.nightCount": "{count} notti",
    "trip.intel.staysByPeriod": "Notti raggruppate per alloggio",
    "trip.intel.noGapsDetected": "Nessuna notte scoperta nei dati registrati. Verifica comunque le prenotazioni e gli spostamenti.",
    "trip.intel.priorityChecks": "Da chiarire prima della partenza",
    "trip.intel.assistantTitle": "Assistente del viaggio",
    "trip.intel.preparationTitle": "Preparazione intelligente",
    "trip.intel.assistantPurpose": "L’agente analizza il viaggio e ti aiuta a decidere cosa organizzare.",
    "trip.intel.preparationPurpose": "Controlla pernottamenti, spostamenti e informazioni da completare.",
    "trip.intel.needDates": "Date del viaggio mancanti o da correggere",
    "trip.intel.openNights": "{count} notti da organizzare o chiarire",
    "trip.intel.nextAction": "Scopri cosa conviene organizzare ora",
    "trip.intel.askAssistant": "Parla con l’agente",
    "trip.intel.nightsCovered": "{done} di {total} notti con una sistemazione indicata",
    "trip.intel.reviewPreparation": "Esamina la preparazione",
    "trip.intel.assistantDescription": "L’agente usa le informazioni del viaggio per proporre il prossimo passo o fare domande mirate.",
    "trip.intel.preparationDescription": "Controlli sui dati registrati. Copertura indicata non significa prenotazione verificata.",
    "trip.intel.contextKicker": "Dal tuo viaggio",
    "trip.intel.openRelevantSection": "Apri la sezione pertinente",
    "trip.intel.suggestStep": "Suggeriscimi il prossimo passo",
    "trip.intel.clarify": "Fammi le domande che mancano",
    "trip.intel.yourQuestion": "Cosa vuoi organizzare?",
    "trip.intel.questionPlaceholder": "Es. starò da mio zio tre notti e poi in hotel: che cosa manca?",
    "trip.intel.send": "Chiedi all’agente",
    "trip.intel.working": "L’agente sta analizzando il viaggio…",
    "trip.intel.unavailable": "L’agente non è disponibile ora. I dati del viaggio restano accessibili.",
    "trip.intel.noAutoChanges": "L’agente suggerisce azioni; ogni modifica o prenotazione richiede la tua conferma.",
    "trip.intel.nightsTitle": "Copertura pernottamenti",
    "trip.intel.unknownCoverage": "Percentuale non calcolabile",
    "trip.intel.hotelRecorded": "Alloggio registrato (da verificare)",
    "trip.intel.hostDeclared": "Pernottamento da parenti/amici dichiarato",
    "trip.intel.needClarification": "Sistemazione da chiarire",
    "trip.intel.undatedHotels": "{count} alloggi senza un intervallo di date valido: non conteggiati.",
    "trip.intel.overlaps": "{count} notti con alloggi sovrapposti: verifica le prenotazioni.",
    "trip.intel.unknownNeeds": "Mancano informazioni per stabilire dove dormirai in tutte le notti. La percentuale misura solo la copertura documentata.",
    "trip.intel.openHotels": "Controlla gli alloggi",
    "trip.intel.otherChecks": "Altri elementi rilevati",
    "trip.intel.transportFound": "{flights} voli e {transfers} trasferimenti registrati",
    "trip.intel.denominatorUnknown": "totale necessario non ancora definito",
    "trip.intel.documentsFound": "{count} documenti presenti",
    "trip.intel.notVerified": "validità non verificata",
    "trip.intel.activitiesFound": "{count} attività o eventi inseriti",
    "trip.intel.analyzeAI": "Analizza con l’agente",
    "trip.intel.verificationWarning": "Le analisi non confermano la validità di documenti, visti, biglietti o prenotazioni. Controlla sempre i requisiti ufficiali.",
    "trip.setup.mode": "Come vuoi creare il viaggio?",
    "trip.setup.guided": "Creazione guidata",
    "trip.setup.quick": "Creazione rapida",
    "trip.setup.step": "Passo {current} di {total}",
    "trip.setup.next": "Continua",
    "trip.setup.back": "Indietro",
    "trip.setup.review": "Rivedi i suggerimenti prima di creare il viaggio.",
    "trip.setup.purpose": "Perché viaggi?",
    "trip.setup.purpose.leisure": "Vacanza",
    "trip.setup.purpose.family": "Visita a parenti o amici",
    "trip.setup.purpose.work": "Lavoro",
    "trip.setup.purpose.other": "Altro",
    "trip.setup.accommodation": "Dove dormirai?",
    "trip.setup.accommodation.unsure": "Non lo so ancora",
    "trip.setup.accommodation.booking": "Hotel o appartamenti da prenotare",
    "trip.setup.accommodation.friends": "Da parenti o amici",
    "trip.setup.accommodation.mixed": "Soluzioni miste",
    "trip.setup.transport": "Come ti sposterai?",
    "trip.setup.transport.unsure": "Non lo so ancora",
    "trip.setup.transport.flight": "In aereo",
    "trip.setup.transport.train": "In treno",
    "trip.setup.transport.car": "In auto",
    "trip.setup.transport.other": "Altri mezzi",
    "trip.setup.notes": "Altre esigenze (facoltative)",
    "trip.setup.notesPlaceholder": "Es. vado a trovare mio zio, non mi serve un hotel",
    "trip.setup.preview": "Sezioni suggerite",
    "trip.setup.hotelVisible": "Mostra la sezione Alloggi",
    "trip.setup.visibilityHint": "Puoi nascondere o riattivare la sezione senza cancellare alcun dato. Le sezioni essenziali restano accessibili.",
    "trip.setup.suggestedSteps": "{count} passaggi organizzativi suggeriti, modificabili in seguito.",
    "trip.setup.askAI": "Suggerisci altri passaggi con AI",
    "trip.setup.aiNoSuggestion": "Nessun ulteriore passaggio suggerito. Puoi comunque aggiungerne altri.",
    "trip.setup.aiReview": "Suggerimenti AI aggiunti alla proposta. Puoi rivederli prima di salvare.",
    "trip.setup.aiUnavailable": "AI non disponibile adesso. Puoi continuare con le risposte già date.",
    "trip.setup.edit": "Personalizza sezioni e percorso",
    "trip.setup.apply": "Applica preferenze",
    "trip.setup.detected": "Rilevato automaticamente: verifica i dettagli prima di confermare.",
    "trip.guide.expand": "Mostra azioni",
    "trip.guide.addNew": "Aggiungi un passaggio",
    "trip.guide.confirmDelete": "Eliminare questo passaggio? Non verranno cancellati i dati delle sezioni.",
    "trip.guide.statusHint": "Completato manualmente: non equivale alla verifica dei documenti o prenotazioni.",
    "trip.prep.confirmedOnly": "{done} di {total} verifiche confermate",
    "trip.prep.detectedCount": "{count} controlli rilevati: richiedono la tua conferma",
    "trip.prep.whyDetected": "Presenza rilevata, non validità verificata.",
    "trip.prep.checklistTitle": "Viaggio senza sorprese",
    "trip.prep.guideTitle": "Organizzazione guidata",
    "trip.prep.progress": "{done} di {total} verifiche completate",
    "trip.prep.openDetails": "Controlla tutte le verifiche",
    "trip.prep.allChecked": "Tutte le verifiche applicabili sono completate.",
    "trip.prep.nextStep": "Prossimo passo consigliato",
    "trip.prep.readyTitle": "Preparazione verificata",
    "trip.prep.readyBody": "Hai completato le verifiche applicabili. Ricontrolla le informazioni prima della partenza.",
    "trip.prep.review": "Rivedi preparazione",
    "trip.prep.detailIntro": "Controlla ogni voce. Le verifiche manuali restano separate dalle tue checklist personali.",
    "trip.prep.auto": "Rilevato",
    "trip.prep.confirmed": "Confermato",
    "trip.prep.notApplicable": "Non applicabile",
    "trip.prep.pending": "Da verificare",
    "trip.prep.confirm": "Conferma",
    "trip.prep.reset": "Annulla conferma",
    "trip.prep.skip": "Non applicabile",
    "trip.prep.verificationNote": "Le conferme manuali non sostituiscono la verifica di requisiti di ingresso, validità dei documenti o coperture. Controlla sempre le fonti ufficiali.",
    "trip.prep.officialSource": "Viaggiare Sicuri",
    "trip.prep.destination": "Destinazione e date",
    "trip.prep.destinationHint": "Indica destinazione e date corrette del viaggio.",
    "trip.prep.accommodation": "Alloggi e prenotazioni",
    "trip.prep.accommodationHint": "Controlla che le prenotazioni coprano i soggiorni necessari.",
    "trip.prep.transport": "Voli e trasporti",
    "trip.prep.transportHint": "Conferma che i trasporti siano prenotati e che orari e biglietti siano corretti.",
    "trip.prep.documents": "Documenti di viaggio",
    "trip.prep.documentsHint": "Controlla passaporto, eventuali visti e requisiti della destinazione. Il caricamento non verifica la validità.",
    "trip.prep.transfers": "Trasferimenti da e per aeroporto",
    "trip.prep.transfersHint": "Verifica come raggiungere l’alloggio o segnala che non è necessario.",
    "trip.prep.insurance": "Assicurazione di viaggio",
    "trip.prep.insuranceHint": "Controlla la copertura oppure indica che non è prevista.",
    "trip.prep.activities": "Attività e prenotazioni",
    "trip.prep.activitiesHint": "Verifica gli ingressi e le esperienze da prenotare oppure indica che non servono.",
    "trip.prep.reminders": "Promemoria personali",
    "trip.prep.remindersHint": "Rivedi le ultime cose da fare oppure indica che non servono.",
    "trip.prep.personalChecklists": "Le tue checklist personali",
    "trip.prep.personalChecklistsHint": "Controlla valigia e liste personali, che restano gestibili separatamente.",
    "trip.prep.openTrip": "Controlla viaggio",
    "trip.prep.openHotels": "Apri alloggi",
    "trip.prep.openItinerary": "Apri itinerario",
    "trip.prep.openDocuments": "Apri documenti",
    "trip.prep.openExperiences": "Apri esperienze",
    "trip.prep.openNotes": "Apri promemoria",
    "trip.prep.openChecklists": "Apri le mie checklist",
    "trip.prep.remaining": "{count} verifiche ancora da completare",
    "trip.prep.groupEssential": "Essenziale",
    "trip.prep.groupImportant": "Importante",
    "trip.prep.groupBefore": "Prima della partenza",
    "trip.prep.groupPending": "{count} da verificare",
    "trip.prep.groupCompleted": "Tutto verificato",
    "trip.prep.reasonConfirmed": "Confermato da te",
    "trip.prep.reasonNotApplicable": "Segnato come non applicabile",
    "trip.prep.reasonPersonalDone": "Tutte le attività delle tue checklist sono completate",
    "trip.prep.reasonDetected": "Informazioni principali presenti nel viaggio",
    "trip.prep.reasonPersonalPending": "{count} attività personali ancora da completare",
    "trip.prep.reasonPersonalEmpty": "Nessuna attività personale creata: puoi aggiungerne una",
    "trip.prep.reasonStays": "{count} alloggi registrati: controlla date e prenotazioni",
    "trip.prep.reasonDocuments": "{count} documenti presenti: validità da verificare",
    "trip.prep.reasonEntries": "{count} elementi presenti: controlla i dettagli",
    "trip.prep.urgencySoon": "Partenza vicina: controllo consigliato",
    "trip.prep.urgencyImminent": "Partenza imminente: verifica prioritaria",
    "trip.prep.urgencyInProgress": "Durante il viaggio: prossimo controllo",
    "trip.guide.remaining": "{count} attività ancora da organizzare",
    "trip.guide.freeOrder": "Scegli tu l’ordine",
    "trip.guide.openGuide": "Apri organizzazione guidata",
    "trip.guide.openSection": "Apri sezione",
    "trip.guide.allPlannedDone": "Nessuna attività in sospeso. Puoi aggiungerne altre quando vuoi.",
    "trip.guide.intro": "Organizza il viaggio nell’ordine che preferisci: aggiungi più hotel, voli o treni, rimanda o sposta qualsiasi attività.",
    "trip.guide.todo": "Da fare",
    "trip.guide.done": "Completate",
    "trip.guide.deferred": "Rimandate",
    "trip.guide.moveUp": "Sposta su",
    "trip.guide.moveDown": "Sposta giù",
    "trip.guide.stepName": "Nome attività",
    "trip.guide.markDone": "Fatto",
    "trip.guide.defer": "Rimanda",
    "trip.guide.resume": "Riprendi",
    "trip.guide.rename": "Rinomina",
    "trip.guide.addStep": "Aggiungi attività",
    "trip.guide.type": "Tipo di attività",
    "trip.guide.date": "Data (facoltativa)",
    "trip.guide.repeatHint": "Puoi aggiungere più volte lo stesso tipo di attività, anche per giorni diversi.",
    "trip.guide.empty": "Nessuna attività: aggiungine una qui sotto.",
    "trip.guide.kindAccommodation": "Alloggio",
    "trip.guide.kindFlight": "Volo",
    "trip.guide.kindTrain": "Treno",
    "trip.guide.kindTransfer": "Trasferimento",
    "trip.guide.kindDocuments": "Documenti",
    "trip.guide.kindActivity": "Attività o biglietto",
    "trip.guide.kindInsurance": "Assicurazione",
    "trip.guide.kindOther": "Altra attività",
    "album.customFileName": "Nome file (senza estensione)",
    "album.fileNames": "Nomi delle immagini",
    "profile.introduction": "Presentazione",
    "profile.introductionEmpty": "Nessuna presentazione inserita.",
    "profile.introductionPlaceholder": "Racconta qualcosa di te, del tuo modo di viaggiare e dei tuoi interessi.",
    "profile.introductionHint": "Massimo 1.200 caratteri.",
    "profile.personalPhotos": "Foto personali",
    "profile.personalPhotosBody": "Puoi aggiungere fino a 10 foto personali al tuo profilo.",
    "profile.personalPhotosLimit": "Puoi inserire al massimo 10 foto personali.",
    "profile.personalPhotosSaved": "Foto personali aggiornate.",
    "profile.personalPhotoAlt": "Foto personale {number}",
    "profile.addPersonalPhotos": "Aggiungi foto",
    "itinerary.startDateTime": "Data e orario di inizio",
    "itinerary.endDateTime": "Data e orario di fine",
    "participants.changeRole": "Cambia ruolo",
    "participants.roleUpdated": "Ruolo aggiornato.",
    "participants.roleUpdateError": "Non è stato possibile aggiornare il ruolo.",
    "documents.otherParticipantsTitle": "Documenti degli altri partecipanti",
    "documents.otherParticipantsBody": "Documenti personali condivisi dai partecipanti di questo viaggio.",
    "profile.sections": "Sezioni del profilo",
    "profile.documentsSection": "Documenti",
    "notifications.openTrip": "Entra nel viaggio",
    "notifications.previewModeTitle": "Anteprima del viaggio",
    "notifications.previewModeBody": "Puoi consultare tutte le sezioni. Accetta l’invito per iniziare a modificarle.",
    "common.next": "Avanti",
    "common.back": "Indietro",
    "common.skip": "Salta",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.close": "Chiudi",
    "common.retry": "Riprova",
    "common.other": "Altro",
    "common.loading": "Caricamento…",
    "common.optional": "Facoltativo",
    "common.required": "Obbligatorio",
    "common.continue": "Continua",
    "common.done": "Fatto",
    "common.edit": "Modifica",
    "common.delete": "Elimina",
    "common.open": "Apri",
    "notifications.contentUnavailable": "Contenuto non disponibile.",
    "notifications.video": "Video",
    "notifications.openVideo": "Apri video",
    "common.timePlaceholder": "HH:MM",
    "common.restore": "Ripristina",
    "welcome.language": "Lingua",
    "welcome.chooseLanguage": "Scegli la lingua",
    "welcome.slide1.title": "Il tuo viaggio, tutto in un posto",
    "welcome.slide1.body": "Organizza itinerari, tappe, prenotazioni, documenti e ricordi con una struttura semplice e sincronizzata.",
    "welcome.slide2.title": "Mundely viaggia con te",
    "welcome.slide2.body": "Consulta i tuoi viaggi anche offline e ritrova le modifiche su Web, Android e iOS quando torni online.",
    "welcome.slide3.title": "Un assistente AI per ogni viaggio",
    "welcome.slide3.body": "Pianifica, riassumi e migliora il viaggio con l’AI, mantenendo il controllo sui tuoi dati.",
    "welcome.start": "Inizia con Mundely",
    "auth.signIn": "Accedi",
    "auth.register": "Registrati",
    "auth.firstName": "Nome",
    "auth.lastName": "Cognome",
    "auth.username": "Username",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Conferma password",
    "auth.usernamePlaceholder": "es. MarioRossi",
    "auth.emailPlaceholder": "mario.rossi@email.com",
    "auth.forgotPassword": "Password dimenticata?",
    "auth.resetPassword": "Recupera password",
    "auth.resetInfo": "Ti invieremo un link sicuro per reimpostarla.",
    "auth.sendReset": "Invia email di recupero",
    "auth.or": "oppure",
    "auth.google": "Accedi con Google",
    "auth.apple": "Accedi con Apple",
    "auth.createAccount": "Crea account",
    "auth.loginIdentifier": "Username o email",
    "auth.loginIdentifierPlaceholder": "es. MarioRossi o mario.rossi@email.com",
    "auth.completeProfile": "Completa il profilo",
    "auth.completeProfileBody": "Per usare Mundely scegli nome, cognome e uno username univoco.",
    "auth.logout": "Esci",
    "auth.resetSent": "Email di recupero inviata. Controlla la casella di posta.",
    "auth.loginError": "Credenziali non corrette.",
    "auth.usernameTaken": "Questo username è già utilizzato.",
    "auth.usernameTooShort": "Lo username è troppo corto: inserisci almeno 3 caratteri.",
    "auth.usernameInvalidCharacters": "Lo username può contenere solo lettere (A-Z), numeri, punti e trattini bassi. Non sono ammessi @, spazi o altri simboli.",
    "auth.emailTaken": "Questa email è già associata a un account.",
    "auth.invalidEmail": "Inserisci un indirizzo email valido.",
    "auth.passwordMin": "La password deve contenere almeno 8 caratteri.",
    "auth.passwordMismatch": "Le password non coincidono.",
    "auth.fieldRequired": "Compila tutti i campi obbligatori.",
    "auth.accountCreated": "Account creato.",
    "setup.title": "Configurazione guidata",
    "setup.subtitle": "Imposta Mundely una sola volta. Le preferenze dell’account verranno sincronizzate sui tuoi dispositivi.",
    "setup.basicTitle": "Configurazione base",
    "setup.basicBody": "Scegli lingua, valuta e preferenze essenziali per iniziare subito a usare Mundely.",
    "setup.advancedTitle": "Configurazione avanzata",
    "setup.advancedBody": "Dopo la base puoi completare notifiche, sicurezza, foto profilo e collegamento a fAInance Test.",
    "setup.advancedHint": "Per ora questa configurazione avanzata copre gli elementi principali. La perfezioneremo nelle prossime implementazioni.",
    "setup.language": "Lingua",
    "setup.currency": "Valuta principale",
    "setup.measurement": "Unità di misura",
    "setup.metric": "Sistema metrico",
    "setup.imperial": "Sistema imperiale",
    "setup.dateFormat": "Formato data",
    "setup.weekStartsOn": "Inizio della settimana", "setup.weekMonday": "Lunedì", "setup.weekSunday": "Domenica",
    "setup.notifications": "Preferenze notifiche",
    "setup.notificationsBody": "Puoi modificarle in qualsiasi momento.",
    "setup.operational": "Operative del viaggio",
    "setup.reminders": "Promemoria",
    "setup.ai": "AI",
    "setup.collaboration": "Condivisione e collaborazione",
    "setup.marketing": "Marketing e promozioni",
    "setup.security": "Biometria e PIN",
    "setup.securityBody": "Scegli biometria oppure un PIN locale di 4 cifre. Potrai cambiare metodo in Sicurezza.",
    "setup.biometric": "Attiva biometria",
    "setup.pin": "Imposta PIN",
    "setup.pinPlaceholder": "PIN di 4 cifre",
    "setup.photo": "Foto profilo",
    "setup.fainanceTitle": "Collega fAInance",
    "setup.fainanceBody": "Se hai già un account fAInance puoi collegarlo a Mundely. L'approvazione avverrà dal tuo account fAInance.",
    "setup.fainanceLater": "Puoi saltare questo passaggio e collegare l'account in qualsiasi momento da Impostazioni.",
    "currency.searchLabel": "Cerca valuta",
    "currency.searchBody": "Puoi cercare per codice o per nome della valuta.",
    "currency.searchPlaceholder": "Es. EUR, euro, dollaro",
    "currency.noResults": "Nessuna valuta trovata.",
    "fainanceLink.title": "Collega fAInance",
    "fainanceLink.menuBody": "Collega il tuo account fAInance e sincronizza automaticamente i viaggi con Share.",
    "fainanceLink.body": "Il collegamento permette a Mundely di creare e aggiornare automaticamente un progetto Share per ogni viaggio.",
    "fainanceLink.profileBody": "Collega dal tuo profilo l’account fAInance che vuoi usare con Mundely.",
    "fainanceLink.testEnvironment": "Ambiente: fAInance Test",
    "fainanceLink.testBridgeUnavailable": "Il collegamento con fAInance Test non è disponibile in questo momento. Nessuna richiesta è stata inviata alla Produzione.",
    "fainanceLink.identifierInfoTitle": "Come identificare l’account",
    "fainanceLink.approvalTitle": "Come funziona il collegamento",
    "fainanceLink.pendingTitle": "Richiesta in attesa",
    "fainanceLink.queueTitle": "Stato del bridge",
    "fainanceLink.requestQueued": "Richiesta salvata e messa in coda.",
    "fainanceLink.cloudQueueBody": "La richiesta è stata salvata nel cloud Mundely ed è pronta per essere elaborata dal bridge fAInance.",
    "fainanceLink.localQueueBody": "La richiesta è stata salvata sul dispositivo. Verrà inviata al bridge appena il collegamento cloud sarà disponibile.",
    "fainanceLink.status.connected": "Collegato",
    "fainanceLink.status.pending": "In attesa",
    "fainanceLink.status.rejected": "Rifiutato",
    "fainanceLink.status.notLinked": "Non collegato",
    "fainanceLink.connectedAs": "Account fAInance collegato",
    "fainanceLink.connectedBody": "I nuovi viaggi vengono messi automaticamente in coda per la sincronizzazione con Share. Anche i viaggi già creati vengono riallineati quando apri questa pagina.",
    "fainanceLink.emailLabel": "Email dell'account fAInance",
    "fainanceLink.emailPlaceholder": "nome@email.it",
    "fainanceLink.identifierLabel": "Email o username fAInance",
    "fainanceLink.identifierPlaceholder": "nome@email.it oppure username",
    "fainanceLink.identifierHint": "Puoi usare indifferentemente l’email o lo username del tuo account fAInance.",
    "fainanceLink.invalidIdentifier": "Inserisci un’email valida oppure uno username fAInance valido.",
    "fainanceLink.approvalBody": "Mundely registra la richiesta di collegamento. La connessione diventa attiva solo dopo l'approvazione nell'account fAInance corrispondente.",
    "fainanceLink.connect": "Richiedi collegamento",
    "fainanceLink.requestSent": "Richiesta di collegamento registrata.",
    "fainanceLink.requestCancelled": "Richiesta annullata.",
    "fainanceLink.pendingBody": "Richiesta inviata per {identifier}. In attesa dell'approvazione da fAInance.",
    "fainanceLink.cancelRequest": "Annulla richiesta",
    "fainanceLink.disconnect": "Scollega account",
    "fainanceLink.disconnected": "Account fAInance scollegato.",
    "fainanceLink.syncTrips": "Sincronizza viaggi",
    "fainanceLink.syncQueued": "Sincronizzazione preparata per {count} viaggi.",
    "fainanceLink.error": "Non è stato possibile completare l'operazione con fAInance.",
    "analytics.title": "Analytics e utilizzo",
    "analytics.body": "Controlla l’invio di dati anonimi sull’utilizzo di Mundely.",
    "analytics.usageTitle": "Condividi dati di utilizzo anonimi",
    "analytics.usageBody": "Aiuta a capire quali sezioni vengono usate e dove migliorare l’app. Non vengono inviati contenuti personali, documenti o testi delle conversazioni.",
    "analytics.note": "Il tracciamento usa Firebase Analytics su Android, iOS e Web. Puoi disattivarlo in qualsiasi momento.",
    "setup.photoBody": "Puoi aggiungerla ora oppure più avanti.",
    "setup.photoHint": "Trascina la foto per centrarla e usa lo zoom per scegliere il ritaglio.",
    "setup.photoZoom": "Zoom",
    "setup.photoReset": "Reimposta",
    "setup.photoChoose": "Scegli o cambia foto",
    "setup.finish": "Completa configurazione",
    "setup.completed": "Configurazione completata",
    "nav.home": "Home",
    "nav.trips": "Viaggi",
    "nav.world": "Il mio mondo",
    "nav.map": "Mappa",
    "nav.ai": "AGENTE",
    "nav.profile": "Profilo",
    "nav.settings": "Impostazioni",
    "nav.menu": "Menu",
    "menu.subtitle": "Viaggi, preferenze e impostazioni dell'app.",
    "settings.title": "Impostazioni",
    "settings.subtitle": "Personalizza Mundely e gestisci account, sicurezza, supporto e dati.",
    "settings.profile": "Profilo",
    "gamification.title": "Punti e classifiche",
    "gamification.menuBody": "Guadagna punti viaggiando, contribuendo alla community e completando il tuo profilo di viaggiatore.",
    "gamification.body": "Il punteggio riunisce esperienza di viaggio, attività nell'app e qualità dei contributi alla community.",
    "gamification.score": "Punti",
    "gamification.rank": "Posizione",
    "gamification.nextLevel": "{points} punti al livello {level}",
    "gamification.maxLevel": "Hai raggiunto il livello massimo attuale",
    "gamification.communityQuality": "Qualità dei contributi",
    "gamification.communityQualityBody": "La reputazione considera anche quanto le tue recensioni risultano utili agli altri viaggiatori.",
    "gamification.helpfulReceived": "Voti utili ricevuti",
    "gamification.helpfulRatio": "Quota voti utili",
    "gamification.publicTitle": "Reputazione Mundely",
    "gamification.breakdown": "Da dove arrivano i punti",
    "gamification.breakdownBody": "Ogni attività valida contribuisce automaticamente al punteggio.",
    "gamification.countries": "Nazioni visitate",
    "gamification.quizAnswers": "Risposte al quiz",
    "gamification.feedbacks": "Feedback di viaggio",
    "gamification.completedTrips": "Viaggi completati",
    "gamification.reviews": "Recensioni pubbliche",
    "gamification.helpfulVotes": "Voti utili ricevuti",
    "gamification.notHelpfulVotes": "Voti non utili ricevuti",
    "gamification.voteBalance": "Impatto voti community",
    "gamification.badges": "Badge",
    "gamification.badgesBody": "I badge riconoscono esperienza, contributo e specializzazione geografica.",
    "gamification.earned": "Ottenuto",
    "gamification.badge.explorer": "Esploratore",
    "gamification.badge.explorerBody": "Visita almeno 10 nazioni.",
    "gamification.badge.topContributor": "Top Contributor",
    "gamification.badge.topContributorBody": "Ricevi almeno 10 voti utili sulle tue recensioni.",
    "gamification.badge.asiaExpert": "Esperto d'Asia",
    "gamification.badge.asiaExpertBody": "Visita almeno 10 nazioni asiatiche.",
    "gamification.badge.quizMaster": "Maestro del quiz",
    "gamification.badge.quizMasterBody": "Completa tutte le 16 preferenze del profilo viaggiatore.",
    "gamification.badge.reviewer": "Recensore",
    "gamification.badge.reviewerBody": "Pubblica almeno 10 recensioni utili alla community.",
    "gamification.badge.veteran": "Viaggiatore esperto",
    "gamification.badge.veteranBody": "Completa almeno 10 viaggi in Mundely.",
    "gamification.history": "Storico punti",
    "gamification.historyBody": "Le variazioni più recenti del tuo punteggio Mundely.",
    "gamification.historyInitial": "Punteggio iniziale",
    "gamification.historyProgress": "Aggiornamento attività",
    "gamification.historyEmpty": "Lo storico comparirà quando il punteggio cambierà.",
    "gamification.level.starter": "Viaggiatore",
    "gamification.level.explorer": "Esploratore",
    "gamification.level.expert": "Viaggiatore esperto",
    "gamification.level.globetrotter": "Globetrotter",
    "gamification.rules": "Regole punti",
    "gamification.rulesBody": "Il punteggio viene ricalcolato sui dati reali del profilo e della community.",
    "gamification.rule.country": "Ogni nazione visitata",
    "gamification.rule.quiz": "Ogni risposta al quiz",
    "gamification.rule.feedback": "Ogni feedback di viaggio",
    "gamification.rule.completedTrip": "Ogni viaggio completato",
    "gamification.rule.review": "Ogni recensione pubblica",
    "gamification.rule.helpful": "Ogni voto Utile ricevuto",
    "gamification.rule.notHelpful": "Ogni voto Non utile ricevuto",
    "gamification.leaderboard": "Classifica viaggiatori",
    "gamification.leaderboardBody": "La classifica usa il punteggio Mundely aggiornato degli utenti che hanno già aperto questa versione dell'app.",
    "gamification.noLeaderboard": "La classifica non è ancora disponibile.",
    "quiz.profileTitle": "Il tuo profilo di viaggio",
    "quiz.communityBody": "Le risposte sono salvate nel tuo profilo. Le scelte espresse contribuiscono anche alle preferenze aggregate dei viaggiatori che Mundely può usare per migliorare i suggerimenti.",
    "quiz.communityCompare": "Come hanno risposto altri viaggiatori · {count} risposte",
    "quiz.communityShort": "Community: {minus}% / {plus}%",
    "quiz.popular": 'Luoghi iconici',
    "quiz.remote": 'Luoghi remoti',
    "quiz.comfort": 'Comfort e servizi',
    "quiz.authentic": 'Vita locale',
    "quiz.food": 'Cibo e sapori',
    "quiz.historyMuseums": 'Storia e musei',
    "quiz.early": 'Partire presto',
    "quiz.late": 'Vivere la notte',
    "quiz.solo": 'Spazi per me',
    "quiz.social": 'Conoscere persone',
    "quiz.fixed": 'Programma definito',
    "quiz.flexible": 'Decidere sul momento',
    "quiz.direct": 'Una base principale',
    "quiz.multiStop": 'Molte tappe',
    "quiz.classic": 'Grandi classici',
    "quiz.unusual": 'Posti insoliti',
    "tools.title": "Tool",
    "tools.menuBody": "Calcolatrice e convertitore di valuta in un’unica sezione.",
    "calculator.title": "Calcolatrice",
    "calculator.menuBody": "Esegui calcoli rapidi durante il viaggio.",
    "calculator.body": "Calcolatrice completa, con le stesse funzioni essenziali disponibili nei Tool di fAInance.",
    "currency.title": 'Convertitore di valuta',
    "currency.menuBody": 'Converti valute con un tasso online aggiornato.',
    "currency.body": 'Calcola rapidamente quanto vale un importo nella valuta che ti serve durante il viaggio.',
    "currency.amount": 'Importo',
    "currency.from": 'Da',
    "currency.to": 'A',
    "currency.swap": 'Inverti valute',
    "currency.error": 'Non è stato possibile recuperare il tasso di cambio. Controlla la connessione e riprova.',
    "currency.result": 'Risultato',
    "currency.waiting": 'Tasso non disponibile',
    "currency.updated": 'Tasso di riferimento del {date}',
    "currency.refresh": 'Aggiorna tasso',
    "currency.source": 'Fonte tassi: Frankfurter, basata sui tassi di riferimento pubblicati dalla BCE e da altre banche centrali.',
    "currency.rate": 'Tasso',
    "currency.automatic": 'conversione automatica',
    "nextTrip.title": 'Prossimo viaggio',
    "nextTrip.menuBody": 'Idee e consigli dell’agente per scegliere la tua prossima destinazione.',
    "nextTrip.body": 'Combina quando vuoi partire, budget e preferenze personali per ricevere proposte più pertinenti.',
    "nextTrip.heroTitle": 'Trova la tua prossima meta',
    "nextTrip.heroBody": 'Parlane con il tuo Agente.',
    "nextTrip.personalizationTitle": "Personalizzazione Mundely",
    "nextTrip.personalizationBody": "I consigli combinano le tue preferenze, i luoghi già visitati e i segnali della community.",
    "nextTrip.personalizationQuiz": "Scelte: {count}",
    "nextTrip.personalizationVisited": "Paesi visitati: {count}",
    "nextTrip.personalizationReviews": "Recensioni considerate: {count}",
    "nextTrip.whyTitle": "Perché te la consiglio",
    "nextTrip.whyQuiz": "alta affinità con le tue preferenze",
    "nextTrip.whyStyle": "coerente con {style}",
    "nextTrip.whyBudget": "compatibile con il budget indicato",
    "nextTrip.whyNewPlace": "evita le mete che hai già visitato",
    "nextTrip.whyCommunity": "supportata anche da segnali della community",
    "nextTrip.whyProfile": "coerente con il profilo che Mundely conosce di te",
    "nextTrip.whyTravelerProfile": "coerente con la tua preferenza {style}",
    "travelerProfile.title": "Profilo viaggiatore",
    "travelerProfile.body": "Mundely combina quiz, viaggi, spese, recensioni e abitudini per capire meglio come ti piace viaggiare. Puoi correggere quello che non ti rappresenta.",
    "travelerProfile.inferred": "Il tuo stile di viaggio",
    "travelerProfile.inferredBody": "Le preferenze che emergono dalle tue risposte e recensioni. Tocca una scheda per personalizzarla.",
    "travelerProfile.correctTitle": "Personalizza le preferenze",
    "travelerProfile.correctBody": "Scegli ciò che ti piace e ciò che preferisci evitare. Tocca di nuovo una scelta per annullarla.",
    "travelerProfile.note": "Indicazioni per Mundely",
    "travelerProfile.notePlaceholder": "Es. preferisco piccoli hotel, niente voli con più scali, adoro la cucina locale…",
    "travelerProfile.saved": "Profilo aggiornato",
    "travelerProfile.notEnoughData": "Servono ancora alcune informazioni per individuare uno stile.",
    "travelerProfile.countries": "Nazioni",
    "travelerProfile.completedTrips": "Viaggi terminati",
    "travelerProfile.reviews": "Recensioni",
    "travelerProfile.groupSize": "Gruppo abituale",
    "travelerProfile.publicTitle": "Stile di viaggio",
    "travelerStyle.relax": "Relax",
    "travelerStyle.culture": "Cultura",
    "travelerStyle.sea": "Mare",
    "travelerStyle.adventure": "Avventura",
    "travelerStyle.city": "Città",
    "travelerStyle.nature": "Natura",
    "travelerStyle.budget": "Budget",
    "travelerStyle.comfort": "Comfort",
    "travelerStyle.food": "Cucina locale",
    "travelerStyle.social": "Sociale",
    "travelerStyle.remote": "Fuori rotta",
    "travelerStyle.flexible": "Flessibile",
    "nextTrip.whenTitle": 'Quando vuoi partire?',
    "nextTrip.styleTitle": 'Che viaggio cerchi?',
    "nextTrip.style.relax": 'Relax',
    "nextTrip.style.culture": 'Cultura',
    "nextTrip.style.sea": 'Mare',
    "nextTrip.style.adventure": 'Avventura',
    "nextTrip.style.surprise": 'Sorprendimi',
    "nextTrip.askAgent": 'Chiedi consiglio all’Agente',
    "nextTrip.applyPreferences": 'Aggiorna i consigli',
    "nextTrip.editPreferences": 'Modifica',
    "nextTrip.chatTitle": 'Parla con il tuo Agente',
    "nextTrip.chatBody": 'Perfeziona il consiglio senza ricominciare da zero.',
    "nextTrip.newSearch": 'Nuova ricerca',
    "nextTrip.composerPlaceholder": 'Scrivi un messaggio…',
    "nextTrip.sendMessage": 'Invia messaggio',
    "nextTrip.quick.cheaper": 'Più economiche',
    "nextTrip.quick.warmer": 'Più caldo',
    "nextTrip.quick.compare": 'Confronta le proposte',
    "nextTrip.quick.more": 'Altre proposte',
    "nextTrip.quick.whatToSee": 'Cosa vedere',
    "nextTrip.quick.costs": 'Costi e budget',
    "nextTrip.quick.bestTime": 'Quando andare',
    "nextTrip.quick.similar": 'Alternative simili',
    "nextTrip.live.title": 'Prezzi voli e hotel',
    "nextTrip.live.subtitle": 'Verifica prezzi reali per {destination}.',
    "nextTrip.live.origin": 'Città di partenza',
    "nextTrip.live.originPlaceholder": 'es. Napoli',
    "nextTrip.live.departure": 'Andata',
    "nextTrip.live.return": 'Ritorno',
    "nextTrip.live.travelers": 'Viaggiatori',
    "nextTrip.live.search": 'Cerca prezzi live',
    "nextTrip.live.destinationUnavailable": 'Scegli prima una città o un’isola precisa per cercare voli reali.',
    "nextTrip.live.notConfigured": 'La ricerca prezzi live è pronta nell’app, ma il backend non è ancora configurato con le credenziali dei provider.',
    "nextTrip.live.error": 'Non è stato possibile recuperare i prezzi live. Riprova tra poco.',
    "nextTrip.live.noResults": 'Nessuna offerta disponibile con questi criteri. Prova altre date o una destinazione diversa.',
    "nextTrip.live.partial": 'Alcuni fornitori non sono disponibili. Ti mostro solo le offerte effettivamente recuperate.',
    "nextTrip.live.openOption": 'Apri prenotazione',
    "nextTrip.live.flight": 'Volo A/R',
    "nextTrip.live.hotel": 'Hotel',
    "nextTrip.live.total": 'Volo + hotel',
    "nextTrip.live.bestAvailable": 'Migliore opzione disponibile',
    "nextTrip.live.flightHotelOnly": 'Sono considerate solo le voci live disponibili.',
    "nextTrip.live.remaining": 'Restano {amount} del budget.',
    "nextTrip.live.over": 'Supera il budget di {amount}.',
    "nextTrip.live.checkedAt": 'Ultima verifica: {value}',
    "nextTrip.live.refresh": 'Aggiorna prezzi',
    "nextTrip.live.cheaperDates": 'Cambia date',
    "nextTrip.live.openHotel": 'Apri hotel',
    "nextTrip.live.flightOptions": 'Opzioni di volo reali',
    "nextTrip.live.hotelOptions": 'Hotel disponibili',
    "nextTrip.live.select": 'Seleziona',
    "nextTrip.live.selected": 'Selezionato',
    "nextTrip.live.direct": 'Diretto',
    "nextTrip.live.stops": '{count} scali',
    "nextTrip.live.rating": 'Valutazione {value}',
    "nextTrip.live.selectFlightMessage": 'Scelgo questo volo',
    "nextTrip.live.flightSelected": 'Volo selezionato per questa pianificazione',
    "nextTrip.live.flightSelectedNext": 'Ora posso continuare con hotel, itinerario e spostamenti senza perdere questa scelta.',
    "nextTrip.live.selectHotelMessage": 'Scelgo questo hotel',
    "nextTrip.live.hotelSelected": 'Hotel selezionato per questa pianificazione',
    "nextTrip.live.hotelSelectedNext": 'Mantengo questa struttura come riferimento mentre continuiamo a costruire il viaggio.',
    "nextTrip.actions.title": 'Azioni sul viaggio',
    "nextTrip.actions.readyToCreate": 'Pronto per diventare un viaggio',
    "nextTrip.actions.readyToCreateBody": 'Quando confermi, creo il viaggio e posso iniziare ad aggiungere elementi reali.',
    "nextTrip.actions.planActive": 'Viaggio creato e collegato alla conversazione',
    "nextTrip.actions.planActiveBody": 'Ora puoi aggiungere luoghi, voli e hotel direttamente alle sezioni del viaggio.',
    "nextTrip.actions.createTrip": 'Crea viaggio',
    "nextTrip.actions.openTrip": 'Apri viaggio',
    "nextTrip.actions.addItem": 'Aggiungi all’itinerario',
    "nextTrip.actions.addFlight": 'Aggiungi volo',
    "nextTrip.actions.addHotel": 'Aggiungi hotel',
    "nextTrip.actions.needDestination": 'Prima scegli una città o un’isola precisa: non creo un viaggio generico su un intero Paese.',
    "nextTrip.actions.needDates": 'Per creare il viaggio mi servono le date esatte di andata e ritorno. Scrivile nella conversazione e userò quelle.',
    "nextTrip.actions.tripName": '{destination} {year}',
    "nextTrip.actions.tripCreated": 'Viaggio creato per **{destination}**, dal **{start}** al **{end}**. Da questo momento posso inserire direttamente tappe, voli e hotel.',
    "nextTrip.actions.itemAdded": '**{item}** è stato aggiunto all’itinerario del viaggio.',
    "nextTrip.actions.itemAlreadyAdded": '**{item}** è già presente nell’itinerario.',
    "nextTrip.actions.addedFromNextTrip": 'Aggiunto da Prossimo viaggio.',
    "nextTrip.actions.flightTitle": 'Volo {origin} → {destination}',
    "nextTrip.actions.flightAdded": 'Il volo selezionato è stato aggiunto all’itinerario del viaggio.',
    "nextTrip.actions.hotelAdded": '**{hotel}** è stato aggiunto alla sezione Hotel del viaggio.',
    "nextTrip.quick.city": 'Panoramica',
    "nextTrip.quick.foods": 'Piatti tipici',
    "nextTrip.quick.places": 'Luoghi da vedere',
    "nextTrip.quick.culture": 'Cultura locale',
    "nextTrip.continueWith": 'Continua con {destination}',
    "nextTrip.ideasForYou": 'Idee per te',
    "nextTrip.ideasForYouBody": 'Destinazioni compatibili con il tuo profilo di viaggio.',
    "nextTrip.compatibility": 'Compatibilità con il tuo profilo',
    "nextTrip.compatibilityShort": 'compatibile',
    "nextTrip.saveIdea": 'Salva idea',
    "nextTrip.removeIdea": 'Rimuovi idea salvata',
    "nextTrip.suggestionIntro": 'Ecco 3 proposte in linea con il tuo profilo. Tocca una meta o continua la conversazione.',
    "nextTrip.followUpIntro": 'Ho aggiornato le proposte in base al tuo ultimo messaggio.',
    "nextTrip.cardFrom": 'da {price}',
    "nextTrip.cardMatch": 'Compatibilità {value}%',
    "community.updateReview": 'Aggiorna recensione',
    "nextTrip.savedIdeas": 'Le tue idee salvate',
    "nextTrip.savedIdeasBody": 'Tienile da parte mentre decidi il prossimo viaggio.',
    "nextTrip.matchesTitle": 'Destinazioni compatibili con il tuo profilo',
    "nextTrip.matchesBody": 'Tocca una proposta per inserirla subito come destinazione da valutare.',
    "nextTrip.time.soon": 'Parto tra poco',
    "nextTrip.time.threeMonths": 'Nei prossimi 3 mesi',
    "nextTrip.time.sixMonths": 'Tra 6 mesi',
    "nextTrip.time.nextYear": 'Il prossimo anno',
    "nextTrip.budget": 'Budget indicativo',
    "nextTrip.destination": 'Destinazione da valutare',
    "nextTrip.destinationPlaceholder": 'Es. Giappone, Madeira, New York…',
    "nextTrip.destinationRequired": 'Inserisci una destinazione prima di chiedere cosa sapere prima di prenotare.',
    "nextTrip.agentAdvice": 'Consigli dell’agente',
    "nextTrip.agentAdviceBody": 'Destinazioni costruite sulle tue preferenze e sul periodo scelto.',
    "nextTrip.experts": 'Idee da viaggiatori esperti',
    "nextTrip.expertsBody": 'Sei a corto di idee? Scopri mete apprezzate da viaggiatori con esperienza.',
    "nextTrip.beforeBook": 'Prima di prenotare',
    "nextTrip.beforeBookBody": 'Scegli un luogo: periodo migliore, clima, costi, criticità e cosa controllare.',
    "nextTrip.whereBudget": 'Dove vado con il mio budget?',
    "nextTrip.whereBudgetBody": 'Indica quanto vuoi spendere e ricevi destinazioni realistiche da confrontare.',
    "nextTrip.loading": 'L’agente sta preparando i consigli…',
    "nextTrip.result": 'Consiglio personalizzato',
    "nextTrip.resultBody": 'Usa questa risposta come punto di partenza e approfondisci poi la destinazione con l’agente.',
    "nextTrip.error": 'Non è stato possibile generare i consigli. Riprova.',
    "nextTrip.prompt.agent": 'Suggerisci 5 destinazioni adatte a questo viaggiatore, spiegando in modo concreto perché ciascuna è coerente con le sue preferenze e con il periodo di partenza.',
    "nextTrip.prompt.experts": 'Suggerisci 5 mete che un viaggiatore esperto potrebbe consigliare per qualità dell’esperienza, varietà e rapporto valore/tempo, evitando una lista banale. Distingui chiaramente l’opinione aggregata degli utenti dai fatti.',
    "nextTrip.prompt.destination": 'Analizza la destinazione indicata e dimmi cosa è importante sapere prima di prenotare: periodo migliore, clima, durata consigliata, budget, trasporti, eventuali criticità, affollamento e cosa prenotare in anticipo.',
    "nextTrip.prompt.budget": 'Partendo dal budget indicato, proponi 5 destinazioni realistiche e confronta costo del viaggio, durata consigliata, punti forti e principali compromessi.',
    "nextTrip.prompt.timeframe": 'Quando vuole partire',
    "nextTrip.prompt.budgetLabel": 'Budget',
    "nextTrip.prompt.notSpecified": 'non specificato',
    "nextTrip.prompt.destinationLabel": 'Destinazione',
    "nextTrip.prompt.format": 'Rispondi senza asterischi Markdown. Sii sintetico ma concreto; segnala chiaramente cosa è fatto verificabile e cosa deriva da preferenze/opinioni dei viaggiatori.',
    "nextTrip.prompt.travelStyle": 'Tipo di viaggio desiderato',
    "nextTrip.prompt.userRole": 'Utente',
    "nextTrip.prompt.agentRole": 'Agente',
    "nextTrip.prompt.conversationStart": 'Avvia una conversazione per scegliere il prossimo viaggio. Proponi poche alternative concrete e invita l’utente a perfezionare la scelta con messaggi successivi.',
    "nextTrip.prompt.conversationContinue": 'Continua la stessa conversazione sul prossimo viaggio. Usa tutto il contesto precedente e modifica o approfondisci i consigli in base all’ultimo messaggio, senza ripartire da zero.',
    "nextTrip.prompt.profileMatches": "Destinazioni compatibili con le tue preferenze",
    "nextTrip.prompt.history": 'Conversazione finora',
    "nextTrip.prompt.latestMessage": 'Ultimo messaggio dell’utente',
    "nextTrip.prompt.initialRequest": 'Consigliami alcune destinazioni adatte a me sulla base delle preferenze indicate.',
    "nextTrip.prompt.conversationFormat": 'Rispondi senza asterischi Markdown. Sii concreto e conversazionale. Non ripetere domande a cui il contesto ha già risposto. Se proponi destinazioni, limita la prima risposta a 3 o 4 alternative con una breve motivazione per ciascuna e lascia spazio alla conversazione successiva.',
    "expenses.title": 'Spese del viaggio',
    "expenses.body": 'Registra i costi del viaggio e mantieni un riepilogo separato per ogni valuta.',
    "expenses.empty": 'Non hai ancora registrato spese per questo viaggio.',
    "expenses.description": 'Descrizione',
    "expenses.amount": 'Importo',
    "expenses.currency": 'Valuta',
    "expenses.category": 'Categoria',
    "expenses.date": 'Data',
    "expenses.payer": 'Pagato da',
    "expenses.note": 'Nota',
    "expenses.add": 'Aggiungi spesa',
    "expenses.datePlaceholder": "GG/MM/AAAA",
    "expenses.addedFeedback": "Spesa aggiunta correttamente.",
    "expenses.updatedFeedback": "Spesa aggiornata correttamente.",
    "feedback.itemAdded": "Elemento aggiunto correttamente.",
    "feedback.itemSaved": "Modifica salvata correttamente.",
    "feedback.documentAdded": "Documento aggiunto correttamente.",
    "feedback.checklistAdded": "Voce aggiunta alla checklist.",
    "feedback.noteAdded": "Appunto aggiunto correttamente.",
    "itinerary.savedFeedback": "Tappa salvata correttamente.",
    "expenses.list": 'Movimenti',
    "expenses.listBody": 'Modifica o elimina le spese già registrate.',
    "expenses.category.transport": 'Trasporti',
    "expenses.category.stay": 'Alloggio',
    "expenses.category.food": 'Cibo e bevande',
    "expenses.category.activities": 'Attività',
    "expenses.category.shopping": 'Shopping',
    "expenses.category.fees": 'Commissioni e tasse',
    "expenses.category.other": 'Altro',
    "expenses.me": "Io",
    "expenses.sharedWith": "Condivisa con",
    "expenses.sharedWithBody": "Scegli i partecipanti e come suddividere l'importo.",
    "expenses.split.equal": "Parti uguali",
    "expenses.split.percentage": "Percentuali",
    "expenses.split.shares": "Quote",
    "expenses.sharesUnit": "quote",
    "expenses.percentageTotal": "Totale percentuali: {total}%",
    "expenses.browserBody": "Tutti i costi del viaggio, organizzati per valuta e partecipante.",
    "expenses.count": "{count} spese",
    "expenses.filters": "Filtri spese",
    "expenses.filterAll": "Tutte ({count})",
    "expenses.myExpenses": "Le mie spese",
    "expenses.paidBy": "Pagato da {name}",
    "expenses.participantCount": "{count} partecipanti",
    "expenses.perPerson": "a persona",
    "expenses.editTitle": "Modifica spesa",
    "expenses.descriptionPlaceholder": "Descrizione della spesa",
    "expenses.amountPlaceholder": "0,00",
    "expenses.notePlaceholder": "Aggiungi una nota",
    "feedback.expenseDeleted": "Spesa eliminata correttamente.",
    "trip.section.statistics": "Statistiche",
    "trip.section.statisticsBody": "Analisi completa delle spese del singolo viaggio.",
    "statistics.title": "Statistiche del viaggio",
    "statistics.body": "Tutte le spese del viaggio, aggregate per valuta, categoria, pagatore e partecipante.",
    "statistics.empty": "Non ci sono ancora spese da analizzare.",
    "statistics.movements": "Movimenti",
    "statistics.sharedExpenses": "Spese condivise",
    "statistics.tripDays": "Giorni del viaggio",
    "statistics.total": "Totale",
    "statistics.dailyAverage": "Media giornaliera",
    "statistics.byCategory": "Per categoria",
    "statistics.byCategoryBody": "Quanto è stato speso nelle diverse categorie.",
    "statistics.byPayer": "Pagato da",
    "statistics.byPayerBody": "Totale anticipato da ciascun pagatore.",
    "statistics.byParticipant": "Quote per partecipante",
    "statistics.byParticipantBody": "Importo attribuito a ciascun partecipante nelle spese condivise.",
    "statistics.allExpenses": "Tutte le spese",
    "statistics.allExpensesBody": "Storico completo usato per queste statistiche.",
    "statistics.unknownPayer": "Pagatore non indicato",
    "tripHome.quickExpense": "Spesa rapida",
    "tripHome.openExpenses": "Apri spese",
    "tripHome.documentReady": "Pronto",
    "tripHome.documentPending": "In caricamento",
    "tripHome.addDocument": "Aggiungi documento",
    "tripHome.uploadDocument": "Carica documento",
    "tripHome.linkPlaceholder": "Incolla un link https://",
    "tripHome.completed": "completati",
    "tripHome.quickChecklistPlaceholder": "Nuova voce",
    "tripHome.openChecklist": "Apri checklist",
    "tripHome.reminder": "Promemoria",
    "tripHome.reminderPlaceholder": "Scrivi un promemoria",
    "tripHome.openNotes": "Apri appunti",
    "tripHome.statistics": "Statistiche",
    "tripHome.movements": "movimenti",
    "trip.section.expenses": 'Spese',
    "trip.section.expensesBody": 'Costi sostenuti durante il viaggio, organizzati per categoria e valuta.',
    "tripHome.expenses": 'Spese',
    "tripHome.group.plan": "Pianifica",
    "tripHome.group.planBody": "Organizza il tuo itinerario giorno per giorno",
    "tripHome.group.organize": "Organizza",
    "tripHome.group.organizeBody": "Tieni tutto sotto controllo",
    "tripHome.group.during": "Durante il viaggio",
    "tripHome.group.duringBody": "Informazioni utili sempre a portata di mano",
    "tripHome.restyle.preparation": "Preparazione",
    "tripHome.restyle.preparationAction": "Fai il punto",
    "tripHome.restyle.pendingChecklist": "Attività da completare",
    "tripHome.restyle.documentsBody": "File e prenotazioni del viaggio",
    "tripHome.restyle.offlineReady": "Pronto da scaricare",
    "tripHome.restyle.offlineBody": "Le informazioni del viaggio sempre con te, anche senza rete.",
    "tripHome.restyle.offlineDownload": "Scarica il viaggio",
    "tripHome.restyle.offlineExcludes": "Include dati e documenti. Album fotografico escluso.",
    "tripHome.guide.featureTitle": "La tua guida, sempre con te",
    "tripHome.guide.mapEmpty": "Esplora il viaggio",
    "tripHome.guide.placesEmpty": "Scopri cosa visitare",
    "usefulInfo.plug.otherTypes": "Altre prese presenti",
    "usefulInfo.plug.checkAdapter": "Verifica che il tuo adattatore sia compatibile con la presa disponibile.",
    "tripHome.noNextStopShort": "Aggiungi la prima tappa per iniziare.",
    "tripHome.countStops": "{count} tappe",
    "tripHome.itinerarySummary": "Crea il tuo percorso di viaggio.",
    "tripHome.savedStops": "Luoghi salvati",
    "tripHome.countMovements": "{count} movimenti",
    "tripHome.countDocuments": "{count} documenti",
    "tripHome.documentsSummary": "Passaporti, prenotazioni, assicurazioni…",
    "tripHome.activitiesPending": "Attività da completare",
    "tripHome.countPlaces": "{count} luoghi salvati",
    "tripHome.usefulInfoSummary": "Trasporti, salute, valuta e altre informazioni utili.",
    "tripHome.usefulInfoGuide": "Guida pratica",
    "settings.open": 'Apri',
    "settings.termsUse": 'Termini di utilizzo',
    "settings.termsUseBody": 'Consulta ambito dell’app, limiti dell’Agente AI e responsabilità dell’utente.',
    "settings.privacyPolicy": 'Informativa Privacy',
    "settings.privacyPolicyBody": 'Consulta come Mundely gestisce dati, account e informazioni di viaggio.',
    "settings.buttonCorners": 'Angoli dei pulsanti',
    "settings.buttonCornersBody": 'Scegli quanto devono essere squadrati o arrotondati i pulsanti dell’app.',
    "settings.buttonCornersPill": 'Pillola',
    "settings.widgets": 'Widget',
    "settings.widgetsBody": 'Personalizza i widget disponibili nelle Home e nei viaggi.',
    "widgets.settingsIntro": 'Configura i widget Android di Mundely come in fAInance: dimensioni del testo, colori, trasparenza, bordi, contenuti visibili e aggiornamento automatico.',
    "widgets.settingsIntroExact": 'Configura l’aspetto dei widget Android. Per Documenti, Checklist e Promemoria il contenuto preciso si sceglie quando aggiungi o riconfiguri il widget dalla Home del telefono.',
    "widgets.chooseContentOnHome": 'Scegli il contenuto preciso quando aggiungi o riconfiguri il widget dalla Home del telefono; qui personalizzi testo, colori, trasparenza e aggiornamento.',
    "widgets.nextStop": 'Prossima tappa',
    "widgets.nextStopBody": 'Mostra la prossima tappa del viaggio e apre direttamente l’itinerario.',
    "widgets.expenses": 'Spesa rapida',
    "widgets.expensesBody": 'Mostra solo il pulsante per aggiungere rapidamente una spesa al viaggio scelto.',
    "widgets.expenseHistory": 'Spese',
    "widgets.expenseHistoryBody": 'Mostra lo storico delle spese del viaggio scelto, con dettagli completi e scorrimento.',
    "widgets.documents": 'Documenti e biglietti',
    "widgets.documentsBody": 'Mostra il riepilogo di documenti e biglietti e apre la sezione Documenti.',
    "widgets.checklist": 'Checklist',
    "widgets.checklistBody": 'Mostra l’avanzamento e le prossime attività ancora da completare.',
    "widgets.reminder": 'Promemoria',
    "widgets.reminderBody": 'Mostra il prossimo appunto o promemoria del viaggio.',
    "widgets.calculator": "Calcolatrice",
    "widgets.calculatorBody": "Calcolatrice completa direttamente nella Home del telefono.",
    "widgets.converter": "Convertitore",
    "widgets.converterBody": "Convertitore di valuta direttamente nella Home del telefono.",
    "widgets.preview": "Anteprima",
    "widgets.createTransaction": "Crea transazione",
    "widgets.titleSection": "Titolo",
    "widgets.showTitle": "Mostra titolo",
    "widgets.showTransaction": "Mostra Crea transazione",
    "widgets.specificInstance": "Stai personalizzando questo widget specifico.",
    "widgets.baseColors": "Base",
    "widgets.keys": "Tasti",
    "widgets.primaryKeys": "Principali",
    "widgets.secondaryKeys": "Secondari",
    "widgets.operationKeys": "Operazioni",
    "widgets.buttonBorders": "Bordi dei tasti",
    "widgets.offlineUse": "Uso offline",
    "widgets.offlineUseBody": "Il widget usa l’ultimo tasso disponibile e aggiorna automaticamente il cambio quando torna la connessione.",
    "widgets.converterOfflinePreview": "Offline · 1 CHF = 1,06 EUR",
    "widgets.previewFromCode": "CHF",
    "widgets.previewToCode": "EUR",
    "widgets.previewFromValue": "77 CHF",
    "widgets.previewToValue": "81,62 EUR",
    "widgets.textSize": 'Grandezza testo',
    "widgets.textSizeBody": 'Dimensione del contenuto mostrato nel widget.',
    "widgets.checklistItems": 'Voci visibili',
    "widgets.checklistItemsBody": 'Numero massimo di voci della checklist mostrate nel widget quando c’è spazio.',
    "widgets.backgroundTransparency": 'Trasparenza sfondo widget',
    "widgets.backgroundTransparencyBody": '100% = completamente trasparente. 0% = sfondo pieno.',
    "widgets.colors": 'Colori',
    "widgets.backgroundColor": 'Sfondo',
    "widgets.iconColor": 'Colore icona',
    "widgets.titleColor": 'Colore titolo',
    "widgets.textColor": 'Colore testo',
    "widgets.actionColor": 'Colore pulsante',
    "widgets.buttonCorners": 'Bordi dei tasti widget',
    "widgets.buttonCornersBody": 'Scegli la forma dei pulsanti del widget.',
    "widgets.buttonStyle.square": 'Squadrati',
    "widgets.buttonStyle.sharp": 'Compatti',
    "widgets.buttonStyle.soft": 'Morbidi',
    "widgets.buttonStyle.rounded": 'Arrotondati',
    "widgets.showHeader": 'Mostra titolo',
    "widgets.showHeaderBody": 'Mostra il nome del widget nella parte superiore.',
    "widgets.showTripName": 'Mostra viaggio',
    "widgets.showTripNameBody": 'Mostra il nome del viaggio collegato al widget.',
    "widgets.showSecondary": 'Mostra dettagli',
    "widgets.showSecondaryBody": 'Mostra la riga informativa secondaria quando c’è spazio.',
    "widgets.autoUpdate": 'Aggiornamento automatico',
    "widgets.autoUpdateBody": 'Aggiorna i widget già installati quando cambiano i dati del viaggio.',
    "widgets.maxChars": 'Numero massimo di caratteri',
    "widgets.maxCharsBody": 'Limita il testo mostrato nel widget.',
    "widgets.maxStops": 'Prossime tappe visibili',
    "widgets.maxStopsBody": 'Di default vengono mostrate tutte. Puoi limitarle fino a una sola tappa.',
    "widgets.allStops": 'Tutte',
    "widgets.includePastStops": 'Mostra anche le tappe passate',
    "widgets.includePastStopsBody": 'Disattivato per impostazione predefinita.',
    "widgets.documentDisplay": 'Visualizzazione documento',
    "widgets.documentDisplayBody": 'Scegli se il widget deve mostrare il documento oppure un collegamento cliccabile.',
    "widgets.documentDisplayImage": 'Immagine del documento',
    "widgets.documentDisplayLink": 'Link per aprire il documento',
    "widgets.visibleItems": 'Voci visibili',
    "widgets.visibleItemsBody": 'Scegli quante attività della checklist mostrare quando lo spazio lo consente.',
    "widgets.saveUpdate": 'Salva e aggiorna widget',
    "widgets.reset": 'Ripristina',
    "widgets.saved": 'Impostazioni widget salvate e applicate.',
    "widgets.preview.tripName": 'Weekend a Lisbona',
    "widgets.preview.nextStop": 'Itinerario ancora vuoto',
    "widgets.preview.nextStopSecondary": 'Aggiungi la prima tappa per iniziare il viaggio.',
    "widgets.preview.documents": '0 documenti',
    "widgets.preview.tickets": 'Biglietti: 0',
    "widgets.preview.reminder": 'Nessun appunto',
    "widgets.preview.reminderSecondary": 'Apri appunti per aggiungerne uno.',
    "widgets.preview.movements": '4 movimenti',
    "widgets.preview.checklist": 'Attività da completare',
    "widgets.preview.checkItem1": 'Preparare i documenti',
    "widgets.preview.checkItem2": 'Controllare i biglietti',
    "widgets.preview.addExpense": 'Aggiungi spesa',
    "widgets.preview.open": 'Apri',
    "widgets.colorPicker.title": 'Scegli un colore',
    "widgets.colorPicker.presets": 'Predefiniti',
    "widgets.colorPicker.custom": 'Personalizzato',
    "widgets.colorPicker.presetColors": 'Colori predefiniti',
    "widgets.colorPicker.customColor": 'Colore personalizzato',
    "widgets.colorPicker.htmlCode": 'Codice HTML',
    "widgets.colorPicker.invalidHtml": 'Inserisci un codice HTML valido',
    "widgets.colorPicker.apply": 'Applica colore',
    "widgets.colorPicker.color": 'Colore',
    "widgets.colorPicker.htmlPlaceholder": '#124848',
    "settings.barsSection": 'Barra superiore e inferiore',
    "settings.topBar": 'Barra superiore',
    "settings.topBarBody": 'Impostazioni predisposte per la futura personalizzazione della barra superiore.',
    "settings.bottomBar": 'Barra inferiore',
    "settings.bottomBarBody": 'Impostazioni predisposte per la futura personalizzazione della barra di navigazione.',
    "settings.supportEmail": 'Contatta il supporto',
    "settings.supportEmailBody": 'Canale di assistenza Mundely.',
    "settings.reportProblem": 'Segnala un problema',
    "settings.reportProblemBody": 'Invia una segnalazione tecnica o un malfunzionamento.',
    "settings.faq": 'Domande frequenti',
    "settings.faqBody": 'Risposte rapide sui principali dubbi di utilizzo.',
    "settings.website": 'Sito web',
    "settings.websiteBody": 'Informazioni, aggiornamenti e risorse ufficiali Mundely.',
    "settings.linksPreparedBody": 'La struttura è pronta. Collegheremo in seguito gli indirizzi definitivi di assistenza, sito e social.',
    "settings.appInfoTagline": 'Il tuo spazio intelligente per organizzare, vivere e ricordare i viaggi.',
    "settings.webSocial": 'Web e social',
    "settings.webSocialBody": 'Canali ufficiali Mundely predisposti per i collegamenti definitivi.',
    "quiz.title": "Conosciamoci meglio", "quiz.menuBody": "Racconta cosa ami, per viaggi più adatti a te.", "quiz.intro": "Scegli d'istinto tra due alternative. Il profilo si aggiorna e si sincronizza sui tuoi dispositivi.", "quiz.choose": "Quale preferisci?", "quiz.or": "oppure", "quiz.questionProgress": "Domanda {current} di {total}", "quiz.complete": "Profilo completato", "quiz.completeBody": "Puoi modificare ogni risposta in qualsiasi momento.", "quiz.history": "Le tue risposte", "quiz.historyBody": "Rivedi e modifica lo storico: il Top 10 verrà ricalcolato.", "quiz.unanswered": "Da rispondere", "quiz.top10": "Il tuo Top 10", "quiz.top10Body": "Compatibilità indicativa calcolata sulle tue preferenze.", "quiz.catalogHint": "Il motore confronta almeno {count} destinazioni e può estendersi con il catalogo cloud.", "quiz.top10Empty": "Rispondi alla prima domanda per generare la classifica.", "quiz.saveError": "Salvataggio non riuscito. La risposta non è stata applicata.", "quiz.syncWarning": "Sincronizzazione momentaneamente non disponibile: vedi l'ultima copia salvata su questo dispositivo.", "quiz.sea": "Mare", "quiz.mountain": "Montagna", "quiz.city": "Città", "quiz.nature": "Natura", "quiz.warm": "Caldo", "quiz.cold": "Freddo", "quiz.planned": "Organizzato", "quiz.adventure": "Avventura", "quiz.luxury": "Lusso", "quiz.budget": "Budget", "quiz.relax": "Relax", "quiz.activity": "Attività", "quiz.culture": "Cultura", "quiz.nightlife": "Nightlife", "quiz.short": "Viaggio breve", "quiz.long": "Viaggio lungo", "quiz.destination.bali": "Bali", "quiz.destination.tokyo": "Tokyo", "quiz.destination.iceland": "Islanda", "quiz.destination.maldives": "Maldive", "quiz.destination.newYork": "New York", "quiz.destination.dolomites": "Dolomiti", "quiz.destination.barcelona": "Barcellona", "quiz.destination.costarica": "Costa Rica", "quiz.destination.paris": "Parigi", "quiz.destination.thailand": "Thailandia", "quiz.destination.norway": "Norvegia", "quiz.destination.dubai": "Dubai", "quiz.destination.lisbon": "Lisbona", "quiz.destination.rome": "Roma", "quiz.destination.london": "Londra", "quiz.destination.athens": "Atene", "quiz.destination.istanbul": "Istanbul", "quiz.destination.marrakech": "Marrakech", "quiz.destination.capeTown": "Città del Capo", "quiz.destination.zanzibar": "Zanzibar", "quiz.destination.singapore": "Singapore", "quiz.destination.seoul": "Seul", "quiz.destination.vietnam": "Vietnam", "quiz.destination.sriLanka": "Sri Lanka", "quiz.destination.nepal": "Nepal", "quiz.destination.patagonia": "Patagonia", "quiz.destination.peru": "Perù", "quiz.destination.mexico": "Messico", "quiz.destination.canadaRockies": "Montagne Rocciose canadesi", "quiz.destination.newZealand": "Nuova Zelanda",
    "settings.profileBody": "Dati personali, account, accesso e sicurezza.",
    "settings.security": "Sicurezza",
    "settings.securityBody": "Password, dispositivi collegati, PIN e biometria.",
    "settings.general": "Generale",
    "settings.generalBody": "Lingua, valuta, unità di misura e formato data.",
    "settings.appearance": "Aspetto",
    "settings.appearanceBody": "Tema, colori, stile dei pulsanti, widget e modelli.",
    "settings.notifications": "Notifiche e Promemoria",
    "settings.notificationsBody": "Avvisi operativi, promemoria, AI, collaborazione e comunicazioni.",
    "profile.socialTitle": "Social",
    "profile.socialBody": "Aggiungi i link ai tuoi profili social. Puoi scegliere se mostrarli nel profilo pubblico.",
    "profile.socialPublic": "Mostra i social nel profilo pubblico",
    "profile.socialInvalid": "Inserisci un link HTTPS valido al profilo del social indicato.",
    "settings.infoData": "Piani, dati e supporto",
    "settings.infoDataBody": "Piano, dati, assistenza, privacy e informazioni sull’app.",
    "settings.localLock": "Protezione del dispositivo",
    "settings.localLockBody": "Scegli come proteggere l’accesso ai dati disponibili su questo dispositivo.",
    "settings.nativeOnly": "La biometria richiede l’app Android o iOS. PIN e password account possono essere usati anche sul Web.",
    "settings.currentLock": "Protezione attuale",
    "settings.pin": "PIN",
    "settings.biometric": "Biometria",
    "settings.noLock": "Nessuna protezione locale",
    "settings.savePin": "Salva PIN",
    "settings.disableLock": "Disattiva protezione locale",
    "settings.lockDisabled": "Protezione locale disattivata.",
    "settings.lockSaved": "Impostazione di sicurezza salvata.",
    "settings.pinInvalid": "Il PIN deve contenere esattamente 4 numeri.",
    "settings.protectApp": "Proteggi l’app",
    "settings.protectAppBody": "Scegli se sbloccare Mundely con biometria, password dell’account o PIN di 4 numeri.",
    "settings.biometricMethodDesc": "Impronta, Face ID o codice dispositivo",
    "settings.passwordMethod": "Password account",
    "settings.passwordMethodDesc": "Usa la stessa password dell’account email",
    "settings.pinFourDigits": "PIN 4 numeri",
    "settings.pinMethodDesc": "Codice locale di 4 cifre",
    "settings.pinSaved": "PIN salvato.",
    "settings.pinConfigured": "PIN configurato",
    "settings.pinRequired": "Imposta prima un PIN di 4 numeri.",
    "settings.passwordMethodInfo": "La password dell’account funziona per gli account creati con email e password. Gli account Google o Apple possono non avere una password Mundely verificabile localmente.",
    "settings.enableBiometricReason": "Conferma l’attivazione del blocco biometrico",
    "settings.disableBiometricReason": "Conferma la disattivazione del blocco dell’app",
    "settings.lockEnabled": "Protezione app attivata.",
    "settings.lockUpdated": "Impostazioni aggiornate.",
    "settings.lockReturn": "Richiedi blocco al ritorno nell’app",
    "settings.lockReturnBody": "Dopo quanto tempo in background Mundely deve bloccarsi di nuovo.",
    "settings.timeoutNow": "Subito",
    "settings.timeout1": "1 minuto",
    "settings.timeout5": "5 minuti",
    "settings.timeout15": "15 minuti",
    "settings.localLockInfo": "Il blocco locale non sostituisce il login Google, Apple o email: protegge solo l’accesso ai dati già disponibili sul dispositivo.",
    "settings.appearanceApp": "Tema e stile",
    "settings.appearanceInterface": "Interfaccia",
    "settings.appearanceAppBody": "Tema, colori, forma dei pulsanti e aspetto dell’interfaccia.",
    "settings.languageFormats": "Lingua e formati",
    "settings.languageFormatsBody": "Queste preferenze sono salvate sul tuo account e sincronizzate tra i dispositivi.",
    "settings.generalFormatsBody": "Scegli lingua, valuta, unità di misura e formato data usati nell’app.",
    "settings.preferencesSaved": "Preferenze aggiornate.",
    "settings.appearanceSaved": "Aspetto aggiornato.",
    "settings.notificationsSaved": "Preferenze di notifica aggiornate.",
    "settings.notificationPreferences": "Preferenze di notifica",
    "settings.notificationOperational": "Avvisi operativi",
    "settings.notificationOperationalBody": "Aggiornamenti importanti sul funzionamento dell’app e del tuo account.",
    "settings.notificationReminders": "Promemoria",
    "settings.notificationRemindersBody": "Promemoria relativi a viaggi, attività e scadenze.",
    "settings.notificationAi": "Suggerimenti AI",
    "settings.notificationAiBody": "Avvisi e suggerimenti generati dalle funzioni intelligenti di Mundely.",
    "settings.notificationCollaboration": "Collaborazione",
    "settings.notificationCollaborationBody": "Inviti, modifiche condivise e attività degli altri partecipanti.",
    "settings.notificationMarketing": "Novità e comunicazioni",
    "settings.notificationMarketingBody": "Aggiornamenti su novità, funzionalità e comunicazioni non operative.",
    "settings.darkMode": "Dark Mode",
    "settings.darkModeBody": "Attiva i colori scuri per utilizzare Mundely con meno luminosità.",
    "settings.buttonColor": "Colore dei pulsanti",
    "settings.buttonColorBody": "Scegli il colore principale dei pulsanti dell’app.",
    "settings.themeSaved": "Tema aggiornato.",
    "settings.usefulInfo": "Info Utili",
    "settings.usefulInfoBody": "Scegli il layout predefinito della scheda Info Utili.",
    "settings.travelLayouts": "Itinerario e Timeline",
    "settings.travelLayoutsBody": "Prova otto modelli diversi per Itinerario e otto per Timeline e scegli quelli da usare nell'app.",
    "settings.travelLayoutsSaved": "Modello aggiornato.",
    "settings.itineraryLayouts": "Modelli Itinerario",
    "settings.itineraryLayoutsBody": "La scelta cambia la visualizzazione principale dell'itinerario in tutti i viaggi.",
    "settings.timelineLayouts": "Modelli Timeline",
    "settings.timelineLayoutsBody": "La scelta cambia la rappresentazione grafica della timeline in tutti i viaggi.",
    "settings.itineraryLayout1": "Schede giornaliere",
    "settings.itineraryLayout1Body": "Giornate in card con attività ordinate.",
    "settings.itineraryLayout2": "Agenda compatta",
    "settings.itineraryLayout2Body": "Elenco denso con orari e dettagli essenziali.",
    "settings.itineraryLayout3": "Planner a colonne",
    "settings.itineraryLayout3Body": "Giornate affiancate come un planner visuale.",
    "settings.itineraryLayout4": "Magazine",
    "settings.itineraryLayout4Body": "Card ampie, immagini protagoniste e ritmo editoriale.",
    "settings.itineraryLayout5": "Percorso",
    "settings.itineraryLayout5Body": "Le giornate sono collegate da una linea di viaggio.",
    "settings.itineraryLayout6": "Agenda oraria",
    "settings.itineraryLayout6Body": "Visualizzazione centrata sulla sequenza degli orari.",
    "settings.itineraryLayout7": "Mosaico",
    "settings.itineraryLayout7Body": "Griglia visuale con giornate di dimensioni dinamiche.",
    "settings.itineraryLayout8": "Minimal",
    "settings.itineraryLayout8Body": "Essenziale, pulito e molto leggibile.",
    "settings.timelineLayout1": "Linea verticale",
    "settings.timelineLayout1Body": "Timeline classica con nodi giornalieri.",
    "settings.timelineLayout2": "Rotta geografica",
    "settings.timelineLayout2Body": "Tappe e spostamenti come una rotta di viaggio.",
    "settings.timelineLayout3": "Capitoli",
    "settings.timelineLayout3Body": "Ogni tappa diventa un capitolo del viaggio.",
    "settings.timelineLayout4": "Doppia corsia",
    "settings.timelineLayout4Body": "Attività alternate sui due lati della linea temporale.",
    "settings.timelineLayout5": "Nastro",
    "settings.timelineLayout5Body": "Sequenza orizzontale a blocchi collegati.",
    "settings.timelineLayout6": "Calendario",
    "settings.timelineLayout6Body": "Timeline organizzata come un calendario visuale.",
    "settings.timelineLayout7": "Mappa schematica",
    "settings.timelineLayout7Body": "Percorso illustrato con nodi, curve e tappe.",
    "settings.timelineLayout8": "Cinematica",
    "settings.timelineLayout8Body": "Grandi scene, date e titoli in stile racconto visuale.",
    "settings.sections": "Sezioni",
    "settings.preferencesPending": "Modifiche conservate sul dispositivo, in attesa di sincronizzazione.",
    "settings.preferencesConflict": "Le opzioni sono cambiate su un altro dispositivo. Riapri la sezione e ripeti la modifica.",
    "settings.sectionsBody": "Configura le opzioni usate nelle singole sezioni dell’app.",
    "settings.sectionsHotels": "Hotel",
    "settings.sectionsHotelsBody": "Gestisci i valori disponibili nel campo Prenotato con degli hotel.",
    "settings.sectionsRestaurants": "Ristoranti",
    "settings.sectionsRestaurantsBody": "Gestisci i valori disponibili nel campo Prenotato con dei ristoranti.",
    "settings.sectionsChecklist": "Checklist",
    "settings.sectionsChecklistBody": "Gestisci le categorie disponibili nelle checklist dei viaggi.",
    "settings.sectionsChecklistCategories": "Checklist · Categorie",
    "settings.sectionsParticipants": "Partecipanti",
    "settings.sectionsWorldMap": "Colori Il mio mondo",
    "settings.sectionsWorldMapBody": "Scegli i colori della mappa per Visitata, Ci ho vissuto e Non visitata.",
    "settings.sectionsWorldMapHelp": "Questi colori vengono usati nella mappa di Il mio mondo e si sincronizzano con il tuo profilo.",
    "settings.sectionsWorldMapSaved": "Colori della mappa aggiornati.",
    "settings.sectionsWorldMapReset": "Ripristina predefiniti",
    "settings.sectionsWorldMapSaveError": "Non è stato possibile salvare i colori della mappa.",
    "settings.sectionsParticipantsBody": "Gestisci i ruoli disponibili per i partecipanti ai viaggi.",
    "settings.sectionsParticipantRoles": "Partecipanti · Ruoli",
    "settings.sectionsHotelBookedWith": "Hotel · Prenotato con",
    "settings.sectionsRestaurantBookedWith": "Ristoranti · Prenotato con",
    "settings.sectionsListBody": "Aggiungi, rinomina, ordina o archivia i valori. I valori archiviati restano validi nei dati già salvati ma non compaiono nei nuovi inserimenti.",
    "settings.sectionsAddPlaceholder": "Nuovo valore",
    "settings.sectionsAdd": "Aggiungi valore",
    "settings.sectionsCustomValue": "Consente un valore personalizzato",
    "settings.moveUp": "Sposta su",
    "settings.moveDown": "Sposta giù",
    "settings.archive": "Archivia",
    "settings.archivedValues": "Valori archiviati",
    "settings.restoreDefaults": "Ripristina valori predefiniti",
    "settings.usefulInfoLayoutBody": "Scegli quale dei cinque modelli usare in tutti i viaggi. Il Modello 1 è il predefinito.",
    "settings.usefulInfoLayout1": "Modello 1 · Sezioni a colori",
    "settings.usefulInfoLayout2": "Modello 2 · Riepilogo + dettagli",
    "settings.usefulInfoLayout3": "Modello 3 · Sezioni espandibili",
    "settings.usefulInfoLayout4": "Modello 4 · Card compatte",
    "settings.usefulInfoLayout5": "Modello 5 · Riepilogo rapido",
    "settings.usefulInfoLayoutSaved": "Layout Info Utili aggiornato.",
    "settings.default": "Predefinito",
    "settings.prepared": "Predisposto",
    "settings.usefulInfoPreparedBody": "La struttura è pronta. Definiremo qui le opzioni di Info Utili quando analizzeremo la scheda.",
    "billing.feelsLike": "Percepita",
    "billing.wind": "Vento",
    "billing.sharePassword": "Password del link",
    "billing.shareExpiry": "Scadenza del link (opzionale)",
    "billing.revokeLink": "Disattiva il link",
    "billing.completeRequired": "Disponibile con il Piano Completo",
    "billing.preserved": "I tuoi dati e le tue preferenze restano conservati. Passa al Piano Completo per usare questa funzione.",
    "billing.viewPlans": "Vedi i piani",
    "billing.actionError": "Operazione non riuscita. Controlla la connessione e riprova.",
    "billing.manual": "Viaggi e inserimento manuale",
    "billing.tripSuggestions": "Suggerimenti contestuali sulle attività",
    "billing.tripReplanning": "Ricalcolo intelligente dell’itinerario",
    "billing.voice": "Assistente AI vocale",
    "billing.photoAi": "Selezione AI delle foto",
    "billing.weather": "Meteo",
    "billing.weatherFree": "Clima medio e 2 giorni",
    "billing.weatherComplete": "14 giorni e dettaglio orario",
    "billing.widgets": "Widget",
    "billing.widgetsFree": "Itinerario, checklist, spesa, appunti, calcolatrice, convertitore",
    "billing.widgetsComplete": "Tutti, inclusi documenti e storico spese",
    "billing.stats": "Statistiche spese",
    "billing.statsFree": "Singolo viaggio",
    "billing.statsComplete": "Confronti, trend e insight",
    "billing.fx": "Conversione automatica multi-valuta",
    "billing.fxFree": "Convertitore manuale",
    "billing.sharing": "Link pubblico",
    "billing.sharingFree": "Intero viaggio, revocabile",
    "billing.sharingComplete": "Sezioni, password e scadenza",
    "billing.offline": "Accesso offline",
    "billing.cache": "Cache normale",
    "billing.fullDownload": "Download completo del viaggio",
    "billing.backup": "Export account, backup e ripristino",
    "billing.days": "giorni",
    "billing.tools": "Calcolatrice, convertitore e fAInance",
    "billing.importExport": "Import e PDF/Excel del singolo viaggio",
    "billing.collaboration": "Inviti, ruoli e sincronizzazione",
    "billing.community": "Community e preferenze",
    "billing.live": "Servizi live, calendario e ottimizzazione — in roadmap",
    "billing.personal": "Il piano è personale: segue il tuo account, anche nei viaggi condivisi.",
    "billing.trialActive": "Prova del Piano Completo attiva",
    "billing.until": "Piano Completo attivo fino al",
    "billing.cancelScheduled": "Rinnovo disattivato. Il piano resta attivo fino alla scadenza.",
    "billing.statusError": "Stato del piano non aggiornabile. Le funzioni a pagamento richiedono la verifica del server.",
    "billing.notMeasured": "Utilizzo da misurare",
    "billing.refreshUsage": "Aggiorna utilizzo",
    "billing.overQuota": "Spazio oltre quota: i file esistenti restano accessibili. Elimina file o passa al Piano Completo prima di nuovi caricamenti.",
    "billing.trialBody": "Prova tutte le funzioni del Piano Completo per 30 giorni, una sola volta. Nessun addebito automatico.",
    "billing.startTrial": "Inizia la prova di 30 giorni",
    "billing.trialUsed": "Hai già utilizzato la prova gratuita.",
    "billing.cancelRenewal": "Disattiva il rinnovo",
    "map.showAll": "Mostra tutto",
    "travelerProfile.guidanceBody": "Dicci cosa ami e cosa vuoi evitare. Mundely userà queste indicazioni per personalizzare i tuoi viaggi.",
    "tools.createExpense": "Crea una spesa",
    "tools.expenseBody": "Usa questo risultato come importo di una spesa. Potrai completare i dettagli prima di salvarla.",
    "tools.chooseTrip": "Per quale viaggio?",
    "tools.noTrips": "Crea prima un viaggio per registrare una spesa.",
    "quiz.upNext": "Le prossime scelte",
    "quiz.upNextBody": "Una risposta alla volta, per conoscerti meglio.",
    "billing.freeForever": "Senza abbonamento",
    "billing.bestValue": "La scelta più conveniente",
    "billing.recoveryTitle": "Cestino e versioni dei viaggi",
    "billing.recoveryBody": "Con il Piano Completo puoi recuperare i viaggi eliminati e ripristinare versioni precedenti entro 30 giorni.",
    "travelerProfile.neutral": "Automatico",
    "travelerProfile.prefer": "Mi piace",
    "travelerProfile.avoid": "Preferisco evitarlo",
    "profile.searchCountry": "Cerca una nazione",
    "profile.countryHint": "Tocca il campo e digita le prime lettere.",
    "profile.noCountry": "Nessun risultato",
    "quiz.destinationDetail": "Una meta affine alle tue preferenze. Puoi esplorarla insieme a Mundely e decidere come organizzare il viaggio.",
    "quiz.exploreDestination": "Esplora con Mundely",
    "quiz.destinationPrompt": "Vorrei organizzare un viaggio a {destination}. Aiutami a esplorare questa meta in base alle mie preferenze.",
    "legal.welcome": "Prima di iniziare",
    "legal.intro": "Consulta i Termini e l’Informativa privacy quando desideri, quindi conferma le due dichiarazioni per continuare.",
    "legal.read": "Letto",
    "legal.toRead": "Da leggere",
    "legal.acceptTerms": "Accetto i Termini di utilizzo.",
    "legal.acceptPrivacy": "Confermo di aver ricevuto l’Informativa Privacy.",
    "legal.continue": "Accetta e continua",
    "legal.decline": "Non accetto · Esci",
    "legal.readEnd": "Hai raggiunto la fine del documento.",
    "legal.websiteVersion": "Consulta la pagina sul sito Mundely",
    "legal.loadError": "Non riesco a verificare l’accettazione precedente. Puoi leggere i documenti e riprovare con una connessione disponibile.",
    "legal.saveError": "L’accettazione non è stata confermata. Controlla la connessione e riprova: le tue preferenze restano conservate.",
    "common.actions": "Azioni",
    "trips.inProgress": "Viaggi in corso",
    "trips.future": "Viaggi futuri",
    "trips.finished": "Viaggi terminati",
    "trips.sectionEmpty": "Nessun viaggio in questa sezione.",
    "profile.openPublic": "Apri il profilo",
    "travelerProfile.generate": "Genera indicazioni",
    "travelerProfile.generatedTitle": "Indicazioni proposte",
    "travelerProfile.generatedBody": "Controlla e modifica il testo. Verrà inserito nel campo, e potrai salvarlo quando vuoi.",
    "travelerProfile.useGenerated": "Usa queste indicazioni",
    "travelerProfile.generatedIntro": "Personalizza i consigli usando le informazioni che ho inserito in Mundely.",
    "travelerProfile.generatedAnswers": "Ho espresso {count} scelte sul mio modo di viaggiare.",
    "travelerProfile.generatedFavorites": "Preferisco: {styles}.",
    "travelerProfile.generatedSignals": "Le mie risposte e recensioni suggeriscono interesse per: {styles}.",
    "travelerProfile.generatedAvoid": "Preferisco evitare: {styles}.",
    "travelerProfile.generatedCountries": "Nel profilo ho registrato {count} paesi.",
    "travelerProfile.generatedTrips": "I miei viaggi terminati sono {count}.",
    "travelerProfile.generatedDestinations": "Nei miei viaggi compaiono: {places}.",
    "travelerProfile.generatedDuration": "La durata media dei viaggi registrati è di circa {count} giorni.",
    "travelerProfile.generatedGroup": "Il gruppo indicato nei miei viaggi è mediamente di {count} persone.",
    "travelerProfile.generatedDetails": "Tra le attività e tappe inserite ci sono: {details}.",
    "travelerProfile.generatedEnd": "Usa questi segnali come punto di partenza e chiedimi conferma quando una preferenza non è chiara.",
    "travelerProfile.knownTitle": "Le informazioni raccolte",
    "travelerProfile.knownBody": "Dati del profilo e dei viaggi, utili per personalizzare i consigli.",
    "travelerProfile.people": "{count} persone",
    "ai.voicePlanTitle": "Vocale disponibile con il Piano Completo",
    "ai.voicePlanBody": "Con il piano Gratuito puoi continuare a scrivere. Il microfono richiede il Piano Completo.",
    "settings.cornersRounded": "Arrotondati",
    "settings.cornersSoft": "Morbidi",
    "settings.cornersSquare": "Squadrati",
    "settings.cornersSharp": "Taglienti",
    "settings.metricExample": "Chilometri, chilogrammi e Celsius. Es.: 10 km · 70 kg · 20 °C",
    "settings.imperialExample": "Miglia, libbre e Fahrenheit. Es.: 6,2 mi · 154 lb · 68 °F",
    "settings.dateDayFirst": "Giorno / mese / anno",
    "settings.dateMonthFirst": "Mese / giorno / anno",
    "settings.dateYearFirst": "Anno / mese / giorno",
    "layout.day": "Giorno {number}",
    "layout.trip": "Il viaggio",
    "layout.useful": "Informazioni utili",
    "layout.example": "Esempio",
    "layout.passport": "Passaporto",
    "layout.rome": "Roma",
    "layout.florence": "Firenze",
    "layout.venice": "Venezia",
    "layout.museum": "Museo",
    "layout.lunch": "Pranzo",
    "layout.park": "Parco",
    "billing.completePlanLabel": "Piano Completo",
    "home.allTrips": "Tutti i miei viaggi",
    "settings.unitDistance": "Distanze",
    "settings.unitWeight": "Peso",
    "settings.unitTemperature": "Temperatura",
    "settings.metricShortExample": "10 km · 70 kg · 20 °C",
    "settings.imperialShortExample": "6,2 mi · 154 lb · 68 °F",
    "travelerProfile.noGenerationData": "Aggiungi risposte o informazioni sui viaggi per generare indicazioni personalizzate.",
    "travelerProfile.recordedCountries": "Paesi registrati",
    "travelerProfile.countryHint": "Visitati o in cui hai vissuto",
    "travelerProfile.openTripsHint": "Apri i tuoi viaggi",
    "travelerProfile.myReviews": "Le tue recensioni",
    "travelerProfile.myReviewsBody": "Le recensioni che hai pubblicato su paesi, città e luoghi.",
    "travelerProfile.reviewsHint": "Paesi, città e luoghi recensiti",
    "travelerProfile.groupAverage": "Dimensione media del gruppo",
    "travelerProfile.groupHint": "Tu e i compagni registrati",
    "travelerProfile.tripGroups": "Gruppi dei tuoi viaggi",
    "travelerProfile.tripGroupsBody": "La media considera i viaggi in cui hai registrato compagni, includendo anche te nel numero di persone. Qui trovi i gruppi da cui è ricavata.",
    "travelerProfile.openTravelGroup": "Apri i partecipanti",
    "travelerProfile.sourceEmpty": "Non ci sono informazioni da mostrare in questa sezione.",
    "travelerProfile.avoidShort": "Evita",
    "profile.cloudSpaceInfo": "Spazio cloud del tuo piano",
    "profile.cloudSpaceBody": "Il piano {plan} include {limit} di spazio cloud complessivo. Foto personali, documenti e file dei viaggi condividono questo limite: non è uno spazio separato per ogni sezione.",
    "profile.exitApp": "Esci dall'App",
    "profile.exitConfirm": "Vuoi uscire dal tuo account?",
    "expenses.date.today": "Oggi",
    "expenses.date.yesterday": "Ieri",
    "expenses.date.specific": "Data specifica",
    "world.cityNote": "Nota",
    "tripHome.lastActivity": "Ultima attività",
    "tripHome.organizedDays": "{count} giorni organizzati",
    "tripHome.totalDays": "Su {count} giorni di viaggio",
    "tripHome.stays": "Alloggi",
    "tripHome.savedStays": "Strutture inserite nel viaggio",
    "world.searchCities": "Cerca città o paese",
    "world.cityGroupCount": "{count} città registrate",
    "world.noCityMatches": "Nessuna città corrisponde alla ricerca.",
    "itinerary.viewDetails": "Apri dettagli: {title}",
    "home.flexibleTime": "Orario libero",
    "home.toolsBody": "Calcolatrice e cambio valuta, sempre a portata di mano.",
    "billing.pricingLater": "Gli acquisti saranno disponibili dopo l’attivazione negli store.",
    "billing.pricesTitle": "Scegli il tuo piano",
    "billing.freePlan": "Gratuito",
    "billing.monthlyPlan": "Completo mensile",
    "billing.annualPlan": "Completo annuale",
    "billing.month": "mese",
    "billing.year": "anno",
    "billing.upgradePrices": "Piano Completo: {monthly}/mese oppure {annual}/anno.",
    "billing.downgrade": "Alla scadenza del Piano Completo",
    "billing.downgradeBody": "Nessun dato viene cancellato. I file restano visibili e scaricabili; oltre 100 MB sono bloccati i nuovi upload. Riparte il plafond Free di 20 utilizzi AI. I widget premium restano in posizione con accesso bloccato.",
    "billing.layoutsPending": "La scelta dei quattro layout finali e del layout Free resta da definire. Le preferenze attuali vengono conservate.",
    "billing.aiLimit": "Hai raggiunto i 20 utilizzi AI di questo mese.",
    "settings.plan": "Piano e abbonamento",
    "settings.planBody": "Piano attivo, limiti e gestione dell’abbonamento.",
    "settings.currentPlan": "Piano attuale",
    "settings.planPreparedBody": "La gestione completa degli acquisti verrà collegata al sistema Premium centralizzato.",
    "settings.planUnlimited": "Illimitato",
    "settings.planYes": "Sì",
    "settings.planNo": "No",
    "settings.planAiRequests": "Richieste AI mensili",
    "settings.planTrips": "Viaggi disponibili",
    "settings.planStorage": "Spazio cloud",
    "settings.planRecovery": "Cestino e recupero",
    "settings.planCompare": "Confronta i piani",
    "settings.planCompareBody": "I limiti vengono letti dalla configurazione remota di Mundely e possono essere aggiornati senza reinstallare l’app.",
    "settings.planFeature": "Funzione",
    "settings.planFreeActiveBody": "Stai usando il piano gratuito di Mundely.",
    "settings.planPremiumActiveBody": "Il tuo account ha accesso alle funzioni Premium abilitate.",
    "settings.planBenefitRecovery": "Recupero e versioning",
    "settings.planBenefitRecoveryBody": "Ripristina elementi eliminati e accedi alle funzioni di recupero disponibili per il piano.",
    "settings.planBenefitAi": "Più AI",
    "settings.planBenefitAiBody": "Limiti AI gestiti centralmente e adattabili al piano attivo.",
    "settings.planBenefitStorage": "Più spazio cloud",
    "settings.planBenefitStorageBody": "Lo spazio disponibile segue i limiti definiti per il tuo piano.",
    "settings.planBenefitTrips": "Più viaggi",
    "settings.planBenefitTripsBody": "Il numero massimo di viaggi viene gestito dalla configurazione remota.",
    "settings.planUpgradeTitle": "Passa a Premium",
    "settings.planUpgradeBody": "La pagina è già collegata agli entitlement del tuo account. L’acquisto tramite store verrà attivato quando i prodotti Android e Apple saranno configurati.",
    "settings.planUpgradeNotAvailable": "Acquisto non ancora attivo",
    "settings.planPremiumThanks": "Premium è attivo sul tuo account.",
    "settings.data": "Dati",
    "settings.dataBody": "Export, recupero dati e cancellazione dell’account.",
    "settings.appInfo": "Info app",
    "settings.appInfoBody": "Ambiente, lingue disponibili e informazioni tecniche di Mundely.",
    "settings.support": "Supporto",
    "settings.supportBody": "Assistenza, FAQ e contatti.",
    "settings.supportPreparedBody": "Questa sezione è predisposta per FAQ, contatti e strumenti di assistenza.",
    "settings.faqSyncQuestion": "Come vengono sincronizzati i miei viaggi?",
    "settings.faqSyncAnswer": "Le modifiche vengono sincronizzate sul cloud quando sei online. Se lavori offline, Mundely conserva le modifiche e prova a sincronizzarle appena torna disponibile una connessione.",
    "settings.faqOfflineQuestion": "Posso usare Mundely senza connessione?",
    "settings.faqOfflineAnswer": "Sì. Le informazioni già disponibili sul dispositivo restano consultabili e molte modifiche vengono messe in coda fino al ritorno della connessione.",
    "settings.faqAiQuestion": "Come usa i miei dati l’Agente AI?",
    "settings.faqAiAnswer": "L’Agente usa il contesto necessario per aiutarti con il viaggio, come preferenze, itinerario e informazioni che scegli di condividere. I contenuti personali non vengono inseriti negli eventi Analytics.",
    "settings.faqPrivacyQuestion": "Posso controllare i dati di utilizzo inviati?",
    "settings.faqPrivacyAnswer": "Sì. Dal Profilo puoi attivare o disattivare gli Analytics anonimi. Questa scelta non modifica le funzioni principali di Mundely.",
    "settings.faqFainanceQuestion": "Come funziona il collegamento con fAInance?",
    "settings.faqFainanceAnswer": "Durante i test il collegamento usa esclusivamente fAInance Test. La richiesta deve essere approvata dall’account fAInance indicato prima che le due app risultino collegate.",
    "settings.supportContacts": "Contatti e collegamenti",
    "settings.supportContactsBody": "I collegamenti diventano disponibili quando vengono configurati per l’ambiente corrente.",
    "settings.notConfigured": "Non ancora configurato",
    "settings.diagnosticsTitle": "Diagnostica assistenza",
    "settings.diagnosticsBody": "Copia ambiente, piattaforma e configurazione tecnica utile per una segnalazione, senza contenuti personali.",
    "settings.diagnosticsCopy": "Copia diagnostica",
    "settings.diagnosticsCopied": "Copiato",
    "settings.linksManagedBody": "Sito, contatti, documenti legali e social sono gestiti dalla configurazione di Mundely e possono essere aggiornati senza modificare questa pagina.",
    "settings.platform": "Piattaforma",
    "settings.firebaseProject": "Progetto Firebase",
    "settings.currentLanguage": "Lingua corrente",
    "settings.analyticsStatus": "Analytics",
    "settings.nativeStatus": "Modalità app",
    "settings.enabled": "Attivi",
    "settings.disabled": "Disattivi",
    "settings.nativeApp": "App nativa",
    "settings.webApp": "Web",
    "settings.appName": "App",
    "settings.environment": "Ambiente",
    "settings.production": "Produzione",
    "settings.test": "Test",
    "settings.languages": "Lingue",
    "settings.session": "Sessione",
    "settings.sessionBody": "Esci da Mundely su questo dispositivo.",
    "home.greeting": "Ciao, {name}",
    "home.corporate.plannedIntro": "Il prossimo viaggio prende forma.",
    "home.corporate.prepare": "Prima di partire",
    "home.corporate.pending": "{count} elementi da completare",
    "home.corporate.checklist": "Apri la checklist del viaggio",
    "home.corporate.today": "Oggi, a {place}.",
    "home.corporate.day": "Giorno {count}",
    "home.corporate.nextStop": "La prossima tappa",
    "home.corporate.noStop": "Nessuna prossima tappa per oggi",
    "home.corporate.openItinerary": "Consulta il tuo itinerario",
    "home.corporate.savedStop": "Una tappa salvata nel tuo itinerario",
    "home.corporate.openStop": "Apri la tappa",
    "home.corporate.worldTitle": "Il tuo mondo. La tua storia.",
    "home.corporate.worldFirst": "Il tuo mondo comincia da qui.",
    "home.corporate.newChapter": "Dove ti porterà il prossimo viaggio?",
    "home.corporate.newDeparture": "Organizza una nuova partenza",
    "home.corporate.worldBody": "Foto, luoghi visitati e ricordi",
    "home.corporate.restDay": "Il resto della giornata",
    "home.corporate.tools": "Strumenti di viaggio",
    "home.command.title": "Viaggio",
    "home.command.transport": "Prossimo trasporto",
    "home.command.transportEmpty": "Nessun trasporto in programma",
    "home.command.booking": "Prossima prenotazione",
    "home.command.bookingEmpty": "Nessuna prenotazione registrata",
    "home.command.weather": "Previsioni del giorno",
    "home.command.weatherEmpty": "Nessuna previsione salvata per la data",
    "home.command.savedWeather": "Previsione salvata",
    "home.command.useful": "Informazioni utili",
    "home.command.usefulBody": "Dati utili per le tue destinazioni",
    "home.command.spending": "Spese registrate",
    "home.command.spendingEmpty": "Nessuna spesa registrata",
    "home.command.recent": "Ultima spesa",
    "home.command.reminder": "Prossimo promemoria",
    "home.command.reminderEmpty": "Nessuna attività in sospeso",
    "home.command.pending": "{count} attività in sospeso",
    "home.command.reviewItinerary": "Rivedi itinerario",
    "home.command.openAi": "AGENTE",
    "home.command.agentBody": "Chiedi consigli per il tuo viaggio",
    "home.tripToPlan": "Da organizzare",
    "home.overview": "Il tuo mondo in numeri",
    "home.traveler": "viaggiatore",
    "home.subtitle": "Da qui costruiremo la tua esperienza di viaggio.",
    "home.newTrip": "Nuovo viaggio",
    "home.chooseTrip": "Scegli viaggio",
    "trips.subtitle": "Scegli un viaggio esistente oppure creane uno nuovo.",
    "trips.new": "Nuovo viaggio",
    "trips.emptyBody": "Crea il tuo primo viaggio per iniziare a organizzare itinerario, mappa, documenti e tutte le altre sezioni.",
    "trips.saved": "Viaggi salvati",
    "trips.createTitle": "Crea un nuovo viaggio",
    "trips.createBody": "Inserisci le informazioni di base. Potrai completare il viaggio nelle sue sezioni dedicate.",
    "trips.name": "Nome del viaggio",
    "trips.namePlaceholder": "Es. Filippine 2026",
    "trips.destination": "Destinazione",
    "trips.destinationPlaceholder": "Es. Filippine",
    "trips.startDate": "Data di partenza",
    "trips.endDate": "Data di ritorno",
    "trips.createAction": "Crea viaggio",
    "trips.createRequired": "Compila nome, destinazione e date del viaggio.",
    "trips.createDateError": "La data di ritorno non può precedere la data di partenza.",
    "trip.selected": "Viaggio selezionato",
    "trip.allTrips": "Tutti i viaggi",
    "trip.export": "Esporta viaggio",
    "trip.changeCoverPhoto": "Modifica copertina",
    "trip.changeProfilePhoto": "Modifica foto viaggio",
    "trip.editHome": "Modifica home",
    "trip.finishEditHome": "Termina modifica home",
    "trip.photoInvalid": "Seleziona un file immagine valido.",
    "trip.photoError": "Non è stato possibile elaborare la foto. Riprova.",
    "trip.photosAiPrompt": "Per il viaggio verso {destination}, scegli tra i candidati seguenti una foto rappresentativa per il profilo del viaggio e una per la copertina. Rispondi esclusivamente con JSON nel formato {\"profileIndex\":0,\"coverIndex\":1}. Candidati: {candidates}",
    "trip.share": "Condividi viaggio",
    "trip.comingSoon": "Funzione predisposta: verrà implementata nella relativa fase.",
    "trip.destinationPending": "Destinazione da definire",
    "trip.datesPending": "Date da definire",
    "trip.navigation": "Sezioni del viaggio",
    "trip.collapseNavigation": "Comprimi menu",
    "trip.expandNavigation": "Espandi menu",
    "trip.closeNavigation": "Chiudi sezioni",
    "trip.workspace": "Spazio del viaggio",
    "trip.structureReady": "Struttura pronta",
    "trip.group.organize": "Organizza",
    "trip.group.during": "Durante il viaggio",
    "trip.group.content": "Contenuti",
    "trip.section.overview": "Home viaggio",
    "trip.section.overviewBody": "Riepilogo del viaggio con accesso rapido a tutte le sezioni.",
    "trip.section.itinerary": "Itinerario",
    "trip.section.itineraryBody": "Tappe, giornate, spostamenti e programma del viaggio.",
    "trip.section.hotels": "Hotel",
    "trip.section.hotelsBody": "Strutture, prenotazioni e soggiorni del viaggio.",
    "trip.section.restaurants": "Ristoranti",
    "trip.section.restaurantsBody": "Ristoranti, prenotazioni e pasti del viaggio.",
    "trip.section.places": "Città",
    "trip.section.placesBody": "Città da visitare durante questo viaggio.",
    "trip.section.experiences": "Esperienze",
    "trip.section.experiencesBody": "Attività, tour ed esperienze collegate al viaggio.",
    "trip.section.participants": "Partecipanti",
    "trip.section.participantsBody": "Utenti Mundely e ospiti che partecipano al viaggio.",
    "trip.section.checklist": "Checklist",
    "trip.section.checklistBody": "Cose da preparare, controllare e completare prima e durante il viaggio.",
    "trip.section.map": "Mappa",
    "trip.section.mapBody": "Mappa interattiva specifica del viaggio e dei suoi contenuti.",
    "trip.section.usefulInfo": "Info Utili",
    "trip.section.usefulInfoBody": "Infografica con informazioni pratiche della destinazione alimentate dall’AI.",
    "trip.section.weather": "Clima",
    "trip.section.weatherBody": "Clima e condizioni previste durante il periodo del viaggio.",
    "trip.section.pointsOfInterest": "Punti di interesse",
    "trip.section.pointsOfInterestBody": "Attrazioni e punti di interesse delle città previste nel viaggio.",
    "trip.section.events": "Eventi in città",
    "trip.section.eventsBody": "Eventi disponibili nelle destinazioni durante le date del viaggio.",
    "trip.section.album": "Foto",
    "trip.section.albumBody": "Foto e ricordi raccolti durante il viaggio.",
    "trip.section.documents": "Documenti",
    "trip.section.documentsBody": "Documenti del viaggio e documenti condivisi dai partecipanti.",
    "trip.section.boardingPass": "Biglietti",
    "trip.section.boardingPassBody": "Biglietti, carte d’imbarco e documenti di viaggio ricevuti dalla compagnia aerea.",
    "trip.section.notes": "Appunti",
    "trip.section.notesBody": "Note e appunti personali o condivisi relativi al viaggio.",
    "usefulInfo.subtitle": "Informazioni pratiche per {destination}, raccolte in un’unica infografica.",
    "usefulInfo.edit": "Modifica",
    "usefulInfo.fillWithAi": "Compila con AI",
    "usefulInfo.aiWorking": "Compilazione in corso...",
    "usefulInfo.saved": "Info Utili salvate.",
    "usefulInfo.aiCompleted": "Info Utili compilate dall’AI. Verifica le informazioni sensibili prima del viaggio.",
    "usefulInfo.aiError": "Non è stato possibile compilare le Info Utili con l’AI. Puoi riprovare o inserirle manualmente.",
    "usefulInfo.destinationRequired": "Definisci prima la destinazione del viaggio.",
    "usefulInfo.notAvailable": "Da compilare",
    "usefulInfo.notRequired": "Non necessario",
    "usefulInfo.driving.left": "Sinistra",
    "usefulInfo.driving.right": "Destra",
    "usefulInfo.editPlaceholder": "Inserisci l’informazione...",
    "usefulInfo.completeness": "{filled}/{total} informazioni compilate",
    "usefulInfo.updatedAt": "Aggiornato: {date}",
    "usefulInfo.source.empty": "Non ancora compilato",
    "usefulInfo.source.ai": "Compilato con AI",
    "usefulInfo.source.manual": "Compilato manualmente",
    "usefulInfo.source.database": "Database Mundely",
    "usefulInfo.source.mixed": "Database Mundely + AI/manuale",
    "usefulInfo.disclaimer": "Le informazioni possono cambiare nel tempo. Prima del viaggio verifica sempre personalmente documenti, requisiti d’ingresso, salute, sicurezza, norme locali e indicazioni consolari con le autorità competenti.",
    "usefulInfo.requirementsAttribution": "Requisiti d’ingresso:",
    "usefulInfo.requirementsDatasetName": "TravelRequirements.info",
    "usefulInfo.requirementsLicense": "CC BY 4.0",
    "usefulInfo.requirementsVerified": "dati verificati {date}",
    "usefulInfo.progressLabel": "Completamento",
    "usefulInfo.plug.help": "Seleziona tutti i tipi di presa utilizzati nella destinazione.",
    "usefulInfo.plug.typeLabel": "Tipo {type}",
    "usefulInfo.currency.select": "Seleziona una moneta",
    "usefulInfo.downloadPdf": "Scarica PDF",
    "usefulInfo.pdfPopupBlocked": "Il browser ha bloccato la finestra PDF. Consenti i popup per Mundely e riprova.",
    "usefulInfo.pdfError": "Non è stato possibile preparare il PDF. Riprova.",
    "usefulInfo.group.basics": "Essenziali",
    "usefulInfo.group.basicsDesc": "Le informazioni da sapere appena arrivi.",
    "usefulInfo.group.services": "Servizi utili",
    "usefulInfo.group.servicesDesc": "App e strumenti pratici da usare sul posto.",
    "usefulInfo.group.assistanceDesc": "Contatti e riferimenti da avere sempre a portata di mano.",
    "usefulInfo.group.entryHealthDesc": "Requisiti di ingresso e indicazioni sanitarie per il viaggio.",
    "usefulInfo.group.cultureDesc": "Regole, consuetudini e aspetti sociali da conoscere.",
    "usefulInfo.group.drivingDesc": "Regole essenziali per guidare a destinazione.",
    "usefulInfo.group.assistance": "Assistenza ed emergenze",
    "usefulInfo.group.entryHealth": "Ingresso e salute",
    "usefulInfo.group.culture": "Cultura, regole e società",
    "usefulInfo.group.driving": "Guida",
    "usefulInfo.field.plugType": "Tipo di presa",
    "usefulInfo.field.currency": "Moneta",
    "usefulInfo.field.exchangeRate": "Cambio",
    "usefulInfo.field.timeZone": "Fuso orario",
    "usefulInfo.homeTime": "rispetto a casa",
    "usefulInfo.multi.title": "{count} località del viaggio",
    "usefulInfo.multi.loading": "Raccolta delle informazioni per le località…",
    "usefulInfo.multi.description": "Ogni sezione riunisce i dati uguali e separa le differenze, indicando le località interessate.",
    "usefulInfo.multi.unresolved": "Dato da verificare per questa località",
    "usefulInfo.multi.external": "Fonte automatica: da riconfermare presso gli enti competenti",
    "usefulInfo.multi.provisional": "Dato del catalogo locale: verifica in corso",
    "usefulInfo.timeZoneUnavailable": "Ora locale da verificare",
    "usefulInfo.pdfSaved": "PDF salvato in Download/Mundely.",
    "usefulInfo.field.drinkingWater": "Acqua potabile",
    "usefulInfo.field.taxiApps": "App per taxi",
    "usefulInfo.field.taxiApps.short": "App taxi",
    "usefulInfo.field.foodDeliveryApps": "App per ordinare cibo",
    "usefulInfo.field.foodDeliveryApps.short": "App per ordinare",
    "usefulInfo.field.embassy": "Ambasciata",
    "usefulInfo.field.consulates": "Consolati",
    "usefulInfo.field.emergencyNumber": "Numero emergenze",
    "usefulInfo.emergency.dispatch": "Numero unico",
    "usefulInfo.emergency.police": "Polizia",
    "usefulInfo.emergency.ambulance": "Ambulanza",
    "usefulInfo.emergency.fire": "Vigili del fuoco",
    "usefulInfo.field.specialPrecautions": "Accorgimenti particolari",
    "usefulInfo.field.specialPrecautions.short": "Accorgimenti",
    "usefulInfo.field.governmentType": "Tipo di governo",
    "usefulInfo.field.religion": "Religione",
    "usefulInfo.field.publicAffection": "Effusioni pubbliche",
    "usefulInfo.field.publicAffection.short": "Effusioni",
    "usefulInfo.field.lgbtq": "LGBTQ+",
    "usefulInfo.field.civilRights": "Diritti civili",
    "usefulInfo.details.show": "Approfondisci",
    "usefulInfo.details.hide": "Riduci",
    "usefulInfo.details.label": "Descrizione",
    "usefulInfo.field.requiredVaccines": "Vaccini obbligatori",
    "usefulInfo.field.requiredVaccines.short": "Vaccini",
    "usefulInfo.field.visa": "Visto",
    "usefulInfo.field.passport": "Passaporto",
    "usefulInfo.field.healthInsurance": "Assicurazione sanitaria",
    "usefulInfo.field.healthInsurance.short": "Assicurazione",
    "usefulInfo.healthInsuranceHint": "Verifica se la tessera sanitaria è valida a destinazione e se conviene una polizza per spese mediche, assistenza e rimpatrio.",
    "usefulInfo.civilRightsPending": "Contenuto in aggiornamento: nel frattempo verifica le indicazioni delle autorità locali.",
    "usefulInfo.toBeCompleted": "Da compilare",
    "usefulInfo.field.drivingSide": "Lato di guida",
    "usefulInfo.field.internationalDrivingPermit": "Patente internazionale",
    "usefulInfo.field.internationalDrivingPermit.short": "Patente",
    "boardingPass.subtitle": "Carte d’imbarco per {destination}, organizzate in modo rapido e leggibile.",
    "boardingPass.add": "Aggiungi boarding pass",
    "boardingPass.new": "Nuovo boarding pass",
    "boardingPass.edit": "Modifica boarding pass",
    "boardingPass.formTitle": "Dati del volo",
    "boardingPass.required": "Inserisci passeggero, aeroporti di partenza e arrivo (3 lettere) e data del volo.",
    "boardingPass.deleteConfirm": "Eliminare questo boarding pass?",
    "boardingPass.nextFlight": "Prossimo volo",
    "boardingPass.empty": "Nessun boarding pass",
    "boardingPass.emptyBody": "Aggiungi la prima carta d’imbarco del viaggio. Verrà mostrata come una carta immediata da consultare.",
    "boardingPass.passenger": "Passeggero",
    "boardingPass.airline": "Compagnia aerea",
    "boardingPass.airlineFallback": "Compagnia aerea",
    "boardingPass.flightNumber": "Numero volo",
    "boardingPass.bookingReference": "Codice prenotazione",
    "boardingPass.originCode": "Aeroporto partenza",
    "boardingPass.originCity": "Città di partenza",
    "boardingPass.destinationCode": "Aeroporto arrivo",
    "boardingPass.destinationCity": "Città di arrivo",
    "boardingPass.origin": "Partenza",
    "boardingPass.destination": "Arrivo",
    "boardingPass.date": "Data",
    "boardingPass.departureTime": "Ora partenza",
    "boardingPass.boardingTime": "Imbarco",
    "boardingPass.arrivalTime": "Ora arrivo",
    "boardingPass.terminal": "Terminal",
    "boardingPass.gate": "Gate",
    "boardingPass.seat": "Posto",
    "tickets.subtitle": "Carica biglietti e carte d’imbarco per {destination} come PDF o foto.",
    "tickets.add": "Aggiungi biglietto",
    "tickets.helpTitle": "Carica il documento ricevuto dalla compagnia",
    "tickets.helpBody": "Puoi caricare PDF o immagini. Mundely conserva il file e riprova automaticamente l’upload se la connessione si interrompe.",
    "tickets.invalidType": "Formato non supportato. Usa PDF o immagini.",
    "tickets.added": "Biglietto aggiunto.",
    "tickets.uploadError": "Il file è stato messo in coda ma non è stato possibile completare l’upload ora.",
    "tickets.deleteConfirm": "Eliminare questo biglietto?",
    "tickets.empty": "Nessun biglietto",
    "tickets.emptyBody": "Quando ricevi il biglietto o la carta d’imbarco dalla compagnia aerea, caricalo qui come PDF o foto.",
    "tickets.image": "Immagine",
    "tickets.pdf": "PDF",
    "tickets.sizeKb": "{value} KB",
    "tickets.sizeMb": "{value} MB",
    "tickets.statusUploaded": "Salvato nel cloud",
    "tickets.statusPending": "In attesa del cloud",
    "tickets.statusFailed": "Upload non riuscito",
    "tickets.failedHelp": "Il file è ancora conservato sul dispositivo. Premi Riprova per tentare di nuovo il caricamento nel cloud.",
    "tickets.retry": "Riprova",
    "tickets.pendingHelp": "Il file è al sicuro sul dispositivo e verrà caricato nel cloud automaticamente appena possibile.",
    "tickets.rename": "Rinomina",
    "tickets.renamed": "Biglietto rinominato.",
    "tickets.noExtension": "Nessuna estensione",
    "documents.subtitle": "Organizza i documenti del viaggio per cartella e partecipante.",
    "documents.add": "Aggiungi documento",
    "documents.invalidType": "Formato non supportato.",
    "documents.added": "Documento aggiunto.",
    "documents.uploadError": "Il documento è stato messo in coda ma non è stato possibile completare l’upload ora.",
    "documents.deleteConfirm": "Eliminare questo documento?",
    "documents.empty": "Nessun documento",
    "documents.emptyBody": "Carica qui passaporti, visti, carte d’identità, patente, tessera sanitaria e altri file del viaggio.",
    "documents.folders": "Cartelle",
    "documents.all": "Tutte",
    "documents.newFolder": "Nuova cartella",
    "documents.folderCreated": "Cartella creata.",
    "documents.folderNamePlaceholder": "Nome cartella",
    "documents.participant": "Partecipante",
    "documents.allParticipants": "Tutti i partecipanti",
    "documents.me": "Io",
    "documents.name": "Nome",
    "documents.folder": "Cartella",
    "documents.organize": "Organizza",
    "documents.updated": "Documento aggiornato.",
    "documents.statusUploaded": "Salvato nel cloud",
    "documents.statusPending": "Sincronizzazione in corso",
    "documents.folder.passport": "Passaporto",
    "documents.folder.id": "Carta d’identità",
    "documents.folder.drivingLicense": "Patente",
    "documents.folder.healthCard": "Tessera sanitaria",
    "documents.folder.visas": "Visti",
    "documents.folder.other": "Altro",
    "documents.personalTitle": "Documenti personali",
    "documents.personalBody": "I documenti salvati nel tuo Profilo vengono mostrati automaticamente in ogni viaggio.",
    "documents.noPersonal": "Nessun documento personale salvato",
    "documents.noPersonalBody": "Aggiungi passaporto, carta d’identità, patente, tessera sanitaria o visti in Impostazioni → Profilo.",
    "documents.personalWaiting": "In attesa del cloud",
    "documents.tripTitle": "Documenti del viaggio",
    "documents.tripBody": "Qui puoi aggiungere file specifici di questo viaggio, organizzandoli in cartelle personalizzate.",
    "documents.statusFailed": "Upload non riuscito",
    "documents.failedHelp": "Il file resta salvato sul dispositivo. Premi Riprova per tentare di nuovo il caricamento.",
    "documents.retry": "Riprova",
    "documents.saveUpload": "Salva caricamento",
    "documents.categoryEmpty": "Nessun documento",
    "profileDocuments.title": "Documenti personali",
    "profileDocuments.body": "Carica qui i documenti che appartengono a te. Mundely li renderà disponibili automaticamente nei tuoi viaggi.",
    "profileDocuments.uploadTitle": "Aggiungi un documento personale",
    "profileDocuments.uploadHint": "PDF o immagine. Il documento viene salvato nel cloud e resta disponibile nei tuoi viaggi.",
    "profileDocuments.savedForSync": "Documento salvato sul dispositivo. Il caricamento nel cloud verrà riprovato automaticamente.",
    "profileDocuments.type": "Tipo di documento",
    "profileDocuments.add": "Aggiungi documento",
    "profileDocuments.invalidType": "Formato non supportato. Usa PDF o immagini.",
    "profileDocuments.added": "Documento personale aggiunto.",
    "profileDocuments.uploadError": "Il caricamento nel cloud non è riuscito.",
    "profileDocuments.cloudRequiredError": "Il documento non è stato salvato sul dispositivo. Il caricamento nel cloud non è riuscito: riprova mantenendo questa schermata aperta.",
    "profileDocuments.updated": "Documento personale aggiornato.",
    "profileDocuments.deleteConfirm": "Eliminare questo documento personale?",
    "profileDocuments.empty": "Nessun documento personale",
    "profileDocuments.emptyBody": "Aggiungi i tuoi documenti una sola volta: saranno disponibili in tutti i viaggi.",
    "profileDocuments.statusUploaded": "Salvato nel cloud",
    "profileDocuments.statusPending": "In attesa del cloud",
    "profileDocuments.statusFailed": "Upload non riuscito",
    "profileDocuments.retry": "Riprova",
    "profileDocuments.type.passport": "Passaporto",
    "profileDocuments.type.id": "Carta d’identità",
    "profileDocuments.type.drivingLicense": "Patente",
    "profileDocuments.type.taxCode": "Codice fiscale",
    "profileDocuments.chooseFile": "Scegli documento",
    "profileDocuments.chooseType": "Categoria",
    "profileDocuments.saveUpload": "Salva caricamento",
    "profileDocuments.categoryEmpty": "Nessun documento in questa sezione.",
    "profileDocuments.trashTitle": "Cestino documenti",
    "profileDocuments.trashCount": "{count} elementi",
    "profileDocuments.trashBody": "I documenti eliminati restano recuperabili per 30 giorni, poi vengono cancellati definitivamente.",
    "profileDocuments.trashDays": "Eliminazione definitiva tra {days} giorni",
    "profileDocuments.movedToTrash": "Documento spostato nel cestino.",
    "profileDocuments.restored": "Documento ripristinato.",
    "profileDocuments.deleteForever": "Elimina definitivamente",
    "profileDocuments.deleteForeverConfirm": "Eliminare definitivamente questo documento? L’operazione non può essere annullata.",
    "profileDocuments.openError": "Non è stato possibile aprire il documento dal cloud.",
    "profileDocuments.type.healthCard": "Tessera sanitaria",
    "profileDocuments.type.visa": "Visto",
    "profileDocuments.type.other": "Altro",
    "hotels.subtitle": "Hotel, prenotazioni e soggiorni del viaggio.",
    "hotels.add": "Aggiungi hotel",
    "hotels.name": "Nome struttura",
    "hotels.city": "Città",
    "hotels.address": "Indirizzo",
    "hotels.checkIn": "Check-in",
    "hotels.checkOut": "Check-out",
    "hotels.bookingReference": "Codice prenotazione",
    "hotels.notes": "Note",
    "hotels.empty": "Nessun hotel",
    "hotels.emptyBody": "Aggiungi le strutture in cui soggiornerai durante il viaggio.",
    "hotels.bookedWith": "Prenotato con",
    "hotels.bookedWithNone": "Non specificato",
    "hotels.bookedWithOther": "Nome del servizio",
    "hotels.hotelSite": "Sito dell’hotel",
    "hotels.agency": "Agenzia di viaggio",
    "hotels.phone": "Telefono",
    "hotels.providerBooking": "Booking.com",
    "hotels.providerExpedia": "Expedia",
    "hotels.providerAgoda": "Agoda",
    "restaurants.subtitle": "Ristoranti, prenotazioni e pasti del viaggio.",
    "restaurants.add": "Aggiungi ristorante",
    "restaurants.name": "Nome ristorante",
    "restaurants.city": "Città",
    "restaurants.address": "Indirizzo",
    "restaurants.date": "Data",
    "restaurants.time": "Ora",
    "restaurants.reservationWith": "Prenotato con",
    "restaurants.reservationNone": "Non specificato",
    "restaurants.reservationOther": "Nome del servizio",
    "restaurants.restaurantSite": "Sito del ristorante",
    "restaurants.phone": "Telefono",
    "restaurants.providerTheFork": "TheFork",
    "restaurants.providerOpenTable": "OpenTable",
    "restaurants.providerGoogle": "Google",
    "restaurants.bookingReference": "Codice prenotazione",
    "restaurants.notes": "Note",
    "restaurants.empty": "Nessun ristorante",
    "restaurants.emptyBody": "Aggiungi i ristoranti che vuoi visitare durante il viaggio.",
    "places.autofillTitle": "Compila dalla mappa",
    "places.autofillBody": "Cerca una struttura esistente e lascia che Mundely compili nome, città e indirizzo.",
    "places.chooseFromMap": "Scegli dalla mappa",
    "places.pickerEyebrow": "Ricerca Google Maps",
    "places.pickerTitle": "Cerca sulla mappa",
    "places.pickerBody": "Cerca su Google Maps e seleziona il risultato corretto.",
    "places.searchPlaceholder": "Nome del luogo",
    "places.searchCityPlaceholder": "Nome della città",
    "places.searchHotelPlaceholder": "Nome dell’hotel",
    "places.searchRestaurantPlaceholder": "Nome del ristorante",
    "places.googleFallback": "Google Maps non è disponibile in questo momento. Mundely sta usando temporaneamente la ricerca alternativa.",
    "places.googleNotConfigured": "Google Maps non è ancora configurato. Mundely sta usando temporaneamente la ricerca alternativa.",
    "places.search": "Cerca",
    "places.searching": "Ricerca…",
    "places.minRating": "Punteggio minimo",
    "places.anyRating": "Qualsiasi",
    "places.searchError": "Non è stato possibile cercare i luoghi. Riprova.",
    "places.searchNoResults": "Nessun risultato trovato. Controlla il nome e riprova.",
    "places.searchHint": "Inserisci il nome del luogo per iniziare.",
    "places.mapPreview": "Anteprima mappa",
    "places.mapEmpty": "Seleziona un risultato per visualizzarlo sulla mappa.",
    "places.usePlace": "Usa questo luogo",
    "places.sectionSubtitle": "Indica le città che visiterai durante il viaggio.",
    "places.addPlace": "Aggiungi città",
    "places.selectedPlace": "Città selezionata",
    "places.selectedPlaceBody": "Mundely ha compilato i dati della città da Google Maps. Puoi aggiungere date, note e scegliere l’immagine.",
    "places.changePlace": "Cambia città",
    "places.placeName": "Città",
    "places.city": "Città",
    "places.address": "Localizzazione",
    "places.startDate": "Data inizio",
    "places.endDate": "Data fine",
    "places.notes": "Note",
    "places.previewImage": "Immagine di anteprima",
    "places.previewImageBody": "Mundely usa la foto di Google Maps come predefinita. Puoi sceglierne un’altra prima di salvare.",
    "places.photoLoading": "Caricamento foto…",
    "places.photoUnavailable": "Nessuna foto disponibile su Google Maps per questo luogo.",
    "places.photoAttribution": "Foto:",
    "places.choosePreviewImage": "Scegli l’immagine di anteprima",
    "places.choosePhotoNumber": "Scegli foto {number}",
    "places.uploadCustomPhoto": "Carica una tua foto",
    "places.uploadCustomPhotoBody": "Puoi sostituire l’immagine Google Maps con una foto personale. Mundely la ottimizza automaticamente per l’anteprima.",
    "places.choosePhotoFile": "Scegli foto",
    "places.customPhotoTitle": "Foto personalizzata",
    "places.customPhotoBody": "Questa foto sostituisce l’anteprima di Google Maps.",
    "places.changeCustomPhoto": "Cambia foto",
    "places.useGooglePhoto": "Usa foto Google Maps",
    "places.customPhotoLoading": "Preparazione foto…",
    "places.customPhotoInvalid": "Seleziona un file immagine valido.",
    "places.customPhotoError": "Non è stato possibile preparare la foto. Riprova con un’altra immagine.",
    "places.empty": "Nessuna città salvata",
    "places.emptyBody": "Aggiungi la prima città da visitare cercandola su Google Maps.",
    "poi.sectionSubtitle": "Esplora i luoghi di interesse delle città del viaggio, seleziona quelli da visitare e organizzali per giorno.",
    "poi.noCities": "Aggiungi prima una città",
    "poi.noCitiesBody": "I luoghi di interesse vengono organizzati in base alle città salvate nella sezione Città.",
    "poi.chooseCity": "Scegli la città",
    "poi.loading": "Ricerca dei luoghi di interesse…",
    "poi.error": "Non è stato possibile trovare luoghi di interesse per questa città. Riprova più tardi.",
    "poi.chooseFromMap": "Scegli dalla mappa",
    "poi.suggestionsTitle": "Suggerimenti per questa città",
    "poi.suggestionsBody": "Luoghi consigliati da esplorare a {city}. Selezionali oppure visualizzali sulla mappa.",
    "poi.selectedPlaces": "Luoghi selezionati",
    "poi.selectedPlacesBody": "I luoghi che hai scelto di visitare in questa città.",
    "poi.otherPlaces": "Altri luoghi",
    "poi.otherPlacesBody": "Altri punti di interesse suggeriti per questa città.",
    "poi.noSelectedPlaces": "Non hai ancora selezionato luoghi di interesse per questa città.",
    "poi.noOtherPlaces": "Non ci sono altri luoghi da mostrare in questo momento.",
    "poi.selectPlace": "Seleziona",
    "poi.showOnMap": "Mostra sulla mappa",
    "poi.mapPreview": "Mappa dei luoghi di interesse",
    "poi.mapSelectedLegend": "Luoghi selezionati sulla mappa",
    "poi.mapSelectedLegendBody": "Sono visibili {count} luoghi selezionati per questa città.",
    "poi.openGoogleMaps": "Apri Google Maps",
    "poi.day": "Giorno",
    "poi.notes": "Note",
    "poi.notesPlaceholder": "Aggiungi note, orari o dettagli utili…",
    "poi.getMoreInfo": "Ottieni più informazioni",
    "poi.researching": "Ricerca in corso…",
    "poi.moreInfoTitle": "Informazioni aggiuntive",
    "poi.aiDisabled": "La ricerca con l’agente GPT non è attiva per questo account.",
    "poi.aiUnavailable": "La ricerca con l’agente GPT non è disponibile in questo momento.",
    "poi.aiPrompt": "Cerca informazioni aggiornate e utili per un viaggiatore su {name}, all’indirizzo {address}, nella città di {city}. Spiega cos’è, perché vale la pena visitarlo, orari o modalità di visita se disponibili, costi indicativi, tempo consigliato, curiosità, consigli pratici e possibili criticità. Sii sintetico e segnala quando un dato può cambiare.",
    "checklist.sectionSubtitle": "Organizza tutto ciò che devi preparare e controlla a colpo d’occhio cosa manca.",
    "checklist.addItem": "Aggiungi voce",
    "checklist.progressTitle": "Avanzamento checklist",
    "checklist.progressBody": "{done} di {total} completate",
    "checklist.itemTitle": "Cosa devi fare",
    "checklist.itemPlaceholder": "Es. Fare check-in online",
    "checklist.category": "Categoria",
    "checklist.category.action": "Azione",
    "checklist.category.booking": "Prenotazione",
    "checklist.category.documents": "Documenti",
    "checklist.category.luggage": "Bagaglio",
    "checklist.category.health": "Salute",
    "checklist.category.bookings": "Prenotazioni",
    "checklist.category.other": "Altro",
    "checklist.notes": "Note",
    "checklist.date": "Data",
    "checklist.listsLabel": "Checklist del viaggio",
    "checklist.defaultListName": "Checklist principale",
    "checklist.newListPlaceholder": "Nome nuova checklist",
    "checklist.createList": "Crea checklist",
    "checklist.chooseList": "Checklist attiva",
    "checklist.newListButton": "Nuova checklist",
    "checklist.listName": "Nome checklist",
    "checklist.deleteList": "Elimina checklist",
    "checklist.notesPlaceholder": "Aggiungi dettagli utili…",
    "checklist.filterLabel": "Filtra checklist",
    "checklist.filter.all": "Tutte",
    "checklist.filter.pending": "Da fare",
    "checklist.filter.completed": "Completate",
    "checklist.addStarter": "Aggiungi suggerimenti base",
    "checklist.empty": "Checklist vuota",
    "checklist.emptyBody": "Aggiungi le attività da completare oppure usa i suggerimenti base di Mundely.",
    "checklist.noFilteredItems": "Nessuna voce in questo filtro",
    "checklist.noFilteredItemsBody": "Cambia filtro per visualizzare le altre voci della checklist.",
    "checklist.markCompleted": "Segna come completata",
    "checklist.markPending": "Segna come da fare",
    "checklist.starter.passport": "Controllare passaporto e documenti",
    "checklist.starter.insurance": "Salvare assicurazione di viaggio",
    "checklist.starter.chargers": "Preparare caricabatterie e adattatori",
    "checklist.starter.medicines": "Preparare farmaci personali",
    "checklist.starter.hotel": "Controllare prenotazioni hotel",
    "checklist.starter.transport": "Controllare voli e trasferimenti",
    "notes.subtitle": "Appunti personali legati a questo viaggio.",
    "notes.add": "Nuovo appunto",
    "notes.title": "Titolo",
    "notes.content": "Testo",
    "notes.empty": "Nessun appunto",
    "notes.emptyBody": "Scrivi il primo appunto del viaggio.",
    "notes.untitled": "Senza titolo",
    "home.nextTrip": "Prossimo viaggio",
    "home.quickActions": "Azioni rapide",
    "home.notifications": "Notifiche",
    "home.modular": "Dashboard modulare",
    "home.modularBody": "I widget potranno essere aggiunti, rimossi e riordinati senza cambiare la struttura della Home.",
    "trips.title": "I tuoi viaggi",
    "trips.empty": "Non hai ancora creato viaggi.",
    "trips.create": "Crea il primo viaggio",
    "map.title": "Mappa",
    "map.placeholder": "La mappa interattiva verrà collegata qui.",
    "map.tripSubtitle": "Visualizza insieme città, hotel, ristoranti e luoghi di interesse del viaggio.",
    "map.filters": "Filtri mappa",
    "map.filter.cities": "Città",
    "map.filter.hotels": "Hotel",
    "map.filter.restaurants": "Ristoranti",
    "map.filter.poi": "Punti di interesse",
    "map.loadError": "Non è stato possibile caricare la mappa.",
    "map.empty": "Nessun punto da mostrare",
    "map.emptyBody": "Aggiungi città, hotel, ristoranti o luoghi di interesse per visualizzarli sulla mappa del viaggio.",
    "ai.title": "Mundely",
    "ai.placeholder": "Chiedi qualsiasi cosa sul tuo viaggio.",
    "ai.eyebrow": "Agente di viaggio AI",
    "ai.subtitle": "Conosce i dati salvati in Mundely e ti aiuta a pianificare, controllare e migliorare il viaggio.",
    "ai.newChat": "Nuova chat",
    "ai.tripContext": "Viaggio su cui lavorare",
    "ai.generalContext": "Consulenza di viaggio generale",
    "ai.tripConnected": "Viaggio collegato",
    "ai.tripConnectedBody": "L’agente usa i dati già presenti nelle sezioni del viaggio come contesto.",
    "ai.generalConnected": "Modalità generale",
    "ai.generalConnectedBody": "Nessun viaggio specifico: puoi chiedere informazioni e consigli di viaggio generali.",
    "ai.readyTrip": "Sono pronto a lavorare su {trip}",
    "ai.readyGeneral": "Sono pronto ad aiutarti a viaggiare",
    "ai.readyBody": "Scrivi una richiesta oppure parti da uno di questi suggerimenti.",
    "ai.starter.review": "Controlla il viaggio e dimmi cosa manca",
    "ai.starter.dayPlan": "Organizza meglio le giornate del viaggio",
    "ai.starter.food": "Suggeriscimi cosa mangiare e dove cercarlo",
    "ai.starter.practical": "Dammi i consigli pratici più importanti",
    "ai.you": "Tu",
    "ai.placeholderTrip": "Chiedi qualcosa su {trip}…",
    "ai.placeholderGeneral": "Chiedi qualsiasi cosa sul tuo prossimo viaggio…",
    "ai.send": "Invia",
    "ai.disclaimer": "Mundely usa i dati del viaggio disponibili nell’app. Informazioni soggette a variazioni vanno sempre verificate prima di prenotare o partire.",
    "ai.unavailable": "L’agente AI non è disponibile in questo ambiente o per questo account.",
    "ai.error": "Non è stato possibile contattare l’agente AI. Riprova tra poco.",
    "profile.title": "Profilo",
    "profile.account": "Account",
    "profile.accountBody": "Gestisci username ed email del tuo account.",
    "profile.changePhoto": "Modifica foto profilo",
    "profile.photoTitle": "Foto profilo",
    "profile.photoBody": "Scegli una foto, spostala e usa lo zoom per ottenere il ritaglio che preferisci.",
    "profile.photoChooseHint": "Scegli una foto per aprire l’editor di ritaglio.",
    "profile.savePhoto": "Salva foto",
    "profile.photoSaved": "Foto profilo aggiornata.",
    "profile.preferences": "Preferenze",
    "profile.security": "Sicurezza",
    "profile.devices": "Dispositivi",
    "profile.data": "Dati e privacy",
    "profile.plan": "Piano",
    "profile.free": "Gratis",
    "profile.premium": "Completo",
    "profile.export": "Esporta i miei dati",
    "profile.dataImportTitle": "Importa dati",
    "profile.dataImportBody": "Importa i viaggi da un file CSV o Excel (.xlsx).",
    "profile.dataImportChoose": "Scegli CSV o Excel",
    "profile.dataImportSuccess": "Importati {count} viaggi.",
    "profile.dataImportInvalid": "Il file non contiene righe di viaggio valide.",
    "profile.dataImportRowIssue": "Riga {row}: {reason}",
    "profile.dataImportDateIssue": "data non valida.",
    "profile.dataImportRangeIssue": "la data di ritorno precede la partenza.",
    "profile.dataImportDuplicateIssue": "lo stesso viaggio è presente più volte nel file.",
    "profile.dataImportAmbiguousIssue": "più viaggi corrispondono alla riga: specifica un ID univoco.",
    "profile.dataImportSharedIssue": "non puoi modificare un viaggio di un altro proprietario.",
    "profile.dataImportIdIssue": "ID viaggio non valido.",
    "profile.dataImportStatusIssue": "stato non riconosciuto. Usa planning, upcoming, active o completed.",
    "profile.dataImportPartialIssue": "Importazione interrotta dopo {count} viaggi salvati. Controlla i risultati prima di riprovare.",
    "profile.dataImportAccountIssue": "Account cambiato: importazione interrotta.",
    "profile.dataImportPreserveHint": "Gli ID identificano i viaggi da aggiornare. Senza ID viene cercata una corrispondenza per nome, destinazione e date. Le celle vuote conservano i valori esistenti; foto e sezioni restano invariate.",
    "profile.dataMapTitle": "Mappa le colonne",
    "profile.dataMapBody": "Abbina le colonne del file ai campi Mundely prima di importare, come in fAInance.",
    "profile.dataMapIgnore": "Non importare",
    "profile.dataMapName": "Nome viaggio",
    "profile.dataMapDestination": "Destinazione",
    "profile.dataMapStart": "Data di partenza",
    "profile.dataMapEnd": "Data di ritorno",
    "profile.dataMapStatus": "Stato",
    "profile.dataMapPreview": "Anteprima",
    "profile.dataMapImport": "Importa",
    "profile.dataExportTitle": "Esporta dati",
    "profile.dataExportBody": "Scarica i tuoi viaggi in CSV o Excel.",
    "profile.dataExportCsv": "CSV",
    "profile.dataExportExcel": "Excel",
    "profile.dataExportReady": "Esportati {count} viaggi.",
    "profile.dataTripCount": "{count} viaggi di tua proprietà",
    "profile.dataWorldExportTitle": "Esporta Il mio mondo",
    "profile.dataWorldExportBody": "Scegli se esportare le nazioni visitate, le città visitate o entrambe. Puoi scaricarle in CSV o Excel.",
    "profile.dataWorldCountries": "Nazioni visitate",
    "profile.dataWorldCities": "Città visitate",
    "profile.dataWorldExportReady": "Dati de Il mio mondo esportati.",
    "profile.dataWorldCountry": "Nazione",
    "profile.dataWorldCity": "Città",
    "profile.dataWorldStatus": "Stato",
    "profile.dataWorldFeedback": "Feedback",
    "profile.dataWorldCountriesSheet": "Nazioni visitate",
    "profile.dataWorldCitiesSheet": "Città visitate",
    "profile.dataBackupTitle": "Backup dei dati",
    "profile.dataBackupBody": "Scarica rapidamente il JSON con profilo, viaggi e impostazioni oppure il backup completo ZIP con allegati. Il JSON non contiene i file: per ripristinarlo, gli allegati devono essere ancora nel cloud.",
    "profile.dataBackupJsonDownload": "Scarica backup JSON",
    "profile.dataBackupJsonSaved": "Backup JSON salvato nella destinazione selezionata.",
    "profile.dataBackupJsonTimeout": "Il backup JSON non ha risposto entro 90 secondi. Riprova quando la connessione è stabile.",
    "profile.dataBackupElapsed": "Tempo trascorso: {time}",
    "profile.dataBackupKeepOpen": "Preparazione del backup in corso. Lascia aperta questa schermata fino al salvataggio.",
    "profile.dataBackupProgressFiles": "File completati: {current}/{total}",
    "profile.dataBackupDownload": "Scarica backup completo ZIP",
    "profile.dataBackupRestore": "Ripristina backup",
    "profile.dataBackupPending": "Completa la sincronizzazione delle modifiche e dei file prima di ripristinare il backup.",
    "profile.dataBackupChanged": "I dati sono cambiati durante il backup. Riprova per salvarne una copia coerente.",
    "profile.dataBackupDamaged": "Il backup contiene un file mancante o alterato. Il ripristino non è stato avviato.",
    "profile.dataBackupTooLarge": "Il backup supera i limiti supportati: 15 MB per file e 2 GB complessivi.",
    "profile.dataBackupReady": "Backup pronto. Scegli dove salvarlo.",
    "profile.dataBackupWorkingCollecting": "Preparazione dei dati…",
    "profile.dataBackupWorkingAttachments": "Recupero degli allegati…",
    "profile.dataBackupWorkingSaving": "Backup pronto: scegli dove salvarlo…",
    "profile.dataBackupSaved": "Backup salvato nella destinazione selezionata.",
    "profile.dataBackupSaveFailed": "Non è stato possibile salvare il backup nella destinazione selezionata. Riprova oppure scegli una cartella sul telefono.",
    "profile.dataBackupAttachmentsFailed": "Impossibile recuperare l’allegato {current} di {total} dal cloud. Riprova con una connessione stabile. Nessun backup incompleto è stato salvato.",
    "profile.dataBackupImportJson": "Carica backup JSON",
    "profile.dataBackupImportZip": "Carica backup ZIP",
    "profile.dataBackupImportConfirmTitle": "Importa backup",
    "profile.dataBackupImportConfirmBody": "Controlla il file prima di ripristinare i dati del tuo account.",
    "profile.dataBackupImportContents": "Il file contiene {trips} viaggi, {documents} documenti e {sections} sezioni del viaggio.",
    "profile.dataBackupEmptyFile": "Il file selezionato è vuoto. Attendi che il salvataggio o il download termini e seleziona la copia completa.",
    "profile.dataBackupZipPhotos": "Foto dei viaggi: {travel}. Foto personali: {personal}. Copertine: {covers}. Allegati verificati: {files}.",
    "profile.dataBackupZipOtherAccount": "Questo backup proviene da un altro account. Viaggi, profilo, foto e allegati saranno copiati nel tuo account. Gli accessi e le condivisioni originali non vengono trasferiti. I dati già presenti possono essere aggiornati.",
    "profile.dataBackupImportZipContents": "Archivio ZIP completo. Il contenuto e gli allegati saranno verificati prima del ripristino.",
    "profile.dataBackupImportWarning": "Le informazioni con lo stesso identificativo saranno aggiornate. I dati non presenti nel backup non saranno eliminati. Gli allegati non inclusi nel JSON devono essere ancora disponibili nel cloud. L’operazione può modificare i dati esistenti.",
    "profile.dataBackupImportConfirm": "Conferma ripristino",
    "profile.dataBackupProgressTitle": "Ripristino in corso",
    "profile.dataBackupProgressEstimated": "Progresso effettivo delle scritture confermate dal server. Non chiudere l’app durante il ripristino.",
    "profile.dataBackupProgressScanTitle": "Controllo del backup",
    "profile.dataBackupProgressScanBody": "Stiamo verificando il file selezionato e preparando i dati da importare.",
    "profile.dataBackupProgressCompareTitle": "Verifica dei dati importati",
    "profile.dataBackupProgressCompareBody": "Il server controlla che i viaggi previsti siano stati scritti correttamente.",
    "profile.dataBackupProgressApplyTitle": "Applicazione delle modifiche",
    "profile.dataBackupProgressApplyBody": "I viaggi e le impostazioni compatibili vengono aggiornati in sicurezza.",
    "profile.dataBackupProgressFinishTitle": "Finalizzazione",
    "profile.dataBackupProgressFinishBody": "Stiamo completando gli ultimi passaggi e salvando il risultato finale.",
    "profile.dataBackupModeMerge": "Integra",
    "profile.dataBackupModeAdd": "Aggiungi solo nuovi",
    "profile.dataBackupAddWarning": "Aggiunge soltanto viaggi non presenti. Non modifica viaggi, sezioni, foto o impostazioni esistenti.",
    "profile.dataBackupFullSourceRequired": "Questa sorgente non contiene tutti i file richiesti per un ripristino completo verificato.",
    "profile.dataBackupModeReplace": "Sostituisci dati",
    "profile.dataBackupProgressWrites": "Operazioni confermate: {current}/{total}",
    "profile.dataBackupEmptyReplaceBlocked": "Il backup contiene zero viaggi. Per evitare un’operazione distruttiva involontaria, Sostituisci è bloccato per questo file.",
    "profile.dataBackupVerificationFailed": "Il server non ha confermato il risultato del ripristino. Verifica l’account prima di riprovare; non sono state dichiarate importazioni riuscite.",
    "profile.dataBackupVerifiedResult": "Importazione verificata: {total} viaggi presenti nell'account ({created} aggiunti, {updated} aggiornati).",
    "profile.dataBackupLocalRefreshFailed": "Il server ha completato il trasferimento, ma il telefono non ha aggiornato la lista locale. Riapri la sezione Viaggi e verifica i dati prima di riprovare.",
    "profile.dataBackupOtherAccount": "Questo backup proviene da un altro account Mundely. I viaggi saranno copiati nel tuo account senza trasferire autorizzazioni o allegati cloud.",
    "profile.dataBackupSameAccount": "Scegli come trasferire i dati di questo backup nel tuo account.",
    "profile.dataBackupTransferFilesWarning": "Il JSON contiene {count} riferimenti a documenti: i file non sono inclusi e non verranno copiati. I documenti già presenti nel tuo account resteranno invariati.",
    "profile.dataBackupDeliveredZipPhotos": "Questo ZIP contiene foto esterne al backup JSON: i file immagine non saranno caricati su Firebase. Le foto già presenti sul tuo account saranno conservate; verifica le foto dei nuovi viaggi dopo l'importazione.",
    "profile.dataBackupReconcileResult": "Backup importato: {created} viaggi aggiunti, {updated} viaggi aggiornati senza duplicarli.",
    "profile.dataBackupExistingDuplicates": "Rilevati {count} possibili doppioni già presenti: non sono stati cancellati automaticamente per proteggere i dati.",
    "profile.dataBackupMergeWarning": "Integra aggiunge i viaggi del backup, senza eliminare quelli esistenti; aggiorna solo le preferenze consentite del profilo.",
    "profile.dataBackupReplaceWarning": "Sostituisce i viaggi e le sezioni con i dati del JSON; rimuove i viaggi non presenti. Documenti e file cloud non inclusi nel JSON non vengono importati né eliminati automaticamente. I viaggi condivisi o collegati a fAInance bloccano l’operazione.",
    "profile.dataBackupReplaceCheck": "Confermo di voler sostituire i dati del mio account con quelli del backup.",
    "profile.dataBackupTransferTooMany": "Il backup contiene troppi record per una sostituzione atomica sicura. Nessun dato è stato modificato.",
    "profile.dataBackupSharedTripBlocked": "Non puoi sostituire viaggi già condivisi con altri utenti o collegati a fAInance. Nessun dato è stato modificato. Usa Integra oppure interrompi prima quei collegamenti.",
    "profile.dataBackupRestored": "Backup ripristinato: {trips} viaggi.",
    "profile.dataBackupInvalid": "Il file non è un backup Mundely valido.",
    "profile.dataTransferError": "Non è stato possibile completare l’operazione sui dati.",
    "profile.deleteAccount": "Elimina account",
    "profile.deleteInfo": "La cancellazione prevede 15 giorni di ripensamento.",
    "profile.changeUsername": "Cambia username",
    "profile.recoveryPremium": "Cestino e versioning sono disponibili con Premium.",
    "profile.connectedDevices": "Dispositivi collegati",
    "profile.signOutOthers": "Disconnetti tutti gli altri dispositivi",
    "profile.personalData": "Dati personali",
    "profile.publicProfileSection": "Profilo pubblico",
    "profile.personalDataBody": "Gestisci le informazioni del tuo profilo Mundely.",
    "profile.publicWorldTitle": "Profilo viaggiatore pubblico",
    "profile.publicWorldBody": "Scegli quali informazioni de Il mio mondo rendere visibili nel tuo profilo pubblico.",
    "profile.publicShowCountries": "Mostra nazioni visitate",
    "profile.publicShowCities": "Mostra città visitate",
    "profile.publicShowLived": "Mostra dove hai vissuto",
    "profile.publicShowStats": "Mostra statistiche di viaggio",
    "profile.publicShowReviews": "Mostra recensioni pubbliche",
    "profile.publicWorldSaved": "Preferenze del profilo pubblico aggiornate.",
    "profile.publicVisitedCities": "Città visitate",
    "profile.publicLivedCountries": "Dove ha vissuto",
    "profile.publicReviews": "Recensioni pubbliche",
    "world.eyebrow": "Profilo viaggiatore",
    "world.infoLabel": "Informazioni",
    "world.title": "Il mio mondo",
    "world.subtitle": "Tieni traccia delle nazioni e delle città che hai visitato o in cui hai vissuto. La mappa e le statistiche si aggiornano automaticamente.",
    "world.tabsLabel": "Sezioni Il mio mondo",
    "world.tabMap": "Mappa del mondo",
    "world.tabCountries": "Nazioni",
    "world.tabCities": "Città",
    "world.tabStats": "Statistiche",
    "world.countriesShort": "nazioni",
    "world.citiesShort": "città",
    "world.worldShort": "del mondo",
    "world.statusLabel": "Stato della visita",
    "world.statusVisited": "Visitata",
    "world.statusLived": "Vissuto",
    "world.statusNone": "Non visitata",
    "world.mapTitle": "La tua mappa del mondo",
    "world.mapBody": "Le nazioni cambiano colore in base alla tua esperienza personale.",
    "world.legendLabel": "Legenda della mappa",
    "world.mapHint": "Tocca o clicca una nazione per aprire il suo dettaglio, aggiungere un feedback e vedere le città collegate.",
    "world.mapUnavailable": "La mappa del mondo non è disponibile in questo momento. Nazioni, città e statistiche restano comunque accessibili.",
    "world.countriesTitle": "Nazioni",
    "world.countriesBody": "Sfoglia le nazioni per continente, imposta quelle visitate o in cui hai vissuto e conserva un feedback personale.",
    "world.chooseCountry": "Scegli una nazione",
    "world.limitedRecognition": "riconoscimento limitato",
    "world.specialStatus": "statuto speciale / territorio autonomo",
    "world.addCountry": "Aggiungi",
    "world.searchCountries": "Cerca una nazione",
    "world.noCountries": "Nessuna nazione ancora aggiunta",
    "world.noCountriesBody": "Aggiungi la prima nazione oppure selezionala direttamente dalla mappa.",
    "world.countryDetails": "Dettaglio nazione",
    "world.countryDetailsBody": "Imposta lo stato, annota il tuo feedback e consulta le città collegate.",
    "world.feedback": "Feedback personale",
    "world.privateNote": "Nota privata",
    "world.privateNotePlaceholder": "Aggiungi un ricordo o una nota visibile solo a te.",
    "world.publicReview": "Recensione pubblica",
    "world.saveReview": "Salva recensione",
    "world.publicReviewBody": "La recensione è pubblica e può essere trovata dagli altri viaggiatori.",
    "world.communityReviews": "Recensioni della community",
    "world.communityReviewsBody": "Leggi le esperienze degli altri viaggiatori e vota quelle che trovi utili.",
    "world.communitySortLabel": "Ordina recensioni",
    "world.communityMostHelpful": "Più utili",
    "world.communityMostRecent": "Più recenti",
    "world.communityHelpful": "Utile",
    "world.communityNotHelpful": "Non utile",
    "world.communityOwnReview": "La tua recensione",
    "world.communityNoReviews": "Non ci sono ancora altre recensioni per questa destinazione.",
    "world.communityTraveller": "Viaggiatore",
    "world.communityVoteFailed": "Non è stato possibile registrare il voto. Riprova.",
    "community.tripReviews": "Community",
    "community.tripReviewsBody": "{count} recensioni Mundely per questo luogo.",
    "community.yourReview": "La tua recensione",
    "community.yourReviewBody": "Condividi la tua esperienza: contribuirà ai consigli della community e al tuo punteggio viaggiatore.",
    "community.reviewPlaceholder": "Cosa consiglieresti agli altri viaggiatori?",
    "community.deleteReview": "Elimina recensione",
    "community.noPlaceReviews": "Non ci sono ancora recensioni Mundely per questo luogo.",
    "community.stats.reviews": "Recensioni",
    "community.stats.average": "Media",
    "community.stats.helpful": "Voti utili",
    "community.mostHelpfulBadge": "Più utile",
    "community.reviewSaveFailed": "Non è stato possibile salvare la recensione. Riprova.",
    "world.publicReviewPlaceholder": "Scrivi una recensione utile agli altri viaggiatori.",
    "world.rating": "Valutazione",
    "world.ratingValue": "{value} stelle su 5",
    "world.publishReview": "Rendi pubblica questa recensione",
    "world.countryFeedbackPlaceholder": "Cosa ti è piaciuto? Cosa ricordi di questa nazione?",
    "world.cityCount": "{count} città",
    "world.citiesInCountry": "Città visitate",
    "world.citiesInCountryBody": "L'elenco si aggiorna automaticamente quando aggiungi o modifichi una città.",
    "world.noCitiesForCountry": "Non hai ancora aggiunto città per questa nazione.",
    "world.removeCountry": "Rimuovi nazione",
    "world.removeCountryBlocked": "Per rimuovere questa nazione devi prima eliminare le città collegate.",
    "world.countrySaved": "Nazione aggiornata.",
    "world.countryRemoved": "Nazione rimossa.",
    "world.addCity": "Aggiungi una città",
    "world.editCity": "Modifica città",
    "world.cityEditorBody": "Una città aggiunta aggiorna automaticamente anche la relativa nazione.",
    "world.cityName": "Nome città",
    "world.country": "Nazione",
    "world.cityFeedbackPlaceholder": "Aggiungi un ricordo, un giudizio o una nota personale sulla città.",
    "world.cityCountrySyncHint": "Se la nazione non è ancora presente, Mundely la aggiunge automaticamente. Una città in cui hai vissuto imposta la nazione come vissuta.",
    "world.myCities": "Le mie città",
    "world.myCitiesBody": "Tutte le città visitate o vissute, collegate in tempo reale alle rispettive nazioni.",
    "world.noCities": "Nessuna città ancora aggiunta",
    "world.noCitiesBody": "Inserisci la prima città per iniziare a costruire la tua storia di viaggio.",
    "world.citySaved": "Città aggiornata.",
    "world.cityRemoved": "Città rimossa.",
    "world.statsTitle": "Le tue statistiche di viaggio",
    "world.statsBody": "Una vista sintetica del mondo che hai esplorato finora.",
    "world.statCountries": "Nazioni visitate",
    "world.statLived": "Nazioni vissute",
    "world.statLivedBody": "nazioni in cui hai vissuto",
    "world.statCities": "Città",
    "world.statCitiesBody": "città registrate",
    "world.statTerritory": "Territorio esplorato",
    "world.statTerritoryBody": "quota stimata della superficie delle nazioni del mondo",
    "world.statTerritoryLoading": "calcolo disponibile quando la mappa geografica è caricata",
    "world.worldProgress": "Nazioni del mondo visitate",
    "world.continentAfrica": "Africa",
    "world.continentAsia": "Asia",
    "world.continentEurope": "Europa",
    "world.continentNorthAmerica": "Nord America",
    "world.continentSouthAmerica": "Sud America",
    "world.continentOceania": "Oceania",
    "world.searchCity": "Cerca città",
    "world.citySearchPlaceholder": "Cerca o inserisci una città",
    "world.citySearchHint": "Usa Cerca città per trovare la città con la stessa ricerca geografica usata nei viaggi; Mundely compila automaticamente la nazione quando il provider la restituisce.",
    "world.exportMap": "Esporta mappa",
    "world.exportCountries": "Esporta nazioni",
    "world.exportCities": "Esporta città",
    "world.exportPng": "PNG",
    "world.exportPdf": "PDF",
    "world.exportExcel": "Excel",
    "world.exportCsv": "CSV",
    "world.exportContinent": "Continente",
    "world.exportCountry": "Nazione",
    "world.exportCity": "Città",
    "world.exportStatus": "Stato",
    "world.exportFeedback": "Feedback",
    "world.exportReady": "Esportazione completata.",
    "world.exportFailed": "Non è stato possibile completare l'esportazione.",
    "world.downloadData": "Scarica Il mio mondo",
    "world.downloadShort": "Scarica",
    "world.downloadTitle": "Scarica Il mio mondo",
    "world.downloadBody": "Scegli uno o più contenuti da includere e scaricali insieme in un unico PDF o JPEG.",
    "world.downloadIncludeTitle": "Cosa vuoi includere?",
    "world.downloadIncludeMap": "Mappa",
    "world.downloadIncludeCountries": "Nazioni visitate",
    "world.downloadIncludeCities": "Città",
    "world.downloadIncludeStats": "Statistiche",
    "world.downloadFormatTitle": "Formato",
    "world.exportJpeg": "JPEG",
    "world.downloadAction": "Scarica Il mio mondo",
    "world.downloadSelectAtLeastOne": "Seleziona almeno un contenuto da scaricare.",
    "world.downloadMapBody": "Scarica la mappa con i tuoi colori e il logo Mundely.",
    "world.downloadCountriesBody": "Esporta l'elenco completo delle nazioni con continente, stato e feedback.",
    "world.downloadCitiesBody": "Esporta le città registrate con nazione, stato e feedback.",
    "world.exportStats": "Esporta statistiche",
    "world.downloadStatsBody": "Esporta le statistiche globali e quelle di ogni continente.",
    "world.continentAccordionHint": "Apri un continente alla volta per consultare le sue nazioni. La ricerca mostra direttamente i continenti con risultati.",
    "world.continentSummary": "{visited}/{total} visitate · {cities} città",
    "world.continentStatsTitle": "Statistiche per continente",
    "world.continentStatsBody": "Confronta nazioni visitate, nazioni in cui hai vissuto, città e territorio esplorato in ogni continente.",
    "world.exportScope": "Area",
    "world.worldLabel": "Mondo",
    "world.exportVisitedCountries": "Nazioni visitate",
    "world.exportLivedCountries": "Nazioni vissute",
    "world.exportCitiesCount": "Città",
    "world.exportCompletion": "Completamento",
    "profile.phone": "Telefono",
    "profile.phonePrefix": "Prefisso",
    "profile.phoneInvalid": "Numero di telefono non valido.",
    "profile.birthDate": "Data di nascita",
    "profile.gender": "Sesso",
    "profile.gender.M": "Maschile",
    "profile.gender.F": "Femminile",
    "profile.gender.X": "Non specificato",
    "profile.nationality": "Nazionalità",
    "profile.residenceCountry": "Nazione di residenza",
    "profile.region": "Provincia / Regione",
    "profile.city": "Città",
    "profile.address": "Indirizzo",
    "profile.job": "Lavoro",
    "profile.useReason": "Per cosa vuoi usare principalmente Mundely?",
    "profile.saved": "Profilo aggiornato.",
    "profile.changeEmail": "Cambia email",
    "profile.updateEmail": "Aggiorna email",
    "profile.emailVerificationSent": "Email di verifica inviata alla nuova email. Apri il link ricevuto per completare il cambio.",
    "profile.changePassword": "Cambia password",
    "profile.passwordBody": "Aggiorna la password usata per accedere a Mundely.",
    "profile.currentPassword": "Password attuale",
    "profile.newPassword": "Nuova password",
    "profile.updatePassword": "Aggiorna password",
    "profile.passwordChanged": "Password aggiornata.",
    "profile.recentLogin": "Per sicurezza, accedi nuovamente prima di eseguire questa operazione.",
    "profile.currentPasswordInvalid": "La password attuale non è corretta.",
    "profile.usernameChanged": "Username aggiornato.",
    "profile.usernameCooldown": "Lo username è stato cambiato di recente. Riprova al termine del periodo previsto.",
    "profile.devicesBody": "Controlla i dispositivi che hanno accesso al tuo account.",
    "profile.noDevices": "Nessun dispositivo registrato.",
    "profile.currentDevice": "Questo dispositivo",
    "profile.deviceActive": "Attivo",
    "profile.deviceRevoked": "Disconnesso",
    "profile.disconnect": "Disconnetti",
    "profile.exportQueued": "La richiesta di esportazione è stata registrata.",
    "profile.deleteWarning": "Richiesta di eliminazione account",
    "profile.deleteConfirmBody": "L’account verrà disattivato subito e potrai ripensarci per 15 giorni. Per confermare scrivi {keyword}.",
    "profile.deleteKeyword": "ELIMINA",
    "profile.scheduleDeletion": "Programma eliminazione",
    "profile.pendingDeletionTitle": "Account in fase di eliminazione",
    "profile.pendingDeletionBody": "La cancellazione è programmata. Hai 15 giorni dalla richiesta per ripristinare l’account e i tuoi dati.",
    "profile.restoreAccount": "Ripristina account",
    "auth.linkRequired": "Esiste già un account con questa email. Accedi con username e password per collegare il nuovo metodo di accesso.",
    "auth.linkCompleted": "Metodo di accesso collegato al tuo account.",
    "profile.job.employee": "Dipendente",
    "profile.job.manager": "Manager",
    "profile.job.consultant": "Consulente",
    "profile.job.freelancer": "Libero professionista",
    "profile.job.entrepreneur": "Imprenditore",
    "profile.job.merchant": "Commerciante",
    "profile.job.artisan": "Artigiano",
    "profile.job.education": "Insegnante / Formazione",
    "profile.job.healthcare": "Sanità",
    "profile.job.technology": "Tecnologia / IT",
    "profile.job.finance": "Finanza / Amministrazione",
    "profile.job.marketing": "Marketing / Comunicazione",
    "profile.job.sales": "Vendite",
    "profile.job.student": "Studente",
    "profile.job.retired": "Pensionato",
    "profile.job.unemployed": "Non occupato",
    "profile.job.other": "Altro",
    "profile.reason.planTrips": "Pianificare i viaggi",
    "profile.reason.organizeItinerary": "Organizzare itinerari e tappe",
    "profile.reason.keepBookings": "Tenere insieme le prenotazioni",
    "profile.reason.manageDocuments": "Gestire documenti di viaggio",
    "profile.reason.shareTrips": "Condividere viaggi",
    "profile.reason.discoverPlaces": "Scoprire luoghi ed esperienze",
    "profile.reason.trackExpenses": "Tenere sotto controllo le spese di viaggio",
    "profile.reason.useAi": "Ricevere aiuto dall’AI",
    "profile.reason.keepMemories": "Conservare foto e ricordi",
    "profile.reason.allInOne": "Tenere tutto in un’unica app",
    "profile.reason.other": "Altro",
    "itinerary.subtitle": "Organizza il viaggio giorno per giorno, con orari, tappe e spostamenti.",
    "itinerary.collectorBody": "Ogni giorno del viaggio raccoglie automaticamente hotel, spostamenti, esperienze, ristoranti, città, luoghi, clima, biglietti e foto.",
    "itinerary.twoWayTitle": "Itinerario bidirezionale",
    "itinerary.twoWayBody": "Le modifiche fatte nelle altre sezioni compaiono qui; le modifiche fatte qui aggiornano la sezione di origine.",
    "itinerary.timeline": "Timeline",
    "itinerary.timelineTitle": "Timeline temporale",
    "itinerary.timelineBody": "Vista cronologica di tutte le giornate e di ciò che è stato pianificato.",
    "itinerary.entry": "attività",
    "itinerary.entries": "attività",
    "itinerary.sourceType": "Tipo di elemento",
    "itinerary.source.manual": "Attività",
    "itinerary.source.transfer": "Spostamento",
    "itinerary.source.hotel": "Hotel",
    "itinerary.source.restaurant": "Ristorante",
    "itinerary.source.city": "Città",
    "itinerary.source.poi": "Luogo da visitare",
    "itinerary.source.experience": "Esperienza",
    "itinerary.source.event": "Evento",
    "itinerary.source.boardingPass": "Biglietto aereo",
    "itinerary.source.climate": "Clima",
    "itinerary.dayEmpty": "Nessun elemento pianificato per questa giornata.",
    "itinerary.photos": "Foto",
    "itinerary.searchMap": "Cerca sulla mappa",
    "itinerary.add": "Aggiungi tappa",
    "itinerary.mapTitle": "Collega una posizione reale",
    "itinerary.mapBody": "Puoi compilare città e indirizzo scegliendo un punto dalla mappa.",
    "itinerary.chooseMap": "Scegli dalla mappa",
    "itinerary.enterManually": "Inserisci manualmente",
    "itinerary.freeText": "Testo libero",
    "itinerary.placeName": "Nome del luogo",
    "itinerary.title": "Titolo",
    "itinerary.date": "Data",
    "itinerary.type": "Tipo",
    "itinerary.startTime": "Ora inizio",
    "itinerary.endTime": "Ora fine",
    "itinerary.city": "Città",
    "itinerary.address": "Indirizzo",
    "itinerary.notes": "Note",
    "itinerary.type.activity": "Attività",
    "itinerary.type.transfer": "Spostamento",
    "itinerary.type.meal": "Pasto",
    "itinerary.type.free": "Tempo libero",
    "itinerary.type.other": "Altro",
    "itinerary.empty": "Itinerario vuoto",
    "itinerary.emptyBody": "Aggiungi la prima tappa per iniziare a costruire le giornate del viaggio.",
    "itinerary.noDate": "Senza data",
    "itinerary.showDetails": "Aggiungi dettagli",
    "itinerary.hideDetails": "Nascondi dettagli",
    "itinerary.excel.import": "Importa Excel",
    "itinerary.excel.eyebrow": "Importazione itinerario",
    "itinerary.excel.title": "Carica itinerario da Excel",
    "itinerary.excel.body": "Importa in pochi secondi tutte le tappe del viaggio da un file Excel. Usa il modello Mundely per evitare errori di formato.",
    "itinerary.excel.downloadTemplate": "Scarica modello Excel",
    "itinerary.excel.templateSaved": "Modello salvato in Download/Mundely.",
    "itinerary.excel.templateDownloaded": "Modello Excel scaricato.",
    "itinerary.excel.templateError": "Non è stato possibile salvare il modello Excel. Riprova.",
    "itinerary.excel.chooseFile": "Scegli file Excel",
    "itinerary.excel.columns": "Colonne riconosciute: Titolo, Data, Ora inizio, Ora fine, Tipo, Città, Indirizzo, Note.",
    "itinerary.excel.imported": "Importate {count} tappe.",
    "itinerary.excel.error": "Non è stato possibile importare il file. Controlla che contenga almeno una colonna Titolo e riprova.",
    "itinerary.excel.header.title": "Titolo",
    "itinerary.excel.header.date": "Data",
    "itinerary.excel.header.startTime": "Ora inizio",
    "itinerary.excel.header.endTime": "Ora fine",
    "itinerary.excel.header.type": "Tipo",
    "itinerary.excel.header.city": "Città",
    "itinerary.excel.header.address": "Indirizzo",
    "itinerary.excel.header.notes": "Note",
    "itinerary.excel.sample.title": "Visita centro storico",
    "experiences.subtitle": "Attività, tour ed esperienze che vuoi fare durante il viaggio.",
    "experiences.add": "Aggiungi esperienza",
    "experiences.mapTitle": "Cerca l'esperienza sulla mappa",
    "experiences.mapBody": "Seleziona un luogo reale per compilare automaticamente città e indirizzo.",
    "experiences.chooseMap": "Scegli dalla mappa",
    "experiences.title": "Nome esperienza",
    "experiences.city": "Città",
    "experiences.address": "Indirizzo",
    "experiences.date": "Data",
    "experiences.time": "Ora",
    "experiences.place": "Luogo",
    "experiences.placePlaceholder": "Es. Colosseo, Tour operator, Spiaggia…",
    "experiences.price": "Prezzo",
    "experiences.currency": "Valuta",
    "experiences.notes": "Note",
    "experiences.empty": "Nessuna esperienza",
    "experiences.emptyBody": "Salva tour, attività e cose da fare per ritrovarle durante il viaggio.",
    "participants.subtitle": "Gestisci le persone che partecipano al viaggio.",
    "participants.add": "Aggiungi partecipante",
    "participants.notesPlaceholder": "Note opzionali",
    "participants.name": "Nome",
    "participants.email": "Email",
    "participants.role": "Ruolo",
    "participants.notes": "Note",
    "participants.role.owner": "Proprietario",
    "participants.role.traveller": "Viaggiatore",
    "participants.role.participant": "Partecipante",
    "participants.role.viewer": "Visualizzatore",
    "participants.rolesFixedHint": "I quattro ruoli hanno permessi fissi. Puoi rinominarli, ma i poteri associati non cambiano.",
    "participants.rolePower.owner": "Tutti i poteri e tutte le visibilità, inclusi partecipanti ed eliminazione del viaggio.",
    "participants.rolePower.traveller": "Tutti i poteri e tutte le visibilità, esclusi gestione partecipanti ed eliminazione del viaggio.",
    "participants.rolePower.participant": "Visibilità completa e modifica dei contenuti del viaggio, senza funzioni amministrative.",
    "participants.rolePower.viewer": "Visibilità completa in sola lettura.",
    "participants.empty": "Nessun partecipante",
    "participants.emptyBody": "Aggiungi le persone che prenderanno parte a questo viaggio.",
    "participants.identifier": "Username o email",
    "participants.identifierPlaceholder": "Inserisci username oppure email",
    "participants.identifierHint": "Se l’utente è già su Mundely riceverà un invito nell’app e una notifica. Se l’email non è registrata, verrà preparato un invito via email.",
    "participants.inviteFlowHint": "Il partecipante dovrà accettare o rifiutare l’invito. Riceverai una notifica con l’esito.",
    "participants.sendInvite": "Invia invito",
    "participants.sending": "Invio…",
    "participants.inviteSent": "Invito inviato nell’app.",
    "participants.emailInviteQueued": "Invito email preparato. Il destinatario lo riceverà tramite il servizio email configurato per Mundely.",
    "participants.inviteError": "Non è stato possibile inviare l’invito. Riprova.",
    "participants.userNotFound": "Username non trovato. Per invitare una persona non registrata usa il suo indirizzo email.",
    "participants.cannotInviteSelf": "Non puoi invitare il tuo stesso account.",
    "participants.refreshStatus": "Aggiorna stato",
    "participants.resendEmail": "Reinvia email",
    "participants.removeError": "Non è stato possibile rimuovere il partecipante.",
    "participants.status.pending": "Invito in attesa",
    "participants.status.accepted": "Accettato",
    "participants.status.declined": "Rifiutato",
    "participants.status.external": "Invito email",
    "participants.status.manual": "Partecipante",
    "participants.status.left": "Uscito dal viaggio",
    "participants.leftSection": "Partecipanti usciti",
    "participants.leaveTrip": "Esci dal viaggio",
    "participants.leaveTripTitle": "Uscire dal viaggio?",
    "participants.leaveTripBody": "Non avrai più accesso al viaggio. Il tuo nome resterà visibile nell’elenco dei partecipanti usciti.",
    "participants.leaveTripConfirm": "Esci dal viaggio",
    "participants.leaveError": "Non è stato possibile uscire dal viaggio. Riprova.",
    "participants.currentSection": "Partecipanti",
    "participants.currentEmpty": "Nessun partecipante ha ancora accettato l’invito.",
    "participants.sentSection": "Inviti inviati",
    "participants.sentEmpty": "Nessun invito in attesa.",
    "participants.declinedSection": "Inviti rifiutati",
    "participants.declinedEmpty": "Nessun invito rifiutato.",
    "share.exportHtml": "Esporta HTML",
    "share.exportJson": "Esporta JSON",
    "share.exportSaved": "File esportato nella cartella Download/Mundely.",
    "share.exportError": "Non è stato possibile esportare il file.",
    "notifications.title": "Centro notifiche",
    "notifications.empty": "Nessuna notifica.",
    "notifications.markRead": "Segna come letta",
    "notifications.tripInviteTitle": "Invito a un viaggio",
    "notifications.tripInviteBody": "Hai ricevuto un invito a partecipare a un viaggio.",
    "notifications.tripInviteAcceptedTitle": "Invito accettato",
    "notifications.tripInviteAcceptedBody": "Un partecipante ha accettato il tuo invito.",
    "notifications.tripInviteDeclinedTitle": "Invito rifiutato",
    "notifications.tripInviteDeclinedBody": "Un partecipante ha rifiutato il tuo invito.",
    "notifications.invitedBy": "Invitato da {name}",
    "notifications.acceptInvite": "Accetta",
    "notifications.declineInvite": "Rifiuta",
    "notifications.inviteResponseError": "Non è stato possibile registrare la risposta all’invito.",
    "notifications.details": "Dettagli",
    "notifications.role": "Ruolo: {role}",
    "notifications.dates": "Date",
    "notifications.acceptedPopup": "Hai accettato l’invito al viaggio.",
    "share.eyebrow": "CONDIVIDI ED ESPORTA",
    "share.title": "Scegli cosa mostrare",
    "share.body": "Prima di creare il link o esportare il viaggio, scegli quali informazioni includere.",
    "share.exportTitle": "Esporta viaggio",
    "share.exportBody": "Scegli quali informazioni includere e scarica il viaggio nel formato che preferisci.",
    "share.linkTitle": "Condividi viaggio",
    "share.linkBody": "Scegli quali informazioni rendere visibili e genera un link pubblico dedicato.",
    "share.empty": "Il link è valido, ma al momento non contiene informazioni condivisibili.",
    "share.tickets": "Biglietti",
    "share.documents": "Documenti",
    "share.financials": "Dettagli economici",
    "share.participants": "Partecipanti",
    "share.notes": "Note e appunti",
    "share.generate": "Genera link",
    "share.copy": "Copia link",
    "share.error": "Non è stato possibile creare il link.",
    "share.invalid": "Questo link di condivisione non è valido o non è più disponibile.",
    "trips.archive": "Archivia",
    "trips.archived": "Viaggi archiviati",
    "trips.archivedEmpty": "Non ci sono viaggi archiviati.",
    "trips.archivedReadOnlyTitle": "Viaggio archiviato · sola lettura",
    "trips.archivedReadOnlyBody": "Puoi consultare tutte le sezioni, esportare o condividere il viaggio. Per modificarlo o aggiungere contenuti devi prima ripristinarlo.",
    "trips.activeTitle": "Viaggi attivi",
    "trips.activeEmpty": "Non ci sono viaggi attivi. Puoi crearne uno nuovo oppure ripristinarne uno archiviato.",
    "trips.status": "Stato del viaggio",
    "trips.statusPlanning": "In pianificazione",
    "trips.statusUpcoming": "In arrivo",
    "trips.statusActive": "In corso",
    "trips.statusCompleted": "Completato",
    "trips.sync.idle": "Pronto",
    "trips.sync.syncing": "Sincronizzazione…",
    "trips.sync.synced": "Sincronizzato",
    "trips.sync.offline": "Offline · in attesa",
    "trips.sync.error": "Errore di sincronizzazione",
    "trips.syncRetry": "Tocca per riprovare la sincronizzazione",
    "trips.restore": "Ripristina",
    "trips.deleteConfirm": "Spostare questo viaggio nel cestino? Potrai ripristinarlo per 30 giorni.",
    "trips.editTitle": "Modifica viaggio",
    "trips.archiveConfirm": "Archiviare questo viaggio? Potrai ripristinarlo in qualsiasi momento dalla sezione dei viaggi archiviati.",
    "trips.restoreConfirm": "Ripristinare questo viaggio? Tornerà tra i viaggi attivi.",
    "trips.trashTitle": "Cestino viaggi",
    "trips.trashBody": "I viaggi eliminati restano recuperabili per 30 giorni, poi possono essere cancellati definitivamente.",
    "trips.trashEmpty": "Il cestino dei viaggi è vuoto.",
    "trips.trashDays": "Eliminazione definitiva tra {days} giorni",
    "trips.restoreFromTrash": "Ripristina",
    "trips.deleteForever": "Elimina definitivamente",
    "trips.deleteForeverConfirm": "Eliminare definitivamente questo viaggio e tutti i suoi dati? L’operazione non può essere annullata.",
    "trips.trashSyncError": "Non è stato possibile sincronizzare il cestino. Riprova quando la connessione è disponibile.",
    "trips.historyTitle": "Cronologia versioni",
    "trips.historyBody": "Mundely conserva automaticamente le ultime versioni dei tuoi viaggi su questo dispositivo, così puoi tornare a uno stato precedente.",
    "trips.historyHint": "Seleziona un viaggio, controlla data e ora della versione salvata e tocca Ripristina quando vuoi tornare a quello stato.",
    "trips.historyTrip": "Viaggio",
    "trips.historyNoTrips": "Non ci sono viaggi disponibili.",
    "trips.historyEmpty": "La cronologia comparirà dopo le prossime modifiche al viaggio.",
    "trips.historyRestore": "Ripristina versione",
    "trips.historyRestoreConfirm": "Ripristinare questa versione del viaggio? Prima del ripristino Mundely conserverà automaticamente lo stato attuale.",
    "trips.historyRestored": "Versione ripristinata correttamente.",
    "trips.historyRestoreError": "Non è stato possibile ripristinare questa versione.",
    "security.lockTitle": "Sblocca Mundely",
    "security.unlockBiometric": "Sblocca con biometria",
    "security.unlockPin": "Sblocca con PIN",
    "security.pinInvalid": "PIN errato.",
    "security.biometricUnavailable": "La biometria non è disponibile per questa app o su questo dispositivo.",
    "security.biometricNativeOnly": "Il controllo biometrico è disponibile solo nell’app installata su Android o iPhone.",
    "security.biometricNotEnrolled": "Nessuna impronta o biometria configurata sul dispositivo.",
    "security.deviceCredentialMissing": "Configura prima un PIN, password, sequenza o impronta nelle impostazioni del telefono.",
    "security.biometricLockout": "Troppi tentativi non riusciti. Sblocca il telefono manualmente e riprova.",
    "security.biometricFailed": "Autenticazione biometrica non riuscita.",
    "security.biometricSystemCancel": "Controllo biometrico annullato dal sistema.",
    "security.biometricCancelled": "Controllo biometrico annullato.",
    "security.biometricTimeout": "Il controllo biometrico non ha ricevuto risposta dal sistema. Chiudi e riapri l’app, poi riprova.",
    "security.biometricChecking": "Controllo in corso…",
    "security.lockedTitle": "Mundely è bloccata",
    "security.lockBody": "Sblocca l’app per visualizzare i tuoi dati.",
    "security.pinPlaceholder": "Inserisci PIN",
    "security.pinNotConfigured": "PIN non configurato. Puoi sbloccare con biometria o password account e poi impostare un nuovo PIN.",
    "security.passwordPlaceholder": "Password account",
    "security.unlockPassword": "Sblocca con password",
    "security.passwordUnavailable": "Account non disponibile. Effettua di nuovo il login.",
    "security.passwordInvalid": "Password account non corretta o account non compatibile con accesso tramite password.",
    "security.forgotPin": "PIN dimenticato? Usa un altro metodo",
    "security.lockHelp": "Se non ricordi il PIN, sblocca con biometria o password account e poi imposta un nuovo PIN in Sicurezza.",
    "errors.generic": "Si è verificato un errore. Riprova.",
    "errors.network": "Connessione non disponibile. Le modifiche compatibili verranno accodate e sincronizzate appena possibile.",
    "errors.sessionExpired": "La sessione è scaduta. Accedi nuovamente.",
    "errors.limitReached": "Hai raggiunto il limite previsto dal tuo piano.",
    "errors.sync": "Sincronizzazione non completata. Nessun dato locale è stato eliminato.",
    "errors.upload": "Upload non completato. Il file locale è stato mantenuto.",
    "errors.permission": "Non hai i permessi necessari per questa operazione.",
    "environment.missing": "Configurazione Firebase incompleta",
    "environment.missingBody": "Compila il file .env dell’ambiente prima di collegare il backend.",
    "home.lastTrip": "Ultimo viaggio",
    "home.dashboardSubtitle": "Una panoramica utile dei tuoi viaggi, delle prossime partenze e di ciò che hai già organizzato.",
    "home.tripInProgress": "Viaggio in corso",
    "home.daysUntil": "Mancano {count} giorni",
    "home.startsToday": "Si parte oggi",
    "home.openTrip": "Apri viaggio",
    "home.noTripTitle": "Nessun viaggio ancora",
    "home.noTripBody": "Crea il primo viaggio per iniziare a organizzare itinerario, prenotazioni, esperienze e documenti.",
    "home.statTrips": "Viaggi",
    "home.statCompleted": "Viaggi terminati",
    "home.statDestinations": "Destinazioni visitate",
    "home.statActive": "In corso",
    "home.yourTrips": "I tuoi viaggi",
    "home.yourTripsBody": "Riapri rapidamente i viaggi più recenti.",
    "home.viewAll": "Vedi tutti",
    "home.noTripsYet": "I tuoi viaggi compariranno qui.",
    "tripHome.nextStop": "Prossima tappa",
    "tripHome.locationPending": "Luogo da definire",
    "tripHome.openItinerary": "Apri itinerario",
    "tripHome.noNextStop": "Itinerario ancora vuoto",
    "tripHome.noNextStopBody": "Aggiungi la prima tappa per iniziare a costruire il viaggio.",
    "tripHome.addFirstStop": "Aggiungi prima tappa",
    "tripHome.hotels": "Hotel",
    "tripHome.experiences": "Esperienze",
    "tripHome.events": "Eventi",
    "tripHome.documents": "Documenti",
    "tripHome.days": "Giorni",
    "tripHome.checklist": "Checklist",
    "tripHome.notes": "Appunti",
    "tripHome.stops": "Tappe",
    "tripHome.quickAccess": "Accesso rapido",
    "tripHome.quickAccessBody": "Le sezioni che usi più spesso durante l’organizzazione.",
    "tripHome.allSections": "Tutte le sezioni",
    "tripHome.allSectionsBody": "Apri qualsiasi area del viaggio senza riempire la Home di grandi schede.",
    "aiDiscovery.experiencesTitle": "Cerca esperienze con Mundely",
    "aiDiscovery.eventsTitle": "Cerca eventi con Mundely",
    "aiDiscovery.experiencesBody": "Descrivi cosa ti interessa: l’agente AI prepara una selezione coerente con destinazione e date del viaggio.",
    "aiDiscovery.eventsBody": "L’agente AI cerca eventi compatibili con le città e le date del viaggio e li prepara per l’inserimento.",
    "aiDiscovery.experiencesPlaceholder": "Es. snorkeling, cucina locale, tour poco turistici…",
    "aiDiscovery.eventsPlaceholder": "Es. concerti, mostre, festival, mercati…",
    "aiDiscovery.city": "Città o zona",
    "aiDiscovery.cityPlaceholder": "Es. centro città",
    "aiDiscovery.request": "Cosa vuoi trovare",
    "aiDiscovery.search": "Cerca con AI",
    "aiDiscovery.searching": "Ricerca in corso…",
    "aiDiscovery.notAvailable": "La ricerca AI è predisposta ma il servizio non è disponibile in questo ambiente.",
    "aiDiscovery.noStructuredResults": "Mundely ha risposto, ma non ha restituito risultati strutturati utilizzabili.",
    "aiDiscovery.error": "Non è stato possibile completare la ricerca AI.",
    "aiDiscovery.addSuggestion": "Usa suggerimento",
    "events.subtitle": "Concerti, mostre, festival, mercati ed eventi temporanei durante il viaggio.",
    "events.add": "Aggiungi evento",
    "events.mapTitle": "Collega il luogo dell’evento",
    "events.mapBody": "Seleziona il luogo reale per compilare automaticamente città e indirizzo.",
    "events.chooseMap": "Scegli dalla mappa",
    "events.title": "Nome evento",
    "events.venue": "Luogo / venue",
    "events.city": "Città",
    "events.address": "Indirizzo",
    "events.date": "Data",
    "events.startTime": "Ora inizio",
    "events.endTime": "Ora fine",
    "events.category": "Categoria",
    "events.price": "Prezzo",
    "events.currency": "Valuta",
    "events.url": "Sito o biglietti",
    "events.notes": "Note",
    "events.empty": "Nessun evento",
    "events.emptyBody": "Aggiungi eventi manualmente oppure usa la ricerca con Mundely.",
    "events.openWebsite": "Apri sito",
    "documents.viewMode": "Modalità di visualizzazione dei documenti",
    "documents.viewByCategory": "Per categoria",
    "documents.viewByParticipant": "Per partecipante",
    "notes.chooseIcon": "Scegli icona",
    "notes.removeIcon": "Rimuovi icona",
    "notes.titlePlaceholder": "Titolo dell’appunto",
    "notes.toolbar": "Strumenti di formattazione",
    "notes.bold": "Grassetto",
    "notes.italic": "Corsivo",
    "notes.underline": "Sottolineato",
    "notes.strike": "Barrato",
    "notes.toolBoldSymbol": "B",
    "notes.toolItalicSymbol": "I",
    "notes.toolUnderlineSymbol": "U",
    "notes.toolStrikeSymbol": "S",
    "notes.customColor": "Colore personalizzato",
    "notes.bulletedList": "Elenco puntato",
    "notes.numberedList": "Elenco numerato",
    "dashboard.customize": "Personalizza dashboard",
    "dashboard.done": "Fine modifica",
    "dashboard.editWidget": "Modifica widget",
    "dashboard.widgetTitle": "Titolo del widget",
    "dashboard.width": "Larghezza",
    "dashboard.height": "Altezza",
    "dashboard.background": "Sfondo widget",
    "dashboard.backgroundOption": "Scegli sfondo",
    "dashboard.customColor": "Colore personalizzato",
    "dashboard.opacity": "Trasparenza",
    "dashboard.visible": "Mostra widget",
    "dashboard.moveUp": "Sposta prima",
    "dashboard.moveDown": "Sposta dopo",
    "dashboard.restoreDefaults": "Ripristina widget",
    "dashboard.size.small": "Piccolo",
    "dashboard.size.medium": "Medio",
    "dashboard.size.large": "Grande",
    "dashboard.size.full": "Intera larghezza",
    "dashboard.height.compact": "Compatto",
    "dashboard.height.normal": "Normale",
    "dashboard.height.tall": "Alto",
    "notes.alignment": "Allineamento testo",
    "notes.align.left": "Allinea a sinistra",
    "notes.align.center": "Centra",
    "notes.align.right": "Allinea a destra",
    "notes.align.justify": "Giustifica",
    "notes.color": "Colore appunto",
    "notes.colorOption": "Scegli colore",
    "notes.contentPlaceholder": "Scrivi il tuo appunto…",
    "notes.update": "Aggiorna appunto",
    "map.filter.itinerary": "Itinerario",
    "map.filter.experiences": "Esperienze",
    "map.filter.events": "Eventi",
    "map.days": "Giorni del viaggio",
    "map.allDays": "Tutto il viaggio",
    "map.zoomIn": "Aumenta zoom",
    "map.zoomOut": "Riduci zoom",
    "map.zoomControls": "Controlli zoom",
    "map.day": "Giorno",
    "map.allTrip": "Tutto il viaggio",
    "map.style": "Tipo di mappa",
    "map.styleClassic": "Mappa classica",
    "map.styleSatellite": "Mappa satellitare",
    "map.itineraryOnlyBody": "La mappa viene costruita esclusivamente a partire dall’itinerario del viaggio.",
    "map.infoTitle": "Come funziona la mappa",
    "map.clusterTitle": "{count} luoghi in quest’area",
    "app.backExitWarning": "Premi ancora Indietro per uscire dall’app.",
    "map.itineraryOnlyBadge": "Itinerario → Mappa",
    "map.itineraryEmpty": "Aggiungi elementi con posizione nell’itinerario per costruire la mappa.",
    "map.itineraryFilter.transfers": "Spostamenti",
    "map.itineraryFilter.hotels": "Hotel",
    "map.itineraryFilter.food": "Ristoranti",
    "map.itineraryFilter.cities": "Città",
    "map.itineraryFilter.places": "Luoghi",
    "map.itineraryFilter.experiences": "Esperienze",
    "map.itineraryFilter.events": "Eventi",
    "map.dayLabel": "Giorno {number}",
    "map.autoBuildTitle": "Mappa automatica",
    "map.autoBuildBody": "{points} punti · {photos} foto pronte",
    "map.photoStoryTitle": "Il viaggio in foto",
    "map.photoStoryBody": "Mundely costruisce automaticamente la sequenza fotografica usando città, ristoranti, luoghi di interesse, esperienze ed eventi già inseriti.",
    "map.photoCount": "{count} foto",
    "map.noPhotos": "Le foto compariranno automaticamente quando i luoghi del viaggio avranno immagini disponibili.",
    "map.photoBy": "Foto di",
    "album.autoTitle": "Album automatico",
    "album.autoBody": "Le foto del viaggio vengono organizzate automaticamente a partire dai luoghi già presenti nella mappa.",
    "album.userOnlyBody": "Qui compaiono esclusivamente le foto caricate dai partecipanti al viaggio.",
    "album.userOnlyTitle": "Solo foto reali del viaggio",
    "album.userOnlyDescription": "Mundely non inserisce più foto predefinite di Google Maps o altre immagini automatiche in questa sezione.",
    "album.userOnlyEmpty": "Aggiungi le tue foto e collegale a un giorno o a un punto dell’itinerario.",
    "album.addPhoto": "Aggiungi foto",
    "album.uploadBody": "Carica una foto e collegala al giorno, alla città, all’esperienza o al punto dell’itinerario corretto.",
    "album.file": "Foto",
    "album.date": "Giorno",
    "album.linkTo": "Collega a",
    "album.noLink": "Solo al giorno",
    "album.caption": "Didascalia",
    "album.pending": "Caricamento in corso",
    "album.uploadError": "Il caricamento della foto non è riuscito. La copia locale viene mantenuta e puoi riprovare.",
    "album.autoDescription": "Mundely recupera le immagini disponibili dei luoghi e le ordina per giorno. Le foto personalizzate scelte per le città hanno sempre la priorità.",
    "album.photosBuilt": "foto disponibili",
    "album.undated": "Senza data",
    "album.empty": "Nessuna foto disponibile",
    "album.emptyBody": "Aggiungi città, ristoranti, luoghi di interesse, esperienze o eventi tramite la ricerca sulla mappa. Mundely costruirà automaticamente l’album.",
    "album.withoutDate": "Senza data",
    "album.photoCount": "{count} foto",
    "climate.sectionBody": "Aggiungi o aggiorna le condizioni previste per ogni giorno. Questi dati compaiono automaticamente nell’itinerario.",
    "climate.saved": "Clima inserito",
    "climate.add": "Aggiungi clima",
    "climate.editTitle": "Clima del giorno",
    "climate.editBody": "Le informazioni salvate qui vengono raccolte automaticamente nell’itinerario.",
    "climate.autoBody": "Le previsioni vengono recuperate automaticamente in base alle località del viaggio. Non devi inserire nulla manualmente.",
    "climate.loading": "Aggiornamento previsioni in corso…",
    "climate.autoError": "Le previsioni non sono disponibili in questo momento. Puoi riprovare.",
    "climate.autoUnavailable": "Previsione non disponibile per questa data.",
    "climate.source": "Dati meteo: Open-Meteo",
    "climate.location": "Località: {location}",
    "climate.weather.clear": "Sereno",
    "climate.weather.partlyCloudy": "Parzialmente nuvoloso",
    "climate.weather.fog": "Nebbia",
    "climate.weather.drizzle": "Pioviggine",
    "climate.weather.rain": "Pioggia",
    "climate.weather.snow": "Neve",
    "climate.weather.showers": "Rovesci",
    "climate.weather.thunderstorm": "Temporali",
    "climate.weather.unknown": "Condizioni variabili",
    "climate.conditions": "Condizioni",
    "climate.minTemp": "Temperatura minima",
    "climate.maxTemp": "Temperatura massima",
    "climate.summary": "Riepilogo",
    "climate.notes": "Note",
      "itinerary.startDate": "Data inizio",
    "itinerary.endDate": "Data fine",
    "itinerary.originCity": "Città di partenza",
    "itinerary.destinationCity": "Città di arrivo",
    "itinerary.transportMode": "Come ti sposti",
    "itinerary.transport.car": "Auto",
    "itinerary.transport.bus": "Autobus",
    "itinerary.transport.plane": "Aereo",
    "itinerary.transport.train": "Treno",
    "itinerary.transport.ferry": "Traghetto",
    "settings.sectionsTransfers": "Spostamenti",
    "settings.sectionsTransfersBody": "Configura i mezzi di trasporto disponibili negli spostamenti dell’itinerario.",
    "settings.sectionsTransferModes": "Mezzi di trasporto",
    "album.folder": "Cartella",
    "album.newFolder": "Nuova cartella",
    "album.defaultFolder": "Foto del viaggio",
    "album.massUpload": "Puoi selezionare più foto insieme. Ogni foto viene ottimizzata fino a un massimo di 1 MB.",
    "album.fileTooLarge": "Il file supera il limite massimo di 1 MB.",
    "profile.publicLink": "Profilo pubblico",
    "profile.publicLinkBody": "Condividi foto, presentazione, paesi visitati e viaggi attivi con un link pubblico.",
    "profile.copyPublicLink": "Copia link pubblico",
    "profile.publicLinkCopied": "Link del profilo copiato.",
    "profile.publicNotFound": "Profilo non disponibile",
    "profile.publicTrips": "Viaggi",
    "profile.publicCountries": "Paesi visitati",
    "profile.publicActiveTrips": "Viaggi attivi",
    "profile.publicVisitedCountries": "Paesi visitati",
},
  "en": {
    "offline.prepTask": "Make this trip available offline",
    "offline.prepHint": "Optional: save your trip to view it without an internet connection.",
    "offline.manage": "Manage offline availability",
    "offline.notEnabled": "Offline download not enabled",
    "offline.modeTitle": "What would you like to save on this device?",
    "offline.modeData": "Trip data and documents",
    "offline.modeDataHint": "Itinerary, bookings, useful info, checklists, notes, tickets and documents, without the photo album.",
    "offline.modePhotos": "Trip data, documents and photos",
    "offline.modePhotosHint": "All trip details plus the photos saved in your album.",
    "offline.estimate": "Estimated space: {size}",
    "offline.estimateNote": "Approximate estimate: photo sizes may vary. Downloading is optional.",
    "offline.automatic": "Changes are saved automatically. Continue using the usual trip sections.",
    "offline.integratedNavigation": "There is no separate offline trip: the same sections remain available without internet.",
    "offline.changeOptions": "Save new selection",
    "offline.downloadNoConnection": "An internet connection is required for the initial download.",
    "offline.cacheIncomplete": "Data saved; some attachments are not yet available. Mundely will retry automatically.",
    "offline.autoSync": "Automatic offline updates are enabled.",
    "offline.someFilesPending": "{count} attachments are not yet available offline; they will be retried automatically when possible.",
    "offline.openWhenOffline": "You are offline: open the saved trip copy.",
    "offline.waitForSync": "Wait until the trip is synchronized before downloading a new copy. An existing offline copy remains available.",
    "offline.title": "Offline trip",
    "offline.boardingPasses": "Boarding passes",
    "offline.premiumOnly": "Complete plan required",
    "offline.premiumDescription": "Downloading and viewing a trip offline is available only with the Complete plan.",
    "offline.description": "Save a read-only copy on this device: itinerary, reservations, useful info, checklists, notes, places, tickets, and other trip details. Select files to download.",
    "offline.privateWarning": "Downloaded documents remain on this device. Protect your phone; uninstalling the app can delete offline copies.",
    "offline.selectFiles": "Attachments to keep offline",
    "offline.noAttachments": "No trip attachments available. You can still download the trip details.",
    "offline.available": "Offline copy available",
    "offline.attachments": "attachments",
    "offline.showContents": "View offline",
    "offline.hideContents": "Hide contents",
    "offline.snapshotReadOnly": "Local read-only copy. Changes update automatically when you save.",
    "offline.mapLimit": "Saved places retain their addresses and coordinates. Interactive maps, map tiles and turn-by-turn navigation require an internet connection.",
    "offline.saveAttachment": "Save attachment to device",
    "offline.attachmentNotDownloaded": "Attachment not included in offline copy",
    "offline.progress": "Downloading: {done} of {total}",
    "offline.update": "Update offline copy",
    "offline.download": "Download trip offline",
    "offline.delete": "Delete copy",
    "offline.confirmDelete": "Delete this trip’s offline copy from this device?",
    "offline.saved": "Offline copy ready.",
    "offline.removed": "Offline copy deleted.",
    "offline.storageError": "Unable to access offline storage on this device.",
    "offline.fileSaved": "Attachment saved to the device.",
    "offline.fileSaveError": "Unable to save the attachment.",
    "trip.intel.reviewRecords": "Open section",
    "trip.intel.less": "Show less",
    "trip.intel.more": "Read full response",
    "trip.intel.agentAnswer": "Agent response",
    "trip.intel.assistantQuestionTitle": "Choose what you want to improve",
    "trip.intel.preparationQuestionTitle": "Choose what you want to check",
    "trip.intel.assistantOtherQuestion": "Or ask something specific",
    "trip.intel.preparationOtherQuestion": "Or request a specific check",
    "trip.intel.assistantInputPlaceholder": "Eg. we already have 3 nights with relatives and 2 in hotels: how should I organize the rest?",
    "trip.intel.preparationInputPlaceholder": "Eg. do I need to complete a check-in before the next flight or accommodation?",
    "trip.intel.followupTitle": "Do you want to go deeper on this answer?",
    "trip.intel.followupResultTitle": "Follow-up",
    "trip.intel.followupPlaceholder": "Eg. on which leg am I most at risk of having too little time?",
    "trip.intel.sendFollowup": "Ask a follow-up",
    "trip.intel.openSection.itinerary": "Open Itinerary",
    "trip.intel.openSection.hotels": "Open Stays",
    "trip.intel.openSection.documents": "Open Documents",
    "trip.intel.openSection.checklist": "Open Checklist",
    "trip.intel.openSection.boardingPass": "Open Flights and boarding passes",
    "trip.intel.openSection.experiences": "Open Experiences",
    "trip.intel.openSection.expenses": "Open Expenses",
    "trip.intel.homeAssistantEyebrow": "Tips for your trip",
    "trip.intel.homePrepEyebrow": "Checks for your trip",
    "trip.intel.homeAssistantAfter": "Review expenses, memories and loose ends after your trip.",
    "trip.intel.homeAssistantDuring": "Adapt your next stops to schedules and changing plans.",
    "trip.intel.homeAssistantStays": "You have {count} nights without a recorded stay: find an option that fits the itinerary.",
    "trip.intel.homeAssistantPlan": "You have {count} stops on your itinerary: discover how to plan them better.",
    "trip.intel.homeAssistantStart": "Build an itinerary that fits you, one stop at a time.",
    "trip.intel.homePrepStays": "{count} nights have no recorded stay: check before departure.",
    "trip.intel.homePrepOverlaps": "{count} nights have overlapping stays: review dates and reservations.",
    "trip.intel.homePrepChecklist": "{count} checklist items still need attention.",
    "trip.intel.homePrepReadyReview": "Review documents, check-ins and practical destination details.",
    "trip.intel.homePrepDetails": "Check times, booking references and saved addresses before departure.",
    "trip.intel.homeAssistantRoute": "Group nearby visits and leave time for breaks and getting around.",
    "trip.intel.homeAssistantMemories": "Save your favourite places and ideas for your next trip.",
    "trip.intel.qVisit": "What is really worth seeing?",
    "trip.intel.qVisitDesc": "Places, areas or experiences that fit this trip",
    "trip.intel.qOptimize": "How can I improve the itinerary?",
    "trip.intel.qOptimizeDesc": "Order of stops, timing and better day distribution",
    "trip.intel.qStays": "How should I manage the stays?",
    "trip.intel.qStaysDesc": "Nights, hotel changes and smoother accommodation choices",
    "trip.intel.qTransfer": "How should I organize the transfers?",
    "trip.intel.qTransferDesc": "Connections between stops, timing and critical moves",
    "trip.intel.qActivities": "Which activities fit my trip best?",
    "trip.intel.qActivitiesDesc": "Experiences to add based on destination, pace and season",
    "trip.intel.qSavings": "Where can I optimize the budget?",
    "trip.intel.qSavingsDesc": "Savings on transport, activities, areas or practical choices",
    "trip.intel.qPending": "What still needs to be completed before departure?",
    "trip.intel.qPendingDesc": "Overview of what is missing or worth rechecking",
    "trip.intel.qConnections": "Do the connections between stops really work?",
    "trip.intel.qConnectionsDesc": "Times, layovers and margins between transfers and check-ins",
    "trip.intel.qDocuments": "Documents and requirements: am I covered?",
    "trip.intel.qDocumentsDesc": "Passport, visa, entry rules, insurance and useful documents",
    "trip.intel.qInconsistencies": "Are there dates or bookings to recheck?",
    "trip.intel.qInconsistenciesDesc": "Nights, dates, overlaps and references to verify",
    "trip.intel.qEssentials": "Do I really have everything needed for this destination?",
    "trip.intel.qEssentialsDesc": "Plugs, weather, health, luggage and practical essentials",
    "trip.intel.qCheckins": "Which check-ins or confirmations are still missing?",
    "trip.intel.qCheckinsDesc": "Flights, stays, useful windows and online steps to complete",
    "trip.intel.workletAssistantLead": "Plan your trip more effectively",
    "trip.intel.workletAssistantHint": "Ask for tailored advice based on your actual itinerary.",
    "trip.intel.workletPreparationLead": "Find out what still needs attention",
    "trip.intel.workletPreparationHint": "{count} checklist items still open. Review by topic.",
    "trip.intel.workletIssues": "{count} overnight-stay issues to clarify",
    "trip.intel.statusNoGaps": "No gaps in recorded nights; booking validity still needs checking.",
    "trip.intel.auditWhole": "Analyze the full trip",
    "trip.intel.scopeLabel": "What would you like to analyze?",
    "trip.intel.scopeWhole": "Entire trip",
    "trip.intel.scopeStays": "Accommodation and nights",
    "trip.intel.scopeTransport": "Transport and connections",
    "trip.intel.scopeDocuments": "Documents",
    "trip.intel.scopeActivities": "Activities and checklist",
    "trip.intel.analysis": "Analysis",
    "trip.intel.nextSteps": "Next steps",
    "trip.intel.criticalIssues": "Critical issues",
    "trip.intel.statusAccommodation": "Accommodation",
    "trip.intel.statusTransport": "Transport",
    "trip.intel.statusDocuments": "Documents",
    "trip.intel.statusActivities": "Activities",
    "trip.intel.transportSummary": "{flights} flights · {transfers} transfers",
    "trip.intel.documentsDetail": "Documents recorded, validity not verified",
    "trip.intel.activitiesDetail": "{checklist} personal checklist items still open",
    "trip.intel.invalidHotelDatesTitle": "Accommodation dates to fix",
    "trip.intel.overlapTitle": "Overlaps to review",
    "trip.intel.notBookingConfirmed": "Recorded stays do not prove that reservations are confirmed.",
    "trip.intel.recordedCoverage": "Nights with recorded accommodation",
    "trip.intel.recorded": "Recorded",
    "trip.intel.nightCount": "{count} nights",
    "trip.intel.staysByPeriod": "Nights grouped by stay",
    "trip.intel.noGapsDetected": "No uncovered nights found in saved records. Bookings and transfers still need checking.",
    "trip.intel.priorityChecks": "Needs attention before departure",
    "trip.intel.assistantTitle": "Travel assistant",
    "trip.intel.preparationTitle": "Smart preparation",
    "trip.intel.assistantPurpose": "Your travel agent reviews existing trip details and helps you plan what is next.",
    "trip.intel.preparationPurpose": "Checks stays, connections and details still requiring attention.",
    "trip.intel.needDates": "Trip dates are missing or need correction",
    "trip.intel.openNights": "{count} nights still to arrange or clarify",
    "trip.intel.nextAction": "Find the most useful next step",
    "trip.intel.askAssistant": "Talk to the agent",
    "trip.intel.nightsCovered": "{done} of {total} nights have recorded accommodation",
    "trip.intel.reviewPreparation": "Review preparation",
    "trip.intel.assistantDescription": "Your agent uses saved trip details to suggest a next step or ask focused questions.",
    "trip.intel.preparationDescription": "Review of saved records. Recorded coverage does not mean bookings are verified.",
    "trip.intel.contextKicker": "From your trip",
    "trip.intel.openRelevantSection": "Open related section",
    "trip.intel.suggestStep": "Suggest my next step",
    "trip.intel.clarify": "Ask the missing questions",
    "trip.intel.yourQuestion": "What would you like to plan?",
    "trip.intel.questionPlaceholder": "E.g. I will stay with my uncle for three nights, then in a hotel. What is missing?",
    "trip.intel.send": "Ask the agent",
    "trip.intel.working": "The agent is reviewing your trip…",
    "trip.intel.unavailable": "The agent is unavailable. Your saved trip details are still here.",
    "trip.intel.noAutoChanges": "The agent suggests actions; trip changes and bookings require your approval.",
    "trip.intel.nightsTitle": "Overnight coverage",
    "trip.intel.unknownCoverage": "Percentage unavailable",
    "trip.intel.hotelRecorded": "Accommodation recorded (check details)",
    "trip.intel.hostDeclared": "Stay with friends/family declared",
    "trip.intel.needClarification": "Accommodation needs clarification",
    "trip.intel.undatedHotels": "{count} accommodation entries have invalid or missing dates and were not counted.",
    "trip.intel.overlaps": "{count} nights have overlapping accommodation. Review your bookings.",
    "trip.intel.unknownNeeds": "More information is needed about where you will stay. The percentage only measures recorded coverage.",
    "trip.intel.openHotels": "Review accommodation",
    "trip.intel.otherChecks": "Other recorded details",
    "trip.intel.transportFound": "{flights} flights and {transfers} transfers recorded",
    "trip.intel.denominatorUnknown": "required total not yet known",
    "trip.intel.documentsFound": "{count} documents recorded",
    "trip.intel.notVerified": "validity not verified",
    "trip.intel.activitiesFound": "{count} activities or events recorded",
    "trip.intel.analyzeAI": "Review with the agent",
    "trip.intel.verificationWarning": "These checks do not prove that documents, visas, tickets or bookings are valid. Always check official requirements.",
    "trip.setup.mode": "How would you like to create the trip?",
    "trip.setup.guided": "Guided creation",
    "trip.setup.quick": "Quick creation",
    "trip.setup.step": "Step {current} of {total}",
    "trip.setup.next": "Continue",
    "trip.setup.back": "Back",
    "trip.setup.review": "Review the suggestions before creating your trip.",
    "trip.setup.purpose": "Why are you traveling?",
    "trip.setup.purpose.leisure": "Holiday",
    "trip.setup.purpose.family": "Visiting family or friends",
    "trip.setup.purpose.work": "Work",
    "trip.setup.purpose.other": "Other",
    "trip.setup.accommodation": "Where will you stay?",
    "trip.setup.accommodation.unsure": "Not sure yet",
    "trip.setup.accommodation.booking": "Hotel or rented accommodation",
    "trip.setup.accommodation.friends": "With family or friends",
    "trip.setup.accommodation.mixed": "Mixed stays",
    "trip.setup.transport": "How will you travel?",
    "trip.setup.transport.unsure": "Not sure yet",
    "trip.setup.transport.flight": "By plane",
    "trip.setup.transport.train": "By train",
    "trip.setup.transport.car": "By car",
    "trip.setup.transport.other": "Other transport",
    "trip.setup.notes": "Other needs (optional)",
    "trip.setup.notesPlaceholder": "E.g. visiting my uncle, no hotel needed",
    "trip.setup.preview": "Suggested sections",
    "trip.setup.hotelVisible": "Show Accommodation section",
    "trip.setup.visibilityHint": "Hide or restore the section without deleting any saved data. Essential sections stay accessible.",
    "trip.setup.suggestedSteps": "{count} suggested planning steps; edit later at any time.",
    "trip.setup.askAI": "Ask AI for more suggestions",
    "trip.setup.aiNoSuggestion": "No extra suggestions. You can still add your own steps.",
    "trip.setup.aiReview": "AI suggestions added to the draft. Review before saving.",
    "trip.setup.aiUnavailable": "AI unavailable right now. You can continue with your answers.",
    "trip.setup.edit": "Customize sections and planning",
    "trip.setup.apply": "Apply preferences",
    "trip.setup.detected": "Automatically detected: check details before confirming.",
    "trip.guide.expand": "Show actions",
    "trip.guide.addNew": "Add a step",
    "trip.guide.confirmDelete": "Remove this step? Section data will not be deleted.",
    "trip.guide.statusHint": "Manually marked done: bookings and documents still need verification.",
    "trip.prep.confirmedOnly": "{done} of {total} checks confirmed",
    "trip.prep.detectedCount": "{count} detected checks still need confirmation",
    "trip.prep.whyDetected": "Data found, not verified as valid.",
    "trip.prep.checklistTitle": "Trip without surprises",
    "trip.prep.guideTitle": "Guided trip organization",
    "trip.prep.progress": "{done} of {total} checks completed",
    "trip.prep.openDetails": "Review all checks",
    "trip.prep.allChecked": "All applicable checks are complete.",
    "trip.prep.nextStep": "Recommended next step",
    "trip.prep.readyTitle": "Preparation checked",
    "trip.prep.readyBody": "You have completed all applicable checks. Review everything again before departure.",
    "trip.prep.review": "Review preparation",
    "trip.prep.detailIntro": "Check each item. Manual confirmations stay separate from your personal checklists.",
    "trip.prep.auto": "Detected",
    "trip.prep.confirmed": "Confirmed",
    "trip.prep.notApplicable": "Not applicable",
    "trip.prep.pending": "To check",
    "trip.prep.confirm": "Confirm",
    "trip.prep.reset": "Undo confirmation",
    "trip.prep.skip": "Not applicable",
    "trip.prep.verificationNote": "Manual confirmations do not replace checking entry requirements, document validity or insurance coverage. Always check official sources.",
    "trip.prep.officialSource": "Official travel advice",
    "trip.prep.destination": "Destination and dates",
    "trip.prep.destinationHint": "Enter the correct trip destination and dates.",
    "trip.prep.accommodation": "Stays and bookings",
    "trip.prep.accommodationHint": "Check that reservations cover the necessary stays.",
    "trip.prep.transport": "Flights and transportation",
    "trip.prep.transportHint": "Confirm transport bookings, departure times and tickets.",
    "trip.prep.documents": "Travel documents",
    "trip.prep.documentsHint": "Check passport, visas if needed and entry requirements. Uploading a document does not verify it.",
    "trip.prep.transfers": "Airport transfers",
    "trip.prep.transfersHint": "Check how to get to your accommodation or mark as not applicable.",
    "trip.prep.insurance": "Travel insurance",
    "trip.prep.insuranceHint": "Check your coverage or mark as not required.",
    "trip.prep.activities": "Activities and bookings",
    "trip.prep.activitiesHint": "Check tickets and experiences to book, or mark as not needed.",
    "trip.prep.reminders": "Personal reminders",
    "trip.prep.remindersHint": "Review your to-dos or mark as not needed.",
    "trip.prep.personalChecklists": "Your personal checklists",
    "trip.prep.personalChecklistsHint": "Check packing and other personal lists; manage them separately.",
    "trip.prep.openTrip": "Review trip",
    "trip.prep.openHotels": "Open stays",
    "trip.prep.openItinerary": "Open itinerary",
    "trip.prep.openDocuments": "Open documents",
    "trip.prep.openExperiences": "Open experiences",
    "trip.prep.openNotes": "Open reminders",
    "trip.prep.openChecklists": "Open my checklists",
    "trip.prep.remaining": "{count} checks still to complete",
    "trip.prep.groupEssential": "Essentials",
    "trip.prep.groupImportant": "Important",
    "trip.prep.groupBefore": "Before departure",
    "trip.prep.groupPending": "{count} to check",
    "trip.prep.groupCompleted": "All checked",
    "trip.prep.reasonConfirmed": "Confirmed by you",
    "trip.prep.reasonNotApplicable": "Marked as not applicable",
    "trip.prep.reasonPersonalDone": "All items on your personal lists are complete",
    "trip.prep.reasonDetected": "Basic trip details are present",
    "trip.prep.reasonPersonalPending": "{count} personal items still to complete",
    "trip.prep.reasonPersonalEmpty": "No personal tasks yet: you can add a list",
    "trip.prep.reasonStays": "{count} stays saved: check dates and bookings",
    "trip.prep.reasonDocuments": "{count} documents saved: validity not verified",
    "trip.prep.reasonEntries": "{count} items saved: check the details",
    "trip.prep.urgencySoon": "Departure approaching: recommended check",
    "trip.prep.urgencyImminent": "Departure imminent: priority check",
    "trip.prep.urgencyInProgress": "During your trip: next check",
    "trip.guide.remaining": "{count} activities still to arrange",
    "trip.guide.freeOrder": "Choose your own order",
    "trip.guide.openGuide": "Open trip organizer",
    "trip.guide.openSection": "Open section",
    "trip.guide.allPlannedDone": "No outstanding tasks. You can add more at any time.",
    "trip.guide.intro": "Plan in any order: add multiple hotels, flights or trains, postpone and move any task.",
    "trip.guide.todo": "To do",
    "trip.guide.done": "Completed",
    "trip.guide.deferred": "Postponed",
    "trip.guide.moveUp": "Move up",
    "trip.guide.moveDown": "Move down",
    "trip.guide.stepName": "Task name",
    "trip.guide.markDone": "Done",
    "trip.guide.defer": "Postpone",
    "trip.guide.resume": "Resume",
    "trip.guide.rename": "Rename",
    "trip.guide.addStep": "Add task",
    "trip.guide.type": "Task type",
    "trip.guide.date": "Date (optional)",
    "trip.guide.repeatHint": "Add the same type of task as many times as needed, including on different days.",
    "trip.guide.empty": "No tasks yet: add one below.",
    "trip.guide.kindAccommodation": "Accommodation",
    "trip.guide.kindFlight": "Flight",
    "trip.guide.kindTrain": "Train",
    "trip.guide.kindTransfer": "Transfer",
    "trip.guide.kindDocuments": "Documents",
    "trip.guide.kindActivity": "Activity or ticket",
    "trip.guide.kindInsurance": "Insurance",
    "trip.guide.kindOther": "Other task",
    "album.customFileName": "File name (without extension)",
    "album.fileNames": "Image names",
    "profile.introduction": "Introduction",
    "profile.introductionEmpty": "No introduction added.",
    "profile.introductionPlaceholder": "Tell something about yourself, how you travel and what you are interested in.",
    "profile.introductionHint": "Maximum 1,200 characters.",
    "profile.personalPhotos": "Personal photos",
    "profile.personalPhotosBody": "You can add up to 10 personal photos to your profile.",
    "profile.personalPhotosLimit": "You can add a maximum of 10 personal photos.",
    "profile.personalPhotosSaved": "Personal photos updated.",
    "profile.personalPhotoAlt": "Personal photo {number}",
    "profile.addPersonalPhotos": "Add photos",
    "itinerary.startDateTime": "Start date and time",
    "itinerary.endDateTime": "End date and time",
    "participants.changeRole": "Change role",
    "participants.roleUpdated": "Role updated.",
    "participants.roleUpdateError": "The role could not be updated.",
    "documents.otherParticipantsTitle": "Other participants’ documents",
    "documents.otherParticipantsBody": "Personal documents shared by the participants in this trip.",
    "profile.sections": "Profile sections",
    "profile.documentsSection": "Documents",
    "notifications.openTrip": "Open trip",
    "notifications.previewModeTitle": "Trip preview",
    "notifications.previewModeBody": "You can view every section. Accept the invitation to start editing.",
    "common.next": "Next",
    "common.back": "Back",
    "common.skip": "Skip",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.retry": "Retry",
    "common.other": "Other",
    "common.loading": "Loading…",
    "common.optional": "Optional",
    "common.required": "Required",
    "common.continue": "Continue",
    "common.done": "Done",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.open": "Open",
    "notifications.contentUnavailable": "Content unavailable.",
    "notifications.video": "Video",
    "notifications.openVideo": "Open video",
    "common.timePlaceholder": "HH:MM",
    "common.restore": "Restore",
    "welcome.language": "Language",
    "welcome.chooseLanguage": "Choose language",
    "welcome.slide1.title": "Your whole trip in one place",
    "welcome.slide1.body": "Organize itineraries, stops, bookings, documents and memories in a simple, synchronized structure.",
    "welcome.slide2.title": "Mundely travels with you",
    "welcome.slide2.body": "Use your trips offline and find your changes on Web, Android and iOS when you are back online.",
    "welcome.slide3.title": "An AI assistant for every trip",
    "welcome.slide3.body": "Plan, summarize and improve your trip with AI while keeping control of your data.",
    "welcome.start": "Start with Mundely",
    "auth.signIn": "Sign in",
    "auth.register": "Register",
    "auth.firstName": "First name",
    "auth.lastName": "Last name",
    "auth.username": "Username",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm password",
    "auth.usernamePlaceholder": "e.g. MarkStone",
    "auth.emailPlaceholder": "mark.stone@email.com",
    "auth.forgotPassword": "Forgot password?",
    "auth.resetPassword": "Reset password",
    "auth.resetInfo": "We will send you a secure link to reset it.",
    "auth.sendReset": "Send recovery email",
    "auth.or": "or",
    "auth.google": "Continue with Google",
    "auth.apple": "Continue with Apple",
    "auth.createAccount": "Create account",
    "auth.loginIdentifier": "Username or email",
    "auth.loginIdentifierPlaceholder": "e.g. MarkStone or mark.stone@email.com",
    "auth.completeProfile": "Complete your profile",
    "auth.completeProfileBody": "To use Mundely, enter your first name, last name and a unique username.",
    "auth.logout": "Sign out",
    "auth.resetSent": "Recovery email sent. Check your inbox.",
    "auth.loginError": "Incorrect credentials.",
    "auth.usernameTaken": "This username is already in use.",
    "auth.usernameTooShort": "Username is too short: enter at least 3 characters.",
    "auth.usernameInvalidCharacters": "Username may contain only letters (A-Z), digits, dots and underscores. @, spaces and other symbols are not allowed.",
    "auth.emailTaken": "This email is already linked to an account.",
    "auth.invalidEmail": "Enter a valid email address.",
    "auth.passwordMin": "Password must be at least 8 characters.",
    "auth.passwordMismatch": "Passwords do not match.",
    "auth.fieldRequired": "Complete all required fields.",
    "auth.accountCreated": "Account created.",
    "setup.title": "Guided setup",
    "setup.subtitle": "Set up Mundely once. Account preferences will sync across your devices.",
    "setup.basicTitle": "Basic setup",
    "setup.basicBody": "Choose language, currency and essential preferences so you can start using Mundely right away.",
    "setup.advancedTitle": "Advanced setup",
    "setup.advancedBody": "After the basics, you can complete notifications, security, profile photo and the connection to fAInance Test.",
    "setup.advancedHint": "For now this advanced setup covers the main items. We will refine it in the next implementations.",
    "setup.language": "Language",
    "setup.currency": "Primary currency",
    "setup.measurement": "Units",
    "setup.metric": "Metric system",
    "setup.imperial": "Imperial system",
    "setup.dateFormat": "Date format",
    "setup.weekStartsOn": "First day of the week", "setup.weekMonday": "Monday", "setup.weekSunday": "Sunday",
    "setup.notifications": "Notification preferences",
    "setup.notificationsBody": "You can change them at any time.",
    "setup.operational": "Trip operations",
    "setup.reminders": "Reminders",
    "setup.ai": "AI",
    "setup.collaboration": "Sharing and collaboration",
    "setup.marketing": "Marketing and promotions",
    "setup.security": "Biometrics and PIN",
    "setup.securityBody": "Choose biometrics or a local 4-digit PIN. You can change the method later in Security.",
    "setup.biometric": "Enable biometrics",
    "setup.pin": "Set PIN",
    "setup.pinPlaceholder": "4-digit PIN",
    "setup.photo": "Profile photo",
    "setup.fainanceTitle": "Connect fAInance",
    "setup.fainanceBody": "If you already have a fAInance account, you can link it to Mundely. Approval will happen from your fAInance account.",
    "setup.fainanceLater": "You can skip this step and link the account at any time from Settings.",
    "currency.searchLabel": "Search currency",
    "currency.searchBody": "You can search by currency code or name.",
    "currency.searchPlaceholder": "Example: EUR, euro, dollar",
    "currency.noResults": "No currencies found.",
    "fainanceLink.title": "Connect fAInance",
    "fainanceLink.menuBody": "Connect your fAInance account and automatically sync trips with Share.",
    "fainanceLink.body": "The connection lets Mundely automatically create and update a Share project for every trip.",
    "fainanceLink.profileBody": "Connect from your profile the fAInance account you want to use with Mundely.",
    "fainanceLink.testEnvironment": "Environment: fAInance Test",
    "fainanceLink.testBridgeUnavailable": "The fAInance Test connection is not available right now. No request was sent to Production.",
    "fainanceLink.identifierInfoTitle": "How to identify the account",
    "fainanceLink.approvalTitle": "How linking works",
    "fainanceLink.pendingTitle": "Request pending",
    "fainanceLink.queueTitle": "Bridge status",
    "fainanceLink.requestQueued": "Request saved and queued.",
    "fainanceLink.cloudQueueBody": "The request was saved in Mundely cloud and is ready for the fAInance bridge to process it.",
    "fainanceLink.localQueueBody": "The request was saved on this device. It will be sent to the bridge when cloud linking becomes available.",
    "fainanceLink.status.connected": "Connected",
    "fainanceLink.status.pending": "Pending",
    "fainanceLink.status.rejected": "Rejected",
    "fainanceLink.status.notLinked": "Not connected",
    "fainanceLink.connectedAs": "Connected fAInance account",
    "fainanceLink.connectedBody": "New trips are automatically queued for Share synchronization. Existing trips are also realigned when you open this page.",
    "fainanceLink.emailLabel": "fAInance account email",
    "fainanceLink.emailPlaceholder": "name@email.com",
    "fainanceLink.identifierLabel": "fAInance email or username",
    "fainanceLink.identifierPlaceholder": "name@email.com or username",
    "fainanceLink.identifierHint": "You can use either the email address or username of your fAInance account.",
    "fainanceLink.invalidIdentifier": "Enter a valid email address or a valid fAInance username.",
    "fainanceLink.approvalBody": "Mundely records the link request. The connection becomes active only after approval from the matching fAInance account.",
    "fainanceLink.connect": "Request connection",
    "fainanceLink.requestSent": "Connection request recorded.",
    "fainanceLink.requestCancelled": "Request cancelled.",
    "fainanceLink.pendingBody": "Request sent for {identifier}. Waiting for approval from fAInance.",
    "fainanceLink.cancelRequest": "Cancel request",
    "fainanceLink.disconnect": "Disconnect account",
    "fainanceLink.disconnected": "fAInance account disconnected.",
    "fainanceLink.syncTrips": "Sync trips",
    "fainanceLink.syncQueued": "Synchronization prepared for {count} trips.",
    "fainanceLink.error": "The fAInance operation could not be completed.",
    "analytics.title": "Analytics and usage",
    "analytics.body": "Control the sending of anonymous Mundely usage data.",
    "analytics.usageTitle": "Share anonymous usage data",
    "analytics.usageBody": "Helps us understand which sections are used and where to improve the app. Personal content, documents and conversation text are never sent.",
    "analytics.note": "Tracking uses Firebase Analytics on Android, iOS and Web. You can disable it at any time.",
    "setup.photoBody": "Add it now or later.",
    "setup.photoHint": "Drag the photo to center it and use zoom to choose the crop.",
    "setup.photoZoom": "Zoom",
    "setup.photoReset": "Reset",
    "setup.photoChoose": "Choose or change photo",
    "setup.finish": "Finish setup",
    "setup.completed": "Setup completed",
    "nav.home": "Home",
    "nav.trips": "Trips",
    "nav.world": "My world",
    "nav.map": "Map",
    "nav.ai": "AGENT",
    "nav.profile": "Profile",
    "nav.settings": "Settings",
    "nav.menu": "Menu",
    "menu.subtitle": "Trips, preferences and app settings.",
    "settings.title": "Settings",
    "settings.subtitle": "Customize Mundely and manage your account, security, support and data.",
    "settings.profile": "Profile",
    "gamification.title": "Points & leaderboard",
    "gamification.menuBody": "Earn points by travelling, contributing to the community and completing your traveller profile.",
    "gamification.body": "Your score combines travel experience, in-app activity and the quality of your community contributions.",
    "gamification.score": "Points",
    "gamification.rank": "Rank",
    "gamification.nextLevel": "{points} points to reach {level}",
    "gamification.maxLevel": "You have reached the current maximum level",
    "gamification.communityQuality": "Contribution quality",
    "gamification.communityQualityBody": "Your reputation also reflects how useful other travellers find your reviews.",
    "gamification.helpfulReceived": "Helpful votes received",
    "gamification.helpfulRatio": "Helpful vote share",
    "gamification.publicTitle": "Mundely reputation",
    "gamification.breakdown": "Where your points come from",
    "gamification.breakdownBody": "Every valid activity contributes automatically to your score.",
    "gamification.countries": "Countries visited",
    "gamification.quizAnswers": "Quiz answers",
    "gamification.feedbacks": "Travel feedback",
    "gamification.completedTrips": "Completed trips",
    "gamification.reviews": "Public reviews",
    "gamification.helpfulVotes": "Helpful votes received",
    "gamification.notHelpfulVotes": "Not helpful votes received",
    "gamification.voteBalance": "Community vote impact",
    "gamification.badges": "Badges",
    "gamification.badgesBody": "Badges recognise experience, contribution and geographic expertise.",
    "gamification.earned": "Earned",
    "gamification.badge.explorer": "Explorer",
    "gamification.badge.explorerBody": "Visit at least 10 countries.",
    "gamification.badge.topContributor": "Top Contributor",
    "gamification.badge.topContributorBody": "Receive at least 10 helpful votes on your reviews.",
    "gamification.badge.asiaExpert": "Asia Expert",
    "gamification.badge.asiaExpertBody": "Visit at least 10 Asian countries.",
    "gamification.badge.quizMaster": "Quiz Master",
    "gamification.badge.quizMasterBody": "Complete all 16 traveler-profile preferences.",
    "gamification.badge.reviewer": "Reviewer",
    "gamification.badge.reviewerBody": "Publish at least 10 reviews for the community.",
    "gamification.badge.veteran": "Travel Veteran",
    "gamification.badge.veteranBody": "Complete at least 10 trips in Mundely.",
    "gamification.history": "Points history",
    "gamification.historyBody": "The latest changes to your Mundely score.",
    "gamification.historyInitial": "Initial score",
    "gamification.historyProgress": "Activity update",
    "gamification.historyEmpty": "History will appear when your score changes.",
    "gamification.level.starter": "Traveller",
    "gamification.level.explorer": "Explorer",
    "gamification.level.expert": "Experienced traveller",
    "gamification.level.globetrotter": "Globetrotter",
    "gamification.rules": "Points rules",
    "gamification.rulesBody": "Your score is recalculated from actual profile and community data.",
    "gamification.rule.country": "Each country visited",
    "gamification.rule.quiz": "Each quiz answer",
    "gamification.rule.feedback": "Each travel feedback",
    "gamification.rule.completedTrip": "Each completed trip",
    "gamification.rule.review": "Each public review",
    "gamification.rule.helpful": "Each Helpful vote received",
    "gamification.rule.notHelpful": "Each Not helpful vote received",
    "gamification.leaderboard": "Traveller leaderboard",
    "gamification.leaderboardBody": "The leaderboard uses the updated Mundely score of users who have already opened this app version.",
    "gamification.noLeaderboard": "The leaderboard is not available yet.",
    "quiz.profileTitle": "Your travel profile",
    "quiz.communityBody": "Your answers are saved in your profile. Your choices also contribute to aggregated travel preferences that Mundely can use to improve suggestions.",
    "quiz.communityCompare": "How other travellers answered · {count} responses",
    "quiz.communityShort": "Community: {minus}% / {plus}%",
    "quiz.popular": 'Iconic places',
    "quiz.remote": 'Remote places',
    "quiz.comfort": 'Comfort and services',
    "quiz.authentic": 'Local life',
    "quiz.food": 'Food and flavors',
    "quiz.historyMuseums": 'History and museums',
    "quiz.early": 'Start early',
    "quiz.late": 'Live the night',
    "quiz.solo": 'Time for myself',
    "quiz.social": 'Meet people',
    "quiz.fixed": 'Defined plan',
    "quiz.flexible": 'Decide as I go',
    "quiz.direct": 'One main base',
    "quiz.multiStop": 'Many stops',
    "quiz.classic": 'Great classics',
    "quiz.unusual": 'Unusual places',
    "tools.title": "Tools",
    "tools.menuBody": "Calculator and currency converter in one section.",
    "calculator.title": "Calculator",
    "calculator.menuBody": "Run quick calculations while travelling.",
    "calculator.body": "A complete calculator with the same essential functions available in fAInance Tools.",
    "currency.title": 'Currency converter',
    "currency.menuBody": 'Convert currencies with an updated online rate.',
    "currency.body": 'Quickly calculate how much an amount is worth in the currency you need while traveling.',
    "currency.amount": 'Amount',
    "currency.from": 'From',
    "currency.to": 'To',
    "currency.swap": 'Swap currencies',
    "currency.error": 'The exchange rate could not be retrieved. Check your connection and try again.',
    "currency.result": 'Result',
    "currency.waiting": 'Rate unavailable',
    "currency.updated": 'Reference rate for {date}',
    "currency.refresh": 'Refresh rate',
    "currency.source": 'Rate source: Frankfurter, based on reference rates published by the ECB and other central banks.',
    "currency.rate": 'Rate',
    "currency.automatic": 'automatic conversion',
    "nextTrip.title": 'Next trip',
    "nextTrip.menuBody": 'Agent ideas and advice for choosing your next destination.',
    "nextTrip.body": 'Combine when you want to leave, your budget and personal preferences to get more relevant suggestions.',
    "nextTrip.heroTitle": 'Find your next destination',
    "nextTrip.heroBody": 'Talk it through with your Agent.',
    "nextTrip.personalizationTitle": "Mundely personalization",
    "nextTrip.personalizationBody": "Suggestions combine your preferences, previously visited places and community signals.",
    "nextTrip.personalizationQuiz": "Choices: {count}",
    "nextTrip.personalizationVisited": "Visited countries: {count}",
    "nextTrip.personalizationReviews": "Reviews considered: {count}",
    "nextTrip.whyTitle": "Why I recommend it",
    "nextTrip.whyQuiz": "a strong match with your preferences",
    "nextTrip.whyStyle": "matches {style}",
    "nextTrip.whyBudget": "fits the budget you entered",
    "nextTrip.whyNewPlace": "avoids destinations you already visited",
    "nextTrip.whyCommunity": "also supported by community signals",
    "nextTrip.whyProfile": "matches the traveler profile Mundely knows about you",
    "nextTrip.whyTravelerProfile": "matches your {style} preference",
    "travelerProfile.title": "Traveler profile",
    "travelerProfile.body": "Mundely combines quiz answers, trips, expenses, reviews and habits to understand how you like to travel. You can correct anything that does not represent you.",
    "travelerProfile.inferred": "Your travel style",
    "travelerProfile.inferredBody": "Preferences suggested by your answers and reviews. Tap a card to personalise it.",
    "travelerProfile.correctTitle": "Personalise preferences",
    "travelerProfile.correctBody": "Choose what you like and what you prefer to avoid. Tap a selected choice again to clear it.",
    "travelerProfile.note": "Notes for Mundely",
    "travelerProfile.notePlaceholder": "E.g. I prefer small hotels, no multi-stop flights, I love local food…",
    "travelerProfile.saved": "Profile updated",
    "travelerProfile.notEnoughData": "Mundely needs a little more information to identify your style.",
    "travelerProfile.countries": "Countries",
    "travelerProfile.completedTrips": "Past trips",
    "travelerProfile.reviews": "Reviews",
    "travelerProfile.groupSize": "Usual group",
    "travelerProfile.publicTitle": "Travel style",
    "travelerStyle.relax": "Relax",
    "travelerStyle.culture": "Culture",
    "travelerStyle.sea": "Sea",
    "travelerStyle.adventure": "Adventure",
    "travelerStyle.city": "City",
    "travelerStyle.nature": "Nature",
    "travelerStyle.budget": "Budget",
    "travelerStyle.comfort": "Comfort",
    "travelerStyle.food": "Local food",
    "travelerStyle.social": "Social",
    "travelerStyle.remote": "Off the beaten path",
    "travelerStyle.flexible": "Flexible",
    "nextTrip.whenTitle": 'When do you want to leave?',
    "nextTrip.styleTitle": 'What kind of trip are you looking for?',
    "nextTrip.style.relax": 'Relax',
    "nextTrip.style.culture": 'Culture',
    "nextTrip.style.sea": 'Sea',
    "nextTrip.style.adventure": 'Adventure',
    "nextTrip.style.surprise": 'Surprise me',
    "nextTrip.askAgent": 'Ask the Agent for advice',
    "nextTrip.applyPreferences": 'Update recommendations',
    "nextTrip.editPreferences": 'Edit',
    "nextTrip.chatTitle": 'Talk with your Agent',
    "nextTrip.chatBody": 'Refine the recommendation without starting over.',
    "nextTrip.newSearch": 'New search',
    "nextTrip.composerPlaceholder": 'Write a message…',
    "nextTrip.sendMessage": 'Send message',
    "nextTrip.quick.cheaper": 'Cheaper options',
    "nextTrip.quick.warmer": 'Somewhere warmer',
    "nextTrip.quick.compare": 'Compare the options',
    "nextTrip.quick.more": 'More options',
    "nextTrip.quick.whatToSee": 'What to see',
    "nextTrip.quick.costs": 'Costs and budget',
    "nextTrip.quick.bestTime": 'Best time to go',
    "nextTrip.quick.similar": 'Similar alternatives',
    "nextTrip.live.title": 'Flight and hotel prices',
    "nextTrip.live.subtitle": 'Check real prices for {destination}.',
    "nextTrip.live.origin": 'Departure city',
    "nextTrip.live.originPlaceholder": 'e.g. Naples',
    "nextTrip.live.departure": 'Outbound',
    "nextTrip.live.return": 'Return',
    "nextTrip.live.travelers": 'Travellers',
    "nextTrip.live.search": 'Search live prices',
    "nextTrip.live.destinationUnavailable": 'Choose a specific city or island before searching for live flights.',
    "nextTrip.live.notConfigured": 'Live price search is ready in the app, but the backend provider credentials have not been configured yet.',
    "nextTrip.live.error": 'Live prices could not be retrieved. Please try again shortly.',
    "nextTrip.live.noResults": 'No offers available for these criteria. Try different dates or destination.',
    "nextTrip.live.partial": 'Some providers are unavailable. Only verified offers are shown.',
    "nextTrip.live.openOption": 'Open booking',
    "nextTrip.live.flight": 'Return flight',
    "nextTrip.live.hotel": 'Hotel',
    "nextTrip.live.total": 'Flight + hotel',
    "nextTrip.live.bestAvailable": 'Best available option',
    "nextTrip.live.flightHotelOnly": 'Only available live items are included.',
    "nextTrip.live.remaining": '{amount} of the budget remains.',
    "nextTrip.live.over": 'Over budget by {amount}.',
    "nextTrip.live.checkedAt": 'Last checked: {value}',
    "nextTrip.live.refresh": 'Refresh prices',
    "nextTrip.live.cheaperDates": 'Change dates',
    "nextTrip.live.openHotel": 'Open hotel',
    "nextTrip.live.flightOptions": 'Live flight options',
    "nextTrip.live.hotelOptions": 'Available hotels',
    "nextTrip.live.select": 'Select',
    "nextTrip.live.selected": 'Selected',
    "nextTrip.live.direct": 'Direct',
    "nextTrip.live.stops": '{count} stops',
    "nextTrip.live.rating": 'Rating {value}',
    "nextTrip.live.selectFlightMessage": 'I choose this flight',
    "nextTrip.live.flightSelected": 'Flight selected for this plan',
    "nextTrip.live.flightSelectedNext": 'I can now continue with hotels, itinerary and transfers without losing this choice.',
    "nextTrip.live.selectHotelMessage": 'I choose this hotel',
    "nextTrip.live.hotelSelected": 'Hotel selected for this plan',
    "nextTrip.live.hotelSelectedNext": 'I will keep this property as a reference while we continue building the trip.',
    "nextTrip.actions.title": 'Trip actions',
    "nextTrip.actions.readyToCreate": 'Ready to become a trip',
    "nextTrip.actions.readyToCreateBody": 'When you confirm, I create the trip and can start adding real items to it.',
    "nextTrip.actions.planActive": 'Trip created and linked to this conversation',
    "nextTrip.actions.planActiveBody": 'You can now add places, flights and hotels directly to the trip sections.',
    "nextTrip.actions.createTrip": 'Create trip',
    "nextTrip.actions.openTrip": 'Open trip',
    "nextTrip.actions.addItem": 'Add to itinerary',
    "nextTrip.actions.addFlight": 'Add flight',
    "nextTrip.actions.addHotel": 'Add hotel',
    "nextTrip.actions.needDestination": 'Choose a specific city or island first: I will not create a generic trip for an entire country.',
    "nextTrip.actions.needDates": 'I need exact outbound and return dates to create the trip. Write them in the conversation and I will use those dates.',
    "nextTrip.actions.tripName": '{destination} {year}',
    "nextTrip.actions.tripCreated": 'Trip created for **{destination}**, from **{start}** to **{end}**. From now on I can add stops, flights and hotels directly.',
    "nextTrip.actions.itemAdded": '**{item}** was added to the trip itinerary.',
    "nextTrip.actions.itemAlreadyAdded": '**{item}** is already in the itinerary.',
    "nextTrip.actions.addedFromNextTrip": 'Added from Next trip.',
    "nextTrip.actions.flightTitle": 'Flight {origin} → {destination}',
    "nextTrip.actions.flightAdded": 'The selected flight was added to the trip itinerary.',
    "nextTrip.actions.hotelAdded": '**{hotel}** was added to the trip Hotel section.',
    "nextTrip.quick.city": 'Overview',
    "nextTrip.quick.foods": 'Typical dishes',
    "nextTrip.quick.places": 'Places to see',
    "nextTrip.quick.culture": 'Local culture',
    "nextTrip.continueWith": 'Continue with {destination}',
    "nextTrip.ideasForYou": 'Ideas for you',
    "nextTrip.ideasForYouBody": 'Destinations that match your travel profile.',
    "nextTrip.compatibility": 'Match with your profile',
    "nextTrip.compatibilityShort": 'match',
    "nextTrip.saveIdea": 'Save idea',
    "nextTrip.removeIdea": 'Remove saved idea',
    "nextTrip.suggestionIntro": 'Here are 3 ideas that fit your profile. Tap a destination or continue the conversation.',
    "nextTrip.followUpIntro": 'I updated the proposals based on your latest message.',
    "nextTrip.cardFrom": 'from {price}',
    "nextTrip.cardMatch": 'Match {value}%',
    "community.updateReview": 'Update review',
    "nextTrip.savedIdeas": 'Your saved ideas',
    "nextTrip.savedIdeasBody": 'Keep them handy while you choose your next trip.',
    "nextTrip.matchesTitle": 'Destinations matching your profile',
    "nextTrip.matchesBody": 'Tap a suggestion to use it immediately as the destination to evaluate.',
    "nextTrip.time.soon": 'Leaving soon',
    "nextTrip.time.threeMonths": 'In the next 3 months',
    "nextTrip.time.sixMonths": 'In 6 months',
    "nextTrip.time.nextYear": 'Next year',
    "nextTrip.budget": 'Indicative budget',
    "nextTrip.destination": 'Destination to evaluate',
    "nextTrip.destinationPlaceholder": 'E.g. Japan, Madeira, New York…',
    "nextTrip.destinationRequired": 'Enter a destination before asking what to know before booking.',
    "nextTrip.agentAdvice": 'Agent recommendations',
    "nextTrip.agentAdviceBody": 'Destinations shaped around your preferences and chosen travel period.',
    "nextTrip.experts": 'Ideas from experienced travelers',
    "nextTrip.expertsBody": 'Out of ideas? Explore destinations valued by experienced travelers.',
    "nextTrip.beforeBook": 'Before you book',
    "nextTrip.beforeBookBody": 'Choose a place: best time, weather, costs, trade-offs and what to check.',
    "nextTrip.whereBudget": 'Where can I go with my budget?',
    "nextTrip.whereBudgetBody": 'Set how much you want to spend and get realistic destinations to compare.',
    "nextTrip.loading": 'The agent is preparing your recommendations…',
    "nextTrip.result": 'Personalized recommendation',
    "nextTrip.resultBody": 'Use this as a starting point, then explore the destination in more detail with the agent.',
    "nextTrip.error": 'Recommendations could not be generated. Try again.',
    "nextTrip.prompt.agent": 'Suggest 5 destinations suitable for this traveler and explain concretely why each matches their preferences and travel period.',
    "nextTrip.prompt.experts": 'Suggest 5 destinations an experienced traveler might recommend for experience quality, variety and value for time, avoiding an obvious list. Clearly distinguish aggregated user opinion from facts.',
    "nextTrip.prompt.destination": 'Analyze the selected destination and explain what matters before booking: best time, weather, recommended duration, budget, transport, possible issues, crowds and what to book in advance.',
    "nextTrip.prompt.budget": 'Using the stated budget, suggest 5 realistic destinations and compare trip cost, recommended duration, strengths and main trade-offs.',
    "nextTrip.prompt.timeframe": 'When they want to travel',
    "nextTrip.prompt.budgetLabel": 'Budget',
    "nextTrip.prompt.notSpecified": 'not specified',
    "nextTrip.prompt.destinationLabel": 'Destination',
    "nextTrip.prompt.format": 'Answer without Markdown asterisks. Be concise but concrete; clearly label what is verifiable fact and what comes from traveler preferences/opinions.',
    "nextTrip.prompt.travelStyle": 'Desired travel style',
    "nextTrip.prompt.userRole": 'User',
    "nextTrip.prompt.agentRole": 'Agent',
    "nextTrip.prompt.conversationStart": 'Start a conversation to choose the next trip. Suggest a small number of concrete alternatives and invite the user to refine the choice in later messages.',
    "nextTrip.prompt.conversationContinue": 'Continue the same next-trip conversation. Use all previous context and refine or expand the recommendations based on the latest message instead of starting over.',
    "nextTrip.prompt.profileMatches": "Destinations matching your preferences",
    "nextTrip.prompt.history": 'Conversation so far',
    "nextTrip.prompt.latestMessage": 'Latest user message',
    "nextTrip.prompt.initialRequest": 'Recommend a few destinations that suit me based on the preferences I selected.',
    "nextTrip.prompt.conversationFormat": 'Answer without Markdown asterisks. Be concrete and conversational. Do not repeat questions already answered by the context. When suggesting destinations, keep the first answer to 3 or 4 alternatives with a short reason for each and leave room for follow-up conversation.',
    "expenses.title": 'Trip expenses',
    "expenses.body": 'Record trip costs and keep a separate summary for each currency.',
    "expenses.empty": 'No expenses have been recorded for this trip yet.',
    "expenses.description": 'Description',
    "expenses.amount": 'Amount',
    "expenses.currency": 'Currency',
    "expenses.category": 'Category',
    "expenses.date": 'Date',
    "expenses.payer": 'Paid by',
    "expenses.note": 'Note',
    "expenses.add": 'Add expense',
    "expenses.datePlaceholder": "DD/MM/YYYY",
    "expenses.addedFeedback": "Expense added successfully.",
    "expenses.updatedFeedback": "Expense updated successfully.",
    "feedback.itemAdded": "Item added successfully.",
    "feedback.itemSaved": "Changes saved successfully.",
    "feedback.documentAdded": "Document added successfully.",
    "feedback.checklistAdded": "Checklist item added.",
    "feedback.noteAdded": "Note added successfully.",
    "itinerary.savedFeedback": "Stop saved successfully.",
    "expenses.list": 'Transactions',
    "expenses.listBody": 'Edit or delete expenses already recorded.',
    "expenses.category.transport": 'Transport',
    "expenses.category.stay": 'Accommodation',
    "expenses.category.food": 'Food and drinks',
    "expenses.category.activities": 'Activities',
    "expenses.category.shopping": 'Shopping',
    "expenses.category.fees": 'Fees and taxes',
    "expenses.category.other": 'Other',
    "expenses.me": "Me",
    "expenses.sharedWith": "Shared with",
    "expenses.sharedWithBody": "Choose the participants and how to split the amount.",
    "expenses.split.equal": "Equal parts",
    "expenses.split.percentage": "Percentages",
    "expenses.split.shares": "Shares",
    "expenses.sharesUnit": "shares",
    "expenses.percentageTotal": "Percentage total: {total}%",
    "expenses.browserBody": "All trip costs, organised by currency and participant.",
    "expenses.count": "{count} expenses",
    "expenses.filters": "Expense filters",
    "expenses.filterAll": "All ({count})",
    "expenses.myExpenses": "My expenses",
    "expenses.paidBy": "Paid by {name}",
    "expenses.participantCount": "{count} participants",
    "expenses.perPerson": "per person",
    "expenses.editTitle": "Edit expense",
    "expenses.descriptionPlaceholder": "Expense description",
    "expenses.amountPlaceholder": "0.00",
    "expenses.notePlaceholder": "Add a note",
    "feedback.expenseDeleted": "Expense deleted successfully.",
    "trip.section.statistics": "Statistics",
    "trip.section.statisticsBody": "Complete analysis of this trip's expenses.",
    "statistics.title": "Trip statistics",
    "statistics.body": "All trip expenses aggregated by currency, category, payer and participant.",
    "statistics.empty": "There are no expenses to analyse yet.",
    "statistics.movements": "Transactions",
    "statistics.sharedExpenses": "Shared expenses",
    "statistics.tripDays": "Trip days",
    "statistics.total": "Total",
    "statistics.dailyAverage": "Daily average",
    "statistics.byCategory": "By category",
    "statistics.byCategoryBody": "How much was spent across the different categories.",
    "statistics.byPayer": "Paid by",
    "statistics.byPayerBody": "Total advanced by each payer.",
    "statistics.byParticipant": "Participant shares",
    "statistics.byParticipantBody": "Amount assigned to each participant in shared expenses.",
    "statistics.allExpenses": "All expenses",
    "statistics.allExpensesBody": "Complete history used for these statistics.",
    "statistics.unknownPayer": "Payer not specified",
    "tripHome.quickExpense": "Quick expense",
    "tripHome.openExpenses": "Open expenses",
    "tripHome.documentReady": "Ready",
    "tripHome.documentPending": "Uploading",
    "tripHome.addDocument": "Add document",
    "tripHome.uploadDocument": "Upload document",
    "tripHome.linkPlaceholder": "Paste an https:// link",
    "tripHome.completed": "completed",
    "tripHome.quickChecklistPlaceholder": "New item",
    "tripHome.openChecklist": "Open checklist",
    "tripHome.reminder": "Reminder",
    "tripHome.reminderPlaceholder": "Write a reminder",
    "tripHome.openNotes": "Open notes",
    "tripHome.statistics": "Statistics",
    "tripHome.movements": "transactions",
    "trip.section.expenses": 'Expenses',
    "trip.section.expensesBody": 'Trip costs organized by category and currency.',
    "tripHome.expenses": 'Expenses',
    "tripHome.group.plan": "Plan",
    "tripHome.group.planBody": "Organise your itinerary day by day",
    "tripHome.group.organize": "Organise",
    "tripHome.group.organizeBody": "Keep everything under control",
    "tripHome.group.during": "During the trip",
    "tripHome.group.duringBody": "Useful information always within reach",
    "tripHome.restyle.preparation": "Preparation",
    "tripHome.restyle.preparationAction": "Take stock",
    "tripHome.restyle.pendingChecklist": "Tasks to complete",
    "tripHome.restyle.documentsBody": "Trip files and bookings",
    "tripHome.restyle.offlineReady": "Ready to download",
    "tripHome.restyle.offlineBody": "Keep your trip information with you, even without a connection.",
    "tripHome.restyle.offlineDownload": "Download trip",
    "tripHome.restyle.offlineExcludes": "Includes trip data and documents. Photo album excluded.",
    "tripHome.guide.featureTitle": "Your guide, always with you",
    "tripHome.guide.mapEmpty": "Explore your trip",
    "tripHome.guide.placesEmpty": "Discover places to visit",
    "usefulInfo.plug.otherTypes": "Other sockets in use",
    "usefulInfo.plug.checkAdapter": "Check that your adapter fits the available socket.",
    "tripHome.noNextStopShort": "Add the first stop to get started.",
    "tripHome.countStops": "{count} stops",
    "tripHome.itinerarySummary": "Build your travel route.",
    "tripHome.savedStops": "Saved places",
    "tripHome.countMovements": "{count} transactions",
    "tripHome.countDocuments": "{count} documents",
    "tripHome.documentsSummary": "Passports, bookings, insurance…",
    "tripHome.activitiesPending": "Activities to complete",
    "tripHome.countPlaces": "{count} saved places",
    "tripHome.usefulInfoSummary": "Transport, health, currency and other useful information.",
    "tripHome.usefulInfoGuide": "Travel guide",
    "settings.open": 'Open',
    "settings.termsUse": 'Terms of use',
    "settings.termsUseBody": 'Review the app scope, AI Agent limits and user responsibilities.',
    "settings.privacyPolicy": 'Privacy policy',
    "settings.privacyPolicyBody": 'Review how Mundely handles data, accounts and travel information.',
    "settings.buttonCorners": 'Button corners',
    "settings.buttonCornersBody": 'Choose how square or rounded the app buttons should be.',
    "settings.buttonCornersPill": 'Pill',
    "settings.widgets": 'Widgets',
    "settings.widgetsBody": 'Customise the widgets available on Home and inside trips.',
    "widgets.settingsIntro": 'Configure Mundely Android widgets like in fAInance: text size, colours, transparency, corners, visible content and automatic updates.',
    "widgets.settingsIntroExact": 'Configure the appearance of Android widgets. For Documents, Checklist and Reminders, choose the exact content when you add or reconfigure the widget from the phone Home screen.',
    "widgets.chooseContentOnHome": 'Choose the exact content when you add or reconfigure the widget from the phone Home screen; here you customize text, colours, transparency and updates.',
    "widgets.nextStop": 'Next stop',
    "widgets.nextStopBody": 'Shows the next trip stop and opens the itinerary directly.',
    "widgets.expenses": 'Quick expense',
    "widgets.expensesBody": 'Shows only the button to quickly add an expense to the selected trip.',
    "widgets.expenseHistory": 'Expenses',
    "widgets.expenseHistoryBody": 'Shows the selected trip expense history with complete details and scrolling.',
    "widgets.documents": 'Documents and tickets',
    "widgets.documentsBody": 'Shows a documents and tickets summary and opens Documents.',
    "widgets.checklist": 'Checklist',
    "widgets.checklistBody": 'Shows progress and the next activities still to complete.',
    "widgets.reminder": 'Reminder',
    "widgets.reminderBody": 'Shows the next trip note or reminder.',
    "widgets.calculator": "Calculator",
    "widgets.calculatorBody": "Full calculator directly on your phone Home screen.",
    "widgets.converter": "Currency converter",
    "widgets.converterBody": "Currency converter directly on your phone Home screen.",
    "widgets.preview": "Preview",
    "widgets.createTransaction": "Create transaction",
    "widgets.titleSection": "Title",
    "widgets.showTitle": "Show title",
    "widgets.showTransaction": "Show Create transaction",
    "widgets.specificInstance": "You are customizing this specific widget.",
    "widgets.baseColors": "Base",
    "widgets.keys": "Keys",
    "widgets.primaryKeys": "Primary",
    "widgets.secondaryKeys": "Secondary",
    "widgets.operationKeys": "Operations",
    "widgets.buttonBorders": "Key borders",
    "widgets.offlineUse": "Offline use",
    "widgets.offlineUseBody": "The widget uses the latest available rate and refreshes automatically when connectivity returns.",
    "widgets.converterOfflinePreview": "Offline · 1 CHF = 1.06 EUR",
    "widgets.previewFromCode": "CHF",
    "widgets.previewToCode": "EUR",
    "widgets.previewFromValue": "77 CHF",
    "widgets.previewToValue": "81.62 EUR",
    "widgets.textSize": 'Text size',
    "widgets.textSizeBody": 'Size of the content shown in the widget.',
    "widgets.checklistItems": 'Visible items',
    "widgets.checklistItemsBody": 'Maximum number of checklist items shown in the widget when space is available.',
    "widgets.backgroundTransparency": 'Widget background transparency',
    "widgets.backgroundTransparencyBody": '100% = fully transparent. 0% = solid background.',
    "widgets.colors": 'Colours',
    "widgets.backgroundColor": 'Background',
    "widgets.iconColor": 'Icon colour',
    "widgets.titleColor": 'Title colour',
    "widgets.textColor": 'Text colour',
    "widgets.actionColor": 'Button colour',
    "widgets.buttonCorners": 'Widget button corners',
    "widgets.buttonCornersBody": 'Choose the shape of the widget buttons.',
    "widgets.buttonStyle.square": 'Square',
    "widgets.buttonStyle.sharp": 'Compact',
    "widgets.buttonStyle.soft": 'Soft',
    "widgets.buttonStyle.rounded": 'Rounded',
    "widgets.showHeader": 'Show title',
    "widgets.showHeaderBody": 'Show the widget name at the top.',
    "widgets.showTripName": 'Show trip',
    "widgets.showTripNameBody": 'Show the trip name linked to the widget.',
    "widgets.showSecondary": 'Show details',
    "widgets.showSecondaryBody": 'Show the secondary information row when space allows.',
    "widgets.autoUpdate": 'Automatic update',
    "widgets.autoUpdateBody": 'Update installed widgets when trip data changes.',
    "widgets.maxChars": 'Maximum characters',
    "widgets.maxCharsBody": 'Limit the text shown in the widget.',
    "widgets.maxStops": 'Upcoming stops shown',
    "widgets.maxStopsBody": 'All stops are shown by default. You can limit the list down to one.',
    "widgets.allStops": 'All',
    "widgets.includePastStops": 'Show past stops too',
    "widgets.includePastStopsBody": 'Off by default.',
    "widgets.documentDisplay": 'Document display',
    "widgets.documentDisplayBody": 'Choose whether the widget shows the document or a tappable link.',
    "widgets.documentDisplayImage": 'Document image',
    "widgets.documentDisplayLink": 'Link to open document',
    "widgets.visibleItems": 'Visible items',
    "widgets.visibleItemsBody": 'Choose how many checklist activities to show when space allows.',
    "widgets.saveUpdate": 'Save and update widget',
    "widgets.reset": 'Reset',
    "widgets.saved": 'Widget settings saved and applied.',
    "widgets.preview.tripName": 'Lisbon weekend',
    "widgets.preview.nextStop": 'Itinerary still empty',
    "widgets.preview.nextStopSecondary": 'Add the first stop to start your trip.',
    "widgets.preview.documents": '0 documents',
    "widgets.preview.tickets": 'Tickets: 0',
    "widgets.preview.reminder": 'No notes yet',
    "widgets.preview.reminderSecondary": 'Open notes to add one.',
    "widgets.preview.movements": '4 movements',
    "widgets.preview.checklist": 'Activities to complete',
    "widgets.preview.checkItem1": 'Prepare documents',
    "widgets.preview.checkItem2": 'Check tickets',
    "widgets.preview.addExpense": 'Add expense',
    "widgets.preview.open": 'Open',
    "widgets.colorPicker.title": 'Choose a colour',
    "widgets.colorPicker.presets": 'Presets',
    "widgets.colorPicker.custom": 'Custom',
    "widgets.colorPicker.presetColors": 'Preset colours',
    "widgets.colorPicker.customColor": 'Custom colour',
    "widgets.colorPicker.htmlCode": 'HTML code',
    "widgets.colorPicker.invalidHtml": 'Enter a valid HTML colour code',
    "widgets.colorPicker.apply": 'Apply colour',
    "widgets.colorPicker.color": 'Colour',
    "widgets.colorPicker.htmlPlaceholder": '#124848',
    "settings.barsSection": 'Top and bottom bars',
    "settings.topBar": 'Top bar',
    "settings.topBarBody": 'Settings prepared for future top bar customization.',
    "settings.bottomBar": 'Bottom bar',
    "settings.bottomBarBody": 'Settings prepared for future bottom navigation customization.',
    "settings.supportEmail": 'Contact support',
    "settings.supportEmailBody": 'Mundely support channel.',
    "settings.reportProblem": 'Report a problem',
    "settings.reportProblemBody": 'Send a technical report or malfunction.',
    "settings.faq": 'Frequently asked questions',
    "settings.faqBody": 'Quick answers to common usage questions.',
    "settings.website": 'Website',
    "settings.websiteBody": 'Official Mundely information, updates and resources.',
    "settings.linksPreparedBody": 'The structure is ready. Final support, website and social addresses will be connected later.',
    "settings.appInfoTagline": 'Your intelligent space to organize, experience and remember trips.',
    "settings.webSocial": 'Web and social',
    "settings.webSocialBody": 'Official Mundely channels prepared for their final links.',
    "quiz.title": "Get to know you", "quiz.menuBody": "Discover your travel style and best-matching destinations.", "quiz.intro": "Choose instinctively between two alternatives. Your profile updates and syncs across your devices.", "quiz.choose": "Which do you prefer?", "quiz.or": "or", "quiz.questionProgress": "Question {current} of {total}", "quiz.complete": "Profile complete", "quiz.completeBody": "You can change any answer at any time.", "quiz.history": "Your answers", "quiz.historyBody": "Review and edit your history: the Top 10 will be recalculated.", "quiz.unanswered": "Not answered", "quiz.top10": "Your Top 10", "quiz.top10Body": "Indicative match calculated from your preferences.", "quiz.catalogHint": "The engine compares at least {count} destinations and can expand through the cloud catalog.", "quiz.top10Empty": "Answer the first question to generate the ranking.", "quiz.saveError": "Save failed. The answer was not applied.", "quiz.syncWarning": "Sync is temporarily unavailable: you are seeing the latest copy saved on this device.", "quiz.sea": "Sea", "quiz.mountain": "Mountains", "quiz.city": "City", "quiz.nature": "Nature", "quiz.warm": "Warm", "quiz.cold": "Cold", "quiz.planned": "Organized", "quiz.adventure": "Adventure", "quiz.luxury": "Luxury", "quiz.budget": "Budget", "quiz.relax": "Relax", "quiz.activity": "Activities", "quiz.culture": "Culture", "quiz.nightlife": "Nightlife", "quiz.short": "Short trip", "quiz.long": "Long trip", "quiz.destination.bali": "Bali", "quiz.destination.tokyo": "Tokyo", "quiz.destination.iceland": "Iceland", "quiz.destination.maldives": "Maldives", "quiz.destination.newYork": "New York", "quiz.destination.dolomites": "Dolomites", "quiz.destination.barcelona": "Barcelona", "quiz.destination.costarica": "Costa Rica", "quiz.destination.paris": "Paris", "quiz.destination.thailand": "Thailand", "quiz.destination.norway": "Norway", "quiz.destination.dubai": "Dubai", "quiz.destination.lisbon": "Lisbon", "quiz.destination.rome": "Rome", "quiz.destination.london": "London", "quiz.destination.athens": "Athens", "quiz.destination.istanbul": "Istanbul", "quiz.destination.marrakech": "Marrakech", "quiz.destination.capeTown": "Cape Town", "quiz.destination.zanzibar": "Zanzibar", "quiz.destination.singapore": "Singapore", "quiz.destination.seoul": "Seoul", "quiz.destination.vietnam": "Vietnam", "quiz.destination.sriLanka": "Sri Lanka", "quiz.destination.nepal": "Nepal", "quiz.destination.patagonia": "Patagonia", "quiz.destination.peru": "Peru", "quiz.destination.mexico": "Mexico", "quiz.destination.canadaRockies": "Canadian Rockies", "quiz.destination.newZealand": "New Zealand",
    "settings.profileBody": "Personal details, account, access and security.",
    "settings.security": "Security",
    "settings.securityBody": "Password, connected devices, PIN and biometrics.",
    "settings.general": "General",
    "settings.generalBody": "Language, currency, measurement units and date format.",
    "settings.appearance": "Appearance",
    "settings.appearanceBody": "Theme, colours, button style, widgets and layouts.",
    "settings.notifications": "Notifications & Reminders",
    "settings.notificationsBody": "Operational alerts, reminders, AI, collaboration and communications.",
    "profile.socialTitle": "Social profiles",
    "profile.socialBody": "Add links to your social profiles and choose whether to display them publicly.",
    "profile.socialPublic": "Show social links on my public profile",
    "profile.socialInvalid": "Enter a valid HTTPS profile link for the indicated social network.",
    "settings.infoData": "Plans, data & support",
    "settings.infoDataBody": "Plan, data, support, privacy and app information.",
    "settings.localLock": "Device protection",
    "settings.localLockBody": "Choose how to protect access to data available on this device.",
    "settings.nativeOnly": "Biometrics require the Android or iOS app. PIN and account password can also be used on the Web.",
    "settings.currentLock": "Current protection",
    "settings.pin": "PIN",
    "settings.biometric": "Biometrics",
    "settings.noLock": "No local protection",
    "settings.savePin": "Save PIN",
    "settings.disableLock": "Disable local protection",
    "settings.lockDisabled": "Local protection disabled.",
    "settings.lockSaved": "Security setting saved.",
    "settings.pinInvalid": "The PIN must contain exactly 4 digits.",
    "settings.protectApp": "Protect the app",
    "settings.protectAppBody": "Choose whether to unlock Mundely with biometrics, your account password, or a 4-digit PIN.",
    "settings.biometricMethodDesc": "Fingerprint, Face ID, or device credential",
    "settings.passwordMethod": "Account password",
    "settings.passwordMethodDesc": "Use the same password as your email account",
    "settings.pinFourDigits": "4-digit PIN",
    "settings.pinMethodDesc": "Local 4-digit code",
    "settings.pinSaved": "PIN saved.",
    "settings.pinConfigured": "PIN configured",
    "settings.pinRequired": "Set a 4-digit PIN first.",
    "settings.passwordMethodInfo": "The account password works for accounts created with email and password. Google or Apple accounts may not have a Mundely password that can be verified locally.",
    "settings.enableBiometricReason": "Confirm biometric app lock activation",
    "settings.disableBiometricReason": "Confirm app lock deactivation",
    "settings.lockEnabled": "App protection enabled.",
    "settings.lockUpdated": "Settings updated.",
    "settings.lockReturn": "Require lock when returning to the app",
    "settings.lockReturnBody": "Choose how long Mundely can remain in the background before it locks again.",
    "settings.timeoutNow": "Immediately",
    "settings.timeout1": "1 minute",
    "settings.timeout5": "5 minutes",
    "settings.timeout15": "15 minutes",
    "settings.localLockInfo": "Local app lock does not replace Google, Apple, or email sign-in: it only protects access to data already available on this device.",
    "settings.appearanceApp": "Theme & style",
    "settings.appearanceInterface": "Interface",
    "settings.appearanceAppBody": "Theme, colours, button shape and interface appearance.",
    "settings.languageFormats": "Language and formats",
    "settings.languageFormatsBody": "These preferences are saved to your account and synchronized across devices.",
    "settings.generalFormatsBody": "Choose the language, currency, measurement units and date format used by the app.",
    "settings.preferencesSaved": "Preferences updated.",
    "settings.appearanceSaved": "Appearance updated.",
    "settings.notificationsSaved": "Notification preferences updated.",
    "settings.notificationPreferences": "Notification preferences",
    "settings.notificationOperational": "Operational alerts",
    "settings.notificationOperationalBody": "Important updates about the app and your account.",
    "settings.notificationReminders": "Reminders",
    "settings.notificationRemindersBody": "Reminders related to trips, activities and deadlines.",
    "settings.notificationAi": "AI suggestions",
    "settings.notificationAiBody": "Alerts and suggestions generated by Mundely intelligent features.",
    "settings.notificationCollaboration": "Collaboration",
    "settings.notificationCollaborationBody": "Invitations, shared changes and other participants’ activity.",
    "settings.notificationMarketing": "News & communications",
    "settings.notificationMarketingBody": "Updates about news, features and non-operational communications.",
    "settings.darkMode": "Dark Mode",
    "settings.darkModeBody": "Switch to the dark color theme for more comfortable viewing.",
    "settings.buttonColor": "Button color",
    "settings.buttonColorBody": "Choose the primary color used by app buttons.",
    "settings.themeSaved": "Theme updated.",
    "settings.usefulInfo": "Useful Info",
    "settings.usefulInfoBody": "Choose the default layout for the Useful Info tab.",
    "settings.travelLayouts": "Itinerary & Timeline",
    "settings.travelLayoutsBody": "Try eight different Itinerary layouts and eight Timeline layouts and choose which ones to use across the app.",
    "settings.travelLayoutsSaved": "Layout updated.",
    "settings.itineraryLayouts": "Itinerary layouts",
    "settings.itineraryLayoutsBody": "This choice changes the main itinerary view across all trips.",
    "settings.timelineLayouts": "Timeline layouts",
    "settings.timelineLayoutsBody": "This choice changes the graphical timeline view across all trips.",
    "settings.itineraryLayout1": "Daily cards",
    "settings.itineraryLayout1Body": "Days shown as cards with ordered activities.",
    "settings.itineraryLayout2": "Compact agenda",
    "settings.itineraryLayout2Body": "Dense list focused on times and key details.",
    "settings.itineraryLayout3": "Column planner",
    "settings.itineraryLayout3Body": "Days side by side in a visual planner.",
    "settings.itineraryLayout4": "Magazine",
    "settings.itineraryLayout4Body": "Large cards, strong imagery and editorial rhythm.",
    "settings.itineraryLayout5": "Route",
    "settings.itineraryLayout5Body": "Days are connected by a visible travel line.",
    "settings.itineraryLayout6": "Hourly agenda",
    "settings.itineraryLayout6Body": "A time-first view of the day's sequence.",
    "settings.itineraryLayout7": "Mosaic",
    "settings.itineraryLayout7Body": "A visual grid with dynamic day cards.",
    "settings.itineraryLayout8": "Minimal",
    "settings.itineraryLayout8Body": "Essential, clean and highly readable.",
    "settings.timelineLayout1": "Vertical line",
    "settings.timelineLayout1Body": "Classic timeline with daily nodes.",
    "settings.timelineLayout2": "Geographic route",
    "settings.timelineLayout2Body": "Stops and transfers presented as a travel route.",
    "settings.timelineLayout3": "Chapters",
    "settings.timelineLayout3Body": "Each destination becomes a chapter of the journey.",
    "settings.timelineLayout4": "Double lane",
    "settings.timelineLayout4Body": "Activities alternate on both sides of the time line.",
    "settings.timelineLayout5": "Ribbon",
    "settings.timelineLayout5Body": "Horizontal sequence of connected blocks.",
    "settings.timelineLayout6": "Calendar",
    "settings.timelineLayout6Body": "Timeline organized like a visual calendar.",
    "settings.timelineLayout7": "Schematic map",
    "settings.timelineLayout7Body": "Illustrated route with nodes, curves and stops.",
    "settings.timelineLayout8": "Cinematic",
    "settings.timelineLayout8Body": "Large scenes, dates and titles in a visual-story style.",
    "settings.sections": "Sections",
    "settings.preferencesPending": "Changes saved on this device, waiting to sync.",
    "settings.preferencesConflict": "Options changed on another device. Reopen this section and repeat your change.",
    "settings.sectionsBody": "Configure the options used by individual app sections.",
    "settings.sectionsHotels": "Hotels",
    "settings.sectionsHotelsBody": "Manage the values available in the hotel Booked with field.",
    "settings.sectionsRestaurants": "Restaurants",
    "settings.sectionsRestaurantsBody": "Manage the values available in the restaurant Booked with field.",
    "settings.sectionsChecklist": "Checklist",
    "settings.sectionsChecklistBody": "Manage the categories available in trip checklists.",
    "settings.sectionsChecklistCategories": "Checklist · Categories",
    "settings.sectionsParticipants": "Participants",
    "settings.sectionsWorldMap": "My world colours",
    "settings.sectionsWorldMapBody": "Choose the map colours for Visited, Lived there and Not visited.",
    "settings.sectionsWorldMapHelp": "These colours are used in the My world map and sync with your profile.",
    "settings.sectionsWorldMapSaved": "Map colours updated.",
    "settings.sectionsWorldMapReset": "Restore defaults",
    "settings.sectionsWorldMapSaveError": "The map colours could not be saved.",
    "settings.sectionsParticipantsBody": "Manage the roles available for trip participants.",
    "settings.sectionsParticipantRoles": "Participants · Roles",
    "settings.sectionsHotelBookedWith": "Hotels · Booked with",
    "settings.sectionsRestaurantBookedWith": "Restaurants · Booked with",
    "settings.sectionsListBody": "Add, rename, reorder or archive values. Archived values remain valid in existing data but are hidden from new entries.",
    "settings.sectionsAddPlaceholder": "New value",
    "settings.sectionsAdd": "Add value",
    "settings.sectionsCustomValue": "Allows a custom value",
    "settings.moveUp": "Move up",
    "settings.moveDown": "Move down",
    "settings.archive": "Archive",
    "settings.archivedValues": "Archived values",
    "settings.restoreDefaults": "Restore default values",
    "settings.usefulInfoLayoutBody": "Choose which of the five layouts to use across all trips. Layout 1 is the default.",
    "settings.usefulInfoLayout1": "Layout 1 · Coloured sections",
    "settings.usefulInfoLayout2": "Layout 2 · Summary + details",
    "settings.usefulInfoLayout3": "Layout 3 · Expandable sections",
    "settings.usefulInfoLayout4": "Layout 4 · Compact cards",
    "settings.usefulInfoLayout5": "Layout 5 · Quick summary",
    "settings.usefulInfoLayoutSaved": "Useful Info layout updated.",
    "settings.default": "Default",
    "settings.prepared": "Prepared",
    "settings.usefulInfoPreparedBody": "The structure is ready. We will define the Useful Info options here when we analyze the tab.",
    "billing.feelsLike": "Feels like",
    "billing.wind": "Wind",
    "billing.sharePassword": "Link password",
    "billing.shareExpiry": "Link expiry (optional)",
    "billing.revokeLink": "Disable link",
    "billing.completeRequired": "Available with the Complete Plan",
    "billing.preserved": "Your data and preferences are preserved. Upgrade to the Complete Plan to use this feature.",
    "billing.viewPlans": "View plans",
    "billing.actionError": "Could not complete the operation. Check your connection and try again.",
    "billing.manual": "Trips and manual entries",
    "billing.tripSuggestions": "Contextual activity suggestions",
    "billing.tripReplanning": "Intelligent itinerary replanning",
    "billing.voice": "AI voice assistant",
    "billing.photoAi": "AI photo selection",
    "billing.weather": "Weather",
    "billing.weatherFree": "Average climate and 2 days",
    "billing.weatherComplete": "14 days and hourly detail",
    "billing.widgets": "Widgets",
    "billing.widgetsFree": "Itinerary, checklist, expense, notes, calculator, converter",
    "billing.widgetsComplete": "All, including documents and expense history",
    "billing.stats": "Expense statistics",
    "billing.statsFree": "Single trip",
    "billing.statsComplete": "Comparisons, trends and insights",
    "billing.fx": "Automatic currency conversion",
    "billing.fxFree": "Manual converter",
    "billing.sharing": "Public link",
    "billing.sharingFree": "Entire trip, revocable",
    "billing.sharingComplete": "Sections, password and expiry",
    "billing.offline": "Offline access",
    "billing.cache": "Standard cache",
    "billing.fullDownload": "Full trip download",
    "billing.backup": "Account export, backup and restore",
    "billing.days": "days",
    "billing.tools": "Calculator, converter and fAInance",
    "billing.importExport": "Import and single-trip PDF/Excel",
    "billing.collaboration": "Invitations, roles and sync",
    "billing.community": "Community and preferences",
    "billing.live": "Live services, calendar and optimization — planned",
    "billing.personal": "Your plan follows your account, including shared trips.",
    "billing.trialActive": "Complete trial active",
    "billing.until": "Complete access until",
    "billing.cancelScheduled": "Renewal disabled. Your plan stays active until expiry.",
    "billing.statusError": "Unable to refresh your plan. Paid operations require server verification.",
    "billing.notMeasured": "Usage not measured yet",
    "billing.refreshUsage": "Refresh usage",
    "billing.overQuota": "Storage exceeds your quota. Existing files remain accessible. Delete files or upgrade before uploading.",
    "billing.trialBody": "Try all Complete features for 30 days, once per account. No automatic charge.",
    "billing.startTrial": "Start 30-day trial",
    "billing.trialUsed": "You have already used your free trial.",
    "billing.cancelRenewal": "Disable renewal",
    "map.showAll": "Show all",
    "travelerProfile.guidanceBody": "Tell us what you love and what you want to avoid. Mundely will use these preferences to personalise your trips.",
    "tools.createExpense": "Create an expense",
    "tools.expenseBody": "Use this result as an expense amount. You can complete the details before saving.",
    "tools.chooseTrip": "Which trip?",
    "tools.noTrips": "Create a trip first to record an expense.",
    "quiz.upNext": "Your next choices",
    "quiz.upNextBody": "One answer at a time, to get to know you better.",
    "billing.freeForever": "No subscription",
    "billing.bestValue": "Best value",
    "billing.recoveryTitle": "Trip trash and version history",
    "billing.recoveryBody": "The Complete Plan lets you recover deleted trips and restore earlier versions within 30 days.",
    "travelerProfile.neutral": "Automatic",
    "travelerProfile.prefer": "I like it",
    "travelerProfile.avoid": "Prefer to avoid",
    "profile.searchCountry": "Search for a country",
    "profile.countryHint": "Tap the field and enter the first letters.",
    "profile.noCountry": "No results",
    "quiz.destinationDetail": "A destination that matches your preferences. Explore it with Mundely and decide how to organise your trip.",
    "quiz.exploreDestination": "Explore with Mundely",
    "quiz.destinationPrompt": "I would like to plan a trip to {destination}. Help me explore this destination based on my preferences.",
    "legal.welcome": "Before you start",
    "legal.intro": "You may review the Terms and Privacy Notice at any time. Confirm both acknowledgements to continue.",
    "legal.read": "Read",
    "legal.toRead": "To read",
    "legal.acceptTerms": "I accept the Terms of Use.",
    "legal.acceptPrivacy": "I acknowledge receipt of the Privacy Notice.",
    "legal.continue": "Accept and continue",
    "legal.decline": "Decline · Sign out",
    "legal.readEnd": "You have reached the end of the document.",
    "legal.websiteVersion": "View the page on the Mundely website",
    "legal.loadError": "Previous acceptance could not be verified. You can read the documents and retry with an available connection.",
    "legal.saveError": "Acceptance was not confirmed. Check your connection and retry: your preferences remain saved.",
    "common.actions": "Actions",
    "trips.inProgress": "Trips in progress",
    "trips.future": "Upcoming trips",
    "trips.finished": "Past trips",
    "trips.sectionEmpty": "No trips in this section.",
    "profile.openPublic": "Open profile",
    "travelerProfile.generate": "Generate guidance",
    "travelerProfile.generatedTitle": "Suggested guidance",
    "travelerProfile.generatedBody": "Review and edit the text. It will be inserted in the field, and you can save it when ready.",
    "travelerProfile.useGenerated": "Use this guidance",
    "travelerProfile.generatedIntro": "Personalise suggestions using the information I have added to Mundely.",
    "travelerProfile.generatedAnswers": "I have made {count} choices about my travel preferences.",
    "travelerProfile.generatedFavorites": "I prefer: {styles}.",
    "travelerProfile.generatedSignals": "My answers and reviews suggest interest in: {styles}.",
    "travelerProfile.generatedAvoid": "I prefer to avoid: {styles}.",
    "travelerProfile.generatedCountries": "I have recorded {count} countries in my profile.",
    "travelerProfile.generatedTrips": "I have {count} completed trips.",
    "travelerProfile.generatedDestinations": "My trips include: {places}.",
    "travelerProfile.generatedDuration": "Recorded trips last approximately {count} days on average.",
    "travelerProfile.generatedGroup": "The group recorded in my trips averages {count} people.",
    "travelerProfile.generatedDetails": "Recorded activities and stops include: {details}.",
    "travelerProfile.generatedEnd": "Use these signals as a starting point and ask me when a preference is unclear.",
    "travelerProfile.knownTitle": "What Mundely knows",
    "travelerProfile.knownBody": "Profile and trip information used to personalise suggestions.",
    "travelerProfile.people": "{count} people",
    "ai.voicePlanTitle": "Voice is available with the Complete Plan",
    "ai.voicePlanBody": "You can keep typing on the Free plan. The microphone requires the Complete Plan.",
    "settings.cornersRounded": "Rounded",
    "settings.cornersSoft": "Soft",
    "settings.cornersSquare": "Square",
    "settings.cornersSharp": "Sharp",
    "settings.metricExample": "Kilometres, kilograms and Celsius. E.g. 10 km · 70 kg · 20 °C",
    "settings.imperialExample": "Miles, pounds and Fahrenheit. E.g. 6.2 mi · 154 lb · 68 °F",
    "settings.dateDayFirst": "Day / month / year",
    "settings.dateMonthFirst": "Month / day / year",
    "settings.dateYearFirst": "Year / month / day",
    "layout.day": "Day {number}",
    "layout.trip": "Your trip",
    "layout.useful": "Useful information",
    "layout.example": "Example",
    "layout.passport": "Passport",
    "layout.rome": "Rome",
    "layout.florence": "Florence",
    "layout.venice": "Venice",
    "layout.museum": "Museum",
    "layout.lunch": "Lunch",
    "layout.park": "Park",
    "billing.completePlanLabel": "Complete Plan",
    "home.allTrips": "All my trips",
    "settings.unitDistance": "Distance",
    "settings.unitWeight": "Weight",
    "settings.unitTemperature": "Temperature",
    "settings.metricShortExample": "10 km · 70 kg · 20 °C",
    "settings.imperialShortExample": "6.2 mi · 154 lb · 68 °F",
    "travelerProfile.noGenerationData": "Add answers or trip information to generate personalised guidance.",
    "travelerProfile.recordedCountries": "Recorded countries",
    "travelerProfile.countryHint": "Visited or lived in",
    "travelerProfile.openTripsHint": "Open your trips",
    "travelerProfile.myReviews": "Your reviews",
    "travelerProfile.myReviewsBody": "Reviews you have published about countries, cities and places.",
    "travelerProfile.reviewsHint": "Countries, cities and places reviewed",
    "travelerProfile.groupAverage": "Average group size",
    "travelerProfile.groupHint": "You and recorded companions",
    "travelerProfile.tripGroups": "Your travel groups",
    "travelerProfile.tripGroupsBody": "The average considers trips with recorded companions, including you in the number of people. These are the groups used for the estimate.",
    "travelerProfile.openTravelGroup": "Open participants",
    "travelerProfile.sourceEmpty": "There is no information to show in this section.",
    "travelerProfile.avoidShort": "Avoid",
    "profile.cloudSpaceInfo": "Your plan’s cloud storage",
    "profile.cloudSpaceBody": "The {plan} plan includes {limit} of total cloud storage. Personal photos, documents and trip files share this limit: each section does not have a separate allowance.",
    "profile.exitApp": "Log out of the app",
    "profile.exitConfirm": "Do you want to log out of your account?",
    "expenses.date.today": "Today",
    "expenses.date.yesterday": "Yesterday",
    "expenses.date.specific": "Specific date",
    "world.cityNote": "Note",
    "tripHome.lastActivity": "Last activity",
    "tripHome.organizedDays": "{count} days planned",
    "tripHome.totalDays": "Out of {count} trip days",
    "tripHome.stays": "Stays",
    "tripHome.savedStays": "Properties added to your trip",
    "world.searchCities": "Search city or country",
    "world.cityGroupCount": "{count} recorded cities",
    "world.noCityMatches": "No cities match your search.",
    "itinerary.viewDetails": "View details: {title}",
    "home.flexibleTime": "Flexible time",
    "home.toolsBody": "Calculator and currency exchange, always at hand.",
    "billing.pricingLater": "Purchases will be available after activation in the stores.",
    "billing.pricesTitle": "Choose your plan",
    "billing.freePlan": "Free",
    "billing.monthlyPlan": "Complete monthly",
    "billing.annualPlan": "Complete annual",
    "billing.month": "month",
    "billing.year": "year",
    "billing.upgradePrices": "Complete: {monthly}/month or {annual}/year.",
    "billing.downgrade": "When Complete expires",
    "billing.downgradeBody": "No data is deleted. Files remain visible and downloadable; new uploads are blocked above 100 MB. A fresh 20-use Free AI allowance starts. Premium widgets keep their position with access locked.",
    "billing.layoutsPending": "The four final layouts and the Free layout are still to be selected. Current preferences are preserved.",
    "billing.aiLimit": "You have reached your 20 AI uses this month.",
    "settings.plan": "Plan & subscription",
    "settings.planBody": "Active plan, limits and subscription management.",
    "settings.currentPlan": "Current plan",
    "settings.planPreparedBody": "Full purchase management will be connected to the centralized Premium entitlement system.",
    "settings.planUnlimited": "Unlimited",
    "settings.planYes": "Yes",
    "settings.planNo": "No",
    "settings.planAiRequests": "Monthly AI requests",
    "settings.planTrips": "Available trips",
    "settings.planStorage": "Cloud storage",
    "settings.planRecovery": "Trash and recovery",
    "settings.planCompare": "Compare plans",
    "settings.planCompareBody": "Limits are read from Mundely remote configuration and can be updated without reinstalling the app.",
    "settings.planFeature": "Feature",
    "settings.planFreeActiveBody": "You are using Mundely Free.",
    "settings.planPremiumActiveBody": "Your account has access to the enabled Premium features.",
    "settings.planBenefitRecovery": "Recovery and versioning",
    "settings.planBenefitRecoveryBody": "Restore deleted items and use the recovery features available for your plan.",
    "settings.planBenefitAi": "More AI",
    "settings.planBenefitAiBody": "AI limits are centrally managed and adapt to the active plan.",
    "settings.planBenefitStorage": "More cloud storage",
    "settings.planBenefitStorageBody": "Available storage follows the limits defined for your plan.",
    "settings.planBenefitTrips": "More trips",
    "settings.planBenefitTripsBody": "The maximum number of trips is managed through remote configuration.",
    "settings.planUpgradeTitle": "Upgrade to Premium",
    "settings.planUpgradeBody": "This page is already connected to your account entitlements. Store purchases will be enabled when Android and Apple products are configured.",
    "settings.planUpgradeNotAvailable": "Purchases not active yet",
    "settings.planPremiumThanks": "Premium is active on your account.",
    "settings.data": "Data",
    "settings.dataBody": "Export, data recovery and account deletion.",
    "settings.appInfo": "App info",
    "settings.appInfoBody": "Environment, available languages and Mundely technical information.",
    "settings.support": "Support",
    "settings.supportBody": "Help, FAQs and contacts.",
    "settings.supportPreparedBody": "This section is prepared for FAQs, contacts and support tools.",
    "settings.faqSyncQuestion": "How are my trips synchronized?",
    "settings.faqSyncAnswer": "Changes are synchronized to the cloud when you are online. If you work offline, Mundely keeps your changes and retries synchronization when a connection becomes available.",
    "settings.faqOfflineQuestion": "Can I use Mundely without a connection?",
    "settings.faqOfflineAnswer": "Yes. Information already available on the device remains accessible and many changes are queued until the connection returns.",
    "settings.faqAiQuestion": "How does the AI Agent use my data?",
    "settings.faqAiAnswer": "The Agent uses the context needed to help with your trip, such as preferences, itinerary and information you choose to share. Personal content is not included in Analytics events.",
    "settings.faqPrivacyQuestion": "Can I control usage data sharing?",
    "settings.faqPrivacyAnswer": "Yes. From your Profile you can enable or disable anonymous Analytics. This choice does not change Mundely’s main features.",
    "settings.faqFainanceQuestion": "How does the fAInance connection work?",
    "settings.faqFainanceAnswer": "During testing the connection uses fAInance Test only. The request must be approved by the specified fAInance account before the two apps are shown as connected.",
    "settings.supportContacts": "Contacts and links",
    "settings.supportContactsBody": "Links become available when they are configured for the current environment.",
    "settings.notConfigured": "Not configured yet",
    "settings.diagnosticsTitle": "Support diagnostics",
    "settings.diagnosticsBody": "Copy environment, platform and technical configuration useful for a support report, without personal content.",
    "settings.diagnosticsCopy": "Copy diagnostics",
    "settings.diagnosticsCopied": "Copied",
    "settings.linksManagedBody": "Website, contacts, legal documents and social links are managed by Mundely configuration and can be updated without changing this page.",
    "settings.platform": "Platform",
    "settings.firebaseProject": "Firebase project",
    "settings.currentLanguage": "Current language",
    "settings.analyticsStatus": "Analytics",
    "settings.nativeStatus": "App mode",
    "settings.enabled": "Enabled",
    "settings.disabled": "Disabled",
    "settings.nativeApp": "Native app",
    "settings.webApp": "Web",
    "settings.appName": "App",
    "settings.environment": "Environment",
    "settings.production": "Production",
    "settings.test": "Test",
    "settings.languages": "Languages",
    "settings.session": "Session",
    "settings.sessionBody": "Sign out of Mundely on this device.",
    "home.greeting": "Hi, {name}",
    "home.corporate.plannedIntro": "Your next trip is taking shape.",
    "home.corporate.prepare": "Before you leave",
    "home.corporate.pending": "{count} items to complete",
    "home.corporate.checklist": "Open your trip checklist",
    "home.corporate.today": "Today, in {place}.",
    "home.corporate.day": "Day {count}",
    "home.corporate.nextStop": "Your next stop",
    "home.corporate.noStop": "No upcoming stop for today",
    "home.corporate.openItinerary": "Explore your itinerary",
    "home.corporate.savedStop": "A stop saved in your itinerary",
    "home.corporate.openStop": "Open this stop",
    "home.corporate.worldTitle": "Your world. Your story.",
    "home.corporate.worldFirst": "Your world starts here.",
    "home.corporate.newChapter": "Where will your next trip take you?",
    "home.corporate.newDeparture": "Plan a new departure",
    "home.corporate.worldBody": "Photos, visited places and memories",
    "home.corporate.restDay": "The rest of your day",
    "home.corporate.tools": "Travel tools",
    "home.command.title": "Trip",
    "home.command.transport": "Next transport",
    "home.command.transportEmpty": "No transport scheduled",
    "home.command.booking": "Next booking",
    "home.command.bookingEmpty": "No booking saved",
    "home.command.weather": "Daily forecast",
    "home.command.weatherEmpty": "No forecast saved for this date",
    "home.command.savedWeather": "Saved forecast",
    "home.command.useful": "Useful information",
    "home.command.usefulBody": "Useful facts for your destinations",
    "home.command.spending": "Recorded expenses",
    "home.command.spendingEmpty": "No expenses recorded",
    "home.command.recent": "Latest expense",
    "home.command.reminder": "Next reminder",
    "home.command.reminderEmpty": "No pending tasks",
    "home.command.pending": "{count} pending tasks",
    "home.command.reviewItinerary": "Review itinerary",
    "home.command.openAi": "AGENT",
    "home.command.agentBody": "Ask for help with your journey",
    "home.tripToPlan": "To plan",
    "home.overview": "Your world in numbers",
    "home.traveler": "traveller",
    "home.subtitle": "This is where we will build your travel experience.",
    "home.newTrip": "New trip",
    "home.chooseTrip": "Choose trip",
    "trips.subtitle": "Choose an existing trip or create a new one.",
    "trips.new": "New trip",
    "trips.emptyBody": "Create your first trip to start organizing the itinerary, map, documents and all other sections.",
    "trips.saved": "Saved trips",
    "trips.createTitle": "Create a new trip",
    "trips.createBody": "Enter the basic information. You can complete the trip in its dedicated sections.",
    "trips.name": "Trip name",
    "trips.namePlaceholder": "E.g. Philippines 2026",
    "trips.destination": "Destination",
    "trips.destinationPlaceholder": "E.g. Philippines",
    "trips.startDate": "Departure date",
    "trips.endDate": "Return date",
    "trips.createAction": "Create trip",
    "trips.createRequired": "Enter the trip name, destination and dates.",
    "trips.createDateError": "The return date cannot be earlier than the departure date.",
    "trip.selected": "Selected trip",
    "trip.allTrips": "All trips",
    "trip.export": "Export trip",
    "trip.changeCoverPhoto": "Change cover",
    "trip.changeProfilePhoto": "Change trip photo",
    "trip.editHome": "Edit home",
    "trip.finishEditHome": "Finish editing home",
    "trip.photoInvalid": "Select a valid image file.",
    "trip.photoError": "The photo could not be processed. Try again.",
    "trip.photosAiPrompt": "For the trip to {destination}, choose one representative candidate for the trip profile photo and one for the cover. Reply only with JSON in the format {\"profileIndex\":0,\"coverIndex\":1}. Candidates: {candidates}",
    "trip.share": "Share trip",
    "trip.comingSoon": "This function is prepared and will be implemented in its dedicated phase.",
    "trip.destinationPending": "Destination to be defined",
    "trip.datesPending": "Dates to be defined",
    "trip.navigation": "Trip sections",
    "trip.collapseNavigation": "Collapse menu",
    "trip.expandNavigation": "Expand menu",
    "trip.closeNavigation": "Close sections",
    "trip.workspace": "Trip workspace",
    "trip.structureReady": "Structure ready",
    "trip.group.organize": "Organize",
    "trip.group.during": "During the trip",
    "trip.group.content": "Content",
    "trip.section.overview": "Trip home",
    "trip.section.overviewBody": "Trip overview with quick access to every section.",
    "trip.section.itinerary": "Itinerary",
    "trip.section.itineraryBody": "Stops, days, transfers and the trip schedule.",
    "trip.section.hotels": "Hotels",
    "trip.section.hotelsBody": "Properties, bookings and stays for this trip.",
    "trip.section.restaurants": "Restaurants",
    "trip.section.restaurantsBody": "Restaurants, reservations and meals for this trip.",
    "trip.section.places": "Cities",
    "trip.section.placesBody": "Cities to visit during this trip.",
    "trip.section.experiences": "Experiences",
    "trip.section.experiencesBody": "Activities, tours and experiences linked to the trip.",
    "trip.section.participants": "Participants",
    "trip.section.participantsBody": "Mundely users and guests taking part in the trip.",
    "trip.section.checklist": "Checklist",
    "trip.section.checklistBody": "Things to prepare, check and complete before and during the trip.",
    "trip.section.map": "Map",
    "trip.section.mapBody": "Interactive map dedicated to this trip and its content.",
    "trip.section.usefulInfo": "Useful Info",
    "trip.section.usefulInfoBody": "AI-powered infographic with practical destination information.",
    "trip.section.weather": "Weather",
    "trip.section.weatherBody": "Climate and expected conditions during the travel period.",
    "trip.section.pointsOfInterest": "Points of interest",
    "trip.section.pointsOfInterestBody": "Attractions and points of interest for the cities included in the trip.",
    "trip.section.events": "City events",
    "trip.section.eventsBody": "Events available at the destinations during the trip dates.",
    "trip.section.album": "Photos",
    "trip.section.albumBody": "Photos and memories collected during the trip.",
    "trip.section.documents": "Documents",
    "trip.section.documentsBody": "Trip documents and documents shared by participants.",
    "trip.section.boardingPass": "Tickets",
    "trip.section.boardingPassBody": "Tickets, boarding passes and travel documents received from the airline.",
    "trip.section.notes": "Notes",
    "trip.section.notesBody": "Personal or shared notes related to the trip.",
    "usefulInfo.subtitle": "Practical information for {destination}, collected in one infographic.",
    "usefulInfo.edit": "Edit",
    "usefulInfo.fillWithAi": "Fill with AI",
    "usefulInfo.aiWorking": "Filling information...",
    "usefulInfo.saved": "Useful Info saved.",
    "usefulInfo.aiCompleted": "Useful Info filled by AI. Verify sensitive information before travelling.",
    "usefulInfo.aiError": "Mundely could not fill the Useful Info with AI. Try again or enter it manually.",
    "usefulInfo.destinationRequired": "Set the trip destination first.",
    "usefulInfo.notAvailable": "To be completed",
    "usefulInfo.notRequired": "Not required",
    "usefulInfo.driving.left": "Left",
    "usefulInfo.driving.right": "Right",
    "usefulInfo.editPlaceholder": "Enter the information...",
    "usefulInfo.completeness": "{filled}/{total} items completed",
    "usefulInfo.updatedAt": "Updated: {date}",
    "usefulInfo.source.empty": "Not completed yet",
    "usefulInfo.source.ai": "Filled with AI",
    "usefulInfo.source.manual": "Filled manually",
    "usefulInfo.source.database": "Mundely database",
    "usefulInfo.source.mixed": "Mundely database + AI/manual",
    "usefulInfo.disclaimer": "Information can change over time. Before travelling, always personally verify documents, entry requirements, health, safety, local rules and consular guidance with the relevant authorities.",
    "usefulInfo.requirementsAttribution": "Entry requirements:",
    "usefulInfo.requirementsDatasetName": "TravelRequirements.info",
    "usefulInfo.requirementsLicense": "CC BY 4.0",
    "usefulInfo.requirementsVerified": "data verified {date}",
    "usefulInfo.progressLabel": "Completion",
    "usefulInfo.plug.help": "Select all plug types used at the destination.",
    "usefulInfo.plug.typeLabel": "Type {type}",
    "usefulInfo.currency.select": "Select a currency",
    "usefulInfo.downloadPdf": "Download PDF",
    "usefulInfo.pdfPopupBlocked": "The browser blocked the PDF window. Allow pop-ups for Mundely and try again.",
    "usefulInfo.pdfError": "The PDF could not be prepared. Try again.",
    "usefulInfo.group.basics": "Essentials",
    "usefulInfo.group.basicsDesc": "The practical information you need as soon as you arrive.",
    "usefulInfo.group.services": "Useful services",
    "usefulInfo.group.servicesDesc": "Helpful apps and tools to use while you are there.",
    "usefulInfo.group.assistanceDesc": "Contacts and references to keep close at hand.",
    "usefulInfo.group.entryHealthDesc": "Entry requirements and health information for the trip.",
    "usefulInfo.group.cultureDesc": "Rules, customs and social aspects worth knowing.",
    "usefulInfo.group.drivingDesc": "The essential rules for driving at your destination.",
    "usefulInfo.group.assistance": "Assistance and emergencies",
    "usefulInfo.group.entryHealth": "Entry and health",
    "usefulInfo.group.culture": "Culture, rules and society",
    "usefulInfo.group.driving": "Driving",
    "usefulInfo.field.plugType": "Plug type",
    "usefulInfo.field.currency": "Currency",
    "usefulInfo.field.exchangeRate": "Exchange rate",
    "usefulInfo.field.timeZone": "Time zone",
    "usefulInfo.homeTime": "from home",
    "usefulInfo.multi.title": "{count} trip locations",
    "usefulInfo.multi.loading": "Loading information for each location…",
    "usefulInfo.multi.description": "Each section merges matching information and separates differences, showing where they apply.",
    "usefulInfo.multi.unresolved": "Information to be verified for this location",
    "usefulInfo.multi.external": "Automated source: reconfirm with the competent authorities",
    "usefulInfo.multi.provisional": "Local catalogue information: verification ongoing",
    "usefulInfo.timeZoneUnavailable": "Local time to be verified",
    "usefulInfo.pdfSaved": "PDF saved in Downloads/Mundely.",
    "usefulInfo.field.drinkingWater": "Drinking water",
    "usefulInfo.field.taxiApps": "Taxi apps",
    "usefulInfo.field.taxiApps.short": "Taxi apps",
    "usefulInfo.field.foodDeliveryApps": "Food delivery apps",
    "usefulInfo.field.foodDeliveryApps.short": "Order apps",
    "usefulInfo.field.embassy": "Embassy",
    "usefulInfo.field.consulates": "Consulates",
    "usefulInfo.field.emergencyNumber": "Emergency number",
    "usefulInfo.emergency.dispatch": "General emergency",
    "usefulInfo.emergency.police": "Police",
    "usefulInfo.emergency.ambulance": "Ambulance",
    "usefulInfo.emergency.fire": "Fire brigade",
    "usefulInfo.field.specialPrecautions": "Special precautions",
    "usefulInfo.field.specialPrecautions.short": "Precautions",
    "usefulInfo.field.governmentType": "Type of government",
    "usefulInfo.field.religion": "Religion",
    "usefulInfo.field.publicAffection": "Public affection",
    "usefulInfo.field.publicAffection.short": "Affection",
    "usefulInfo.field.lgbtq": "LGBTQ+",
    "usefulInfo.field.civilRights": "Civil rights",
    "usefulInfo.details.show": "Read more",
    "usefulInfo.details.hide": "Show less",
    "usefulInfo.details.label": "Description",
    "usefulInfo.field.requiredVaccines": "Required vaccines",
    "usefulInfo.field.requiredVaccines.short": "Vaccines",
    "usefulInfo.field.visa": "Visa",
    "usefulInfo.field.passport": "Passport",
    "usefulInfo.field.healthInsurance": "Health insurance",
    "usefulInfo.field.healthInsurance.short": "Insurance",
    "usefulInfo.healthInsuranceHint": "Check whether your health card is valid at the destination and whether you need insurance for medical costs, assistance, and repatriation.",
    "usefulInfo.civilRightsPending": "Content is being completed; in the meantime, check local guidance with the relevant authorities.",
    "usefulInfo.toBeCompleted": "To be completed",
    "usefulInfo.field.drivingSide": "Driving side",
    "usefulInfo.field.internationalDrivingPermit": "International driving permit",
    "usefulInfo.field.internationalDrivingPermit.short": "License",
    "boardingPass.subtitle": "Boarding passes for {destination}, organised for fast, clear access.",
    "boardingPass.add": "Add boarding pass",
    "boardingPass.new": "New boarding pass",
    "boardingPass.edit": "Edit boarding pass",
    "boardingPass.formTitle": "Flight details",
    "boardingPass.required": "Enter passenger, departure and arrival airport codes (3 letters), and flight date.",
    "boardingPass.deleteConfirm": "Delete this boarding pass?",
    "boardingPass.nextFlight": "Next flight",
    "boardingPass.empty": "No boarding passes",
    "boardingPass.emptyBody": "Add the first boarding pass for this trip. It will appear as a quick-access travel card.",
    "boardingPass.passenger": "Passenger",
    "boardingPass.airline": "Airline",
    "boardingPass.airlineFallback": "Airline",
    "boardingPass.flightNumber": "Flight number",
    "boardingPass.bookingReference": "Booking reference",
    "boardingPass.originCode": "Departure airport",
    "boardingPass.originCity": "Departure city",
    "boardingPass.destinationCode": "Arrival airport",
    "boardingPass.destinationCity": "Arrival city",
    "boardingPass.origin": "Departure",
    "boardingPass.destination": "Arrival",
    "boardingPass.date": "Date",
    "boardingPass.departureTime": "Departure time",
    "boardingPass.boardingTime": "Boarding",
    "boardingPass.arrivalTime": "Arrival time",
    "boardingPass.terminal": "Terminal",
    "boardingPass.gate": "Gate",
    "boardingPass.seat": "Seat",
    "tickets.subtitle": "Upload tickets and boarding passes for {destination} as PDF files or photos.",
    "tickets.add": "Add ticket",
    "tickets.helpTitle": "Upload the document received from the airline",
    "tickets.helpBody": "You can upload PDFs or images. Mundely keeps a local copy and retries automatically if the connection is interrupted.",
    "tickets.invalidType": "Unsupported format. Use a PDF or image.",
    "tickets.added": "Ticket added.",
    "tickets.uploadError": "The file was queued but the upload could not be completed right now.",
    "tickets.deleteConfirm": "Delete this ticket?",
    "tickets.empty": "No tickets",
    "tickets.emptyBody": "When you receive the ticket or boarding pass from the airline, upload it here as a PDF or photo.",
    "tickets.image": "Image",
    "tickets.pdf": "PDF",
    "tickets.sizeKb": "{value} KB",
    "tickets.sizeMb": "{value} MB",
    "tickets.statusUploaded": "Saved to cloud",
    "tickets.statusPending": "Waiting for cloud",
    "tickets.statusFailed": "Upload failed",
    "tickets.failedHelp": "The file is still stored on this device. Tap Retry to try uploading it to the cloud again.",
    "tickets.retry": "Retry",
    "tickets.pendingHelp": "The file is safe on this device and will upload to the cloud automatically as soon as possible.",
    "tickets.rename": "Rename",
    "tickets.renamed": "Ticket renamed.",
    "tickets.noExtension": "No extension",
    "documents.subtitle": "Organize trip documents by folder and participant.",
    "documents.add": "Add document",
    "documents.invalidType": "Unsupported format.",
    "documents.added": "Document added.",
    "documents.uploadError": "The document was queued but the upload could not be completed right now.",
    "documents.deleteConfirm": "Delete this document?",
    "documents.empty": "No documents",
    "documents.emptyBody": "Upload passports, visas, IDs, driving licences, health cards and other trip files here.",
    "documents.folders": "Folders",
    "documents.all": "All",
    "documents.newFolder": "New folder",
    "documents.folderCreated": "Folder created.",
    "documents.folderNamePlaceholder": "Folder name",
    "documents.participant": "Participant",
    "documents.allParticipants": "All participants",
    "documents.me": "Me",
    "documents.name": "Name",
    "documents.folder": "Folder",
    "documents.organize": "Organize",
    "documents.updated": "Document updated.",
    "documents.statusUploaded": "Saved to cloud",
    "documents.statusPending": "Sync in progress",
    "documents.folder.passport": "Passport",
    "documents.folder.id": "ID card",
    "documents.folder.drivingLicense": "Driving licence",
    "documents.folder.healthCard": "Health card",
    "documents.folder.visas": "Visas",
    "documents.folder.other": "Other",
    "documents.personalTitle": "Personal documents",
    "documents.personalBody": "Documents saved in your Profile are shown automatically in every trip.",
    "documents.noPersonal": "No personal documents saved",
    "documents.noPersonalBody": "Add your passport, ID card, driving licence, health card or visas in Settings → Profile.",
    "documents.personalWaiting": "Waiting for cloud",
    "documents.tripTitle": "Trip documents",
    "documents.tripBody": "Add files that belong only to this trip and organise them in custom folders.",
    "documents.statusFailed": "Upload failed",
    "documents.failedHelp": "The file remains saved on this device. Tap Retry to upload it again.",
    "documents.retry": "Retry",
    "documents.saveUpload": "Save upload",
    "documents.categoryEmpty": "No documents",
    "profileDocuments.title": "Personal documents",
    "profileDocuments.body": "Upload documents that belong to you here. Mundely will make them available automatically in your trips.",
    "profileDocuments.uploadTitle": "Add a personal document",
    "profileDocuments.uploadHint": "PDF or image. The document is saved to the cloud and remains available in your trips.",
    "profileDocuments.savedForSync": "Document saved on this device. Cloud upload will retry automatically.",
    "profileDocuments.type": "Document type",
    "profileDocuments.add": "Add document",
    "profileDocuments.invalidType": "Unsupported format. Use PDF or images.",
    "profileDocuments.added": "Personal document added.",
    "profileDocuments.uploadError": "The cloud upload failed.",
    "profileDocuments.cloudRequiredError": "The document was not saved on this device. Cloud upload failed: retry while keeping this screen open.",
    "profileDocuments.updated": "Personal document updated.",
    "profileDocuments.deleteConfirm": "Delete this personal document?",
    "profileDocuments.empty": "No personal documents",
    "profileDocuments.emptyBody": "Add your documents once and they will be available in every trip.",
    "profileDocuments.statusUploaded": "Saved to cloud",
    "profileDocuments.statusPending": "Waiting for cloud",
    "profileDocuments.statusFailed": "Upload failed",
    "profileDocuments.retry": "Retry",
    "profileDocuments.type.passport": "Passport",
    "profileDocuments.type.id": "ID card",
    "profileDocuments.type.drivingLicense": "Driving licence",
    "profileDocuments.type.taxCode": "Tax code",
    "profileDocuments.chooseFile": "Choose document",
    "profileDocuments.chooseType": "Category",
    "profileDocuments.saveUpload": "Save upload",
    "profileDocuments.categoryEmpty": "No documents in this section.",
    "profileDocuments.trashTitle": "Document trash",
    "profileDocuments.trashCount": "{count} items",
    "profileDocuments.trashBody": "Deleted documents remain recoverable for 30 days, then they are permanently removed.",
    "profileDocuments.trashDays": "Permanent deletion in {days} days",
    "profileDocuments.movedToTrash": "Document moved to trash.",
    "profileDocuments.restored": "Document restored.",
    "profileDocuments.deleteForever": "Delete permanently",
    "profileDocuments.deleteForeverConfirm": "Permanently delete this document? This action cannot be undone.",
    "profileDocuments.openError": "The cloud document could not be opened.",
    "profileDocuments.type.healthCard": "Health card",
    "profileDocuments.type.visa": "Visa",
    "profileDocuments.type.other": "Other",
    "hotels.subtitle": "Hotels, bookings and stays for this trip.",
    "hotels.add": "Add hotel",
    "hotels.name": "Property name",
    "hotels.city": "City",
    "hotels.address": "Address",
    "hotels.checkIn": "Check-in",
    "hotels.checkOut": "Check-out",
    "hotels.bookingReference": "Booking reference",
    "hotels.notes": "Notes",
    "hotels.empty": "No hotels",
    "hotels.emptyBody": "Add the places where you will stay during the trip.",
    "hotels.bookedWith": "Booked with",
    "hotels.bookedWithNone": "Not specified",
    "hotels.bookedWithOther": "Service name",
    "hotels.hotelSite": "Hotel website",
    "hotels.agency": "Travel agency",
    "hotels.phone": "Phone",
    "hotels.providerBooking": "Booking.com",
    "hotels.providerExpedia": "Expedia",
    "hotels.providerAgoda": "Agoda",
    "restaurants.subtitle": "Restaurants, reservations and meals for this trip.",
    "restaurants.add": "Add restaurant",
    "restaurants.name": "Restaurant name",
    "restaurants.city": "City",
    "restaurants.address": "Address",
    "restaurants.date": "Date",
    "restaurants.time": "Time",
    "restaurants.reservationWith": "Booked with",
    "restaurants.reservationNone": "Not specified",
    "restaurants.reservationOther": "Service name",
    "restaurants.restaurantSite": "Restaurant website",
    "restaurants.phone": "Phone",
    "restaurants.providerTheFork": "TheFork",
    "restaurants.providerOpenTable": "OpenTable",
    "restaurants.providerGoogle": "Google",
    "restaurants.bookingReference": "Booking reference",
    "restaurants.notes": "Notes",
    "restaurants.empty": "No restaurants",
    "restaurants.emptyBody": "Add the restaurants you want to visit during the trip.",
    "places.autofillTitle": "Fill from map",
    "places.autofillBody": "Search an existing place and let Mundely fill name, city and address.",
    "places.chooseFromMap": "Choose from map",
    "places.pickerEyebrow": "Google Maps search",
    "places.pickerTitle": "Search the map",
    "places.pickerBody": "Search Google Maps and select the correct result.",
    "places.searchPlaceholder": "Place name",
    "places.searchCityPlaceholder": "City name",
    "places.searchHotelPlaceholder": "Hotel name",
    "places.searchRestaurantPlaceholder": "Restaurant name",
    "places.googleFallback": "Google Maps is temporarily unavailable. Mundely is using the alternative search for now.",
    "places.googleNotConfigured": "Google Maps is not configured yet. Mundely is using the alternative search for now.",
    "places.search": "Search",
    "places.searching": "Searching…",
    "places.minRating": "Minimum rating",
    "places.anyRating": "Any",
    "places.searchError": "Places could not be searched. Try again.",
    "places.searchNoResults": "No results found. Check the name and try again.",
    "places.searchHint": "Enter a place name to start.",
    "places.mapPreview": "Map preview",
    "places.mapEmpty": "Select a result to show it on the map.",
    "places.usePlace": "Use this place",
    "places.sectionSubtitle": "Choose the cities you will visit during the trip.",
    "places.addPlace": "Add city",
    "places.selectedPlace": "Selected city",
    "places.selectedPlaceBody": "Mundely filled the city data from Google Maps. You can add dates, notes and choose the image.",
    "places.changePlace": "Change city",
    "places.placeName": "City",
    "places.city": "City",
    "places.address": "Location",
    "places.startDate": "Start date",
    "places.endDate": "End date",
    "places.notes": "Notes",
    "places.previewImage": "Preview image",
    "places.previewImageBody": "Mundely uses the Google Maps photo by default. You can choose another one before saving.",
    "places.photoLoading": "Loading photos…",
    "places.photoUnavailable": "No Google Maps photo is available for this place.",
    "places.photoAttribution": "Photo:",
    "places.choosePreviewImage": "Choose the preview image",
    "places.choosePhotoNumber": "Choose photo {number}",
    "places.uploadCustomPhoto": "Upload your own photo",
    "places.uploadCustomPhotoBody": "You can replace the Google Maps image with a personal photo. Mundely automatically optimizes it for the preview.",
    "places.choosePhotoFile": "Choose photo",
    "places.customPhotoTitle": "Custom photo",
    "places.customPhotoBody": "This photo replaces the Google Maps preview.",
    "places.changeCustomPhoto": "Change photo",
    "places.useGooglePhoto": "Use Google Maps photo",
    "places.customPhotoLoading": "Preparing photo…",
    "places.customPhotoInvalid": "Select a valid image file.",
    "places.customPhotoError": "The photo could not be prepared. Try another image.",
    "places.empty": "No saved cities",
    "places.emptyBody": "Add the first city to visit by searching Google Maps.",
    "poi.sectionSubtitle": "Explore points of interest in your trip cities, select the ones to visit and organize them by day.",
    "poi.noCities": "Add a city first",
    "poi.noCitiesBody": "Points of interest are organized using the cities saved in the Cities section.",
    "poi.chooseCity": "Choose the city",
    "poi.loading": "Searching for points of interest…",
    "poi.error": "Points of interest could not be found for this city. Try again later.",
    "poi.chooseFromMap": "Choose from map",
    "poi.suggestionsTitle": "Suggestions for this city",
    "poi.suggestionsBody": "Recommended places to explore in {city}. Select them or view them on the map.",
    "poi.selectedPlaces": "Selected places",
    "poi.selectedPlacesBody": "The places you chose to visit in this city.",
    "poi.otherPlaces": "Other places",
    "poi.otherPlacesBody": "Other suggested points of interest for this city.",
    "poi.noSelectedPlaces": "You have not selected any points of interest for this city yet.",
    "poi.noOtherPlaces": "There are no other places to show right now.",
    "poi.selectPlace": "Select",
    "poi.showOnMap": "Show on map",
    "poi.mapPreview": "Points of interest map",
    "poi.mapSelectedLegend": "Selected places on the map",
    "poi.mapSelectedLegendBody": "{count} selected places for this city are visible.",
    "poi.openGoogleMaps": "Open Google Maps",
    "poi.day": "Day",
    "poi.notes": "Notes",
    "poi.notesPlaceholder": "Add notes, opening times or useful details…",
    "poi.getMoreInfo": "Get more information",
    "poi.researching": "Researching…",
    "poi.moreInfoTitle": "Additional information",
    "poi.aiDisabled": "GPT agent research is not enabled for this account.",
    "poi.aiUnavailable": "GPT agent research is not available right now.",
    "poi.aiPrompt": "Find current and useful traveler information about {name}, at {address}, in {city}. Explain what it is, why it is worth visiting, opening hours or visit requirements when available, indicative costs, recommended time, interesting facts, practical tips and possible issues. Be concise and flag information that may change.",
    "checklist.sectionSubtitle": "Organize everything you need to prepare and see at a glance what is still missing.",
    "checklist.addItem": "Add item",
    "checklist.progressTitle": "Checklist progress",
    "checklist.progressBody": "{done} of {total} completed",
    "checklist.itemTitle": "What you need to do",
    "checklist.itemPlaceholder": "E.g. Complete online check-in",
    "checklist.category": "Category",
    "checklist.category.action": "Action",
    "checklist.category.booking": "Booking",
    "checklist.category.documents": "Documents",
    "checklist.category.luggage": "Luggage",
    "checklist.category.health": "Health",
    "checklist.category.bookings": "Bookings",
    "checklist.category.other": "Other",
    "checklist.notes": "Notes",
    "checklist.date": "Date",
    "checklist.listsLabel": "Trip checklists",
    "checklist.defaultListName": "Main checklist",
    "checklist.newListPlaceholder": "New checklist name",
    "checklist.createList": "Create checklist",
    "checklist.chooseList": "Active checklist",
    "checklist.newListButton": "New checklist",
    "checklist.listName": "Checklist name",
    "checklist.deleteList": "Delete checklist",
    "checklist.notesPlaceholder": "Add useful details…",
    "checklist.filterLabel": "Filter checklist",
    "checklist.filter.all": "All",
    "checklist.filter.pending": "To do",
    "checklist.filter.completed": "Completed",
    "checklist.addStarter": "Add starter suggestions",
    "checklist.empty": "Empty checklist",
    "checklist.emptyBody": "Add the tasks you need to complete or use Mundely starter suggestions.",
    "checklist.noFilteredItems": "No items in this filter",
    "checklist.noFilteredItemsBody": "Change the filter to view the other checklist items.",
    "checklist.markCompleted": "Mark as completed",
    "checklist.markPending": "Mark as to do",
    "checklist.starter.passport": "Check passport and documents",
    "checklist.starter.insurance": "Save travel insurance",
    "checklist.starter.chargers": "Pack chargers and adapters",
    "checklist.starter.medicines": "Pack personal medicines",
    "checklist.starter.hotel": "Check hotel bookings",
    "checklist.starter.transport": "Check flights and transfers",
    "notes.subtitle": "Personal notes linked to this trip.",
    "notes.add": "New note",
    "notes.title": "Title",
    "notes.content": "Text",
    "notes.empty": "No notes",
    "notes.emptyBody": "Write the first note for this trip.",
    "notes.untitled": "Untitled",
    "home.nextTrip": "Next trip",
    "home.quickActions": "Quick actions",
    "home.notifications": "Notifications",
    "home.modular": "Modular dashboard",
    "home.modularBody": "Widgets can be added, removed and reordered without changing the Home structure.",
    "trips.title": "Your trips",
    "trips.empty": "You have not created any trips yet.",
    "trips.create": "Create your first trip",
    "map.title": "Map",
    "map.placeholder": "The interactive map will be connected here.",
    "map.tripSubtitle": "View trip cities, hotels, restaurants and points of interest together.",
    "map.filters": "Map filters",
    "map.filter.cities": "Cities",
    "map.filter.hotels": "Hotels",
    "map.filter.restaurants": "Restaurants",
    "map.filter.poi": "Points of interest",
    "map.loadError": "The map could not be loaded.",
    "map.empty": "No places to show",
    "map.emptyBody": "Add cities, hotels, restaurants or points of interest to display them on the trip map.",
    "ai.title": "Mundely",
    "ai.placeholder": "Ask anything about your trip.",
    "ai.eyebrow": "AI travel agent",
    "ai.subtitle": "It knows the data saved in Mundely and helps you plan, review and improve your trip.",
    "ai.newChat": "New chat",
    "ai.tripContext": "Trip to work on",
    "ai.generalContext": "General travel advice",
    "ai.tripConnected": "Trip connected",
    "ai.tripConnectedBody": "The agent uses the data already stored in your trip sections as context.",
    "ai.generalConnected": "General mode",
    "ai.generalConnectedBody": "No specific trip selected: ask for general travel information and advice.",
    "ai.readyTrip": "I’m ready to work on {trip}",
    "ai.readyGeneral": "I’m ready to help you travel",
    "ai.readyBody": "Write a request or start with one of these suggestions.",
    "ai.starter.review": "Review my trip and tell me what is missing",
    "ai.starter.dayPlan": "Improve the daily plan for my trip",
    "ai.starter.food": "Suggest what to eat and where to look for it",
    "ai.starter.practical": "Give me the most important practical advice",
    "ai.you": "You",
    "ai.placeholderTrip": "Ask something about {trip}…",
    "ai.placeholderGeneral": "Ask anything about your next trip…",
    "ai.send": "Send",
    "ai.disclaimer": "Mundely uses the trip data available in the app. Information that can change should always be verified before booking or travelling.",
    "ai.unavailable": "The AI agent is not available in this environment or for this account.",
    "ai.error": "The AI agent could not be reached. Please try again shortly.",
    "profile.title": "Profile",
    "profile.account": "Account",
    "profile.accountBody": "Manage your account username and email.",
    "profile.changePhoto": "Edit profile photo",
    "profile.photoTitle": "Profile photo",
    "profile.photoBody": "Choose a photo, move it and use zoom to get the crop you want.",
    "profile.photoChooseHint": "Choose a photo to open the crop editor.",
    "profile.savePhoto": "Save photo",
    "profile.photoSaved": "Profile photo updated.",
    "profile.preferences": "Preferences",
    "profile.security": "Security",
    "profile.devices": "Devices",
    "profile.data": "Data and privacy",
    "profile.plan": "Plan",
    "profile.free": "Free",
    "profile.premium": "Complete",
    "profile.export": "Export my data",
    "profile.dataImportTitle": "Import data",
    "profile.dataImportBody": "Import trips from a CSV or Excel (.xlsx) file.",
    "profile.dataImportChoose": "Choose CSV or Excel",
    "profile.dataImportSuccess": "Imported {count} trips.",
    "profile.dataImportInvalid": "The file does not contain valid trip rows.",
    "profile.dataImportRowIssue": "Row {row}: {reason}",
    "profile.dataImportDateIssue": "invalid date.",
    "profile.dataImportRangeIssue": "the end date precedes the start date.",
    "profile.dataImportDuplicateIssue": "the same trip appears more than once in the file.",
    "profile.dataImportAmbiguousIssue": "multiple trips match this row: specify a unique ID.",
    "profile.dataImportSharedIssue": "you cannot edit a trip owned by someone else.",
    "profile.dataImportIdIssue": "invalid trip ID.",
    "profile.dataImportStatusIssue": "unknown status. Use planning, upcoming, active or completed.",
    "profile.dataImportPartialIssue": "Import stopped after {count} saved trips. Check the results before retrying.",
    "profile.dataImportAccountIssue": "Account changed: import stopped.",
    "profile.dataImportPreserveHint": "IDs identify trips to update. Without an ID, name, destination and dates are matched. Blank cells preserve existing values; photos and sections remain unchanged.",
    "profile.dataMapTitle": "Map columns",
    "profile.dataMapBody": "Match file columns to Mundely fields before importing, just like in fAInance.",
    "profile.dataMapIgnore": "Do not import",
    "profile.dataMapName": "Trip name",
    "profile.dataMapDestination": "Destination",
    "profile.dataMapStart": "Start date",
    "profile.dataMapEnd": "End date",
    "profile.dataMapStatus": "Status",
    "profile.dataMapPreview": "Preview",
    "profile.dataMapImport": "Import",
    "profile.dataExportTitle": "Export data",
    "profile.dataExportBody": "Download your trips as CSV or Excel.",
    "profile.dataExportCsv": "CSV",
    "profile.dataExportExcel": "Excel",
    "profile.dataExportReady": "Exported {count} trips.",
    "profile.dataTripCount": "{count} trips you own",
    "profile.dataWorldExportTitle": "Export My world",
    "profile.dataWorldExportBody": "Choose whether to export visited countries, visited cities or both. You can download them as CSV or Excel.",
    "profile.dataWorldCountries": "Visited countries",
    "profile.dataWorldCities": "Visited cities",
    "profile.dataWorldExportReady": "My world data exported.",
    "profile.dataWorldCountry": "Country",
    "profile.dataWorldCity": "City",
    "profile.dataWorldStatus": "Status",
    "profile.dataWorldFeedback": "Feedback",
    "profile.dataWorldCountriesSheet": "Visited countries",
    "profile.dataWorldCitiesSheet": "Visited cities",
    "profile.dataBackupTitle": "Data backup",
    "profile.dataBackupBody": "Quickly download your profile, trips and settings as JSON, or a complete ZIP backup with attachments. JSON does not include files: attachments must still exist in the cloud to restore them.",
    "profile.dataBackupJsonDownload": "Download JSON backup",
    "profile.dataBackupJsonSaved": "JSON backup saved to the selected destination.",
    "profile.dataBackupJsonTimeout": "The JSON backup did not respond within 90 seconds. Try again with a stable connection.",
    "profile.dataBackupElapsed": "Elapsed time: {time}",
    "profile.dataBackupKeepOpen": "Preparing your backup. Keep this screen open until it is saved.",
    "profile.dataBackupProgressFiles": "Files completed: {current}/{total}",
    "profile.dataBackupDownload": "Download full ZIP backup",
    "profile.dataBackupRestore": "Restore backup",
    "profile.dataBackupPending": "Finish synchronizing changes and files before restoring the backup.",
    "profile.dataBackupChanged": "Data changed during the backup. Try again to save a consistent copy.",
    "profile.dataBackupDamaged": "The backup contains a missing or altered file. Restore has not started.",
    "profile.dataBackupTooLarge": "The backup exceeds the supported limits: 15 MB per file and 2 GB in total.",
    "profile.dataBackupReady": "Backup ready. Choose where to save it.",
    "profile.dataBackupWorkingCollecting": "Preparing your data…",
    "profile.dataBackupWorkingAttachments": "Collecting attachments…",
    "profile.dataBackupWorkingSaving": "Backup ready: choose where to save…",
    "profile.dataBackupSaved": "Backup saved to your selected destination.",
    "profile.dataBackupSaveFailed": "Could not save the backup to the selected location. Try again or choose a folder on your device.",
    "profile.dataBackupAttachmentsFailed": "Could not download cloud attachment {current} of {total}. Try again with a stable connection. No incomplete backup was saved.",
    "profile.dataBackupImportJson": "Import JSON backup",
    "profile.dataBackupImportZip": "Import ZIP backup",
    "profile.dataBackupImportConfirmTitle": "Import backup",
    "profile.dataBackupImportConfirmBody": "Review the file before restoring your account data.",
    "profile.dataBackupImportContents": "This file contains {trips} trips, {documents} documents and {sections} trip sections.",
    "profile.dataBackupEmptyFile": "The selected file is empty. Wait for saving or downloading to finish, then select the complete copy.",
    "profile.dataBackupZipPhotos": "Travel photos: {travel}. Personal photos: {personal}. Covers: {covers}. Verified attachments: {files}.",
    "profile.dataBackupZipOtherAccount": "This backup belongs to another account. Trips, profile, photos and attachments will be copied into your account. Original access permissions and sharing are not transferred. Existing data may be updated.",
    "profile.dataBackupImportZipContents": "Full ZIP archive. Contents and attachments will be verified before restoring.",
    "profile.dataBackupImportWarning": "Entries with the same ID will be updated. Data not included in the backup will not be deleted. Attachments missing from the JSON must still be available in the cloud. This operation may change existing data.",
    "profile.dataBackupImportConfirm": "Confirm restore",
    "profile.dataBackupProgressTitle": "Restore in progress",
    "profile.dataBackupProgressEstimated": "Actual progress based on server-confirmed writes. Keep the app open during restore.",
    "profile.dataBackupProgressScanTitle": "Checking the backup",
    "profile.dataBackupProgressScanBody": "We are validating the selected file and preparing the data to import.",
    "profile.dataBackupProgressCompareTitle": "Verifying imported data",
    "profile.dataBackupProgressCompareBody": "The server checks that all expected trips have been written correctly.",
    "profile.dataBackupProgressApplyTitle": "Applying changes",
    "profile.dataBackupProgressApplyBody": "Trips and compatible settings are being updated safely.",
    "profile.dataBackupProgressFinishTitle": "Finalizing",
    "profile.dataBackupProgressFinishBody": "We are completing the last steps and saving the final result.",
    "profile.dataBackupModeMerge": "Integrate",
    "profile.dataBackupModeAdd": "Add new only",
    "profile.dataBackupAddWarning": "Adds only trips that are not already present. Does not change existing trips, sections, photos or settings.",
    "profile.dataBackupFullSourceRequired": "This source does not include all the files required for a verified full restore.",
    "profile.dataBackupModeReplace": "Replace data",
    "profile.dataBackupProgressWrites": "Confirmed operations: {current}/{total}",
    "profile.dataBackupEmptyReplaceBlocked": "The backup contains zero trips. Replace is blocked to prevent accidental deletion.",
    "profile.dataBackupVerificationFailed": "The server has not confirmed the restore result. Check your account before retrying; no successful import was declared.",
    "profile.dataBackupVerifiedResult": "Verified import: {total} trips in your account ({created} added, {updated} updated).",
    "profile.dataBackupLocalRefreshFailed": "The server completed the transfer, but the phone could not refresh its local trip list. Reopen Trips and check before retrying.",
    "profile.dataBackupOtherAccount": "This backup belongs to another Mundely account. Trips will be copied into your account without carrying over permissions or cloud attachments.",
    "profile.dataBackupSameAccount": "Choose how to transfer this backup into your account.",
    "profile.dataBackupTransferFilesWarning": "The JSON references {count} documents: files are not included and will not be copied. Documents already in your account remain unchanged.",
    "profile.dataBackupDeliveredZipPhotos": "This ZIP contains photos outside the JSON backup: image files will not be uploaded to Firebase. Photos already in your account will be preserved; check photos in new trips after import.",
    "profile.dataBackupReconcileResult": "Backup imported: {created} trips added, {updated} trips updated without duplication.",
    "profile.dataBackupExistingDuplicates": "Found {count} possible pre-existing duplicates: these were not automatically deleted to protect your data.",
    "profile.dataBackupMergeWarning": "Integrate adds the backup trips without removing existing trips; only permitted profile preferences are updated.",
    "profile.dataBackupReplaceWarning": "Replaces trips and sections with JSON data and removes trips absent from the backup. Cloud documents and files not contained in the JSON are neither imported nor automatically deleted. Shared or fAInance-linked trips block replacement.",
    "profile.dataBackupReplaceCheck": "I confirm that I want to replace my account data with the backup data.",
    "profile.dataBackupTransferTooMany": "The backup contains too many records for a safe atomic replacement. No data was changed.",
    "profile.dataBackupSharedTripBlocked": "Shared trips or trips linked to fAInance cannot be replaced. No data was changed. Use Integrate or disconnect those trips first.",
    "profile.dataBackupRestored": "Backup restored: {trips} trips.",
    "profile.dataBackupInvalid": "This file is not a valid Mundely backup.",
    "profile.dataTransferError": "The data operation could not be completed.",
    "profile.deleteAccount": "Delete account",
    "profile.deleteInfo": "Account deletion includes a 15-day reconsideration period.",
    "profile.changeUsername": "Change username",
    "profile.recoveryPremium": "Trash and version history are available with Premium.",
    "profile.connectedDevices": "Connected devices",
    "profile.signOutOthers": "Sign out all other devices",
    "profile.personalData": "Personal details",
    "profile.publicProfileSection": "Public profile",
    "profile.personalDataBody": "Manage your Mundely profile information.",
    "profile.publicWorldTitle": "Public traveller profile",
    "profile.publicWorldBody": "Choose which My world information is visible on your public profile.",
    "profile.publicShowCountries": "Show visited countries",
    "profile.publicShowCities": "Show visited cities",
    "profile.publicShowLived": "Show where you lived",
    "profile.publicShowStats": "Show travel statistics",
    "profile.publicShowReviews": "Show public reviews",
    "profile.publicWorldSaved": "Public profile preferences updated.",
    "profile.publicVisitedCities": "Visited cities",
    "profile.publicLivedCountries": "Places lived",
    "profile.publicReviews": "Public reviews",
    "world.eyebrow": "Traveller profile",
    "world.infoLabel": "Information",
    "world.title": "My world",
    "world.subtitle": "Track the countries and cities you have visited or lived in. The map and statistics update automatically.",
    "world.tabsLabel": "My world sections",
    "world.tabMap": "World map",
    "world.tabCountries": "Countries",
    "world.tabCities": "Cities",
    "world.tabStats": "Statistics",
    "world.countriesShort": "countries",
    "world.citiesShort": "cities",
    "world.worldShort": "of the world",
    "world.statusLabel": "Visit status",
    "world.statusVisited": "Visited",
    "world.statusLived": "Lived",
    "world.statusNone": "Not visited",
    "world.mapTitle": "Your world map",
    "world.mapBody": "Countries change colour based on your personal experience.",
    "world.legendLabel": "Map legend",
    "world.mapHint": "Tap or click a country to open its details, add feedback and see linked cities.",
    "world.mapUnavailable": "The world map is unavailable right now. Countries, cities and statistics are still accessible.",
    "world.countriesTitle": "Countries",
    "world.countriesBody": "Browse countries by continent, mark the ones you visited or lived in, and keep a personal note for each one.",
    "world.chooseCountry": "Choose a country",
    "world.limitedRecognition": "limited recognition",
    "world.specialStatus": "special status / autonomous territory",
    "world.addCountry": "Add",
    "world.searchCountries": "Search a country",
    "world.noCountries": "No countries added yet",
    "world.noCountriesBody": "Add your first country or select it directly from the map.",
    "world.countryDetails": "Country details",
    "world.countryDetailsBody": "Set the status, save your feedback and review the linked cities.",
    "world.feedback": "Personal feedback",
    "world.privateNote": "Private note",
    "world.privateNotePlaceholder": "Add a memory or note visible only to you.",
    "world.publicReview": "Public review",
    "world.saveReview": "Save review",
    "world.publicReviewBody": "The review is public and can be found by other travellers.",
    "world.communityReviews": "Community reviews",
    "world.communityReviewsBody": "Read other travellers' experiences and vote for the ones you find useful.",
    "world.communitySortLabel": "Sort reviews",
    "world.communityMostHelpful": "Most helpful",
    "world.communityMostRecent": "Most recent",
    "world.communityHelpful": "Helpful",
    "world.communityNotHelpful": "Not helpful",
    "world.communityOwnReview": "Your review",
    "world.communityNoReviews": "There are no other reviews for this destination yet.",
    "world.communityTraveller": "Traveller",
    "world.communityVoteFailed": "The vote could not be saved. Please try again.",
    "community.tripReviews": "Community",
    "community.tripReviewsBody": "{count} Mundely reviews for this place.",
    "community.yourReview": "Your review",
    "community.yourReviewBody": "Share your experience: it will contribute to community recommendations and your traveller score.",
    "community.reviewPlaceholder": "What would you recommend to other travellers?",
    "community.deleteReview": "Delete review",
    "community.noPlaceReviews": "There are no Mundely reviews for this place yet.",
    "community.stats.reviews": "Reviews",
    "community.stats.average": "Average",
    "community.stats.helpful": "Helpful votes",
    "community.mostHelpfulBadge": "Most helpful",
    "community.reviewSaveFailed": "The review could not be saved. Please try again.",
    "world.publicReviewPlaceholder": "Write a review that can help other travellers.",
    "world.rating": "Rating",
    "world.ratingValue": "{value} stars out of 5",
    "world.publishReview": "Make this review public",
    "world.countryFeedbackPlaceholder": "What did you like? What do you remember about this country?",
    "world.cityCount": "{count} cities",
    "world.citiesInCountry": "Visited cities",
    "world.citiesInCountryBody": "The list updates automatically when you add or edit a city.",
    "world.noCitiesForCountry": "You have not added any cities for this country yet.",
    "world.removeCountry": "Remove country",
    "world.removeCountryBlocked": "Remove the linked cities before removing this country.",
    "world.countrySaved": "Country updated.",
    "world.countryRemoved": "Country removed.",
    "world.addCity": "Add a city",
    "world.editCity": "Edit city",
    "world.cityEditorBody": "Adding a city automatically updates its country too.",
    "world.cityName": "City name",
    "world.country": "Country",
    "world.cityFeedbackPlaceholder": "Add a memory, opinion or personal note about the city.",
    "world.cityCountrySyncHint": "If the country is not already present, Mundely adds it automatically. A city you lived in marks the country as lived in too.",
    "world.myCities": "My cities",
    "world.myCitiesBody": "All visited or lived-in cities, linked in real time to their countries.",
    "world.noCities": "No cities added yet",
    "world.noCitiesBody": "Add your first city to start building your travel history.",
    "world.citySaved": "City updated.",
    "world.cityRemoved": "City removed.",
    "world.statsTitle": "Your travel statistics",
    "world.statsBody": "A quick view of the world you have explored so far.",
    "world.statCountries": "Countries visited",
    "world.statLived": "Countries lived in",
    "world.statLivedBody": "countries you have lived in",
    "world.statCities": "Cities",
    "world.statCitiesBody": "cities recorded",
    "world.statTerritory": "Territory explored",
    "world.statTerritoryBody": "estimated share of the world's countries by land area",
    "world.statTerritoryLoading": "calculation available when geographic map data is loaded",
    "world.worldProgress": "Countries of the world visited",
    "world.continentAfrica": "Africa",
    "world.continentAsia": "Asia",
    "world.continentEurope": "Europe",
    "world.continentNorthAmerica": "North America",
    "world.continentSouthAmerica": "South America",
    "world.continentOceania": "Oceania",
    "world.searchCity": "Search city",
    "world.citySearchPlaceholder": "Search or enter a city",
    "world.citySearchHint": "Use Search city to find a city with the same geographic search used in trips; Mundely fills in the country automatically when the provider returns it.",
    "world.exportMap": "Export map",
    "world.exportCountries": "Export countries",
    "world.exportCities": "Export cities",
    "world.exportPng": "PNG",
    "world.exportPdf": "PDF",
    "world.exportExcel": "Excel",
    "world.exportCsv": "CSV",
    "world.exportContinent": "Continent",
    "world.exportCountry": "Country",
    "world.exportCity": "City",
    "world.exportStatus": "Status",
    "world.exportFeedback": "Feedback",
    "world.exportReady": "Export completed.",
    "world.exportFailed": "The export could not be completed.",
    "world.downloadData": "Download My world",
    "world.downloadShort": "Download",
    "world.downloadTitle": "Download My world",
    "world.downloadBody": "Choose one or more items to include and download them together in a single PDF or JPEG.",
    "world.downloadIncludeTitle": "What do you want to include?",
    "world.downloadIncludeMap": "Map",
    "world.downloadIncludeCountries": "Visited countries",
    "world.downloadIncludeCities": "Cities",
    "world.downloadIncludeStats": "Statistics",
    "world.downloadFormatTitle": "Format",
    "world.exportJpeg": "JPEG",
    "world.downloadAction": "Download My world",
    "world.downloadSelectAtLeastOne": "Select at least one item to download.",
    "world.downloadMapBody": "Download the map with your colours and the Mundely logo.",
    "world.downloadCountriesBody": "Export the complete country list with continent, status and feedback.",
    "world.downloadCitiesBody": "Export recorded cities with country, status and feedback.",
    "world.exportStats": "Export statistics",
    "world.downloadStatsBody": "Export global statistics and statistics for every continent.",
    "world.continentAccordionHint": "Open one continent at a time to browse its countries. Search directly shows continents with matching results.",
    "world.continentSummary": "{visited}/{total} visited · {cities} cities",
    "world.continentStatsTitle": "Statistics by continent",
    "world.continentStatsBody": "Compare visited countries, countries lived in, cities and explored territory for each continent.",
    "world.exportScope": "Area",
    "world.worldLabel": "World",
    "world.exportVisitedCountries": "Countries visited",
    "world.exportLivedCountries": "Countries lived in",
    "world.exportCitiesCount": "Cities",
    "world.exportCompletion": "Completion",
    "profile.phone": "Phone",
    "profile.phonePrefix": "Prefix",
    "profile.phoneInvalid": "Invalid phone number.",
    "profile.birthDate": "Date of birth",
    "profile.gender": "Gender",
    "profile.gender.M": "Male",
    "profile.gender.F": "Female",
    "profile.gender.X": "Not specified",
    "profile.nationality": "Nationality",
    "profile.residenceCountry": "Country of residence",
    "profile.region": "Province / Region",
    "profile.city": "City",
    "profile.address": "Address",
    "profile.job": "Job",
    "profile.useReason": "What do you mainly want to use Mundely for?",
    "profile.saved": "Profile updated.",
    "profile.changeEmail": "Change email",
    "profile.updateEmail": "Update email",
    "profile.emailVerificationSent": "A verification email was sent to the new address. Open the link to complete the change.",
    "profile.changePassword": "Change password",
    "profile.passwordBody": "Update the password you use to sign in to Mundely.",
    "profile.currentPassword": "Current password",
    "profile.newPassword": "New password",
    "profile.updatePassword": "Update password",
    "profile.passwordChanged": "Password updated.",
    "profile.recentLogin": "For security, sign in again before performing this operation.",
    "profile.currentPasswordInvalid": "The current password is incorrect.",
    "profile.usernameChanged": "Username updated.",
    "profile.usernameCooldown": "The username was changed recently. Try again after the configured waiting period.",
    "profile.devicesBody": "Review the devices that can access your account.",
    "profile.noDevices": "No registered devices.",
    "profile.currentDevice": "This device",
    "profile.deviceActive": "Active",
    "profile.deviceRevoked": "Signed out",
    "profile.disconnect": "Sign out",
    "profile.exportQueued": "Your data export request has been recorded.",
    "profile.deleteWarning": "Account deletion request",
    "profile.deleteConfirmBody": "The account will be disabled immediately and you can change your mind for 15 days. To confirm, type {keyword}.",
    "profile.deleteKeyword": "DELETE",
    "profile.scheduleDeletion": "Schedule deletion",
    "profile.pendingDeletionTitle": "Account scheduled for deletion",
    "profile.pendingDeletionBody": "Deletion is scheduled. You have 15 days from the request to restore your account and data.",
    "profile.restoreAccount": "Restore account",
    "auth.linkRequired": "An account already exists with this email. Sign in with username and password to link the new sign-in method.",
    "auth.linkCompleted": "Sign-in method linked to your account.",
    "profile.job.employee": "Employee",
    "profile.job.manager": "Manager",
    "profile.job.consultant": "Consultant",
    "profile.job.freelancer": "Freelancer",
    "profile.job.entrepreneur": "Entrepreneur",
    "profile.job.merchant": "Merchant",
    "profile.job.artisan": "Artisan",
    "profile.job.education": "Education / Training",
    "profile.job.healthcare": "Healthcare",
    "profile.job.technology": "Technology / IT",
    "profile.job.finance": "Finance / Administration",
    "profile.job.marketing": "Marketing / Communications",
    "profile.job.sales": "Sales",
    "profile.job.student": "Student",
    "profile.job.retired": "Retired",
    "profile.job.unemployed": "Not employed",
    "profile.job.other": "Other",
    "profile.reason.planTrips": "Plan trips",
    "profile.reason.organizeItinerary": "Organize itineraries and stops",
    "profile.reason.keepBookings": "Keep bookings together",
    "profile.reason.manageDocuments": "Manage travel documents",
    "profile.reason.shareTrips": "Share trips",
    "profile.reason.discoverPlaces": "Discover places and experiences",
    "profile.reason.trackExpenses": "Track travel expenses",
    "profile.reason.useAi": "Get help from AI",
    "profile.reason.keepMemories": "Keep photos and memories",
    "profile.reason.allInOne": "Keep everything in one app",
    "profile.reason.other": "Other",
    "itinerary.subtitle": "Plan the trip day by day with times, stops and transfers.",
    "itinerary.collectorBody": "Every travel day automatically collects hotels, transfers, experiences, restaurants, cities, places, climate, tickets and photos.",
    "itinerary.twoWayTitle": "Two-way itinerary",
    "itinerary.twoWayBody": "Changes made in other sections appear here; changes made here update the source section.",
    "itinerary.timeline": "Timeline",
    "itinerary.timelineTitle": "Travel timeline",
    "itinerary.timelineBody": "Chronological view of every day and everything that has been planned.",
    "itinerary.entry": "item",
    "itinerary.entries": "items",
    "itinerary.sourceType": "Item type",
    "itinerary.source.manual": "Activity",
    "itinerary.source.transfer": "Transfer",
    "itinerary.source.hotel": "Hotel",
    "itinerary.source.restaurant": "Restaurant",
    "itinerary.source.city": "City",
    "itinerary.source.poi": "Place to visit",
    "itinerary.source.experience": "Experience",
    "itinerary.source.event": "Event",
    "itinerary.source.boardingPass": "Flight ticket",
    "itinerary.source.climate": "Climate",
    "itinerary.dayEmpty": "Nothing planned for this day yet.",
    "itinerary.photos": "Photos",
    "itinerary.searchMap": "Search on map",
    "itinerary.add": "Add stop",
    "itinerary.mapTitle": "Link a real location",
    "itinerary.mapBody": "Fill city and address by choosing a point on the map.",
    "itinerary.chooseMap": "Choose from map",
    "itinerary.enterManually": "Enter manually",
    "itinerary.freeText": "Free text",
    "itinerary.placeName": "Place name",
    "itinerary.title": "Title",
    "itinerary.date": "Date",
    "itinerary.type": "Type",
    "itinerary.startTime": "Start time",
    "itinerary.endTime": "End time",
    "itinerary.city": "City",
    "itinerary.address": "Address",
    "itinerary.notes": "Notes",
    "itinerary.type.activity": "Activity",
    "itinerary.type.transfer": "Transfer",
    "itinerary.type.meal": "Meal",
    "itinerary.type.free": "Free time",
    "itinerary.type.other": "Other",
    "itinerary.empty": "Empty itinerary",
    "itinerary.emptyBody": "Add the first stop to start building your trip days.",
    "itinerary.noDate": "No date",
    "itinerary.showDetails": "Add details",
    "itinerary.hideDetails": "Hide details",
    "itinerary.excel.import": "Import Excel",
    "itinerary.excel.eyebrow": "Itinerary import",
    "itinerary.excel.title": "Upload itinerary from Excel",
    "itinerary.excel.body": "Import all trip stops from an Excel file in seconds. Use the Mundely template to avoid formatting errors.",
    "itinerary.excel.downloadTemplate": "Download Excel template",
    "itinerary.excel.templateSaved": "Template saved in Download/Mundely.",
    "itinerary.excel.templateDownloaded": "Excel template downloaded.",
    "itinerary.excel.templateError": "The Excel template could not be saved. Please try again.",
    "itinerary.excel.chooseFile": "Choose Excel file",
    "itinerary.excel.columns": "Recognized columns: Title, Date, Start time, End time, Type, City, Address, Notes.",
    "itinerary.excel.imported": "Imported {count} stops.",
    "itinerary.excel.error": "The file could not be imported. Make sure it contains at least a Title column and try again.",
    "itinerary.excel.header.title": "Title",
    "itinerary.excel.header.date": "Date",
    "itinerary.excel.header.startTime": "Start time",
    "itinerary.excel.header.endTime": "End time",
    "itinerary.excel.header.type": "Type",
    "itinerary.excel.header.city": "City",
    "itinerary.excel.header.address": "Address",
    "itinerary.excel.header.notes": "Notes",
    "itinerary.excel.sample.title": "Visit historic center",
    "experiences.subtitle": "Activities, tours and experiences you want to do during the trip.",
    "experiences.add": "Add experience",
    "experiences.mapTitle": "Find the experience on the map",
    "experiences.mapBody": "Select a real place to automatically fill city and address.",
    "experiences.chooseMap": "Choose from map",
    "experiences.title": "Experience name",
    "experiences.city": "City",
    "experiences.address": "Address",
    "experiences.date": "Date",
    "experiences.time": "Time",
    "experiences.place": "Place",
    "experiences.placePlaceholder": "E.g. Colosseum, tour operator, beach…",
    "experiences.price": "Price",
    "experiences.currency": "Currency",
    "experiences.notes": "Notes",
    "experiences.empty": "No experiences",
    "experiences.emptyBody": "Save tours, activities and things to do so you can find them during the trip.",
    "participants.subtitle": "Manage the people taking part in the trip.",
    "participants.add": "Add participant",
    "participants.notesPlaceholder": "Optional notes",
    "participants.name": "Name",
    "participants.email": "Email",
    "participants.role": "Role",
    "participants.notes": "Notes",
    "participants.role.owner": "Owner",
    "participants.role.traveller": "Traveller",
    "participants.role.participant": "Participant",
    "participants.role.viewer": "Viewer",
    "participants.rolesFixedHint": "The four roles have fixed permissions. You can rename them, but their permissions do not change.",
    "participants.rolePower.owner": "Full visibility and control, including participant management and trip deletion.",
    "participants.rolePower.traveller": "Full visibility and control except participant management and trip deletion.",
    "participants.rolePower.participant": "Full visibility and permission to edit trip content, without administrative actions.",
    "participants.rolePower.viewer": "Full visibility in read-only mode.",
    "participants.empty": "No participants",
    "participants.emptyBody": "Add the people who will take part in this trip.",
    "participants.identifier": "Username or email",
    "participants.identifierPlaceholder": "Enter a username or email",
    "participants.identifierHint": "If the user is already on Mundely they will receive an in-app invitation and notification. If the email is not registered, an email invitation will be prepared.",
    "participants.inviteFlowHint": "The participant must accept or decline the invitation. You will receive a notification with the result.",
    "participants.sendInvite": "Send invitation",
    "participants.sending": "Sending…",
    "participants.inviteSent": "Invitation sent in the app.",
    "participants.emailInviteQueued": "Email invitation prepared. The recipient will receive it through the email service configured for Mundely.",
    "participants.inviteError": "The invitation could not be sent. Try again.",
    "participants.userNotFound": "Username not found. To invite someone who is not registered, use their email address.",
    "participants.cannotInviteSelf": "You cannot invite your own account.",
    "participants.refreshStatus": "Refresh status",
    "participants.resendEmail": "Resend email",
    "participants.removeError": "The participant could not be removed.",
    "participants.status.pending": "Invitation pending",
    "participants.status.accepted": "Accepted",
    "participants.status.declined": "Declined",
    "participants.status.external": "Email invitation",
    "participants.status.manual": "Participant",
    "participants.status.left": "Left the trip",
    "participants.leftSection": "Participants who left",
    "participants.leaveTrip": "Leave trip",
    "participants.leaveTripTitle": "Leave this trip?",
    "participants.leaveTripBody": "You will no longer have access to the trip. Your name will remain visible in the list of participants who left.",
    "participants.leaveTripConfirm": "Leave trip",
    "participants.leaveError": "The trip could not be left. Try again.",
    "participants.currentSection": "Participants",
    "participants.currentEmpty": "No participant has accepted the invitation yet.",
    "participants.sentSection": "Sent invitations",
    "participants.sentEmpty": "No pending invitations.",
    "participants.declinedSection": "Declined invitations",
    "participants.declinedEmpty": "No declined invitations.",
    "share.exportHtml": "Export HTML",
    "share.exportJson": "Export JSON",
    "share.exportSaved": "File exported to the Download/Mundely folder.",
    "share.exportError": "The file could not be exported.",
    "notifications.title": "Notification center",
    "notifications.empty": "No notifications.",
    "notifications.markRead": "Mark as read",
    "notifications.tripInviteTitle": "Trip invitation",
    "notifications.tripInviteBody": "You received an invitation to join a trip.",
    "notifications.tripInviteAcceptedTitle": "Invitation accepted",
    "notifications.tripInviteAcceptedBody": "A participant accepted your invitation.",
    "notifications.tripInviteDeclinedTitle": "Invitation declined",
    "notifications.tripInviteDeclinedBody": "A participant declined your invitation.",
    "notifications.invitedBy": "Invited by {name}",
    "notifications.acceptInvite": "Accept",
    "notifications.declineInvite": "Decline",
    "notifications.inviteResponseError": "The invitation response could not be saved.",
    "notifications.details": "Details",
    "notifications.role": "Role: {role}",
    "notifications.dates": "Dates",
    "notifications.acceptedPopup": "You accepted the trip invitation.",
    "share.eyebrow": "SHARE AND EXPORT",
    "share.title": "Choose what to show",
    "share.body": "Before creating the link or exporting the trip, choose which information to include.",
    "share.exportTitle": "Export trip",
    "share.exportBody": "Choose which information to include and download the trip in your preferred format.",
    "share.linkTitle": "Share trip",
    "share.linkBody": "Choose which information to make visible and generate a dedicated public link.",
    "share.empty": "The link is valid, but it currently contains no shareable information.",
    "share.tickets": "Tickets",
    "share.documents": "Documents",
    "share.financials": "Financial details",
    "share.participants": "Participants",
    "share.notes": "Notes",
    "share.generate": "Generate link",
    "share.copy": "Copy link",
    "share.error": "The share link could not be created.",
    "share.invalid": "This share link is invalid or no longer available.",
    "trips.archive": "Archive",
    "trips.archived": "Archived trips",
    "trips.archivedEmpty": "There are no archived trips.",
    "trips.archivedReadOnlyTitle": "Archived trip · read only",
    "trips.archivedReadOnlyBody": "You can view every section, export or share the trip. Restore it before editing or adding content.",
    "trips.activeTitle": "Active trips",
    "trips.activeEmpty": "There are no active trips. Create a new one or restore an archived trip.",
    "trips.status": "Trip status",
    "trips.statusPlanning": "Planning",
    "trips.statusUpcoming": "Upcoming",
    "trips.statusActive": "In progress",
    "trips.statusCompleted": "Completed",
    "trips.sync.idle": "Ready",
    "trips.sync.syncing": "Syncing…",
    "trips.sync.synced": "Synced",
    "trips.sync.offline": "Offline · waiting",
    "trips.sync.error": "Sync error",
    "trips.syncRetry": "Tap to retry synchronization",
    "trips.restore": "Restore",
    "trips.deleteConfirm": "Move this trip to the trash? You can restore it for 30 days.",
    "trips.editTitle": "Edit trip",
    "trips.archiveConfirm": "Archive this trip? You can restore it at any time from archived trips.",
    "trips.restoreConfirm": "Restore this trip? It will return to active trips.",
    "trips.trashTitle": "Trip trash",
    "trips.trashBody": "Deleted trips remain recoverable for 30 days, then they can be permanently removed.",
    "trips.trashEmpty": "The trip trash is empty.",
    "trips.trashDays": "Permanent deletion in {days} days",
    "trips.restoreFromTrash": "Restore",
    "trips.deleteForever": "Delete permanently",
    "trips.deleteForeverConfirm": "Permanently delete this trip and all of its data? This action cannot be undone.",
    "trips.trashSyncError": "The trash could not be synchronized. Try again when a connection is available.",
    "trips.historyTitle": "Version history",
    "trips.historyBody": "Mundely automatically keeps the latest versions of your trips on this device, so you can return to an earlier state.",
    "trips.historyHint": "Choose a trip, check the date and time of the saved version, then tap Restore when you want to go back to that state.",
    "trips.historyTrip": "Trip",
    "trips.historyNoTrips": "There are no trips available.",
    "trips.historyEmpty": "Version history will appear after the next changes to this trip.",
    "trips.historyRestore": "Restore version",
    "trips.historyRestoreConfirm": "Restore this version of the trip? Mundely will automatically keep the current state before restoring it.",
    "trips.historyRestored": "Version restored successfully.",
    "trips.historyRestoreError": "This version could not be restored.",
    "security.lockTitle": "Unlock Mundely",
    "security.unlockBiometric": "Unlock with biometrics",
    "security.unlockPin": "Unlock with PIN",
    "security.pinInvalid": "Incorrect PIN.",
    "security.biometricUnavailable": "Biometrics are unavailable for this app or on this device.",
    "security.biometricNativeOnly": "Biometric authentication is available only in the installed Android or iPhone app.",
    "security.biometricNotEnrolled": "No fingerprint or biometric authentication is configured on this device.",
    "security.deviceCredentialMissing": "Set up a device PIN, password, pattern, or biometric authentication in your phone settings first.",
    "security.biometricLockout": "Too many failed attempts. Unlock the phone manually and try again.",
    "security.biometricFailed": "Biometric authentication failed.",
    "security.biometricSystemCancel": "Biometric authentication was cancelled by the system.",
    "security.biometricCancelled": "Biometric authentication was cancelled.",
    "security.biometricTimeout": "Biometric authentication did not receive a response from the system. Close and reopen the app, then try again.",
    "security.biometricChecking": "Checking…",
    "security.lockedTitle": "Mundely is locked",
    "security.lockBody": "Unlock the app to view your data.",
    "security.pinPlaceholder": "Enter PIN",
    "security.pinNotConfigured": "No PIN is configured. Unlock with biometrics or your account password, then set a new PIN.",
    "security.passwordPlaceholder": "Account password",
    "security.unlockPassword": "Unlock with password",
    "security.passwordUnavailable": "Account unavailable. Sign in again.",
    "security.passwordInvalid": "Incorrect account password or this account does not support password authentication.",
    "security.forgotPin": "Forgot your PIN? Use another method",
    "security.lockHelp": "If you do not remember your PIN, unlock with biometrics or your account password, then set a new PIN in Security.",
    "errors.generic": "Something went wrong. Try again.",
    "errors.network": "No connection. Compatible changes will be queued and synchronized as soon as possible.",
    "errors.sessionExpired": "Your session has expired. Sign in again.",
    "errors.limitReached": "You have reached your plan limit.",
    "errors.sync": "Sync was not completed. No local data was deleted.",
    "errors.upload": "Upload was not completed. The local file was kept.",
    "errors.permission": "You do not have permission for this action.",
    "environment.missing": "Incomplete Firebase configuration",
    "environment.missingBody": "Complete the environment .env file before connecting the backend.",
    "home.lastTrip": "Last trip",
    "home.dashboardSubtitle": "A useful overview of your trips, upcoming departures and what you have already organised.",
    "home.tripInProgress": "Trip in progress",
    "home.daysUntil": "{count} days to go",
    "home.startsToday": "Leaving today",
    "home.openTrip": "Open trip",
    "home.noTripTitle": "No trips yet",
    "home.noTripBody": "Create your first trip to start organising itinerary, bookings, experiences and documents.",
    "home.statTrips": "Trips",
    "home.statCompleted": "Past trips",
    "home.statDestinations": "Destinations visited",
    "home.statActive": "In progress",
    "home.yourTrips": "Your trips",
    "home.yourTripsBody": "Quickly reopen your most recent trips.",
    "home.viewAll": "View all",
    "home.noTripsYet": "Your trips will appear here.",
    "tripHome.nextStop": "Next stop",
    "tripHome.locationPending": "Location to be decided",
    "tripHome.openItinerary": "Open itinerary",
    "tripHome.noNextStop": "Itinerary is still empty",
    "tripHome.noNextStopBody": "Add the first stop to start building your trip.",
    "tripHome.addFirstStop": "Add first stop",
    "tripHome.hotels": "Hotels",
    "tripHome.experiences": "Experiences",
    "tripHome.events": "Events",
    "tripHome.documents": "Documents",
    "tripHome.days": "Days",
    "tripHome.checklist": "Checklist",
    "tripHome.notes": "Notes",
    "tripHome.stops": "Stops",
    "tripHome.quickAccess": "Quick access",
    "tripHome.quickAccessBody": "The sections you use most while organising the trip.",
    "tripHome.allSections": "All sections",
    "tripHome.allSectionsBody": "Open any trip area without filling the Home with large cards.",
    "aiDiscovery.experiencesTitle": "Find experiences with Mundely",
    "aiDiscovery.eventsTitle": "Find events with Mundely",
    "aiDiscovery.experiencesBody": "Describe what interests you: the AI agent prepares options that match the trip destination and dates.",
    "aiDiscovery.eventsBody": "The AI agent looks for events matching the cities and dates of the trip and prepares them for adding.",
    "aiDiscovery.experiencesPlaceholder": "E.g. snorkelling, local food, less touristy tours…",
    "aiDiscovery.eventsPlaceholder": "E.g. concerts, exhibitions, festivals, markets…",
    "aiDiscovery.city": "City or area",
    "aiDiscovery.cityPlaceholder": "E.g. city centre",
    "aiDiscovery.request": "What do you want to find",
    "aiDiscovery.search": "Search with AI",
    "aiDiscovery.searching": "Searching…",
    "aiDiscovery.notAvailable": "AI search is prepared, but the service is not available in this environment.",
    "aiDiscovery.noStructuredResults": "Mundely replied but did not return structured results that can be used.",
    "aiDiscovery.error": "The AI search could not be completed.",
    "aiDiscovery.addSuggestion": "Use suggestion",
    "events.subtitle": "Concerts, exhibitions, festivals, markets and temporary events during the trip.",
    "events.add": "Add event",
    "events.mapTitle": "Link the event venue",
    "events.mapBody": "Select the real venue to automatically fill city and address.",
    "events.chooseMap": "Choose from map",
    "events.title": "Event name",
    "events.venue": "Venue",
    "events.city": "City",
    "events.address": "Address",
    "events.date": "Date",
    "events.startTime": "Start time",
    "events.endTime": "End time",
    "events.category": "Category",
    "events.price": "Price",
    "events.currency": "Currency",
    "events.url": "Website or tickets",
    "events.notes": "Notes",
    "events.empty": "No events",
    "events.emptyBody": "Add events manually or use Mundely search.",
    "events.openWebsite": "Open website",
    "documents.viewMode": "Document view mode",
    "documents.viewByCategory": "By category",
    "documents.viewByParticipant": "By participant",
    "notes.chooseIcon": "Choose icon",
    "notes.removeIcon": "Remove icon",
    "notes.titlePlaceholder": "Note title",
    "notes.toolbar": "Formatting tools",
    "notes.bold": "Bold",
    "notes.italic": "Italic",
    "notes.underline": "Underline",
    "notes.strike": "Strikethrough",
    "notes.toolBoldSymbol": "B",
    "notes.toolItalicSymbol": "I",
    "notes.toolUnderlineSymbol": "U",
    "notes.toolStrikeSymbol": "S",
    "notes.customColor": "Custom colour",
    "notes.bulletedList": "Bulleted list",
    "notes.numberedList": "Numbered list",
    "dashboard.customize": "Customise dashboard",
    "dashboard.done": "Finish editing",
    "dashboard.editWidget": "Edit widget",
    "dashboard.widgetTitle": "Widget title",
    "dashboard.width": "Width",
    "dashboard.height": "Height",
    "dashboard.background": "Widget background",
    "dashboard.backgroundOption": "Choose background",
    "dashboard.customColor": "Custom colour",
    "dashboard.opacity": "Transparency",
    "dashboard.visible": "Show widget",
    "dashboard.moveUp": "Move earlier",
    "dashboard.moveDown": "Move later",
    "dashboard.restoreDefaults": "Restore widgets",
    "dashboard.size.small": "Small",
    "dashboard.size.medium": "Medium",
    "dashboard.size.large": "Large",
    "dashboard.size.full": "Full width",
    "dashboard.height.compact": "Compact",
    "dashboard.height.normal": "Normal",
    "dashboard.height.tall": "Tall",
    "notes.alignment": "Text alignment",
    "notes.align.left": "Align left",
    "notes.align.center": "Centre",
    "notes.align.right": "Align right",
    "notes.align.justify": "Justify",
    "notes.color": "Note colour",
    "notes.colorOption": "Choose colour",
    "notes.contentPlaceholder": "Write your note…",
    "notes.update": "Update note",
    "map.filter.itinerary": "Itinerary",
    "map.filter.experiences": "Experiences",
    "map.filter.events": "Events",
    "map.days": "Trip days",
    "map.allDays": "Whole trip",
    "map.zoomIn": "Zoom in",
    "map.zoomOut": "Zoom out",
    "map.zoomControls": "Zoom controls",
    "map.day": "Day",
    "map.allTrip": "Whole trip",
    "map.style": "Map type",
    "map.styleClassic": "Classic map",
    "map.styleSatellite": "Satellite map",
    "map.itineraryOnlyBody": "The map is built exclusively from the trip itinerary.",
    "map.infoTitle": "How the map works",
    "map.clusterTitle": "{count} places in this area",
    "app.backExitWarning": "Press Back once more to exit the app.",
    "map.itineraryOnlyBadge": "Itinerary → Map",
    "map.itineraryEmpty": "Add itinerary items with a location to build the map.",
    "map.itineraryFilter.transfers": "Transfers",
    "map.itineraryFilter.hotels": "Hotels",
    "map.itineraryFilter.food": "Restaurants",
    "map.itineraryFilter.cities": "Cities",
    "map.itineraryFilter.places": "Places",
    "map.itineraryFilter.experiences": "Experiences",
    "map.itineraryFilter.events": "Events",
    "map.dayLabel": "Day {number}",
    "map.autoBuildTitle": "Automatic map",
    "map.autoBuildBody": "{points} points · {photos} photos ready",
    "map.photoStoryTitle": "The trip in photos",
    "map.photoStoryBody": "Mundely automatically builds the photo sequence from cities, restaurants, points of interest, experiences and events already added to the trip.",
    "map.photoCount": "{count} photos",
    "map.noPhotos": "Photos will appear automatically when images are available for the places in your trip.",
    "map.photoBy": "Photo by",
    "album.autoTitle": "Automatic album",
    "album.autoBody": "Trip photos are automatically organized from the places already included on the map.",
    "album.userOnlyBody": "Only photos uploaded by trip participants appear here.",
    "album.userOnlyTitle": "Real trip photos only",
    "album.userOnlyDescription": "Mundely no longer inserts default Google Maps photos or other automatic images in this section.",
    "album.userOnlyEmpty": "Add your photos and link them to a day or itinerary point.",
    "album.addPhoto": "Add photo",
    "album.uploadBody": "Upload a photo and link it to the correct day, city, experience or itinerary point.",
    "album.file": "Photo",
    "album.date": "Day",
    "album.linkTo": "Link to",
    "album.noLink": "Day only",
    "album.caption": "Caption",
    "album.pending": "Upload in progress",
    "album.uploadError": "The photo upload failed. The local copy is kept and you can retry.",
    "album.autoDescription": "Mundely retrieves available place images and orders them by day. Custom photos selected for cities always take priority.",
    "album.photosBuilt": "photos available",
    "album.undated": "Without a date",
    "album.empty": "No photos available",
    "album.emptyBody": "Add cities, restaurants, points of interest, experiences or events through map search. Mundely will automatically build the album.",
    "album.withoutDate": "No date",
    "album.photoCount": "{count} photos",
    "climate.sectionBody": "Add or update expected conditions for each day. These details automatically appear in the itinerary.",
    "climate.saved": "Climate added",
    "climate.add": "Add climate",
    "climate.editTitle": "Daily climate",
    "climate.editBody": "Information saved here is automatically collected in the itinerary.",
    "climate.autoBody": "Forecasts are fetched automatically from the locations in your trip. You do not need to enter anything manually.",
    "climate.loading": "Updating forecast…",
    "climate.autoError": "Forecasts are not available right now. You can retry.",
    "climate.autoUnavailable": "Forecast unavailable for this date.",
    "climate.source": "Weather data: Open-Meteo",
    "climate.location": "Location: {location}",
    "climate.weather.clear": "Clear",
    "climate.weather.partlyCloudy": "Partly cloudy",
    "climate.weather.fog": "Fog",
    "climate.weather.drizzle": "Drizzle",
    "climate.weather.rain": "Rain",
    "climate.weather.snow": "Snow",
    "climate.weather.showers": "Showers",
    "climate.weather.thunderstorm": "Thunderstorms",
    "climate.weather.unknown": "Variable conditions",
    "climate.conditions": "Conditions",
    "climate.minTemp": "Minimum temperature",
    "climate.maxTemp": "Maximum temperature",
    "climate.summary": "Summary",
    "climate.notes": "Notes",
      "itinerary.startDate": "Start date",
    "itinerary.endDate": "End date",
    "itinerary.originCity": "Departure city",
    "itinerary.destinationCity": "Arrival city",
    "itinerary.transportMode": "Transport mode",
    "itinerary.transport.car": "Car",
    "itinerary.transport.bus": "Bus",
    "itinerary.transport.plane": "Plane",
    "itinerary.transport.train": "Train",
    "itinerary.transport.ferry": "Ferry",
    "settings.sectionsTransfers": "Transfers",
    "settings.sectionsTransfersBody": "Configure the transport modes available for itinerary transfers.",
    "settings.sectionsTransferModes": "Transport modes",
    "album.folder": "Folder",
    "album.newFolder": "New folder",
    "album.defaultFolder": "Trip photos",
    "album.massUpload": "You can select multiple photos at once. Each photo is optimized to a maximum of 1 MB.",
    "album.fileTooLarge": "The file exceeds the 1 MB maximum size.",
    "profile.publicLink": "Public profile",
    "profile.publicLinkBody": "Share photos, introduction, visited countries and active trips with a public link.",
    "profile.copyPublicLink": "Copy public link",
    "profile.publicLinkCopied": "Profile link copied.",
    "profile.publicNotFound": "Profile unavailable",
    "profile.publicTrips": "Trips",
    "profile.publicCountries": "Visited countries",
    "profile.publicActiveTrips": "Active trips",
    "profile.publicVisitedCountries": "Visited countries",
},
  "es": {
    "offline.prepTask": "Hacer que el viaje esté disponible sin conexión",
    "offline.prepHint": "Opcional: guarda el viaje para consultarlo sin conexión a Internet.",
    "offline.manage": "Gestionar disponibilidad sin conexión",
    "offline.notEnabled": "Descarga sin conexión no activada",
    "offline.modeTitle": "¿Qué quieres guardar en el dispositivo?",
    "offline.modeData": "Datos y documentos del viaje",
    "offline.modeDataHint": "Itinerario, reservas, información útil, listas, notas, billetes y documentos, sin el álbum de fotos.",
    "offline.modePhotos": "Datos, documentos y fotos del viaje",
    "offline.modePhotosHint": "Toda la información del viaje y las fotos guardadas en el álbum.",
    "offline.estimate": "Espacio estimado: {size}",
    "offline.estimateNote": "Estimación aproximada: el tamaño de las fotos puede variar. La descarga es opcional.",
    "offline.automatic": "Los cambios se guardan automáticamente. Sigue usando las secciones habituales del viaje.",
    "offline.integratedNavigation": "No existe una segunda versión del viaje: las mismas secciones están disponibles sin Internet.",
    "offline.changeOptions": "Guardar nueva selección",
    "offline.downloadNoConnection": "Para realizar la descarga inicial necesitas conexión a Internet.",
    "offline.cacheIncomplete": "Datos guardados; algunos archivos aún no están disponibles. Mundely lo volverá a intentar automáticamente.",
    "offline.autoSync": "Las actualizaciones automáticas de la copia sin conexión están activadas.",
    "offline.someFilesPending": "{count} archivos adjuntos aún no están disponibles sin conexión; se reintentará automáticamente cuando sea posible.",
    "offline.openWhenOffline": "Estás sin conexión: abre la copia guardada del viaje.",
    "offline.waitForSync": "Espera a que el viaje termine de sincronizarse antes de descargar una nueva copia. La copia guardada sigue disponible.",
    "offline.title": "Viaje sin conexión",
    "offline.boardingPasses": "Tarjetas de embarque",
    "offline.premiumOnly": "Disponible en el plan Completo",
    "offline.premiumDescription": "La descarga y consulta del viaje sin conexión está disponible solo en el plan Completo.",
    "offline.description": "Guarda una copia de solo lectura en el dispositivo: itinerario, reservas, información útil, listas, notas, lugares, billetes y otros datos. Selecciona los archivos que quieras descargar.",
    "offline.privateWarning": "Los documentos descargados permanecen en este dispositivo. Protege el móvil; al desinstalar la aplicación podrías perder las copias.",
    "offline.selectFiles": "Archivos para guardar sin conexión",
    "offline.noAttachments": "No hay archivos del viaje disponibles. Aun así, puedes descargar los datos del viaje.",
    "offline.available": "Copia sin conexión disponible",
    "offline.attachments": "archivos",
    "offline.showContents": "Consultar sin conexión",
    "offline.hideContents": "Ocultar contenido",
    "offline.snapshotReadOnly": "Copia local de solo lectura. Los cambios se actualizan automáticamente al guardar.",
    "offline.mapLimit": "Se conservan las direcciones y coordenadas. Los mapas interactivos, sus mosaicos y la navegación requieren conexión a Internet.",
    "offline.saveAttachment": "Guardar archivo en el dispositivo",
    "offline.attachmentNotDownloaded": "Archivo no incluido en la copia sin conexión",
    "offline.progress": "Descarga: {done} de {total}",
    "offline.update": "Actualizar copia",
    "offline.download": "Descargar viaje sin conexión",
    "offline.delete": "Eliminar copia",
    "offline.confirmDelete": "¿Eliminar la copia sin conexión de este viaje del dispositivo?",
    "offline.saved": "Copia sin conexión lista.",
    "offline.removed": "Copia sin conexión eliminada.",
    "offline.storageError": "No se puede acceder al almacenamiento sin conexión.",
    "offline.fileSaved": "Archivo guardado en el dispositivo.",
    "offline.fileSaveError": "No se pudo guardar el archivo.",
    "trip.intel.reviewRecords": "Abrir sección",
    "trip.intel.less": "Mostrar menos",
    "trip.intel.more": "Leer respuesta completa",
    "trip.intel.agentAnswer": "Respuesta del agente",
    "trip.intel.assistantQuestionTitle": "Elige qué quieres mejorar",
    "trip.intel.preparationQuestionTitle": "Elige qué quieres revisar",
    "trip.intel.assistantOtherQuestion": "O haz una pregunta específica",
    "trip.intel.preparationOtherQuestion": "O pide una verificación específica",
    "trip.intel.assistantInputPlaceholder": "Ej. ya tenemos 3 noches con familiares y 2 en hotel: ¿cómo organizo mejor el resto?",
    "trip.intel.preparationInputPlaceholder": "Ej. ¿debo hacer algún check-in antes del próximo vuelo o alojamiento?",
    "trip.intel.followupTitle": "¿Quieres profundizar en esta respuesta?",
    "trip.intel.followupResultTitle": "Más detalles",
    "trip.intel.followupPlaceholder": "Ej. ¿en qué trayecto tengo más riesgo de ir justo de tiempo?",
    "trip.intel.sendFollowup": "Pedir más detalle",
    "trip.intel.openSection.itinerary": "Abrir Itinerario",
    "trip.intel.openSection.hotels": "Abrir Alojamientos",
    "trip.intel.openSection.documents": "Abrir Documentos",
    "trip.intel.openSection.checklist": "Abrir Checklist",
    "trip.intel.openSection.boardingPass": "Abrir Vuelos y tarjetas de embarque",
    "trip.intel.openSection.experiences": "Abrir Experiencias",
    "trip.intel.openSection.expenses": "Abrir Gastos",
    "trip.intel.homeAssistantEyebrow": "Sugerencias para el viaje",
    "trip.intel.homePrepEyebrow": "Comprobaciones para el viaje",
    "trip.intel.homeAssistantAfter": "Revisa gastos, recuerdos y tareas pendientes tras el viaje.",
    "trip.intel.homeAssistantDuring": "Adapta las próximas etapas a horarios y cambios de planes.",
    "trip.intel.homeAssistantStays": "Tienes {count} noches sin alojamiento registrado: busca opciones acordes al itinerario.",
    "trip.intel.homeAssistantPlan": "Ya tienes {count} etapas registradas: descubre cómo organizarlas mejor.",
    "trip.intel.homeAssistantStart": "Crea un itinerario a tu medida, etapa a etapa.",
    "trip.intel.homePrepStays": "{count} noches sin alojamiento registrado: compruébalo antes de salir.",
    "trip.intel.homePrepOverlaps": "{count} noches con alojamientos solapados: revisa fechas y reservas.",
    "trip.intel.homePrepChecklist": "Quedan {count} elementos de la lista por completar.",
    "trip.intel.homePrepReadyReview": "Revisa documentos, check-ins y detalles prácticos del destino.",
    "trip.intel.homePrepDetails": "Revisa horarios, referencias de reservas y direcciones guardadas antes de salir.",
    "trip.intel.homeAssistantRoute": "Agrupa las visitas cercanas y deja tiempo para descansar y desplazarte.",
    "trip.intel.homeAssistantMemories": "Guarda tus lugares favoritos y las ideas para tu próximo viaje.",
    "trip.intel.qVisit": "¿Qué merece realmente la pena visitar?",
    "trip.intel.qVisitDesc": "Lugares, zonas o experiencias coherentes con este viaje",
    "trip.intel.qOptimize": "¿Cómo puedo mejorar el itinerario?",
    "trip.intel.qOptimizeDesc": "Orden de etapas, tiempos y mejor reparto de los días",
    "trip.intel.qStays": "¿Cómo conviene gestionar los alojamientos?",
    "trip.intel.qStaysDesc": "Noches, cambios de alojamiento y opciones más cómodas",
    "trip.intel.qTransfer": "¿Cómo organizo mejor los desplazamientos?",
    "trip.intel.qTransferDesc": "Conexiones entre etapas, tiempos y pasos más delicados",
    "trip.intel.qActivities": "¿Qué actividades encajan mejor con mi viaje?",
    "trip.intel.qActivitiesDesc": "Experiencias que añadir según destino, ritmo y temporada",
    "trip.intel.qSavings": "¿Dónde puedo optimizar el presupuesto?",
    "trip.intel.qSavingsDesc": "Ahorro en transporte, actividades, zonas o decisiones prácticas",
    "trip.intel.qPending": "¿Qué me falta completar antes de salir?",
    "trip.intel.qPendingDesc": "Visión general de lo que falta o conviene revisar",
    "trip.intel.qConnections": "¿Funcionan realmente los enlaces entre etapas?",
    "trip.intel.qConnectionsDesc": "Horarios, enlaces y márgenes entre traslados y check-ins",
    "trip.intel.qDocuments": "Documentos y requisitos: ¿está todo en regla?",
    "trip.intel.qDocumentsDesc": "Pasaporte, visado, entrada, seguro y documentos útiles",
    "trip.intel.qInconsistencies": "¿Hay fechas o reservas que deba revisar?",
    "trip.intel.qInconsistenciesDesc": "Noches, fechas, solapamientos y referencias a verificar",
    "trip.intel.qEssentials": "¿Tengo de verdad todo lo necesario para este destino?",
    "trip.intel.qEssentialsDesc": "Enchufes, clima, salud, equipaje y necesidades prácticas",
    "trip.intel.qCheckins": "¿Qué check-ins o confirmaciones me faltan?",
    "trip.intel.qCheckinsDesc": "Vuelos, alojamientos, plazos útiles y pasos online pendientes",
    "trip.intel.workletAssistantLead": "Organiza mejor tu viaje",
    "trip.intel.workletAssistantHint": "Pide consejos personalizados con los datos de tu itinerario.",
    "trip.intel.workletPreparationLead": "Comprueba qué falta realmente",
    "trip.intel.workletPreparationHint": "{count} elementos de checklist pendientes. Revisa por tema.",
    "trip.intel.workletIssues": "{count} detalles pendientes sobre las noches",
    "trip.intel.statusNoGaps": "No hay noches sin registrar; aún se debe verificar la validez de las reservas.",
    "trip.intel.auditWhole": "Analizar todo el viaje",
    "trip.intel.scopeLabel": "¿Qué quieres analizar?",
    "trip.intel.scopeWhole": "Viaje completo",
    "trip.intel.scopeStays": "Alojamientos y noches",
    "trip.intel.scopeTransport": "Transportes y conexiones",
    "trip.intel.scopeDocuments": "Documentos",
    "trip.intel.scopeActivities": "Actividades y checklist",
    "trip.intel.analysis": "Análisis",
    "trip.intel.nextSteps": "Próximos pasos",
    "trip.intel.criticalIssues": "Puntos críticos",
    "trip.intel.statusAccommodation": "Alojamientos",
    "trip.intel.statusTransport": "Transportes",
    "trip.intel.statusDocuments": "Documentos",
    "trip.intel.statusActivities": "Actividades",
    "trip.intel.transportSummary": "{flights} vuelos · {transfers} traslados",
    "trip.intel.documentsDetail": "Documentos registrados, validez no verificada",
    "trip.intel.activitiesDetail": "{checklist} elementos personales de checklist aún abiertos",
    "trip.intel.invalidHotelDatesTitle": "Alojamientos con fechas por corregir",
    "trip.intel.overlapTitle": "Solapamientos por revisar",
    "trip.intel.notBookingConfirmed": "Esto no confirma que las reservas estén verificadas.",
    "trip.intel.recordedCoverage": "Noches con alojamiento indicado",
    "trip.intel.recorded": "Registrado",
    "trip.intel.nightCount": "{count} noches",
    "trip.intel.staysByPeriod": "Noches agrupadas por alojamiento",
    "trip.intel.noGapsDetected": "No se detectan noches sin alojamiento en los datos. Verifica reservas y traslados.",
    "trip.intel.priorityChecks": "Pendiente antes de salir",
    "trip.intel.assistantTitle": "Asistente de viaje",
    "trip.intel.preparationTitle": "Preparación inteligente",
    "trip.intel.assistantPurpose": "El agente analiza tu viaje y te ayuda a organizar lo que falta.",
    "trip.intel.preparationPurpose": "Comprueba alojamientos, traslados y datos pendientes.",
    "trip.intel.needDates": "Faltan las fechas del viaje o deben corregirse",
    "trip.intel.openNights": "{count} noches por organizar o aclarar",
    "trip.intel.nextAction": "Descubre el siguiente paso útil",
    "trip.intel.askAssistant": "Habla con el agente",
    "trip.intel.nightsCovered": "{done} de {total} noches con alojamiento indicado",
    "trip.intel.reviewPreparation": "Revisar preparación",
    "trip.intel.assistantDescription": "El agente usa los datos del viaje para proponer un siguiente paso o hacer preguntas concretas.",
    "trip.intel.preparationDescription": "Revisión de datos registrados. La cobertura no confirma reservas.",
    "trip.intel.contextKicker": "De tu viaje",
    "trip.intel.openRelevantSection": "Abrir sección relacionada",
    "trip.intel.suggestStep": "Sugiere mi siguiente paso",
    "trip.intel.clarify": "Hazme las preguntas necesarias",
    "trip.intel.yourQuestion": "¿Qué quieres organizar?",
    "trip.intel.questionPlaceholder": "P. ej., pasaré tres noches con mi tío y luego iré a un hotel. ¿Qué falta?",
    "trip.intel.send": "Preguntar al agente",
    "trip.intel.working": "El agente está analizando tu viaje…",
    "trip.intel.unavailable": "El agente no está disponible ahora. Tus datos siguen accesibles.",
    "trip.intel.noAutoChanges": "El agente sugiere acciones; los cambios y reservas requieren tu confirmación.",
    "trip.intel.nightsTitle": "Cobertura de noches",
    "trip.intel.unknownCoverage": "Porcentaje no disponible",
    "trip.intel.hotelRecorded": "Alojamiento registrado (pendiente de verificar)",
    "trip.intel.hostDeclared": "Estancia con amigos o familia declarada",
    "trip.intel.needClarification": "Alojamiento pendiente de aclarar",
    "trip.intel.undatedHotels": "{count} alojamientos sin fechas válidas, no contabilizados.",
    "trip.intel.overlaps": "{count} noches con alojamientos solapados: revisa las reservas.",
    "trip.intel.unknownNeeds": "Faltan datos para saber dónde dormirás cada noche. El porcentaje solo mide las noches con alojamiento indicado.",
    "trip.intel.openHotels": "Revisar alojamientos",
    "trip.intel.otherChecks": "Otros datos registrados",
    "trip.intel.transportFound": "{flights} vuelos y {transfers} traslados registrados",
    "trip.intel.denominatorUnknown": "total necesario aún no definido",
    "trip.intel.documentsFound": "{count} documentos registrados",
    "trip.intel.notVerified": "validez sin comprobar",
    "trip.intel.activitiesFound": "{count} actividades o eventos registrados",
    "trip.intel.analyzeAI": "Analizar con el agente",
    "trip.intel.verificationWarning": "Estos controles no confirman la validez de documentos, visados, billetes o reservas. Consulta siempre los requisitos oficiales.",
    "trip.setup.mode": "¿Cómo quieres crear el viaje?",
    "trip.setup.guided": "Creación guiada",
    "trip.setup.quick": "Creación rápida",
    "trip.setup.step": "Paso {current} de {total}",
    "trip.setup.next": "Continuar",
    "trip.setup.back": "Atrás",
    "trip.setup.review": "Revisa las sugerencias antes de crear el viaje.",
    "trip.setup.purpose": "¿Por qué viajas?",
    "trip.setup.purpose.leisure": "Vacaciones",
    "trip.setup.purpose.family": "Visita a familiares o amigos",
    "trip.setup.purpose.work": "Trabajo",
    "trip.setup.purpose.other": "Otro",
    "trip.setup.accommodation": "¿Dónde te alojarás?",
    "trip.setup.accommodation.unsure": "Aún no lo sé",
    "trip.setup.accommodation.booking": "Hotel o alojamiento de alquiler",
    "trip.setup.accommodation.friends": "Con familiares o amigos",
    "trip.setup.accommodation.mixed": "Alojamientos mixtos",
    "trip.setup.transport": "¿Cómo viajarás?",
    "trip.setup.transport.unsure": "Aún no lo sé",
    "trip.setup.transport.flight": "En avión",
    "trip.setup.transport.train": "En tren",
    "trip.setup.transport.car": "En coche",
    "trip.setup.transport.other": "Otros medios",
    "trip.setup.notes": "Otras necesidades (opcional)",
    "trip.setup.notesPlaceholder": "Ej. voy a visitar a mi tío, no necesito hotel",
    "trip.setup.preview": "Secciones sugeridas",
    "trip.setup.hotelVisible": "Mostrar la sección Alojamientos",
    "trip.setup.visibilityHint": "Oculta o reactiva la sección sin borrar datos guardados. Las secciones esenciales siguen accesibles.",
    "trip.setup.suggestedSteps": "{count} pasos sugeridos, que podrás modificar después.",
    "trip.setup.askAI": "Pedir más sugerencias a la IA",
    "trip.setup.aiNoSuggestion": "Sin más sugerencias. Puedes añadir pasos manualmente.",
    "trip.setup.aiReview": "Sugerencias de IA añadidas. Revísalas antes de guardar.",
    "trip.setup.aiUnavailable": "La IA no está disponible ahora. Puedes continuar con tus respuestas.",
    "trip.setup.edit": "Personalizar secciones y organización",
    "trip.setup.apply": "Aplicar preferencias",
    "trip.setup.detected": "Detectado automáticamente: revisa los datos antes de confirmar.",
    "trip.guide.expand": "Mostrar acciones",
    "trip.guide.addNew": "Añadir un paso",
    "trip.guide.confirmDelete": "¿Eliminar este paso? No se borrarán los datos de las secciones.",
    "trip.guide.statusHint": "Marcado manualmente: reservas y documentos aún requieren verificación.",
    "trip.prep.confirmedOnly": "{done} de {total} verificaciones confirmadas",
    "trip.prep.detectedCount": "{count} verificaciones detectadas pendientes de confirmar",
    "trip.prep.whyDetected": "Datos presentes, validez sin verificar.",
    "trip.prep.checklistTitle": "Viaje sin sorpresas",
    "trip.prep.guideTitle": "Organización guiada",
    "trip.prep.progress": "{done} de {total} comprobaciones completadas",
    "trip.prep.openDetails": "Revisar todas las comprobaciones",
    "trip.prep.allChecked": "Se han completado todas las comprobaciones aplicables.",
    "trip.prep.nextStep": "Siguiente paso recomendado",
    "trip.prep.readyTitle": "Preparación comprobada",
    "trip.prep.readyBody": "Has completado todas las comprobaciones aplicables. Revísalo todo antes de salir.",
    "trip.prep.review": "Revisar preparación",
    "trip.prep.detailIntro": "Revisa cada elemento. Las confirmaciones manuales son independientes de tus listas personales.",
    "trip.prep.auto": "Detectado",
    "trip.prep.confirmed": "Confirmado",
    "trip.prep.notApplicable": "No aplicable",
    "trip.prep.pending": "Por comprobar",
    "trip.prep.confirm": "Confirmar",
    "trip.prep.reset": "Deshacer confirmación",
    "trip.prep.skip": "No aplicable",
    "trip.prep.verificationNote": "Las confirmaciones manuales no sustituyen la comprobación de requisitos de entrada, validez documental o cobertura del seguro. Consulta siempre fuentes oficiales.",
    "trip.prep.officialSource": "Consejos oficiales de viaje",
    "trip.prep.destination": "Destino y fechas",
    "trip.prep.destinationHint": "Indica el destino y las fechas correctas del viaje.",
    "trip.prep.accommodation": "Alojamientos y reservas",
    "trip.prep.accommodationHint": "Comprueba que las reservas cubran todas las estancias necesarias.",
    "trip.prep.transport": "Vuelos y transportes",
    "trip.prep.transportHint": "Confirma las reservas, los horarios y los billetes de transporte.",
    "trip.prep.documents": "Documentos de viaje",
    "trip.prep.documentsHint": "Comprueba pasaporte, visados necesarios y requisitos de entrada. Subir un documento no valida su vigencia.",
    "trip.prep.transfers": "Traslados al aeropuerto",
    "trip.prep.transfersHint": "Comprueba cómo llegar al alojamiento o marca que no corresponde.",
    "trip.prep.insurance": "Seguro de viaje",
    "trip.prep.insuranceHint": "Comprueba la cobertura o marca que no se necesita.",
    "trip.prep.activities": "Actividades y reservas",
    "trip.prep.activitiesHint": "Comprueba entradas y experiencias por reservar o marca que no son necesarias.",
    "trip.prep.reminders": "Recordatorios personales",
    "trip.prep.remindersHint": "Revisa las tareas pendientes o indica que no se necesitan.",
    "trip.prep.personalChecklists": "Tus listas personales",
    "trip.prep.personalChecklistsHint": "Revisa equipaje y otras listas personales, que seguirán siendo independientes.",
    "trip.prep.openTrip": "Revisar viaje",
    "trip.prep.openHotels": "Abrir alojamientos",
    "trip.prep.openItinerary": "Abrir itinerario",
    "trip.prep.openDocuments": "Abrir documentos",
    "trip.prep.openExperiences": "Abrir experiencias",
    "trip.prep.openNotes": "Abrir recordatorios",
    "trip.prep.openChecklists": "Abrir mis listas",
    "trip.prep.remaining": "{count} comprobaciones pendientes",
    "trip.prep.groupEssential": "Esencial",
    "trip.prep.groupImportant": "Importante",
    "trip.prep.groupBefore": "Antes de salir",
    "trip.prep.groupPending": "{count} pendientes",
    "trip.prep.groupCompleted": "Todo comprobado",
    "trip.prep.reasonConfirmed": "Confirmado por ti",
    "trip.prep.reasonNotApplicable": "Marcado como no aplicable",
    "trip.prep.reasonPersonalDone": "Todas las tareas de tus listas están completadas",
    "trip.prep.reasonDetected": "Los datos básicos del viaje están presentes",
    "trip.prep.reasonPersonalPending": "{count} tareas personales por completar",
    "trip.prep.reasonPersonalEmpty": "No hay tareas personales: puedes crear una lista",
    "trip.prep.reasonStays": "{count} alojamientos guardados: comprueba fechas y reservas",
    "trip.prep.reasonDocuments": "{count} documentos guardados: validez sin verificar",
    "trip.prep.reasonEntries": "{count} elementos guardados: comprueba los detalles",
    "trip.prep.urgencySoon": "Salida cercana: revisión recomendada",
    "trip.prep.urgencyImminent": "Salida inminente: revisión prioritaria",
    "trip.prep.urgencyInProgress": "Durante el viaje: próxima revisión",
    "trip.guide.remaining": "{count} actividades por organizar",
    "trip.guide.freeOrder": "Elige tu propio orden",
    "trip.guide.openGuide": "Abrir organización del viaje",
    "trip.guide.openSection": "Abrir sección",
    "trip.guide.allPlannedDone": "No hay tareas pendientes. Puedes añadir otras cuando quieras.",
    "trip.guide.intro": "Organiza el viaje en cualquier orden: añade varios hoteles, vuelos o trenes, pospón y mueve cualquier tarea.",
    "trip.guide.todo": "Pendientes",
    "trip.guide.done": "Completadas",
    "trip.guide.deferred": "Pospuestas",
    "trip.guide.moveUp": "Subir",
    "trip.guide.moveDown": "Bajar",
    "trip.guide.stepName": "Nombre de la tarea",
    "trip.guide.markDone": "Hecho",
    "trip.guide.defer": "Posponer",
    "trip.guide.resume": "Reanudar",
    "trip.guide.rename": "Renombrar",
    "trip.guide.addStep": "Añadir tarea",
    "trip.guide.type": "Tipo de tarea",
    "trip.guide.date": "Fecha (opcional)",
    "trip.guide.repeatHint": "Puedes añadir varias tareas del mismo tipo, incluso para días diferentes.",
    "trip.guide.empty": "Aún no hay tareas: añade una abajo.",
    "trip.guide.kindAccommodation": "Alojamiento",
    "trip.guide.kindFlight": "Vuelo",
    "trip.guide.kindTrain": "Tren",
    "trip.guide.kindTransfer": "Traslado",
    "trip.guide.kindDocuments": "Documentos",
    "trip.guide.kindActivity": "Actividad o billete",
    "trip.guide.kindInsurance": "Seguro",
    "trip.guide.kindOther": "Otra tarea",
    "album.customFileName": "Nombre de archivo (sin extensión)",
    "album.fileNames": "Nombres de imágenes",
    "profile.introduction": "Presentación",
    "profile.introductionEmpty": "No se ha añadido ninguna presentación.",
    "profile.introductionPlaceholder": "Cuenta algo sobre ti, tu forma de viajar y tus intereses.",
    "profile.introductionHint": "Máximo 1.200 caracteres.",
    "profile.personalPhotos": "Fotos personales",
    "profile.personalPhotosBody": "Puedes añadir hasta 10 fotos personales a tu perfil.",
    "profile.personalPhotosLimit": "Puedes añadir un máximo de 10 fotos personales.",
    "profile.personalPhotosSaved": "Fotos personales actualizadas.",
    "profile.personalPhotoAlt": "Foto personal {number}",
    "profile.addPersonalPhotos": "Añadir fotos",
    "itinerary.startDateTime": "Fecha y hora de inicio",
    "itinerary.endDateTime": "Fecha y hora de fin",
    "participants.changeRole": "Cambiar rol",
    "participants.roleUpdated": "Rol actualizado.",
    "participants.roleUpdateError": "No se pudo actualizar el rol.",
    "documents.otherParticipantsTitle": "Documentos de otros participantes",
    "documents.otherParticipantsBody": "Documentos personales compartidos por los participantes de este viaje.",
    "profile.sections": "Secciones del perfil",
    "profile.documentsSection": "Documentos",
    "notifications.openTrip": "Entrar en el viaje",
    "notifications.previewModeTitle": "Vista previa del viaje",
    "notifications.previewModeBody": "Puedes ver todas las secciones. Acepta la invitación para empezar a modificarlas.",
    "common.next": "Siguiente",
    "common.back": "Atrás",
    "common.skip": "Omitir",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.close": "Cerrar",
    "common.retry": "Reintentar",
    "common.other": "Otro",
    "common.loading": "Cargando…",
    "common.optional": "Opcional",
    "common.required": "Obligatorio",
    "common.continue": "Continuar",
    "common.done": "Hecho",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.open": "Abrir",
    "notifications.contentUnavailable": "Contenido no disponible.",
    "notifications.video": "Vídeo",
    "notifications.openVideo": "Abrir vídeo",
    "common.timePlaceholder": "HH:MM",
    "common.restore": "Restaurar",
    "welcome.language": "Idioma",
    "welcome.chooseLanguage": "Elige el idioma",
    "welcome.slide1.title": "Todo tu viaje en un solo lugar",
    "welcome.slide1.body": "Organiza itinerarios, etapas, reservas, documentos y recuerdos con una estructura sencilla y sincronizada.",
    "welcome.slide2.title": "Mundely viaja contigo",
    "welcome.slide2.body": "Consulta tus viajes sin conexión y recupera tus cambios en Web, Android e iOS cuando vuelvas a estar online.",
    "welcome.slide3.title": "Un asistente de IA para cada viaje",
    "welcome.slide3.body": "Planifica, resume y mejora el viaje con IA manteniendo el control de tus datos.",
    "welcome.start": "Empezar con Mundely",
    "auth.signIn": "Acceder",
    "auth.register": "Registrarse",
    "auth.firstName": "Nombre",
    "auth.lastName": "Apellidos",
    "auth.username": "Usuario",
    "auth.email": "Email",
    "auth.password": "Contraseña",
    "auth.confirmPassword": "Confirmar contraseña",
    "auth.usernamePlaceholder": "p. ej. PedroRojas",
    "auth.emailPlaceholder": "pedro.rojas@email.com",
    "auth.forgotPassword": "¿Olvidaste la contraseña?",
    "auth.resetPassword": "Recuperar contraseña",
    "auth.resetInfo": "Te enviaremos un enlace seguro para restablecerla.",
    "auth.sendReset": "Enviar email de recuperación",
    "auth.or": "o",
    "auth.google": "Acceder con Google",
    "auth.apple": "Acceder con Apple",
    "auth.createAccount": "Crear cuenta",
    "auth.loginIdentifier": "Usuario o email",
    "auth.loginIdentifierPlaceholder": "p. ej. PedroRojas o pedro.rojas@email.com",
    "auth.completeProfile": "Completa tu perfil",
    "auth.completeProfileBody": "Para usar Mundely, indica nombre, apellidos y un usuario único.",
    "auth.logout": "Cerrar sesión",
    "auth.resetSent": "Email de recuperación enviado. Revisa tu bandeja de entrada.",
    "auth.loginError": "Credenciales incorrectas.",
    "auth.usernameTaken": "Este usuario ya está en uso.",
    "auth.usernameTooShort": "El nombre de usuario es demasiado corto: introduce al menos 3 caracteres.",
    "auth.usernameInvalidCharacters": "El nombre de usuario solo puede contener letras (A-Z), números, puntos y guiones bajos. No se permiten @, espacios ni otros símbolos.",
    "auth.emailTaken": "Este correo ya está vinculado a una cuenta.",
    "auth.invalidEmail": "Introduce un email válido.",
    "auth.passwordMin": "La contraseña debe tener al menos 8 caracteres.",
    "auth.passwordMismatch": "Las contraseñas no coinciden.",
    "auth.fieldRequired": "Completa todos los campos obligatorios.",
    "auth.accountCreated": "Cuenta creada.",
    "setup.title": "Configuración guiada",
    "setup.subtitle": "Configura Mundely una sola vez. Las preferencias de la cuenta se sincronizarán en tus dispositivos.",
    "setup.basicTitle": "Configuración básica",
    "setup.basicBody": "Elige idioma, moneda y preferencias esenciales para empezar a usar Mundely de inmediato.",
    "setup.advancedTitle": "Configuración avanzada",
    "setup.advancedBody": "Después de la base puedes completar notificaciones, seguridad, foto de perfil y la conexión a fAInance Test.",
    "setup.advancedHint": "Por ahora esta configuración avanzada cubre los elementos principales. La perfeccionaremos en las próximas implementaciones.",
    "setup.language": "Idioma",
    "setup.currency": "Moneda principal",
    "setup.measurement": "Unidades de medida",
    "setup.metric": "Sistema métrico",
    "setup.imperial": "Sistema imperial",
    "setup.dateFormat": "Formato de fecha",
    "setup.weekStartsOn": "Inicio de la semana", "setup.weekMonday": "Lunes", "setup.weekSunday": "Domingo",
    "setup.notifications": "Preferencias de notificaciones",
    "setup.notificationsBody": "Puedes cambiarlas en cualquier momento.",
    "setup.operational": "Operativas del viaje",
    "setup.reminders": "Recordatorios",
    "setup.ai": "IA",
    "setup.collaboration": "Compartir y colaborar",
    "setup.marketing": "Marketing y promociones",
    "setup.security": "Biometría y PIN",
    "setup.securityBody": "Elige biometría o un PIN local de 4 dígitos. Podrás cambiar el método más adelante en Seguridad.",
    "setup.biometric": "Activar biometría",
    "setup.pin": "Configurar PIN",
    "setup.pinPlaceholder": "PIN de 4 dígitos",
    "setup.photo": "Foto de perfil",
    "setup.fainanceTitle": "Conecta fAInance",
    "setup.fainanceBody": "Si ya tienes una cuenta de fAInance, puedes vincularla a Mundely. La aprobación se realizará desde tu cuenta de fAInance.",
    "setup.fainanceLater": "Puedes omitir este paso y vincular la cuenta en cualquier momento desde Ajustes.",
    "currency.searchLabel": "Buscar moneda",
    "currency.searchBody": "Puedes buscar por código o por nombre de la moneda.",
    "currency.searchPlaceholder": "Ej.: EUR, euro, dólar",
    "currency.noResults": "No se encontró ninguna moneda.",
    "fainanceLink.title": "Conecta fAInance",
    "fainanceLink.menuBody": "Conecta tu cuenta de fAInance y sincroniza automáticamente los viajes con Share.",
    "fainanceLink.body": "La conexión permite que Mundely cree y actualice automáticamente un proyecto Share para cada viaje.",
    "fainanceLink.profileBody": "Conecta desde tu perfil la cuenta de fAInance que quieres utilizar con Mundely.",
    "fainanceLink.testEnvironment": "Entorno: fAInance Test",
    "fainanceLink.testBridgeUnavailable": "La conexión con fAInance Test no está disponible en este momento. No se ha enviado ninguna solicitud a Producción.",
    "fainanceLink.identifierInfoTitle": "Cómo identificar la cuenta",
    "fainanceLink.approvalTitle": "Cómo funciona la conexión",
    "fainanceLink.pendingTitle": "Solicitud pendiente",
    "fainanceLink.queueTitle": "Estado del puente",
    "fainanceLink.requestQueued": "Solicitud guardada y puesta en cola.",
    "fainanceLink.cloudQueueBody": "La solicitud se guardó en la nube de Mundely y está lista para que la procese el puente de fAInance.",
    "fainanceLink.localQueueBody": "La solicitud se guardó en este dispositivo. Se enviará al puente cuando la conexión en la nube esté disponible.",
    "fainanceLink.status.connected": "Conectado",
    "fainanceLink.status.pending": "Pendiente",
    "fainanceLink.status.rejected": "Rechazado",
    "fainanceLink.status.notLinked": "No conectado",
    "fainanceLink.connectedAs": "Cuenta fAInance conectada",
    "fainanceLink.connectedBody": "Los nuevos viajes se ponen automáticamente en cola para sincronizarse con Share. Los viajes ya creados también se vuelven a alinear al abrir esta página.",
    "fainanceLink.emailLabel": "Email de la cuenta fAInance",
    "fainanceLink.emailPlaceholder": "nombre@email.com",
    "fainanceLink.identifierLabel": "Email o username de fAInance",
    "fainanceLink.identifierPlaceholder": "nombre@email.com o username",
    "fainanceLink.identifierHint": "Puedes usar indistintamente el email o el username de tu cuenta de fAInance.",
    "fainanceLink.invalidIdentifier": "Introduce un email válido o un username de fAInance válido.",
    "fainanceLink.approvalBody": "Mundely registra la solicitud de conexión. La conexión solo se activa después de la aprobación desde la cuenta fAInance correspondiente.",
    "fainanceLink.connect": "Solicitar conexión",
    "fainanceLink.requestSent": "Solicitud de conexión registrada.",
    "fainanceLink.requestCancelled": "Solicitud cancelada.",
    "fainanceLink.pendingBody": "Solicitud enviada para {identifier}. Esperando la aprobación desde fAInance.",
    "fainanceLink.cancelRequest": "Cancelar solicitud",
    "fainanceLink.disconnect": "Desconectar cuenta",
    "fainanceLink.disconnected": "Cuenta fAInance desconectada.",
    "fainanceLink.syncTrips": "Sincronizar viajes",
    "fainanceLink.syncQueued": "Sincronización preparada para {count} viajes.",
    "fainanceLink.error": "No se pudo completar la operación con fAInance.",
    "analytics.title": "Analytics y uso",
    "analytics.body": "Controla el envío de datos anónimos sobre el uso de Mundely.",
    "analytics.usageTitle": "Compartir datos de uso anónimos",
    "analytics.usageBody": "Ayuda a entender qué secciones se utilizan y dónde mejorar la app. Nunca se envían contenidos personales, documentos ni textos de conversaciones.",
    "analytics.note": "El seguimiento utiliza Firebase Analytics en Android, iOS y Web. Puedes desactivarlo en cualquier momento.",
    "setup.photoBody": "Puedes añadirla ahora o más adelante.",
    "setup.photoHint": "Arrastra la foto para centrarla y usa el zoom para elegir el recorte.",
    "setup.photoZoom": "Zoom",
    "setup.photoReset": "Restablecer",
    "setup.photoChoose": "Elegir o cambiar foto",
    "setup.finish": "Completar configuración",
    "setup.completed": "Configuración completada",
    "nav.home": "Inicio",
    "nav.trips": "Viajes",
    "nav.world": "Mi mundo",
    "nav.map": "Mapa",
    "nav.ai": "AGENTE",
    "nav.profile": "Perfil",
    "nav.settings": "Ajustes",
    "nav.menu": "Menú",
    "menu.subtitle": "Conozcámonos mejor y ajustes de la aplicación.",
    "settings.title": "Ajustes",
    "settings.subtitle": "Personaliza Mundely y gestiona tu cuenta, seguridad, soporte y datos.",
    "settings.profile": "Perfil",
    "gamification.title": "Puntos y clasificación",
    "gamification.menuBody": "Gana puntos viajando, contribuyendo a la comunidad y completando tu perfil de viajero.",
    "gamification.body": "Tu puntuación combina experiencia de viaje, actividad en la app y calidad de tus aportes a la comunidad.",
    "gamification.score": "Puntos",
    "gamification.rank": "Posición",
    "gamification.nextLevel": "{points} puntos para llegar a {level}",
    "gamification.maxLevel": "Has alcanzado el nivel máximo actual",
    "gamification.communityQuality": "Calidad de las aportaciones",
    "gamification.communityQualityBody": "Tu reputación también tiene en cuenta cuánto ayudan tus reseñas a otros viajeros.",
    "gamification.helpfulReceived": "Votos útiles recibidos",
    "gamification.helpfulRatio": "Porcentaje de votos útiles",
    "gamification.publicTitle": "Reputación Mundely",
    "gamification.breakdown": "De dónde salen tus puntos",
    "gamification.breakdownBody": "Cada actividad válida contribuye automáticamente a tu puntuación.",
    "gamification.countries": "Países visitados",
    "gamification.quizAnswers": "Respuestas al quiz",
    "gamification.feedbacks": "Feedback de viaje",
    "gamification.completedTrips": "Viajes completados",
    "gamification.reviews": "Reseñas públicas",
    "gamification.helpfulVotes": "Votos útiles recibidos",
    "gamification.notHelpfulVotes": "Votos no útiles recibidos",
    "gamification.voteBalance": "Impacto de votos de la comunidad",
    "gamification.badges": "Insignias",
    "gamification.badgesBody": "Las insignias reconocen experiencia, contribución y especialización geográfica.",
    "gamification.earned": "Conseguida",
    "gamification.badge.explorer": "Explorador",
    "gamification.badge.explorerBody": "Visita al menos 10 países.",
    "gamification.badge.topContributor": "Top Contributor",
    "gamification.badge.topContributorBody": "Recibe al menos 10 votos útiles en tus reseñas.",
    "gamification.badge.asiaExpert": "Experto en Asia",
    "gamification.badge.asiaExpertBody": "Visita al menos 10 países asiáticos.",
    "gamification.badge.quizMaster": "Maestro del quiz",
    "gamification.badge.quizMasterBody": "Completa las 16 preferencias del perfil viajero.",
    "gamification.badge.reviewer": "Reseñador",
    "gamification.badge.reviewerBody": "Publica al menos 10 reseñas para la comunidad.",
    "gamification.badge.veteran": "Viajero veterano",
    "gamification.badge.veteranBody": "Completa al menos 10 viajes en Mundely.",
    "gamification.history": "Historial de puntos",
    "gamification.historyBody": "Los cambios más recientes de tu puntuación Mundely.",
    "gamification.historyInitial": "Puntuación inicial",
    "gamification.historyProgress": "Actualización de actividad",
    "gamification.historyEmpty": "El historial aparecerá cuando cambie tu puntuación.",
    "gamification.level.starter": "Viajero",
    "gamification.level.explorer": "Explorador",
    "gamification.level.expert": "Viajero experto",
    "gamification.level.globetrotter": "Globetrotter",
    "gamification.rules": "Reglas de puntos",
    "gamification.rulesBody": "La puntuación se recalcula con los datos reales del perfil y de la comunidad.",
    "gamification.rule.country": "Cada país visitado",
    "gamification.rule.quiz": "Cada respuesta al quiz",
    "gamification.rule.feedback": "Cada feedback de viaje",
    "gamification.rule.completedTrip": "Cada viaje completado",
    "gamification.rule.review": "Cada reseña pública",
    "gamification.rule.helpful": "Cada voto Útil recibido",
    "gamification.rule.notHelpful": "Cada voto No útil recibido",
    "gamification.leaderboard": "Clasificación de viajeros",
    "gamification.leaderboardBody": "La clasificación usa la puntuación Mundely actualizada de los usuarios que ya han abierto esta versión de la app.",
    "gamification.noLeaderboard": "La clasificación aún no está disponible.",
    "quiz.profileTitle": "Tu perfil de viaje",
    "quiz.communityBody": "Tus respuestas se guardan en tu perfil. Las elecciones también contribuyen a preferencias agregadas de viajeros que Mundely puede utilizar para mejorar las sugerencias.",
    "quiz.communityCompare": "Cómo respondieron otros viajeros · {count} respuestas",
    "quiz.communityShort": "Comunidad: {minus}% / {plus}%",
    "quiz.popular": 'Lugares icónicos',
    "quiz.remote": 'Lugares remotos',
    "quiz.comfort": 'Comodidad y servicios',
    "quiz.authentic": 'Vida local',
    "quiz.food": 'Comida y sabores',
    "quiz.historyMuseums": 'Historia y museos',
    "quiz.early": 'Empezar temprano',
    "quiz.late": 'Vivir la noche',
    "quiz.solo": 'Tiempo para mí',
    "quiz.social": 'Conocer gente',
    "quiz.fixed": 'Plan definido',
    "quiz.flexible": 'Decidir sobre la marcha',
    "quiz.direct": 'Una base principal',
    "quiz.multiStop": 'Muchas etapas',
    "quiz.classic": 'Grandes clásicos',
    "quiz.unusual": 'Lugares insólitos',
    "tools.title": "Herramientas",
    "tools.menuBody": "Calculadora y conversor de moneda en una sola sección.",
    "calculator.title": "Calculadora",
    "calculator.menuBody": "Haz cálculos rápidos durante el viaje.",
    "calculator.body": "Calculadora completa con las mismas funciones esenciales disponibles en las Herramientas de fAInance.",
    "currency.title": 'Conversor de moneda',
    "currency.menuBody": 'Convierte monedas con un tipo online actualizado.',
    "currency.body": 'Calcula rápidamente cuánto vale un importe en la moneda que necesitas durante el viaje.',
    "currency.amount": 'Importe',
    "currency.from": 'De',
    "currency.to": 'A',
    "currency.swap": 'Invertir monedas',
    "currency.error": 'No se pudo obtener el tipo de cambio. Comprueba la conexión e inténtalo de nuevo.',
    "currency.result": 'Resultado',
    "currency.waiting": 'Tipo no disponible',
    "currency.updated": 'Tipo de referencia del {date}',
    "currency.refresh": 'Actualizar tipo',
    "currency.source": 'Fuente de tipos: Frankfurter, basada en tipos de referencia publicados por el BCE y otros bancos centrales.',
    "currency.rate": 'Tipo',
    "currency.automatic": 'conversión automática',
    "nextTrip.title": 'Próximo viaje',
    "nextTrip.menuBody": 'Ideas y consejos del agente para elegir tu próximo destino.',
    "nextTrip.body": 'Combina cuándo quieres salir, presupuesto y preferencias personales para obtener propuestas más relevantes.',
    "nextTrip.heroTitle": 'Encuentra tu próximo destino',
    "nextTrip.heroBody": 'Háblalo con tu Agente.',
    "nextTrip.personalizationTitle": "Personalización de Mundely",
    "nextTrip.personalizationBody": "Las sugerencias combinan tus preferencias, los lugares visitados y las señales de la comunidad.",
    "nextTrip.personalizationQuiz": "Elecciones: {count}",
    "nextTrip.personalizationVisited": "Países visitados: {count}",
    "nextTrip.personalizationReviews": "Reseñas consideradas: {count}",
    "nextTrip.whyTitle": "Por qué te lo recomiendo",
    "nextTrip.whyQuiz": "alta afinidad con tus preferencias",
    "nextTrip.whyStyle": "coherente con {style}",
    "nextTrip.whyBudget": "compatible con el presupuesto indicado",
    "nextTrip.whyNewPlace": "evita destinos que ya has visitado",
    "nextTrip.whyCommunity": "también respaldado por señales de la comunidad",
    "nextTrip.whyProfile": "coherente con el perfil de viajero que Mundely conoce de ti",
    "nextTrip.whyTravelerProfile": "coincide con tu preferencia {style}",
    "travelerProfile.title": "Perfil viajero",
    "travelerProfile.body": "Mundely combina quiz, viajes, gastos, reseñas y hábitos para entender cómo te gusta viajar. Puedes corregir lo que no te represente.",
    "travelerProfile.inferred": "Tu estilo de viaje",
    "travelerProfile.inferredBody": "Preferencias que se desprenden de tus respuestas y reseñas. Toca una tarjeta para personalizarla.",
    "travelerProfile.correctTitle": "Personalizar preferencias",
    "travelerProfile.correctBody": "Elige lo que te gusta y lo que prefieres evitar. Toca de nuevo una elección para desmarcarla.",
    "travelerProfile.note": "Indicaciones para Mundely",
    "travelerProfile.notePlaceholder": "Ej. prefiero hoteles pequeños, sin vuelos con varias escalas, me encanta la comida local…",
    "travelerProfile.saved": "Perfil actualizado",
    "travelerProfile.notEnoughData": "Mundely necesita algo más de información para identificar tu estilo.",
    "travelerProfile.countries": "Países",
    "travelerProfile.completedTrips": "Viajes finalizados",
    "travelerProfile.reviews": "Reseñas",
    "travelerProfile.groupSize": "Grupo habitual",
    "travelerProfile.publicTitle": "Estilo de viaje",
    "travelerStyle.relax": "Relax",
    "travelerStyle.culture": "Cultura",
    "travelerStyle.sea": "Mar",
    "travelerStyle.adventure": "Aventura",
    "travelerStyle.city": "Ciudad",
    "travelerStyle.nature": "Naturaleza",
    "travelerStyle.budget": "Presupuesto",
    "travelerStyle.comfort": "Comodidad",
    "travelerStyle.food": "Comida local",
    "travelerStyle.social": "Social",
    "travelerStyle.remote": "Fuera de ruta",
    "travelerStyle.flexible": "Flexible",
    "nextTrip.whenTitle": '¿Cuándo quieres viajar?',
    "nextTrip.styleTitle": '¿Qué tipo de viaje buscas?',
    "nextTrip.style.relax": 'Relax',
    "nextTrip.style.culture": 'Cultura',
    "nextTrip.style.sea": 'Mar',
    "nextTrip.style.adventure": 'Aventura',
    "nextTrip.style.surprise": 'Sorpréndeme',
    "nextTrip.askAgent": 'Pide consejo al Agente',
    "nextTrip.applyPreferences": 'Actualizar consejos',
    "nextTrip.editPreferences": 'Modificar',
    "nextTrip.chatTitle": 'Habla con tu Agente',
    "nextTrip.chatBody": 'Perfecciona el consejo sin empezar de cero.',
    "nextTrip.newSearch": 'Nueva búsqueda',
    "nextTrip.composerPlaceholder": 'Escribe un mensaje…',
    "nextTrip.sendMessage": 'Enviar mensaje',
    "nextTrip.quick.cheaper": 'Más económicas',
    "nextTrip.quick.warmer": 'Más calor',
    "nextTrip.quick.compare": 'Comparar las propuestas',
    "nextTrip.quick.more": 'Otras propuestas',
    "nextTrip.quick.whatToSee": 'Qué ver',
    "nextTrip.quick.costs": 'Costes y presupuesto',
    "nextTrip.quick.bestTime": 'Cuándo ir',
    "nextTrip.quick.similar": 'Alternativas similares',
    "nextTrip.live.title": 'Precios de vuelos y hotel',
    "nextTrip.live.subtitle": 'Comprueba precios reales para {destination}.',
    "nextTrip.live.origin": 'Ciudad de salida',
    "nextTrip.live.originPlaceholder": 'p. ej. Nápoles',
    "nextTrip.live.departure": 'Ida',
    "nextTrip.live.return": 'Vuelta',
    "nextTrip.live.travelers": 'Viajeros',
    "nextTrip.live.search": 'Buscar precios en vivo',
    "nextTrip.live.destinationUnavailable": 'Elige primero una ciudad o isla concreta para buscar vuelos reales.',
    "nextTrip.live.notConfigured": 'La búsqueda de precios en vivo está lista en la app, pero el backend todavía no tiene configuradas las credenciales de los proveedores.',
    "nextTrip.live.error": 'No se pudieron recuperar los precios en vivo. Inténtalo de nuevo en unos minutos.',
    "nextTrip.live.noResults": 'No hay ofertas disponibles con estos criterios. Prueba otras fechas o destino.',
    "nextTrip.live.partial": 'Algunos proveedores no están disponibles. Solo se muestran ofertas verificadas.',
    "nextTrip.live.openOption": 'Abrir reserva',
    "nextTrip.live.flight": 'Vuelo ida y vuelta',
    "nextTrip.live.hotel": 'Hotel',
    "nextTrip.live.total": 'Vuelo + hotel',
    "nextTrip.live.bestAvailable": 'Mejor opción disponible',
    "nextTrip.live.flightHotelOnly": 'Solo se incluyen los elementos en vivo disponibles.',
    "nextTrip.live.remaining": 'Quedan {amount} del presupuesto.',
    "nextTrip.live.over": 'Supera el presupuesto en {amount}.',
    "nextTrip.live.checkedAt": 'Última comprobación: {value}',
    "nextTrip.live.refresh": 'Actualizar precios',
    "nextTrip.live.cheaperDates": 'Cambiar fechas',
    "nextTrip.live.openHotel": 'Abrir hotel',
    "nextTrip.live.flightOptions": 'Opciones de vuelo reales',
    "nextTrip.live.hotelOptions": 'Hoteles disponibles',
    "nextTrip.live.select": 'Seleccionar',
    "nextTrip.live.selected": 'Seleccionado',
    "nextTrip.live.direct": 'Directo',
    "nextTrip.live.stops": '{count} escalas',
    "nextTrip.live.rating": 'Valoración {value}',
    "nextTrip.live.selectFlightMessage": 'Elijo este vuelo',
    "nextTrip.live.flightSelected": 'Vuelo seleccionado para este plan',
    "nextTrip.live.flightSelectedNext": 'Ahora puedo continuar con hoteles, itinerario y traslados sin perder esta elección.',
    "nextTrip.live.selectHotelMessage": 'Elijo este hotel',
    "nextTrip.live.hotelSelected": 'Hotel seleccionado para este plan',
    "nextTrip.live.hotelSelectedNext": 'Mantendré este alojamiento como referencia mientras seguimos construyendo el viaje.',
    "nextTrip.actions.title": 'Acciones del viaje',
    "nextTrip.actions.readyToCreate": 'Listo para convertirse en un viaje',
    "nextTrip.actions.readyToCreateBody": 'Cuando confirmes, crearé el viaje y podré empezar a añadir elementos reales.',
    "nextTrip.actions.planActive": 'Viaje creado y vinculado a esta conversación',
    "nextTrip.actions.planActiveBody": 'Ahora puedes añadir lugares, vuelos y hoteles directamente a las secciones del viaje.',
    "nextTrip.actions.createTrip": 'Crear viaje',
    "nextTrip.actions.openTrip": 'Abrir viaje',
    "nextTrip.actions.addItem": 'Añadir al itinerario',
    "nextTrip.actions.addFlight": 'Añadir vuelo',
    "nextTrip.actions.addHotel": 'Añadir hotel',
    "nextTrip.actions.needDestination": 'Primero elige una ciudad o isla concreta: no crearé un viaje genérico para todo un país.',
    "nextTrip.actions.needDates": 'Necesito las fechas exactas de ida y vuelta para crear el viaje. Escríbelas en la conversación y usaré esas fechas.',
    "nextTrip.actions.tripName": '{destination} {year}',
    "nextTrip.actions.tripCreated": 'Viaje creado para **{destination}**, del **{start}** al **{end}**. A partir de ahora puedo añadir etapas, vuelos y hoteles directamente.',
    "nextTrip.actions.itemAdded": '**{item}** se ha añadido al itinerario del viaje.',
    "nextTrip.actions.itemAlreadyAdded": '**{item}** ya está en el itinerario.',
    "nextTrip.actions.addedFromNextTrip": 'Añadido desde Próximo viaje.',
    "nextTrip.actions.flightTitle": 'Vuelo {origin} → {destination}',
    "nextTrip.actions.flightAdded": 'El vuelo seleccionado se ha añadido al itinerario del viaje.',
    "nextTrip.actions.hotelAdded": '**{hotel}** se ha añadido a la sección Hotel del viaje.',
    "nextTrip.quick.city": 'Panorámica',
    "nextTrip.quick.foods": 'Platos típicos',
    "nextTrip.quick.places": 'Lugares para ver',
    "nextTrip.quick.culture": 'Cultura local',
    "nextTrip.continueWith": 'Continuar con {destination}',
    "nextTrip.ideasForYou": 'Ideas para ti',
    "nextTrip.ideasForYouBody": 'Destinos compatibles con tu perfil de viaje.',
    "nextTrip.compatibility": 'Compatibilidad con tu perfil',
    "nextTrip.compatibilityShort": 'compatible',
    "nextTrip.saveIdea": 'Guardar idea',
    "nextTrip.removeIdea": 'Eliminar idea guardada',
    "nextTrip.suggestionIntro": 'Aquí tienes 3 propuestas alineadas con tu perfil. Toca un destino o continúa la conversación.',
    "nextTrip.followUpIntro": 'He actualizado las propuestas según tu último mensaje.',
    "nextTrip.cardFrom": 'desde {price}',
    "nextTrip.cardMatch": 'Compatibilidad {value}%',
    "community.updateReview": 'Actualizar reseña',
    "nextTrip.savedIdeas": 'Tus ideas guardadas',
    "nextTrip.savedIdeasBody": 'Guárdalas mientras decides tu próximo viaje.',
    "nextTrip.matchesTitle": 'Destinos compatibles con tu perfil',
    "nextTrip.matchesBody": 'Toca una propuesta para usarla de inmediato como destino a evaluar.',
    "nextTrip.time.soon": 'Salgo dentro de poco',
    "nextTrip.time.threeMonths": 'En los próximos 3 meses',
    "nextTrip.time.sixMonths": 'Dentro de 6 meses',
    "nextTrip.time.nextYear": 'El próximo año',
    "nextTrip.budget": 'Presupuesto indicativo',
    "nextTrip.destination": 'Destino a evaluar',
    "nextTrip.destinationPlaceholder": 'Ej. Japón, Madeira, Nueva York…',
    "nextTrip.destinationRequired": 'Introduce un destino antes de preguntar qué debes saber antes de reservar.',
    "nextTrip.agentAdvice": 'Consejos del agente',
    "nextTrip.agentAdviceBody": 'Destinos construidos alrededor de tus preferencias y del periodo elegido.',
    "nextTrip.experts": 'Ideas de viajeros expertos',
    "nextTrip.expertsBody": '¿Sin ideas? Descubre destinos valorados por viajeros con experiencia.',
    "nextTrip.beforeBook": 'Antes de reservar',
    "nextTrip.beforeBookBody": 'Elige un lugar: mejor época, clima, costes, puntos críticos y qué comprobar.',
    "nextTrip.whereBudget": '¿Dónde voy con mi presupuesto?',
    "nextTrip.whereBudgetBody": 'Indica cuánto quieres gastar y recibe destinos realistas para comparar.',
    "nextTrip.loading": 'El agente está preparando los consejos…',
    "nextTrip.result": 'Consejo personalizado',
    "nextTrip.resultBody": 'Úsalo como punto de partida y profundiza después en el destino con el agente.',
    "nextTrip.error": 'No se pudieron generar los consejos. Inténtalo de nuevo.',
    "nextTrip.prompt.agent": 'Sugiere 5 destinos adecuados para este viajero y explica de forma concreta por qué cada uno encaja con sus preferencias y periodo de viaje.',
    "nextTrip.prompt.experts": 'Sugiere 5 destinos que un viajero experto podría recomendar por calidad de experiencia, variedad y valor del tiempo, evitando una lista obvia. Distingue claramente la opinión agregada de usuarios de los hechos.',
    "nextTrip.prompt.destination": 'Analiza el destino indicado y explica qué es importante saber antes de reservar: mejor época, clima, duración recomendada, presupuesto, transporte, posibles problemas, masificación y qué reservar con antelación.',
    "nextTrip.prompt.budget": 'A partir del presupuesto indicado, propone 5 destinos realistas y compara coste del viaje, duración recomendada, puntos fuertes y principales compromisos.',
    "nextTrip.prompt.timeframe": 'Cuándo quiere viajar',
    "nextTrip.prompt.budgetLabel": 'Presupuesto',
    "nextTrip.prompt.notSpecified": 'no especificado',
    "nextTrip.prompt.destinationLabel": 'Destino',
    "nextTrip.prompt.format": 'Responde sin asteriscos Markdown. Sé breve pero concreto; indica claramente qué es un hecho verificable y qué deriva de preferencias/opiniones de viajeros.',
    "nextTrip.prompt.travelStyle": 'Tipo de viaje deseado',
    "nextTrip.prompt.userRole": 'Usuario',
    "nextTrip.prompt.agentRole": 'Agente',
    "nextTrip.prompt.conversationStart": 'Inicia una conversación para elegir el próximo viaje. Propón pocas alternativas concretas e invita al usuario a perfeccionar la elección con mensajes posteriores.',
    "nextTrip.prompt.conversationContinue": 'Continúa la misma conversación sobre el próximo viaje. Usa todo el contexto anterior y modifica o amplía los consejos según el último mensaje, sin empezar de cero.',
    "nextTrip.prompt.profileMatches": "Destinos afines a tus preferencias",
    "nextTrip.prompt.history": 'Conversación hasta ahora',
    "nextTrip.prompt.latestMessage": 'Último mensaje del usuario',
    "nextTrip.prompt.initialRequest": 'Recomiéndame algunos destinos adecuados para mí según las preferencias seleccionadas.',
    "nextTrip.prompt.conversationFormat": 'Responde sin asteriscos Markdown. Sé concreto y conversacional. No repitas preguntas ya respondidas por el contexto. Si propones destinos, limita la primera respuesta a 3 o 4 alternativas con una breve razón para cada una y deja espacio para continuar la conversación.',
    "expenses.title": 'Gastos del viaje',
    "expenses.body": 'Registra los costes del viaje y mantén un resumen separado para cada moneda.',
    "expenses.empty": 'Todavía no has registrado gastos para este viaje.',
    "expenses.description": 'Descripción',
    "expenses.amount": 'Importe',
    "expenses.currency": 'Moneda',
    "expenses.category": 'Categoría',
    "expenses.date": 'Fecha',
    "expenses.payer": 'Pagado por',
    "expenses.note": 'Nota',
    "expenses.add": 'Añadir gasto',
    "expenses.datePlaceholder": "DD/MM/AAAA",
    "expenses.addedFeedback": "Gasto añadido correctamente.",
    "expenses.updatedFeedback": "Gasto actualizado correctamente.",
    "feedback.itemAdded": "Elemento añadido correctamente.",
    "feedback.itemSaved": "Cambios guardados correctamente.",
    "feedback.documentAdded": "Documento añadido correctamente.",
    "feedback.checklistAdded": "Elemento añadido a la checklist.",
    "feedback.noteAdded": "Nota añadida correctamente.",
    "itinerary.savedFeedback": "Etapa guardada correctamente.",
    "expenses.list": 'Movimientos',
    "expenses.listBody": 'Edita o elimina los gastos ya registrados.',
    "expenses.category.transport": 'Transporte',
    "expenses.category.stay": 'Alojamiento',
    "expenses.category.food": 'Comida y bebida',
    "expenses.category.activities": 'Actividades',
    "expenses.category.shopping": 'Compras',
    "expenses.category.fees": 'Comisiones e impuestos',
    "expenses.category.other": 'Otros',
    "expenses.me": "Yo",
    "expenses.sharedWith": "Compartido con",
    "expenses.sharedWithBody": "Elige los participantes y cómo dividir el importe.",
    "expenses.split.equal": "Partes iguales",
    "expenses.split.percentage": "Porcentajes",
    "expenses.split.shares": "Cuotas",
    "expenses.sharesUnit": "cuotas",
    "expenses.percentageTotal": "Total porcentajes: {total}%",
    "expenses.browserBody": "Todos los gastos del viaje, organizados por moneda y participante.",
    "expenses.count": "{count} gastos",
    "expenses.filters": "Filtros de gastos",
    "expenses.filterAll": "Todos ({count})",
    "expenses.myExpenses": "Mis gastos",
    "expenses.paidBy": "Pagado por {name}",
    "expenses.participantCount": "{count} participantes",
    "expenses.perPerson": "por persona",
    "expenses.editTitle": "Editar gasto",
    "expenses.descriptionPlaceholder": "Descripción del gasto",
    "expenses.amountPlaceholder": "0,00",
    "expenses.notePlaceholder": "Añade una nota",
    "feedback.expenseDeleted": "Gasto eliminado correctamente.",
    "trip.section.statistics": "Estadísticas",
    "trip.section.statisticsBody": "Análisis completo de los gastos de este viaje.",
    "statistics.title": "Estadísticas del viaje",
    "statistics.body": "Todos los gastos del viaje agrupados por moneda, categoría, pagador y participante.",
    "statistics.empty": "Todavía no hay gastos para analizar.",
    "statistics.movements": "Movimientos",
    "statistics.sharedExpenses": "Gastos compartidos",
    "statistics.tripDays": "Días de viaje",
    "statistics.total": "Total",
    "statistics.dailyAverage": "Media diaria",
    "statistics.byCategory": "Por categoría",
    "statistics.byCategoryBody": "Cuánto se ha gastado en las distintas categorías.",
    "statistics.byPayer": "Pagado por",
    "statistics.byPayerBody": "Total adelantado por cada pagador.",
    "statistics.byParticipant": "Cuotas por participante",
    "statistics.byParticipantBody": "Importe asignado a cada participante en los gastos compartidos.",
    "statistics.allExpenses": "Todos los gastos",
    "statistics.allExpensesBody": "Historial completo utilizado para estas estadísticas.",
    "statistics.unknownPayer": "Pagador no indicado",
    "tripHome.quickExpense": "Gasto rápido",
    "tripHome.openExpenses": "Abrir gastos",
    "tripHome.documentReady": "Listo",
    "tripHome.documentPending": "Subiendo",
    "tripHome.addDocument": "Añadir documento",
    "tripHome.uploadDocument": "Subir documento",
    "tripHome.linkPlaceholder": "Pega un enlace https://",
    "tripHome.completed": "completados",
    "tripHome.quickChecklistPlaceholder": "Nueva entrada",
    "tripHome.openChecklist": "Abrir checklist",
    "tripHome.reminder": "Recordatorio",
    "tripHome.reminderPlaceholder": "Escribe un recordatorio",
    "tripHome.openNotes": "Abrir notas",
    "tripHome.statistics": "Estadísticas",
    "tripHome.movements": "movimientos",
    "trip.section.expenses": 'Gastos',
    "trip.section.expensesBody": 'Costes del viaje organizados por categoría y moneda.',
    "tripHome.expenses": 'Gastos',
    "tripHome.group.plan": "Planifica",
    "tripHome.group.planBody": "Organiza tu itinerario día a día",
    "tripHome.group.organize": "Organiza",
    "tripHome.group.organizeBody": "Tenlo todo bajo control",
    "tripHome.group.during": "Durante el viaje",
    "tripHome.group.duringBody": "Información útil siempre a mano",
    "tripHome.restyle.preparation": "Preparación",
    "tripHome.restyle.preparationAction": "Revisa tu viaje",
    "tripHome.restyle.pendingChecklist": "Tareas pendientes",
    "tripHome.restyle.documentsBody": "Archivos y reservas del viaje",
    "tripHome.restyle.offlineReady": "Listo para descargar",
    "tripHome.restyle.offlineBody": "La información del viaje siempre contigo, incluso sin conexión.",
    "tripHome.restyle.offlineDownload": "Descargar viaje",
    "tripHome.restyle.offlineExcludes": "Incluye datos y documentos. Álbum de fotos no incluido.",
    "tripHome.guide.featureTitle": "Tu guía, siempre contigo",
    "tripHome.guide.mapEmpty": "Explora tu viaje",
    "tripHome.guide.placesEmpty": "Descubre qué visitar",
    "usefulInfo.plug.otherTypes": "Otras tomas presentes",
    "usefulInfo.plug.checkAdapter": "Comprueba que tu adaptador sea compatible con la toma disponible.",
    "tripHome.noNextStopShort": "Añade la primera etapa para empezar.",
    "tripHome.countStops": "{count} etapas",
    "tripHome.itinerarySummary": "Crea tu ruta de viaje.",
    "tripHome.savedStops": "Lugares guardados",
    "tripHome.countMovements": "{count} movimientos",
    "tripHome.countDocuments": "{count} documentos",
    "tripHome.documentsSummary": "Pasaportes, reservas, seguros…",
    "tripHome.activitiesPending": "Actividades por completar",
    "tripHome.countPlaces": "{count} lugares guardados",
    "tripHome.usefulInfoSummary": "Transporte, salud, moneda y otra información útil.",
    "tripHome.usefulInfoGuide": "Guía práctica",
    "settings.open": 'Abrir',
    "settings.termsUse": 'Términos de uso',
    "settings.termsUseBody": 'Consulta el ámbito de la app, los límites del Agente AI y las responsabilidades del usuario.',
    "settings.privacyPolicy": 'Política de privacidad',
    "settings.privacyPolicyBody": 'Consulta cómo Mundely gestiona datos, cuentas e información de viaje.',
    "settings.buttonCorners": 'Esquinas de los botones',
    "settings.buttonCornersBody": 'Elige cuánto deben ser cuadrados o redondeados los botones de la app.',
    "settings.buttonCornersPill": 'Píldora',
    "settings.widgets": 'Widgets',
    "settings.widgetsBody": 'Personaliza los widgets disponibles en Inicio y dentro de los viajes.',
    "widgets.settingsIntro": 'Configura los widgets Android de Mundely como en fAInance: tamaño de texto, colores, transparencia, bordes, contenido visible y actualización automática.',
    "widgets.settingsIntroExact": 'Configura el aspecto de los widgets Android. Para Documentos, Checklist y Recordatorios, el contenido exacto se elige al añadir o reconfigurar el widget desde la pantalla de inicio del teléfono.',
    "widgets.chooseContentOnHome": 'Elige el contenido exacto al añadir o reconfigurar el widget desde la pantalla de inicio del teléfono; aquí personalizas texto, colores, transparencia y actualización.',
    "widgets.nextStop": 'Próxima etapa',
    "widgets.nextStopBody": 'Muestra la próxima etapa del viaje y abre directamente el itinerario.',
    "widgets.expenses": 'Gasto rápido',
    "widgets.expensesBody": 'Muestra solo el botón para añadir rápidamente un gasto al viaje elegido.',
    "widgets.expenseHistory": 'Gastos',
    "widgets.expenseHistoryBody": 'Muestra el historial de gastos del viaje elegido, con detalles completos y desplazamiento.',
    "widgets.documents": 'Documentos y billetes',
    "widgets.documentsBody": 'Muestra un resumen de documentos y billetes y abre Documentos.',
    "widgets.checklist": 'Checklist',
    "widgets.checklistBody": 'Muestra el progreso y las próximas actividades pendientes.',
    "widgets.reminder": 'Recordatorio',
    "widgets.reminderBody": 'Muestra la próxima nota o recordatorio del viaje.',
    "widgets.calculator": "Calculadora",
    "widgets.calculatorBody": "Calculadora completa directamente en la pantalla de inicio del teléfono.",
    "widgets.converter": "Conversor",
    "widgets.converterBody": "Conversor de moneda directamente en la pantalla de inicio del teléfono.",
    "widgets.preview": "Vista previa",
    "widgets.createTransaction": "Crear transacción",
    "widgets.titleSection": "Título",
    "widgets.showTitle": "Mostrar título",
    "widgets.showTransaction": "Mostrar Crear transacción",
    "widgets.specificInstance": "Estás personalizando este widget específico.",
    "widgets.baseColors": "Base",
    "widgets.keys": "Teclas",
    "widgets.primaryKeys": "Principales",
    "widgets.secondaryKeys": "Secundarias",
    "widgets.operationKeys": "Operaciones",
    "widgets.buttonBorders": "Bordes de las teclas",
    "widgets.offlineUse": "Uso sin conexión",
    "widgets.offlineUseBody": "El widget usa el último tipo disponible y actualiza automáticamente el cambio cuando vuelve la conexión.",
    "widgets.converterOfflinePreview": "Sin conexión · 1 CHF = 1,06 EUR",
    "widgets.previewFromCode": "CHF",
    "widgets.previewToCode": "EUR",
    "widgets.previewFromValue": "77 CHF",
    "widgets.previewToValue": "81,62 EUR",
    "widgets.textSize": 'Tamaño del texto',
    "widgets.textSizeBody": 'Tamaño del contenido mostrado en el widget.',
    "widgets.checklistItems": 'Elementos visibles',
    "widgets.checklistItemsBody": 'Número máximo de elementos de la checklist que se muestran en el widget cuando hay espacio.',
    "widgets.backgroundTransparency": 'Transparencia del fondo del widget',
    "widgets.backgroundTransparencyBody": '100% = completamente transparente. 0% = fondo sólido.',
    "widgets.colors": 'Colores',
    "widgets.backgroundColor": 'Fondo',
    "widgets.iconColor": 'Color del icono',
    "widgets.titleColor": 'Color del título',
    "widgets.textColor": 'Color del texto',
    "widgets.actionColor": 'Color del botón',
    "widgets.buttonCorners": 'Bordes de los botones del widget',
    "widgets.buttonCornersBody": 'Elige la forma de los botones del widget.',
    "widgets.buttonStyle.square": 'Cuadrados',
    "widgets.buttonStyle.sharp": 'Compactos',
    "widgets.buttonStyle.soft": 'Suaves',
    "widgets.buttonStyle.rounded": 'Redondeados',
    "widgets.showHeader": 'Mostrar título',
    "widgets.showHeaderBody": 'Muestra el nombre del widget en la parte superior.',
    "widgets.showTripName": 'Mostrar viaje',
    "widgets.showTripNameBody": 'Muestra el nombre del viaje vinculado al widget.',
    "widgets.showSecondary": 'Mostrar detalles',
    "widgets.showSecondaryBody": 'Muestra la línea de información secundaria cuando hay espacio.',
    "widgets.autoUpdate": 'Actualización automática',
    "widgets.autoUpdateBody": 'Actualiza los widgets instalados cuando cambian los datos del viaje.',
    "widgets.maxChars": 'Número máximo de caracteres',
    "widgets.maxCharsBody": 'Limita el texto mostrado en el widget.',
    "widgets.maxStops": 'Próximas etapas visibles',
    "widgets.maxStopsBody": 'Por defecto se muestran todas. Puedes limitar la lista hasta una sola etapa.',
    "widgets.allStops": 'Todas',
    "widgets.includePastStops": 'Mostrar también etapas pasadas',
    "widgets.includePastStopsBody": 'Desactivado por defecto.',
    "widgets.documentDisplay": 'Visualización del documento',
    "widgets.documentDisplayBody": 'Elige si el widget muestra el documento o un enlace pulsable.',
    "widgets.documentDisplayImage": 'Imagen del documento',
    "widgets.documentDisplayLink": 'Enlace para abrir el documento',
    "widgets.visibleItems": 'Elementos visibles',
    "widgets.visibleItemsBody": 'Elige cuántas actividades de la checklist mostrar cuando haya espacio.',
    "widgets.saveUpdate": 'Guardar y actualizar widget',
    "widgets.reset": 'Restablecer',
    "widgets.saved": 'Configuración del widget guardada y aplicada.',
    "widgets.preview.tripName": 'Fin de semana en Lisboa',
    "widgets.preview.nextStop": 'Itinerario todavía vacío',
    "widgets.preview.nextStopSecondary": 'Añade la primera etapa para empezar el viaje.',
    "widgets.preview.documents": '0 documentos',
    "widgets.preview.tickets": 'Billetes: 0',
    "widgets.preview.reminder": 'Sin notas',
    "widgets.preview.reminderSecondary": 'Abre las notas para añadir una.',
    "widgets.preview.movements": '4 movimientos',
    "widgets.preview.checklist": 'Actividades pendientes',
    "widgets.preview.checkItem1": 'Preparar los documentos',
    "widgets.preview.checkItem2": 'Comprobar los billetes',
    "widgets.preview.addExpense": 'Añadir gasto',
    "widgets.preview.open": 'Abrir',
    "widgets.colorPicker.title": 'Elige un color',
    "widgets.colorPicker.presets": 'Predefinidos',
    "widgets.colorPicker.custom": 'Personalizado',
    "widgets.colorPicker.presetColors": 'Colores predefinidos',
    "widgets.colorPicker.customColor": 'Color personalizado',
    "widgets.colorPicker.htmlCode": 'Código HTML',
    "widgets.colorPicker.invalidHtml": 'Introduce un código de color HTML válido',
    "widgets.colorPicker.apply": 'Aplicar color',
    "widgets.colorPicker.color": 'Color',
    "widgets.colorPicker.htmlPlaceholder": '#124848',
    "settings.barsSection": 'Barra superior e inferior',
    "settings.topBar": 'Barra superior',
    "settings.topBarBody": 'Ajustes preparados para la futura personalización de la barra superior.',
    "settings.bottomBar": 'Barra inferior',
    "settings.bottomBarBody": 'Ajustes preparados para la futura personalización de la navegación inferior.',
    "settings.supportEmail": 'Contactar con soporte',
    "settings.supportEmailBody": 'Canal de asistencia de Mundely.',
    "settings.reportProblem": 'Informar de un problema',
    "settings.reportProblemBody": 'Envía un informe técnico o un fallo.',
    "settings.faq": 'Preguntas frecuentes',
    "settings.faqBody": 'Respuestas rápidas a las dudas de uso más comunes.',
    "settings.website": 'Sitio web',
    "settings.websiteBody": 'Información, novedades y recursos oficiales de Mundely.',
    "settings.linksPreparedBody": 'La estructura está lista. Los enlaces definitivos de soporte, web y redes sociales se conectarán más adelante.',
    "settings.appInfoTagline": 'Tu espacio inteligente para organizar, vivir y recordar los viajes.',
    "settings.webSocial": 'Web y redes sociales',
    "settings.webSocialBody": 'Canales oficiales de Mundely preparados para sus enlaces definitivos.',
    "quiz.title": "Conozcámonos mejor", "quiz.menuBody": "Descubre tu estilo de viaje y los destinos más afines.", "quiz.intro": "Elige por instinto entre dos alternativas. Tu perfil se actualiza y sincroniza entre dispositivos.", "quiz.choose": "¿Cuál prefieres?", "quiz.or": "o", "quiz.questionProgress": "Pregunta {current} de {total}", "quiz.complete": "Perfil completado", "quiz.completeBody": "Puedes cambiar cualquier respuesta cuando quieras.", "quiz.history": "Tus respuestas", "quiz.historyBody": "Revisa y modifica el historial: el Top 10 se recalculará.", "quiz.unanswered": "Sin responder", "quiz.top10": "Tu Top 10", "quiz.top10Body": "Compatibilidad orientativa calculada según tus preferencias.", "quiz.catalogHint": "El motor compara al menos {count} destinos y puede ampliarse con el catálogo cloud.", "quiz.top10Empty": "Responde a la primera pregunta para generar la clasificación.", "quiz.saveError": "No se pudo guardar. La respuesta no se aplicó.", "quiz.syncWarning": "La sincronización no está disponible temporalmente: ves la última copia guardada en este dispositivo.", "quiz.sea": "Mar", "quiz.mountain": "Montaña", "quiz.city": "Ciudad", "quiz.nature": "Naturaleza", "quiz.warm": "Calor", "quiz.cold": "Frío", "quiz.planned": "Organizado", "quiz.adventure": "Aventura", "quiz.luxury": "Lujo", "quiz.budget": "Económico", "quiz.relax": "Relax", "quiz.activity": "Actividad", "quiz.culture": "Cultura", "quiz.nightlife": "Vida nocturna", "quiz.short": "Viaje corto", "quiz.long": "Viaje largo", "quiz.destination.bali": "Bali", "quiz.destination.tokyo": "Tokio", "quiz.destination.iceland": "Islandia", "quiz.destination.maldives": "Maldivas", "quiz.destination.newYork": "Nueva York", "quiz.destination.dolomites": "Dolomitas", "quiz.destination.barcelona": "Barcelona", "quiz.destination.costarica": "Costa Rica", "quiz.destination.paris": "París", "quiz.destination.thailand": "Tailandia", "quiz.destination.norway": "Noruega", "quiz.destination.dubai": "Dubái", "quiz.destination.lisbon": "Lisboa", "quiz.destination.rome": "Roma", "quiz.destination.london": "Londres", "quiz.destination.athens": "Atenas", "quiz.destination.istanbul": "Estambul", "quiz.destination.marrakech": "Marrakech", "quiz.destination.capeTown": "Ciudad del Cabo", "quiz.destination.zanzibar": "Zanzíbar", "quiz.destination.singapore": "Singapur", "quiz.destination.seoul": "Seúl", "quiz.destination.vietnam": "Vietnam", "quiz.destination.sriLanka": "Sri Lanka", "quiz.destination.nepal": "Nepal", "quiz.destination.patagonia": "Patagonia", "quiz.destination.peru": "Perú", "quiz.destination.mexico": "México", "quiz.destination.canadaRockies": "Rocosas canadienses", "quiz.destination.newZealand": "Nueva Zelanda",
    "settings.profileBody": "Datos personales, cuenta, acceso y seguridad.",
    "settings.security": "Seguridad",
    "settings.securityBody": "Contraseña, dispositivos conectados, PIN y biometría.",
    "settings.general": "General",
    "settings.generalBody": "Idioma, moneda, unidades de medida y formato de fecha.",
    "settings.appearance": "Apariencia",
    "settings.appearanceBody": "Tema, colores, estilo de botones, widgets y modelos.",
    "settings.notifications": "Notificaciones y Recordatorios",
    "settings.notificationsBody": "Avisos operativos, recordatorios, AI, colaboración y comunicaciones.",
    "profile.socialTitle": "Redes sociales",
    "profile.socialBody": "Añade enlaces a tus perfiles sociales y elige si mostrarlos públicamente.",
    "profile.socialPublic": "Mostrar redes sociales en mi perfil público",
    "profile.socialInvalid": "Introduce un enlace HTTPS válido al perfil de la red social indicada.",
    "settings.infoData": "Planes, datos y soporte",
    "settings.infoDataBody": "Plan, datos, asistencia, privacidad e información de la app.",
    "settings.localLock": "Protección del dispositivo",
    "settings.localLockBody": "Elige cómo proteger el acceso a los datos disponibles en este dispositivo.",
    "settings.nativeOnly": "La biometría requiere la app de Android o iOS. El PIN y la contraseña de la cuenta también pueden usarse en la Web.",
    "settings.currentLock": "Protección actual",
    "settings.pin": "PIN",
    "settings.biometric": "Biometría",
    "settings.noLock": "Sin protección local",
    "settings.savePin": "Guardar PIN",
    "settings.disableLock": "Desactivar protección local",
    "settings.lockDisabled": "Protección local desactivada.",
    "settings.lockSaved": "Configuración de seguridad guardada.",
    "settings.pinInvalid": "El PIN debe contener exactamente 4 dígitos.",
    "settings.protectApp": "Proteger la app",
    "settings.protectAppBody": "Elige si quieres desbloquear Mundely con biometría, la contraseña de tu cuenta o un PIN de 4 dígitos.",
    "settings.biometricMethodDesc": "Huella, Face ID o código del dispositivo",
    "settings.passwordMethod": "Contraseña de la cuenta",
    "settings.passwordMethodDesc": "Usa la misma contraseña de tu cuenta de email",
    "settings.pinFourDigits": "PIN de 4 dígitos",
    "settings.pinMethodDesc": "Código local de 4 dígitos",
    "settings.pinSaved": "PIN guardado.",
    "settings.pinConfigured": "PIN configurado",
    "settings.pinRequired": "Configura primero un PIN de 4 dígitos.",
    "settings.passwordMethodInfo": "La contraseña de la cuenta funciona para las cuentas creadas con email y contraseña. Las cuentas de Google o Apple pueden no tener una contraseña de Mundely que pueda verificarse localmente.",
    "settings.enableBiometricReason": "Confirma la activación del bloqueo biométrico",
    "settings.disableBiometricReason": "Confirma la desactivación del bloqueo de la app",
    "settings.lockEnabled": "Protección de la app activada.",
    "settings.lockUpdated": "Configuración actualizada.",
    "settings.lockReturn": "Solicitar bloqueo al volver a la app",
    "settings.lockReturnBody": "Elige cuánto tiempo puede permanecer Mundely en segundo plano antes de volver a bloquearse.",
    "settings.timeoutNow": "Inmediatamente",
    "settings.timeout1": "1 minuto",
    "settings.timeout5": "5 minutos",
    "settings.timeout15": "15 minutos",
    "settings.localLockInfo": "El bloqueo local no sustituye el acceso con Google, Apple o email: solo protege el acceso a los datos ya disponibles en este dispositivo.",
    "settings.appearanceApp": "Tema y estilo",
    "settings.appearanceInterface": "Interfaz",
    "settings.appearanceAppBody": "Tema, colores, forma de los botones y aspecto de la interfaz.",
    "settings.languageFormats": "Idioma y formatos",
    "settings.languageFormatsBody": "Estas preferencias se guardan en tu cuenta y se sincronizan entre dispositivos.",
    "settings.generalFormatsBody": "Elige el idioma, la moneda, las unidades de medida y el formato de fecha usados por la app.",
    "settings.preferencesSaved": "Preferencias actualizadas.",
    "settings.appearanceSaved": "Apariencia actualizada.",
    "settings.notificationsSaved": "Preferencias de notificación actualizadas.",
    "settings.notificationPreferences": "Preferencias de notificación",
    "settings.notificationOperational": "Avisos operativos",
    "settings.notificationOperationalBody": "Actualizaciones importantes sobre el funcionamiento de la app y tu cuenta.",
    "settings.notificationReminders": "Recordatorios",
    "settings.notificationRemindersBody": "Recordatorios relacionados con viajes, actividades y fechas límite.",
    "settings.notificationAi": "Sugerencias AI",
    "settings.notificationAiBody": "Avisos y sugerencias generados por las funciones inteligentes de Mundely.",
    "settings.notificationCollaboration": "Colaboración",
    "settings.notificationCollaborationBody": "Invitaciones, cambios compartidos y actividad de otros participantes.",
    "settings.notificationMarketing": "Novedades y comunicaciones",
    "settings.notificationMarketingBody": "Actualizaciones sobre novedades, funciones y comunicaciones no operativas.",
    "settings.darkMode": "Modo oscuro",
    "settings.darkModeBody": "Activa el tema oscuro para usar Mundely con menos luminosidad.",
    "settings.buttonColor": "Color de los botones",
    "settings.buttonColorBody": "Elige el color principal de los botones de la aplicación.",
    "settings.themeSaved": "Tema actualizado.",
    "settings.usefulInfo": "Información Útil",
    "settings.usefulInfoBody": "Elige el diseño predeterminado de Información Útil.",
    "settings.travelLayouts": "Itinerario y Cronología",
    "settings.travelLayoutsBody": "Prueba ocho modelos de Itinerario y ocho de Cronología y elige cuáles usar en la app.",
    "settings.travelLayoutsSaved": "Modelo actualizado.",
    "settings.itineraryLayouts": "Modelos de Itinerario",
    "settings.itineraryLayoutsBody": "La elección cambia la vista principal del itinerario en todos los viajes.",
    "settings.timelineLayouts": "Modelos de Cronología",
    "settings.timelineLayoutsBody": "La elección cambia la representación gráfica de la cronología en todos los viajes.",
    "settings.itineraryLayout1": "Tarjetas diarias",
    "settings.itineraryLayout1Body": "Días en tarjetas con actividades ordenadas.",
    "settings.itineraryLayout2": "Agenda compacta",
    "settings.itineraryLayout2Body": "Lista densa centrada en horarios y detalles esenciales.",
    "settings.itineraryLayout3": "Planificador por columnas",
    "settings.itineraryLayout3Body": "Días uno al lado del otro como planificador visual.",
    "settings.itineraryLayout4": "Magazine",
    "settings.itineraryLayout4Body": "Tarjetas amplias, imágenes protagonistas y ritmo editorial.",
    "settings.itineraryLayout5": "Ruta",
    "settings.itineraryLayout5Body": "Los días se conectan mediante una línea de viaje.",
    "settings.itineraryLayout6": "Agenda horaria",
    "settings.itineraryLayout6Body": "Vista centrada en la secuencia de horarios.",
    "settings.itineraryLayout7": "Mosaico",
    "settings.itineraryLayout7Body": "Cuadrícula visual con tarjetas dinámicas.",
    "settings.itineraryLayout8": "Minimal",
    "settings.itineraryLayout8Body": "Esencial, limpio y muy legible.",
    "settings.timelineLayout1": "Línea vertical",
    "settings.timelineLayout1Body": "Cronología clásica con nodos diarios.",
    "settings.timelineLayout2": "Ruta geográfica",
    "settings.timelineLayout2Body": "Etapas y desplazamientos como una ruta de viaje.",
    "settings.timelineLayout3": "Capítulos",
    "settings.timelineLayout3Body": "Cada destino se convierte en un capítulo del viaje.",
    "settings.timelineLayout4": "Doble carril",
    "settings.timelineLayout4Body": "Actividades alternadas a ambos lados de la línea temporal.",
    "settings.timelineLayout5": "Cinta",
    "settings.timelineLayout5Body": "Secuencia horizontal de bloques conectados.",
    "settings.timelineLayout6": "Calendario",
    "settings.timelineLayout6Body": "Cronología organizada como calendario visual.",
    "settings.timelineLayout7": "Mapa esquemático",
    "settings.timelineLayout7Body": "Ruta ilustrada con nodos, curvas y etapas.",
    "settings.timelineLayout8": "Cinemática",
    "settings.timelineLayout8Body": "Grandes escenas, fechas y títulos como un relato visual.",
    "settings.sections": "Secciones",
    "settings.preferencesPending": "Cambios guardados en este dispositivo, pendientes de sincronización.",
    "settings.preferencesConflict": "Las opciones cambiaron en otro dispositivo. Vuelve a abrir la sección y repite el cambio.",
    "settings.sectionsBody": "Configura las opciones utilizadas en las distintas secciones de la app.",
    "settings.sectionsHotels": "Hoteles",
    "settings.sectionsHotelsBody": "Gestiona los valores disponibles en el campo Reservado con de los hoteles.",
    "settings.sectionsRestaurants": "Restaurantes",
    "settings.sectionsRestaurantsBody": "Gestiona los valores disponibles en el campo Reservado con de los restaurantes.",
    "settings.sectionsChecklist": "Checklist",
    "settings.sectionsChecklistBody": "Gestiona las categorías disponibles en las checklist de los viajes.",
    "settings.sectionsChecklistCategories": "Checklist · Categorías",
    "settings.sectionsParticipants": "Participantes",
    "settings.sectionsWorldMap": "Colores de Mi mundo",
    "settings.sectionsWorldMapBody": "Elige los colores del mapa para Visitado, Viví allí y No visitado.",
    "settings.sectionsWorldMapHelp": "Estos colores se usan en el mapa de Mi mundo y se sincronizan con tu perfil.",
    "settings.sectionsWorldMapSaved": "Colores del mapa actualizados.",
    "settings.sectionsWorldMapReset": "Restaurar predeterminados",
    "settings.sectionsWorldMapSaveError": "No se pudieron guardar los colores del mapa.",
    "settings.sectionsParticipantsBody": "Gestiona los roles disponibles para los participantes de los viajes.",
    "settings.sectionsParticipantRoles": "Participantes · Roles",
    "settings.sectionsHotelBookedWith": "Hoteles · Reservado con",
    "settings.sectionsRestaurantBookedWith": "Restaurantes · Reservado con",
    "settings.sectionsListBody": "Añade, renombra, ordena o archiva valores. Los archivados siguen siendo válidos en datos existentes pero no aparecen en nuevas entradas.",
    "settings.sectionsAddPlaceholder": "Nuevo valor",
    "settings.sectionsAdd": "Añadir valor",
    "settings.sectionsCustomValue": "Permite un valor personalizado",
    "settings.moveUp": "Subir",
    "settings.moveDown": "Bajar",
    "settings.archive": "Archivar",
    "settings.archivedValues": "Valores archivados",
    "settings.restoreDefaults": "Restaurar valores predeterminados",
    "settings.usefulInfoLayoutBody": "Elige cuál de los cinco modelos usar en todos los viajes. El Modelo 1 es el predeterminado.",
    "settings.usefulInfoLayout1": "Modelo 1 · Secciones de color",
    "settings.usefulInfoLayout2": "Modelo 2 · Resumen + detalles",
    "settings.usefulInfoLayout3": "Modelo 3 · Secciones desplegables",
    "settings.usefulInfoLayout4": "Modelo 4 · Tarjetas compactas",
    "settings.usefulInfoLayout5": "Modelo 5 · Resumen rápido",
    "settings.usefulInfoLayoutSaved": "Diseño de Información Útil actualizado.",
    "settings.default": "Predeterminado",
    "settings.prepared": "Preparado",
    "settings.usefulInfoPreparedBody": "La estructura está lista. Definiremos aquí las opciones de Información Útil cuando analicemos la pestaña.",
    "billing.feelsLike": "Sensación térmica",
    "billing.wind": "Viento",
    "billing.sharePassword": "Contraseña del enlace",
    "billing.shareExpiry": "Caducidad del enlace (opcional)",
    "billing.revokeLink": "Desactivar enlace",
    "billing.completeRequired": "Disponible con el Plan Completo",
    "billing.preserved": "Tus datos y preferencias se conservan. Pasa al Plan Completo para usar esta función.",
    "billing.viewPlans": "Ver planes",
    "billing.actionError": "No se pudo completar la operación. Comprueba la conexión e inténtalo de nuevo.",
    "billing.manual": "Viajes y entradas manuales",
    "billing.tripSuggestions": "Sugerencias contextuales de actividades",
    "billing.tripReplanning": "Recálculo inteligente del itinerario",
    "billing.voice": "Asistente de voz IA",
    "billing.photoAi": "Selección de fotos con IA",
    "billing.weather": "Tiempo",
    "billing.weatherFree": "Clima medio y 2 días",
    "billing.weatherComplete": "14 días y detalle por hora",
    "billing.widgets": "Widgets",
    "billing.widgetsFree": "Itinerario, checklist, gasto, notas, calculadora, conversor",
    "billing.widgetsComplete": "Todos, incluidos documentos e historial de gastos",
    "billing.stats": "Estadísticas de gastos",
    "billing.statsFree": "Un viaje",
    "billing.statsComplete": "Comparaciones, tendencias e información",
    "billing.fx": "Conversión automática de divisas",
    "billing.fxFree": "Conversor manual",
    "billing.sharing": "Enlace público",
    "billing.sharingFree": "Viaje completo, revocable",
    "billing.sharingComplete": "Secciones, contraseña y caducidad",
    "billing.offline": "Acceso sin conexión",
    "billing.cache": "Caché normal",
    "billing.fullDownload": "Descarga completa del viaje",
    "billing.backup": "Exportación de cuenta, copia y restauración",
    "billing.days": "días",
    "billing.tools": "Calculadora, conversor y fAInance",
    "billing.importExport": "Importación y PDF/Excel de un viaje",
    "billing.collaboration": "Invitaciones, roles y sincronización",
    "billing.community": "Comunidad y preferencias",
    "billing.live": "Servicios en vivo, calendario y optimización — en roadmap",
    "billing.personal": "El plan es personal y sigue tu cuenta, también en viajes compartidos.",
    "billing.trialActive": "Prueba Completo activa",
    "billing.until": "Acceso Completo hasta el",
    "billing.cancelScheduled": "Renovación desactivada. El plan sigue activo hasta su caducidad.",
    "billing.statusError": "No se pudo actualizar el plan. Las operaciones de pago requieren verificación del servidor.",
    "billing.notMeasured": "Uso pendiente de medición",
    "billing.refreshUsage": "Actualizar uso",
    "billing.overQuota": "El espacio supera la cuota. Los archivos existentes siguen accesibles. Elimina archivos o cambia de plan antes de subir más.",
    "billing.trialBody": "Prueba todas las funciones Completo durante 30 días, una vez por cuenta. Sin cobro automático.",
    "billing.startTrial": "Iniciar prueba de 30 días",
    "billing.trialUsed": "Ya has utilizado la prueba gratuita.",
    "billing.cancelRenewal": "Desactivar renovación",
    "map.showAll": "Mostrar todo",
    "travelerProfile.guidanceBody": "Cuéntanos qué te gusta y qué quieres evitar. Mundely usará estas preferencias para personalizar tus viajes.",
    "tools.createExpense": "Crear un gasto",
    "tools.expenseBody": "Usa este resultado como importe de un gasto. Podrás completar los detalles antes de guardarlo.",
    "tools.chooseTrip": "¿Para qué viaje?",
    "tools.noTrips": "Crea primero un viaje para registrar un gasto.",
    "quiz.upNext": "Tus próximas elecciones",
    "quiz.upNextBody": "Una respuesta a la vez, para conocerte mejor.",
    "billing.freeForever": "Sin suscripción",
    "billing.bestValue": "La opción más económica",
    "billing.recoveryTitle": "Papelera e historial de viajes",
    "billing.recoveryBody": "El Plan Completo permite recuperar viajes eliminados y restaurar versiones anteriores durante 30 días.",
    "travelerProfile.neutral": "Automático",
    "travelerProfile.prefer": "Me gusta",
    "travelerProfile.avoid": "Prefiero evitarlo",
    "profile.searchCountry": "Buscar un país",
    "profile.countryHint": "Toca el campo y escribe las primeras letras.",
    "profile.noCountry": "Sin resultados",
    "quiz.destinationDetail": "Un destino afín a tus preferencias. Explóralo con Mundely y decide cómo organizar tu viaje.",
    "quiz.exploreDestination": "Explorar con Mundely",
    "quiz.destinationPrompt": "Me gustaría organizar un viaje a {destination}. Ayúdame a explorar este destino según mis preferencias.",
    "legal.welcome": "Antes de empezar",
    "legal.intro": "Puedes consultar los Términos y el Aviso de privacidad en cualquier momento. Confirma ambas declaraciones para continuar.",
    "legal.read": "Leído",
    "legal.toRead": "Por leer",
    "legal.acceptTerms": "Acepto los Términos de Uso.",
    "legal.acceptPrivacy": "Confirmo que he recibido el Aviso de Privacidad.",
    "legal.continue": "Aceptar y continuar",
    "legal.decline": "No acepto · Cerrar sesión",
    "legal.readEnd": "Has llegado al final del documento.",
    "legal.websiteVersion": "Consultar la página en el sitio Mundely",
    "legal.loadError": "No se pudo verificar la aceptación anterior. Puedes leer los documentos y reintentarlo con conexión.",
    "legal.saveError": "No se confirmó la aceptación. Revisa la conexión y reinténtalo: tus preferencias siguen guardadas.",
    "common.actions": "Acciones",
    "trips.inProgress": "Viajes en curso",
    "trips.future": "Viajes futuros",
    "trips.finished": "Viajes finalizados",
    "trips.sectionEmpty": "No hay viajes en esta sección.",
    "profile.openPublic": "Abrir perfil",
    "travelerProfile.generate": "Generar indicaciones",
    "travelerProfile.generatedTitle": "Indicaciones propuestas",
    "travelerProfile.generatedBody": "Revisa y modifica el texto. Se insertará en el campo y podrás guardarlo cuando quieras.",
    "travelerProfile.useGenerated": "Usar estas indicaciones",
    "travelerProfile.generatedIntro": "Personaliza las sugerencias usando la información que he añadido a Mundely.",
    "travelerProfile.generatedAnswers": "He expresado {count} elecciones sobre mi forma de viajar.",
    "travelerProfile.generatedFavorites": "Prefiero: {styles}.",
    "travelerProfile.generatedSignals": "Mis respuestas y reseñas sugieren interés por: {styles}.",
    "travelerProfile.generatedAvoid": "Prefiero evitar: {styles}.",
    "travelerProfile.generatedCountries": "He registrado {count} países en mi perfil.",
    "travelerProfile.generatedTrips": "Tengo {count} viajes finalizados.",
    "travelerProfile.generatedDestinations": "Mis viajes incluyen: {places}.",
    "travelerProfile.generatedDuration": "Los viajes registrados duran aproximadamente {count} días de media.",
    "travelerProfile.generatedGroup": "El grupo registrado en mis viajes tiene una media de {count} personas.",
    "travelerProfile.generatedDetails": "Las actividades y paradas registradas incluyen: {details}.",
    "travelerProfile.generatedEnd": "Usa estas señales como punto de partida y pregúntame cuando una preferencia no esté clara.",
    "travelerProfile.knownTitle": "La información recopilada",
    "travelerProfile.knownBody": "Información del perfil y de los viajes para personalizar las sugerencias.",
    "travelerProfile.people": "{count} personas",
    "ai.voicePlanTitle": "Voz disponible con el Plan Completo",
    "ai.voicePlanBody": "Puedes seguir escribiendo con el plan Gratuito. El micrófono requiere el Plan Completo.",
    "settings.cornersRounded": "Redondeados",
    "settings.cornersSoft": "Suaves",
    "settings.cornersSquare": "Cuadrados",
    "settings.cornersSharp": "Rectos",
    "settings.metricExample": "Kilómetros, kilogramos y Celsius. Ej.: 10 km · 70 kg · 20 °C",
    "settings.imperialExample": "Millas, libras y Fahrenheit. Ej.: 6,2 mi · 154 lb · 68 °F",
    "settings.dateDayFirst": "Día / mes / año",
    "settings.dateMonthFirst": "Mes / día / año",
    "settings.dateYearFirst": "Año / mes / día",
    "layout.day": "Día {number}",
    "layout.trip": "El viaje",
    "layout.useful": "Información útil",
    "layout.example": "Ejemplo",
    "layout.passport": "Pasaporte",
    "layout.rome": "Roma",
    "layout.florence": "Florencia",
    "layout.venice": "Venecia",
    "layout.museum": "Museo",
    "layout.lunch": "Almuerzo",
    "layout.park": "Parque",
    "billing.completePlanLabel": "Plan Completo",
    "home.allTrips": "Todos mis viajes",
    "settings.unitDistance": "Distancias",
    "settings.unitWeight": "Peso",
    "settings.unitTemperature": "Temperatura",
    "settings.metricShortExample": "10 km · 70 kg · 20 °C",
    "settings.imperialShortExample": "6,2 mi · 154 lb · 68 °F",
    "travelerProfile.noGenerationData": "Añade respuestas o información de viajes para generar indicaciones personalizadas.",
    "travelerProfile.recordedCountries": "Países registrados",
    "travelerProfile.countryHint": "Visitados o donde has vivido",
    "travelerProfile.openTripsHint": "Abrir tus viajes",
    "travelerProfile.myReviews": "Tus reseñas",
    "travelerProfile.myReviewsBody": "Reseñas que has publicado sobre países, ciudades y lugares.",
    "travelerProfile.reviewsHint": "Países, ciudades y lugares reseñados",
    "travelerProfile.groupAverage": "Tamaño medio del grupo",
    "travelerProfile.groupHint": "Tú y los acompañantes registrados",
    "travelerProfile.tripGroups": "Grupos de tus viajes",
    "travelerProfile.tripGroupsBody": "La media considera los viajes con acompañantes registrados, incluyéndote en el número de personas. Estos son los grupos utilizados para la estimación.",
    "travelerProfile.openTravelGroup": "Abrir participantes",
    "travelerProfile.sourceEmpty": "No hay información que mostrar en esta sección.",
    "travelerProfile.avoidShort": "Evitar",
    "profile.cloudSpaceInfo": "Almacenamiento cloud de tu plan",
    "profile.cloudSpaceBody": "El plan {plan} incluye {limit} de almacenamiento cloud total. Las fotos personales, documentos y archivos de viajes comparten este límite; no es un espacio separado para cada sección.",
    "profile.exitApp": "Salir de la app",
    "profile.exitConfirm": "¿Quieres salir de tu cuenta?",
    "expenses.date.today": "Hoy",
    "expenses.date.yesterday": "Ayer",
    "expenses.date.specific": "Fecha específica",
    "world.cityNote": "Nota",
    "tripHome.lastActivity": "Última actividad",
    "tripHome.organizedDays": "{count} días organizados",
    "tripHome.totalDays": "De {count} días de viaje",
    "tripHome.stays": "Alojamientos",
    "tripHome.savedStays": "Alojamientos añadidos al viaje",
    "world.searchCities": "Buscar ciudad o país",
    "world.cityGroupCount": "{count} ciudades registradas",
    "world.noCityMatches": "Ninguna ciudad coincide con tu búsqueda.",
    "itinerary.viewDetails": "Ver detalles: {title}",
    "home.flexibleTime": "Horario libre",
    "home.toolsBody": "Calculadora y cambio de moneda, siempre a mano.",
    "billing.pricingLater": "Las compras estarán disponibles tras su activación en las tiendas.",
    "billing.pricesTitle": "Elige tu plan",
    "billing.freePlan": "Gratuito",
    "billing.monthlyPlan": "Completo mensual",
    "billing.annualPlan": "Completo anual",
    "billing.month": "mes",
    "billing.year": "año",
    "billing.upgradePrices": "Piano Completo: {monthly}/mes o {annual}/año.",
    "billing.downgrade": "Cuando caduca Completo",
    "billing.downgradeBody": "No se borran datos. Los archivos siguen visibles y descargables; se bloquean nuevas subidas por encima de 100 MB. Se inicia un nuevo cupo Free de 20 usos IA. Los widgets premium conservan su posición con acceso bloqueado.",
    "billing.layoutsPending": "Los cuatro diseños finales y el diseño Free quedan por elegir. Se conservan las preferencias actuales.",
    "billing.aiLimit": "Has alcanzado los 20 usos IA de este mes.",
    "settings.plan": "Plan y suscripción",
    "settings.planBody": "Plan activo, límites y gestión de la suscripción.",
    "settings.currentPlan": "Plan actual",
    "settings.planPreparedBody": "La gestión completa de compras se conectará al sistema Premium centralizado.",
    "settings.planUnlimited": "Ilimitado",
    "settings.planYes": "Sí",
    "settings.planNo": "No",
    "settings.planAiRequests": "Solicitudes de IA mensuales",
    "settings.planTrips": "Viajes disponibles",
    "settings.planStorage": "Espacio en la nube",
    "settings.planRecovery": "Papelera y recuperación",
    "settings.planCompare": "Comparar planes",
    "settings.planCompareBody": "Los límites se leen desde la configuración remota de Mundely y pueden actualizarse sin reinstalar la app.",
    "settings.planFeature": "Función",
    "settings.planFreeActiveBody": "Estás usando el plan gratuito de Mundely.",
    "settings.planPremiumActiveBody": "Tu cuenta tiene acceso a las funciones Premium habilitadas.",
    "settings.planBenefitRecovery": "Recuperación y versiones",
    "settings.planBenefitRecoveryBody": "Restaura elementos eliminados y usa las funciones de recuperación disponibles para tu plan.",
    "settings.planBenefitAi": "Más IA",
    "settings.planBenefitAiBody": "Los límites de IA se gestionan de forma centralizada y se adaptan al plan activo.",
    "settings.planBenefitStorage": "Más espacio en la nube",
    "settings.planBenefitStorageBody": "El espacio disponible sigue los límites definidos para tu plan.",
    "settings.planBenefitTrips": "Más viajes",
    "settings.planBenefitTripsBody": "El número máximo de viajes se gestiona mediante la configuración remota.",
    "settings.planUpgradeTitle": "Pasar a Premium",
    "settings.planUpgradeBody": "Esta página ya está conectada a los permisos de tu cuenta. Las compras en las tiendas se activarán cuando se configuren los productos de Android y Apple.",
    "settings.planUpgradeNotAvailable": "Compras aún no activas",
    "settings.planPremiumThanks": "Premium está activo en tu cuenta.",
    "settings.data": "Datos",
    "settings.dataBody": "Exportación, recuperación de datos y eliminación de la cuenta.",
    "settings.appInfo": "Info de la app",
    "settings.appInfoBody": "Entorno, idiomas disponibles e información técnica de Mundely.",
    "settings.support": "Soporte",
    "settings.supportBody": "Ayuda, FAQ y contactos.",
    "settings.supportPreparedBody": "Esta sección está preparada para FAQ, contactos y herramientas de soporte.",
    "settings.faqSyncQuestion": "¿Cómo se sincronizan mis viajes?",
    "settings.faqSyncAnswer": "Los cambios se sincronizan con la nube cuando estás conectado. Si trabajas sin conexión, Mundely conserva los cambios y vuelve a intentar la sincronización cuando hay conexión.",
    "settings.faqOfflineQuestion": "¿Puedo usar Mundely sin conexión?",
    "settings.faqOfflineAnswer": "Sí. La información ya disponible en el dispositivo sigue accesible y muchos cambios quedan en cola hasta que vuelve la conexión.",
    "settings.faqAiQuestion": "¿Cómo usa mis datos el Agente AI?",
    "settings.faqAiAnswer": "El Agente utiliza el contexto necesario para ayudarte con el viaje, como preferencias, itinerario e información que decides compartir. El contenido personal no se incluye en los eventos Analytics.",
    "settings.faqPrivacyQuestion": "¿Puedo controlar los datos de uso enviados?",
    "settings.faqPrivacyAnswer": "Sí. Desde el Perfil puedes activar o desactivar los Analytics anónimos. Esta elección no cambia las funciones principales de Mundely.",
    "settings.faqFainanceQuestion": "¿Cómo funciona la conexión con fAInance?",
    "settings.faqFainanceAnswer": "Durante las pruebas la conexión utiliza exclusivamente fAInance Test. La solicitud debe ser aprobada por la cuenta fAInance indicada antes de que las dos apps aparezcan conectadas.",
    "settings.supportContacts": "Contactos y enlaces",
    "settings.supportContactsBody": "Los enlaces están disponibles cuando se configuran para el entorno actual.",
    "settings.notConfigured": "Aún no configurado",
    "settings.diagnosticsTitle": "Diagnóstico de soporte",
    "settings.diagnosticsBody": "Copia el entorno, la plataforma y la configuración técnica útil para una incidencia, sin contenido personal.",
    "settings.diagnosticsCopy": "Copiar diagnóstico",
    "settings.diagnosticsCopied": "Copiado",
    "settings.linksManagedBody": "Sitio web, contactos, documentos legales y redes sociales se gestionan mediante la configuración de Mundely y pueden actualizarse sin modificar esta página.",
    "settings.platform": "Plataforma",
    "settings.firebaseProject": "Proyecto Firebase",
    "settings.currentLanguage": "Idioma actual",
    "settings.analyticsStatus": "Analytics",
    "settings.nativeStatus": "Modo de app",
    "settings.enabled": "Activos",
    "settings.disabled": "Inactivos",
    "settings.nativeApp": "App nativa",
    "settings.webApp": "Web",
    "settings.appName": "App",
    "settings.environment": "Entorno",
    "settings.production": "Producción",
    "settings.test": "Test",
    "settings.languages": "Idiomas",
    "settings.session": "Sesión",
    "settings.sessionBody": "Cierra sesión de Mundely en este dispositivo.",
    "home.greeting": "Hola, {name}",
    "home.corporate.plannedIntro": "Tu próximo viaje toma forma.",
    "home.corporate.prepare": "Antes de partir",
    "home.corporate.pending": "{count} elementos pendientes",
    "home.corporate.checklist": "Abre la lista de tu viaje",
    "home.corporate.today": "Hoy, en {place}.",
    "home.corporate.day": "Día {count}",
    "home.corporate.nextStop": "Tu próxima parada",
    "home.corporate.noStop": "No hay próximas paradas para hoy",
    "home.corporate.openItinerary": "Consulta tu itinerario",
    "home.corporate.savedStop": "Una parada guardada en tu itinerario",
    "home.corporate.openStop": "Abrir la parada",
    "home.corporate.worldTitle": "Tu mundo. Tu historia.",
    "home.corporate.worldFirst": "Tu mundo empieza aquí.",
    "home.corporate.newChapter": "¿Adónde te llevará tu próximo viaje?",
    "home.corporate.newDeparture": "Organiza una nueva salida",
    "home.corporate.worldBody": "Fotos, lugares visitados y recuerdos",
    "home.corporate.restDay": "El resto del día",
    "home.corporate.tools": "Herramientas de viaje",
    "home.command.title": "Viaje",
    "home.command.transport": "Próximo transporte",
    "home.command.transportEmpty": "No hay transportes previstos",
    "home.command.booking": "Próxima reserva",
    "home.command.bookingEmpty": "No hay reservas guardadas",
    "home.command.weather": "Pronóstico del día",
    "home.command.weatherEmpty": "No hay previsión guardada para esta fecha",
    "home.command.savedWeather": "Previsión guardada",
    "home.command.useful": "Información útil",
    "home.command.usefulBody": "Datos útiles para tus destinos",
    "home.command.spending": "Gastos registrados",
    "home.command.spendingEmpty": "No hay gastos registrados",
    "home.command.recent": "Último gasto",
    "home.command.reminder": "Próximo recordatorio",
    "home.command.reminderEmpty": "No hay tareas pendientes",
    "home.command.pending": "{count} tareas pendientes",
    "home.command.reviewItinerary": "Revisar itinerario",
    "home.command.openAi": "AGENTE",
    "home.command.agentBody": "Pide ideas para tu viaje",
    "home.tripToPlan": "Por organizar",
    "home.overview": "Tu mundo en cifras",
    "home.traveler": "viajero",
    "home.subtitle": "Desde aquí construiremos tu experiencia de viaje.",
    "home.newTrip": "Nuevo viaje",
    "home.chooseTrip": "Elegir viaje",
    "trips.subtitle": "Elige un viaje existente o crea uno nuevo.",
    "trips.new": "Nuevo viaje",
    "trips.emptyBody": "Crea tu primer viaje para empezar a organizar el itinerario, el mapa, los documentos y las demás secciones.",
    "trips.saved": "Viajes guardados",
    "trips.createTitle": "Crear un nuevo viaje",
    "trips.createBody": "Introduce la información básica. Podrás completar el viaje en sus secciones dedicadas.",
    "trips.name": "Nombre del viaje",
    "trips.namePlaceholder": "Ej. Filipinas 2026",
    "trips.destination": "Destino",
    "trips.destinationPlaceholder": "Ej. Filipinas",
    "trips.startDate": "Fecha de salida",
    "trips.endDate": "Fecha de regreso",
    "trips.createAction": "Crear viaje",
    "trips.createRequired": "Completa el nombre, el destino y las fechas del viaje.",
    "trips.createDateError": "La fecha de regreso no puede ser anterior a la fecha de salida.",
    "trip.selected": "Viaje seleccionado",
    "trip.allTrips": "Todos los viajes",
    "trip.export": "Exportar viaje",
    "trip.changeCoverPhoto": "Cambiar portada",
    "trip.changeProfilePhoto": "Cambiar foto del viaje",
    "trip.editHome": "Editar inicio",
    "trip.finishEditHome": "Terminar edición del inicio",
    "trip.photoInvalid": "Selecciona un archivo de imagen válido.",
    "trip.photoError": "No se pudo procesar la foto. Inténtalo de nuevo.",
    "trip.photosAiPrompt": "Para el viaje a {destination}, elige un candidato representativo para la foto de perfil del viaje y otro para la portada. Responde solo con JSON en el formato {\"profileIndex\":0,\"coverIndex\":1}. Candidatos: {candidates}",
    "trip.share": "Compartir viaje",
    "trip.comingSoon": "Esta función está preparada y se implementará en su fase correspondiente.",
    "trip.destinationPending": "Destino por definir",
    "trip.datesPending": "Fechas por definir",
    "trip.navigation": "Secciones del viaje",
    "trip.collapseNavigation": "Contraer menú",
    "trip.expandNavigation": "Expandir menú",
    "trip.closeNavigation": "Cerrar secciones",
    "trip.workspace": "Espacio del viaje",
    "trip.structureReady": "Estructura lista",
    "trip.group.organize": "Organiza",
    "trip.group.during": "Durante el viaje",
    "trip.group.content": "Contenidos",
    "trip.section.overview": "Inicio del viaje",
    "trip.section.overviewBody": "Resumen del viaje con acceso rápido a todas las secciones.",
    "trip.section.itinerary": "Itinerario",
    "trip.section.itineraryBody": "Etapas, días, desplazamientos y programa del viaje.",
    "trip.section.hotels": "Hoteles",
    "trip.section.hotelsBody": "Alojamientos, reservas y estancias del viaje.",
    "trip.section.restaurants": "Restaurantes",
    "trip.section.restaurantsBody": "Restaurantes, reservas y comidas del viaje.",
    "trip.section.places": "Ciudades",
    "trip.section.placesBody": "Ciudades que visitarás durante este viaje.",
    "trip.section.experiences": "Experiencias",
    "trip.section.experiencesBody": "Actividades, tours y experiencias vinculadas al viaje.",
    "trip.section.participants": "Participantes",
    "trip.section.participantsBody": "Usuarios de Mundely e invitados que participan en el viaje.",
    "trip.section.checklist": "Checklist",
    "trip.section.checklistBody": "Cosas que preparar, revisar y completar antes y durante el viaje.",
    "trip.section.map": "Mapa",
    "trip.section.mapBody": "Mapa interactivo específico del viaje y de sus contenidos.",
    "trip.section.usefulInfo": "Info Útil",
    "trip.section.usefulInfoBody": "Infografía con información práctica del destino alimentada por IA.",
    "trip.section.weather": "Clima",
    "trip.section.weatherBody": "Clima y condiciones previstas durante el periodo del viaje.",
    "trip.section.pointsOfInterest": "Lugares de interés",
    "trip.section.pointsOfInterestBody": "Atracciones y puntos de interés de las ciudades incluidas en el viaje.",
    "trip.section.events": "Eventos en la ciudad",
    "trip.section.eventsBody": "Eventos disponibles en los destinos durante las fechas del viaje.",
    "trip.section.album": "Fotos",
    "trip.section.albumBody": "Fotos y recuerdos recopilados durante el viaje.",
    "trip.section.documents": "Documentos",
    "trip.section.documentsBody": "Documentos del viaje y documentos compartidos por los participantes.",
    "trip.section.boardingPass": "Billetes",
    "trip.section.boardingPassBody": "Billetes, tarjetas de embarque y documentos de viaje recibidos de la aerolínea.",
    "trip.section.notes": "Notas",
    "trip.section.notesBody": "Notas personales o compartidas relacionadas con el viaje.",
    "usefulInfo.subtitle": "Información práctica para {destination}, reunida en una sola infografía.",
    "usefulInfo.edit": "Editar",
    "usefulInfo.fillWithAi": "Completar con IA",
    "usefulInfo.aiWorking": "Completando información...",
    "usefulInfo.saved": "Info Útil guardada.",
    "usefulInfo.aiCompleted": "Info Útil completada por la IA. Verifica la información sensible antes del viaje.",
    "usefulInfo.aiError": "Mundely no pudo completar la Info Útil con IA. Inténtalo de nuevo o introdúcela manualmente.",
    "usefulInfo.destinationRequired": "Define primero el destino del viaje.",
    "usefulInfo.notAvailable": "Por completar",
    "usefulInfo.notRequired": "No necesario",
    "usefulInfo.driving.left": "Izquierda",
    "usefulInfo.driving.right": "Derecha",
    "usefulInfo.editPlaceholder": "Introduce la información...",
    "usefulInfo.completeness": "{filled}/{total} datos completados",
    "usefulInfo.updatedAt": "Actualizado: {date}",
    "usefulInfo.source.empty": "Todavía sin completar",
    "usefulInfo.source.ai": "Completado con IA",
    "usefulInfo.source.manual": "Completado manualmente",
    "usefulInfo.source.database": "Base de datos Mundely",
    "usefulInfo.source.mixed": "Base de datos Mundely + IA/manual",
    "usefulInfo.disclaimer": "La información puede cambiar con el tiempo. Antes de viajar, verifica siempre personalmente documentos, requisitos de entrada, salud, seguridad, normas locales e indicaciones consulares con las autoridades competentes.",
    "usefulInfo.requirementsAttribution": "Requisitos de entrada:",
    "usefulInfo.requirementsDatasetName": "TravelRequirements.info",
    "usefulInfo.requirementsLicense": "CC BY 4.0",
    "usefulInfo.requirementsVerified": "datos verificados {date}",
    "usefulInfo.progressLabel": "Completado",
    "usefulInfo.plug.help": "Selecciona todos los tipos de enchufe utilizados en el destino.",
    "usefulInfo.plug.typeLabel": "Tipo {type}",
    "usefulInfo.currency.select": "Selecciona una moneda",
    "usefulInfo.downloadPdf": "Descargar PDF",
    "usefulInfo.pdfPopupBlocked": "El navegador bloqueó la ventana del PDF. Permite las ventanas emergentes para Mundely y vuelve a intentarlo.",
    "usefulInfo.pdfError": "No se pudo preparar el PDF. Inténtalo de nuevo.",
    "usefulInfo.group.basics": "Esenciales",
    "usefulInfo.group.basicsDesc": "La información práctica que necesitas nada más llegar.",
    "usefulInfo.group.services": "Servicios útiles",
    "usefulInfo.group.servicesDesc": "Apps y herramientas prácticas para usar allí.",
    "usefulInfo.group.assistanceDesc": "Contactos y referencias que conviene tener siempre a mano.",
    "usefulInfo.group.entryHealthDesc": "Requisitos de entrada e información sanitaria para el viaje.",
    "usefulInfo.group.cultureDesc": "Normas, costumbres y aspectos sociales que conviene conocer.",
    "usefulInfo.group.drivingDesc": "Las reglas esenciales para conducir en el destino.",
    "usefulInfo.group.assistance": "Asistencia y emergencias",
    "usefulInfo.group.entryHealth": "Entrada y salud",
    "usefulInfo.group.culture": "Cultura, normas y sociedad",
    "usefulInfo.group.driving": "Conducción",
    "usefulInfo.field.plugType": "Tipo de enchufe",
    "usefulInfo.field.currency": "Moneda",
    "usefulInfo.field.exchangeRate": "Cambio",
    "usefulInfo.field.timeZone": "Huso horario",
    "usefulInfo.homeTime": "respecto a casa",
    "usefulInfo.multi.title": "{count} localidades del viaje",
    "usefulInfo.multi.loading": "Recopilando información para cada localidad…",
    "usefulInfo.multi.description": "Cada sección agrupa los datos iguales y separa las diferencias, mostrando dónde se aplican.",
    "usefulInfo.multi.unresolved": "Información pendiente de verificar para esta localidad",
    "usefulInfo.multi.external": "Fuente automática: reconfirmar con las autoridades competentes",
    "usefulInfo.multi.provisional": "Dato del catálogo local: verificación en curso",
    "usefulInfo.timeZoneUnavailable": "Hora local pendiente de verificar",
    "usefulInfo.pdfSaved": "PDF guardado en Descargas/Mundely.",
    "usefulInfo.field.drinkingWater": "Agua potable",
    "usefulInfo.field.taxiApps": "Apps de taxi",
    "usefulInfo.field.taxiApps.short": "Apps taxi",
    "usefulInfo.field.foodDeliveryApps": "Apps para pedir comida",
    "usefulInfo.field.foodDeliveryApps.short": "Apps para pedir",
    "usefulInfo.field.embassy": "Embajada",
    "usefulInfo.field.consulates": "Consulados",
    "usefulInfo.field.emergencyNumber": "Número de emergencias",
    "usefulInfo.emergency.dispatch": "Emergencias",
    "usefulInfo.emergency.police": "Policía",
    "usefulInfo.emergency.ambulance": "Ambulancia",
    "usefulInfo.emergency.fire": "Bomberos",
    "usefulInfo.field.specialPrecautions": "Precauciones especiales",
    "usefulInfo.field.specialPrecautions.short": "Precauciones",
    "usefulInfo.field.governmentType": "Tipo de gobierno",
    "usefulInfo.field.religion": "Religión",
    "usefulInfo.field.publicAffection": "Afecto en público",
    "usefulInfo.field.publicAffection.short": "Afecto",
    "usefulInfo.field.lgbtq": "LGBTQ+",
    "usefulInfo.field.civilRights": "Derechos civiles",
    "usefulInfo.details.show": "Ampliar",
    "usefulInfo.details.hide": "Mostrar menos",
    "usefulInfo.details.label": "Descripción",
    "usefulInfo.field.requiredVaccines": "Vacunas obligatorias",
    "usefulInfo.field.requiredVaccines.short": "Vacunas",
    "usefulInfo.field.visa": "Visado",
    "usefulInfo.field.passport": "Pasaporte",
    "usefulInfo.field.healthInsurance": "Seguro médico",
    "usefulInfo.field.healthInsurance.short": "Seguro",
    "usefulInfo.healthInsuranceHint": "Comprueba si tu tarjeta sanitaria es válida en destino y si te conviene un seguro para gastos médicos, asistencia y repatriación.",
    "usefulInfo.civilRightsPending": "Contenido en actualización; mientras tanto, consulta las indicaciones de las autoridades locales.",
    "usefulInfo.toBeCompleted": "Por completar",
    "usefulInfo.field.drivingSide": "Lado de conducción",
    "usefulInfo.field.internationalDrivingPermit": "Permiso internacional de conducción",
    "usefulInfo.field.internationalDrivingPermit.short": "Permiso",
    "boardingPass.subtitle": "Tarjetas de embarque para {destination}, organizadas para una consulta rápida y clara.",
    "boardingPass.add": "Añadir tarjeta de embarque",
    "boardingPass.new": "Nueva tarjeta de embarque",
    "boardingPass.edit": "Editar tarjeta de embarque",
    "boardingPass.formTitle": "Datos del vuelo",
    "boardingPass.required": "Introduce pasajero, aeropuertos de salida y llegada (3 letras) y fecha del vuelo.",
    "boardingPass.deleteConfirm": "¿Eliminar esta tarjeta de embarque?",
    "boardingPass.nextFlight": "Próximo vuelo",
    "boardingPass.empty": "No hay tarjetas de embarque",
    "boardingPass.emptyBody": "Añade la primera tarjeta de embarque del viaje. Se mostrará como una tarjeta de acceso rápido.",
    "boardingPass.passenger": "Pasajero",
    "boardingPass.airline": "Aerolínea",
    "boardingPass.airlineFallback": "Aerolínea",
    "boardingPass.flightNumber": "Número de vuelo",
    "boardingPass.bookingReference": "Código de reserva",
    "boardingPass.originCode": "Aeropuerto de salida",
    "boardingPass.originCity": "Ciudad de salida",
    "boardingPass.destinationCode": "Aeropuerto de llegada",
    "boardingPass.destinationCity": "Ciudad de llegada",
    "boardingPass.origin": "Salida",
    "boardingPass.destination": "Llegada",
    "boardingPass.date": "Fecha",
    "boardingPass.departureTime": "Hora de salida",
    "boardingPass.boardingTime": "Embarque",
    "boardingPass.arrivalTime": "Hora de llegada",
    "boardingPass.terminal": "Terminal",
    "boardingPass.gate": "Puerta",
    "boardingPass.seat": "Asiento",
    "tickets.subtitle": "Sube billetes y tarjetas de embarque para {destination} como PDF o foto.",
    "tickets.add": "Añadir billete",
    "tickets.helpTitle": "Sube el documento recibido de la aerolínea",
    "tickets.helpBody": "Puedes subir PDF o imágenes. Mundely conserva una copia local y reintenta automáticamente si se interrumpe la conexión.",
    "tickets.invalidType": "Formato no compatible. Usa PDF o imágenes.",
    "tickets.added": "Billete añadido.",
    "tickets.uploadError": "El archivo quedó en cola, pero no se pudo completar la subida ahora.",
    "tickets.deleteConfirm": "¿Eliminar este billete?",
    "tickets.empty": "No hay billetes",
    "tickets.emptyBody": "Cuando recibas el billete o la tarjeta de embarque de la aerolínea, súbelo aquí como PDF o foto.",
    "tickets.image": "Imagen",
    "tickets.pdf": "PDF",
    "tickets.sizeKb": "{value} KB",
    "tickets.sizeMb": "{value} MB",
    "tickets.statusUploaded": "Guardado en la nube",
    "tickets.statusPending": "En espera de la nube",
    "tickets.statusFailed": "La subida ha fallado",
    "tickets.failedHelp": "El archivo sigue guardado en este dispositivo. Pulsa Reintentar para volver a subirlo a la nube.",
    "tickets.retry": "Reintentar",
    "tickets.pendingHelp": "El archivo está seguro en este dispositivo y se subirá a la nube automáticamente en cuanto sea posible.",
    "tickets.rename": "Renombrar",
    "tickets.renamed": "Billete renombrado.",
    "tickets.noExtension": "Sin extensión",
    "documents.subtitle": "Organiza los documentos del viaje por carpeta y participante.",
    "documents.add": "Añadir documento",
    "documents.invalidType": "Formato no compatible.",
    "documents.added": "Documento añadido.",
    "documents.uploadError": "El documento quedó en cola, pero no se pudo completar la subida ahora.",
    "documents.deleteConfirm": "¿Eliminar este documento?",
    "documents.empty": "No hay documentos",
    "documents.emptyBody": "Sube aquí pasaportes, visados, documentos de identidad, permiso de conducir, tarjeta sanitaria y otros archivos del viaje.",
    "documents.folders": "Carpetas",
    "documents.all": "Todas",
    "documents.newFolder": "Nueva carpeta",
    "documents.folderCreated": "Carpeta creada.",
    "documents.folderNamePlaceholder": "Nombre de carpeta",
    "documents.participant": "Participante",
    "documents.allParticipants": "Todos los participantes",
    "documents.me": "Yo",
    "documents.name": "Nombre",
    "documents.folder": "Carpeta",
    "documents.organize": "Organizar",
    "documents.updated": "Documento actualizado.",
    "documents.statusUploaded": "Guardado en la nube",
    "documents.statusPending": "Sincronización en curso",
    "documents.folder.passport": "Pasaporte",
    "documents.folder.id": "Documento de identidad",
    "documents.folder.drivingLicense": "Permiso de conducir",
    "documents.folder.healthCard": "Tarjeta sanitaria",
    "documents.folder.visas": "Visados",
    "documents.folder.other": "Otro",
    "documents.personalTitle": "Documentos personales",
    "documents.personalBody": "Los documentos guardados en tu Perfil aparecen automáticamente en cada viaje.",
    "documents.noPersonal": "No hay documentos personales guardados",
    "documents.noPersonalBody": "Añade pasaporte, DNI, permiso de conducir, tarjeta sanitaria o visados en Ajustes → Perfil.",
    "documents.personalWaiting": "En espera de la nube",
    "documents.tripTitle": "Documentos del viaje",
    "documents.tripBody": "Añade aquí archivos específicos de este viaje y organízalos en carpetas personalizadas.",
    "documents.statusFailed": "La subida ha fallado",
    "documents.failedHelp": "El archivo permanece guardado en este dispositivo. Pulsa Reintentar para volver a subirlo.",
    "documents.retry": "Reintentar",
    "documents.saveUpload": "Guardar carga",
    "documents.categoryEmpty": "No hay documentos",
    "profileDocuments.title": "Documentos personales",
    "profileDocuments.body": "Sube aquí los documentos que te pertenecen. Mundely los mostrará automáticamente en tus viajes.",
    "profileDocuments.uploadTitle": "Añade un documento personal",
    "profileDocuments.uploadHint": "PDF o imagen. El documento se guarda en la nube y queda disponible en tus viajes.",
    "profileDocuments.savedForSync": "Documento guardado en este dispositivo. La subida a la nube se reintentará automáticamente.",
    "profileDocuments.type": "Tipo de documento",
    "profileDocuments.add": "Añadir documento",
    "profileDocuments.invalidType": "Formato no compatible. Usa PDF o imágenes.",
    "profileDocuments.added": "Documento personal añadido.",
    "profileDocuments.uploadError": "La subida a la nube ha fallado.",
    "profileDocuments.cloudRequiredError": "El documento no se ha guardado en el dispositivo. La subida a la nube ha fallado: vuelve a intentarlo manteniendo esta pantalla abierta.",
    "profileDocuments.updated": "Documento personal actualizado.",
    "profileDocuments.deleteConfirm": "¿Eliminar este documento personal?",
    "profileDocuments.empty": "No hay documentos personales",
    "profileDocuments.emptyBody": "Añade tus documentos una sola vez y estarán disponibles en todos tus viajes.",
    "profileDocuments.statusUploaded": "Guardado en la nube",
    "profileDocuments.statusPending": "En espera de la nube",
    "profileDocuments.statusFailed": "La subida ha fallado",
    "profileDocuments.retry": "Reintentar",
    "profileDocuments.type.passport": "Pasaporte",
    "profileDocuments.type.id": "Documento de identidad",
    "profileDocuments.type.drivingLicense": "Permiso de conducir",
    "profileDocuments.type.taxCode": "Código fiscal",
    "profileDocuments.chooseFile": "Elegir documento",
    "profileDocuments.chooseType": "Categoría",
    "profileDocuments.saveUpload": "Guardar carga",
    "profileDocuments.categoryEmpty": "No hay documentos en esta sección.",
    "profileDocuments.trashTitle": "Papelera de documentos",
    "profileDocuments.trashCount": "{count} elementos",
    "profileDocuments.trashBody": "Los documentos eliminados se pueden recuperar durante 30 días y después se borran definitivamente.",
    "profileDocuments.trashDays": "Eliminación definitiva en {days} días",
    "profileDocuments.movedToTrash": "Documento movido a la papelera.",
    "profileDocuments.restored": "Documento restaurado.",
    "profileDocuments.deleteForever": "Eliminar definitivamente",
    "profileDocuments.deleteForeverConfirm": "¿Eliminar definitivamente este documento? Esta acción no se puede deshacer.",
    "profileDocuments.openError": "No se ha podido abrir el documento desde la nube.",
    "profileDocuments.type.healthCard": "Tarjeta sanitaria",
    "profileDocuments.type.visa": "Visado",
    "profileDocuments.type.other": "Otro",
    "hotels.subtitle": "Hoteles, reservas y estancias de este viaje.",
    "hotels.add": "Añadir hotel",
    "hotels.name": "Nombre del alojamiento",
    "hotels.city": "Ciudad",
    "hotels.address": "Dirección",
    "hotels.checkIn": "Check-in",
    "hotels.checkOut": "Check-out",
    "hotels.bookingReference": "Código de reserva",
    "hotels.notes": "Notas",
    "hotels.empty": "No hay hoteles",
    "hotels.emptyBody": "Añade los alojamientos en los que te quedarás durante el viaje.",
    "hotels.bookedWith": "Reservado con",
    "hotels.bookedWithNone": "No especificado",
    "hotels.bookedWithOther": "Nombre del servicio",
    "hotels.hotelSite": "Web del hotel",
    "hotels.agency": "Agencia de viajes",
    "hotels.phone": "Teléfono",
    "hotels.providerBooking": "Booking.com",
    "hotels.providerExpedia": "Expedia",
    "hotels.providerAgoda": "Agoda",
    "restaurants.subtitle": "Restaurantes, reservas y comidas del viaje.",
    "restaurants.add": "Añadir restaurante",
    "restaurants.name": "Nombre del restaurante",
    "restaurants.city": "Ciudad",
    "restaurants.address": "Dirección",
    "restaurants.date": "Fecha",
    "restaurants.time": "Hora",
    "restaurants.reservationWith": "Reservado con",
    "restaurants.reservationNone": "No especificado",
    "restaurants.reservationOther": "Nombre del servicio",
    "restaurants.restaurantSite": "Web del restaurante",
    "restaurants.phone": "Teléfono",
    "restaurants.providerTheFork": "TheFork",
    "restaurants.providerOpenTable": "OpenTable",
    "restaurants.providerGoogle": "Google",
    "restaurants.bookingReference": "Código de reserva",
    "restaurants.notes": "Notas",
    "restaurants.empty": "No hay restaurantes",
    "restaurants.emptyBody": "Añade los restaurantes que quieres visitar durante el viaje.",
    "places.autofillTitle": "Completar desde el mapa",
    "places.autofillBody": "Busca un lugar existente y deja que Mundely complete nombre, ciudad y dirección.",
    "places.chooseFromMap": "Elegir del mapa",
    "places.pickerEyebrow": "Búsqueda en Google Maps",
    "places.pickerTitle": "Buscar en el mapa",
    "places.pickerBody": "Busca en Google Maps y selecciona el resultado correcto.",
    "places.searchPlaceholder": "Nombre del lugar",
    "places.searchCityPlaceholder": "Nombre de la ciudad",
    "places.searchHotelPlaceholder": "Nombre del hotel",
    "places.searchRestaurantPlaceholder": "Nombre del restaurante",
    "places.googleFallback": "Google Maps no está disponible en este momento. Mundely está usando temporalmente la búsqueda alternativa.",
    "places.googleNotConfigured": "Google Maps aún no está configurado. Mundely está usando temporalmente la búsqueda alternativa.",
    "places.search": "Buscar",
    "places.searching": "Buscando…",
    "places.minRating": "Puntuación mínima",
    "places.anyRating": "Cualquiera",
    "places.searchError": "No se pudieron buscar lugares. Inténtalo de nuevo.",
    "places.searchNoResults": "No se encontraron resultados. Comprueba el nombre e inténtalo de nuevo.",
    "places.searchHint": "Introduce el nombre del lugar para empezar.",
    "places.mapPreview": "Vista previa del mapa",
    "places.mapEmpty": "Selecciona un resultado para mostrarlo en el mapa.",
    "places.usePlace": "Usar este lugar",
    "places.sectionSubtitle": "Indica las ciudades que visitarás durante el viaje.",
    "places.addPlace": "Añadir ciudad",
    "places.selectedPlace": "Ciudad seleccionada",
    "places.selectedPlaceBody": "Mundely ha completado los datos de la ciudad desde Google Maps. Puedes añadir fechas, notas y elegir la imagen.",
    "places.changePlace": "Cambiar ciudad",
    "places.placeName": "Ciudad",
    "places.city": "Ciudad",
    "places.address": "Ubicación",
    "places.startDate": "Fecha de inicio",
    "places.endDate": "Fecha de fin",
    "places.notes": "Notas",
    "places.previewImage": "Imagen de vista previa",
    "places.previewImageBody": "Mundely usa la foto de Google Maps de forma predeterminada. Puedes elegir otra antes de guardar.",
    "places.photoLoading": "Cargando fotos…",
    "places.photoUnavailable": "No hay ninguna foto de Google Maps disponible para este lugar.",
    "places.photoAttribution": "Foto:",
    "places.choosePreviewImage": "Elige la imagen de vista previa",
    "places.choosePhotoNumber": "Elegir foto {number}",
    "places.uploadCustomPhoto": "Sube una foto tuya",
    "places.uploadCustomPhotoBody": "Puedes sustituir la imagen de Google Maps por una foto personal. Mundely la optimiza automáticamente para la vista previa.",
    "places.choosePhotoFile": "Elegir foto",
    "places.customPhotoTitle": "Foto personalizada",
    "places.customPhotoBody": "Esta foto sustituye la vista previa de Google Maps.",
    "places.changeCustomPhoto": "Cambiar foto",
    "places.useGooglePhoto": "Usar foto de Google Maps",
    "places.customPhotoLoading": "Preparando foto…",
    "places.customPhotoInvalid": "Selecciona un archivo de imagen válido.",
    "places.customPhotoError": "No se pudo preparar la foto. Prueba con otra imagen.",
    "places.empty": "No hay ciudades guardadas",
    "places.emptyBody": "Añade la primera ciudad que visitarás buscándola en Google Maps.",
    "poi.sectionSubtitle": "Explora los lugares de interés de las ciudades del viaje, selecciona los que visitarás y organízalos por día.",
    "poi.noCities": "Añade primero una ciudad",
    "poi.noCitiesBody": "Los lugares de interés se organizan según las ciudades guardadas en la sección Ciudades.",
    "poi.chooseCity": "Elige la ciudad",
    "poi.loading": "Buscando lugares de interés…",
    "poi.error": "No se pudieron encontrar lugares de interés para esta ciudad. Inténtalo de nuevo más tarde.",
    "poi.chooseFromMap": "Elegir del mapa",
    "poi.suggestionsTitle": "Sugerencias para esta ciudad",
    "poi.suggestionsBody": "Lugares recomendados para explorar en {city}. Selecciónalos o míralos en el mapa.",
    "poi.selectedPlaces": "Lugares seleccionados",
    "poi.selectedPlacesBody": "Los lugares que has elegido visitar en esta ciudad.",
    "poi.otherPlaces": "Otros lugares",
    "poi.otherPlacesBody": "Otros puntos de interés sugeridos para esta ciudad.",
    "poi.noSelectedPlaces": "Todavía no has seleccionado lugares de interés para esta ciudad.",
    "poi.noOtherPlaces": "No hay otros lugares para mostrar en este momento.",
    "poi.selectPlace": "Seleccionar",
    "poi.showOnMap": "Mostrar en el mapa",
    "poi.mapPreview": "Mapa de lugares de interés",
    "poi.mapSelectedLegend": "Lugares seleccionados en el mapa",
    "poi.mapSelectedLegendBody": "Se muestran {count} lugares seleccionados para esta ciudad.",
    "poi.openGoogleMaps": "Abrir Google Maps",
    "poi.day": "Día",
    "poi.notes": "Notas",
    "poi.notesPlaceholder": "Añade notas, horarios o detalles útiles…",
    "poi.getMoreInfo": "Obtener más información",
    "poi.researching": "Investigando…",
    "poi.moreInfoTitle": "Información adicional",
    "poi.aiDisabled": "La búsqueda con el agente GPT no está activada para esta cuenta.",
    "poi.aiUnavailable": "La búsqueda con el agente GPT no está disponible en este momento.",
    "poi.aiPrompt": "Busca información actual y útil para un viajero sobre {name}, en {address}, en la ciudad de {city}. Explica qué es, por qué merece la pena visitarlo, horarios o requisitos de visita cuando estén disponibles, costes orientativos, tiempo recomendado, curiosidades, consejos prácticos y posibles inconvenientes. Sé conciso e indica qué datos pueden cambiar.",
    "checklist.sectionSubtitle": "Organiza todo lo que debes preparar y comprueba de un vistazo lo que falta.",
    "checklist.addItem": "Añadir elemento",
    "checklist.progressTitle": "Progreso de la checklist",
    "checklist.progressBody": "{done} de {total} completadas",
    "checklist.itemTitle": "Qué debes hacer",
    "checklist.itemPlaceholder": "Ej. Hacer el check-in online",
    "checklist.category": "Categoría",
    "checklist.category.action": "Acción",
    "checklist.category.booking": "Reserva",
    "checklist.category.documents": "Documentos",
    "checklist.category.luggage": "Equipaje",
    "checklist.category.health": "Salud",
    "checklist.category.bookings": "Reservas",
    "checklist.category.other": "Otro",
    "checklist.notes": "Notas",
    "checklist.date": "Fecha",
    "checklist.listsLabel": "Checklist del viaje",
    "checklist.defaultListName": "Checklist principal",
    "checklist.newListPlaceholder": "Nombre de la nueva checklist",
    "checklist.createList": "Crear checklist",
    "checklist.chooseList": "Checklist activa",
    "checklist.newListButton": "Nueva checklist",
    "checklist.listName": "Nombre de la checklist",
    "checklist.deleteList": "Eliminar checklist",
    "checklist.notesPlaceholder": "Añade detalles útiles…",
    "checklist.filterLabel": "Filtrar checklist",
    "checklist.filter.all": "Todas",
    "checklist.filter.pending": "Pendientes",
    "checklist.filter.completed": "Completadas",
    "checklist.addStarter": "Añadir sugerencias básicas",
    "checklist.empty": "Checklist vacía",
    "checklist.emptyBody": "Añade las tareas que debes completar o usa las sugerencias básicas de Mundely.",
    "checklist.noFilteredItems": "No hay elementos en este filtro",
    "checklist.noFilteredItemsBody": "Cambia el filtro para ver los demás elementos de la checklist.",
    "checklist.markCompleted": "Marcar como completada",
    "checklist.markPending": "Marcar como pendiente",
    "checklist.starter.passport": "Comprobar pasaporte y documentos",
    "checklist.starter.insurance": "Guardar seguro de viaje",
    "checklist.starter.chargers": "Preparar cargadores y adaptadores",
    "checklist.starter.medicines": "Preparar medicamentos personales",
    "checklist.starter.hotel": "Comprobar reservas de hotel",
    "checklist.starter.transport": "Comprobar vuelos y traslados",
    "notes.subtitle": "Notas personales relacionadas con este viaje.",
    "notes.add": "Nueva nota",
    "notes.title": "Título",
    "notes.content": "Texto",
    "notes.empty": "No hay notas",
    "notes.emptyBody": "Escribe la primera nota del viaje.",
    "notes.untitled": "Sin título",
    "home.nextTrip": "Próximo viaje",
    "home.quickActions": "Acciones rápidas",
    "home.notifications": "Notificaciones",
    "home.modular": "Panel modular",
    "home.modularBody": "Los widgets se podrán añadir, eliminar y reordenar sin cambiar la estructura de Inicio.",
    "trips.title": "Tus viajes",
    "trips.empty": "Todavía no has creado viajes.",
    "trips.create": "Crear el primer viaje",
    "map.title": "Mapa",
    "map.placeholder": "El mapa interactivo se conectará aquí.",
    "map.tripSubtitle": "Visualiza juntas las ciudades, hoteles, restaurantes y lugares de interés del viaje.",
    "map.filters": "Filtros del mapa",
    "map.filter.cities": "Ciudades",
    "map.filter.hotels": "Hoteles",
    "map.filter.restaurants": "Restaurantes",
    "map.filter.poi": "Lugares de interés",
    "map.loadError": "No se pudo cargar el mapa.",
    "map.empty": "No hay puntos para mostrar",
    "map.emptyBody": "Añade ciudades, hoteles, restaurantes o lugares de interés para verlos en el mapa del viaje.",
    "ai.title": "Mundely",
    "ai.placeholder": "Pregunta cualquier cosa sobre tu viaje.",
    "ai.eyebrow": "Agente de viaje con IA",
    "ai.subtitle": "Conoce los datos guardados en Mundely y te ayuda a planificar, revisar y mejorar el viaje.",
    "ai.newChat": "Nueva conversación",
    "ai.tripContext": "Viaje en el que trabajar",
    "ai.generalContext": "Asesoramiento general de viaje",
    "ai.tripConnected": "Viaje conectado",
    "ai.tripConnectedBody": "El agente usa como contexto los datos ya guardados en las secciones del viaje.",
    "ai.generalConnected": "Modo general",
    "ai.generalConnectedBody": "No hay un viaje específico seleccionado: puedes pedir información y consejos generales.",
    "ai.readyTrip": "Estoy listo para trabajar en {trip}",
    "ai.readyGeneral": "Estoy listo para ayudarte a viajar",
    "ai.readyBody": "Escribe una petición o empieza con una de estas sugerencias.",
    "ai.starter.review": "Revisa mi viaje y dime qué falta",
    "ai.starter.dayPlan": "Mejora la organización diaria de mi viaje",
    "ai.starter.food": "Sugiere qué comer y dónde buscarlo",
    "ai.starter.practical": "Dame los consejos prácticos más importantes",
    "ai.you": "Tú",
    "ai.placeholderTrip": "Pregunta algo sobre {trip}…",
    "ai.placeholderGeneral": "Pregunta cualquier cosa sobre tu próximo viaje…",
    "ai.send": "Enviar",
    "ai.disclaimer": "Mundely usa los datos del viaje disponibles en la app. La información que puede cambiar debe verificarse siempre antes de reservar o viajar.",
    "ai.unavailable": "El agente de IA no está disponible en este entorno o para esta cuenta.",
    "ai.error": "No se pudo contactar con el agente de IA. Inténtalo de nuevo en unos instantes.",
    "profile.title": "Perfil",
    "profile.account": "Cuenta",
    "profile.accountBody": "Gestiona el usuario y el email de tu cuenta.",
    "profile.changePhoto": "Editar foto de perfil",
    "profile.photoTitle": "Foto de perfil",
    "profile.photoBody": "Elige una foto, muévela y usa el zoom para obtener el recorte que prefieras.",
    "profile.photoChooseHint": "Elige una foto para abrir el editor de recorte.",
    "profile.savePhoto": "Guardar foto",
    "profile.photoSaved": "Foto de perfil actualizada.",
    "profile.preferences": "Preferencias",
    "profile.security": "Seguridad",
    "profile.devices": "Dispositivos",
    "profile.data": "Datos y privacidad",
    "profile.plan": "Plan",
    "profile.free": "Gratis",
    "profile.premium": "Completo",
    "profile.export": "Exportar mis datos",
    "profile.dataImportTitle": "Importar datos",
    "profile.dataImportBody": "Importa viajes desde un archivo CSV o Excel (.xlsx).",
    "profile.dataImportChoose": "Elegir CSV o Excel",
    "profile.dataImportSuccess": "Se importaron {count} viajes.",
    "profile.dataImportInvalid": "El archivo no contiene filas de viaje válidas.",
    "profile.dataImportRowIssue": "Fila {row}: {reason}",
    "profile.dataImportDateIssue": "fecha no válida.",
    "profile.dataImportRangeIssue": "la fecha de regreso es anterior a la salida.",
    "profile.dataImportDuplicateIssue": "el mismo viaje aparece varias veces en el archivo.",
    "profile.dataImportAmbiguousIssue": "varios viajes coinciden con la fila: indica un ID único.",
    "profile.dataImportSharedIssue": "no puedes modificar un viaje de otro propietario.",
    "profile.dataImportIdIssue": "ID de viaje no válido.",
    "profile.dataImportStatusIssue": "estado desconocido. Usa planning, upcoming, active o completed.",
    "profile.dataImportPartialIssue": "La importación se detuvo después de guardar {count} viajes. Revisa los resultados antes de reintentar.",
    "profile.dataImportAccountIssue": "La cuenta cambió: importación detenida.",
    "profile.dataImportPreserveHint": "Los ID identifican los viajes a actualizar. Sin ID se compara nombre, destino y fechas. Las celdas vacías conservan los valores existentes; las fotos y secciones no cambian.",
    "profile.dataMapTitle": "Mapear columnas",
    "profile.dataMapBody": "Relaciona las columnas del archivo con los campos de Mundely antes de importar, como en fAInance.",
    "profile.dataMapIgnore": "No importar",
    "profile.dataMapName": "Nombre del viaje",
    "profile.dataMapDestination": "Destino",
    "profile.dataMapStart": "Fecha de salida",
    "profile.dataMapEnd": "Fecha de regreso",
    "profile.dataMapStatus": "Estado",
    "profile.dataMapPreview": "Vista previa",
    "profile.dataMapImport": "Importar",
    "profile.dataExportTitle": "Exportar datos",
    "profile.dataExportBody": "Descarga tus viajes en CSV o Excel.",
    "profile.dataExportCsv": "CSV",
    "profile.dataExportExcel": "Excel",
    "profile.dataExportReady": "Se exportaron {count} viajes.",
    "profile.dataTripCount": "{count} viajes de tu propiedad",
    "profile.dataWorldExportTitle": "Exportar Mi mundo",
    "profile.dataWorldExportBody": "Elige si quieres exportar los países visitados, las ciudades visitadas o ambos. Puedes descargarlos en CSV o Excel.",
    "profile.dataWorldCountries": "Países visitados",
    "profile.dataWorldCities": "Ciudades visitadas",
    "profile.dataWorldExportReady": "Datos de Mi mundo exportados.",
    "profile.dataWorldCountry": "País",
    "profile.dataWorldCity": "Ciudad",
    "profile.dataWorldStatus": "Estado",
    "profile.dataWorldFeedback": "Feedback",
    "profile.dataWorldCountriesSheet": "Países visitados",
    "profile.dataWorldCitiesSheet": "Ciudades visitadas",
    "profile.dataBackupTitle": "Copia de seguridad de datos",
    "profile.dataBackupBody": "Descarga rápidamente tu perfil, viajes y ajustes en JSON o una copia ZIP completa con adjuntos. El JSON no incluye archivos: los adjuntos deben seguir disponibles en la nube para restaurarlos.",
    "profile.dataBackupJsonDownload": "Descargar copia JSON",
    "profile.dataBackupJsonSaved": "Copia JSON guardada en el destino seleccionado.",
    "profile.dataBackupJsonTimeout": "La copia JSON no respondió en 90 segundos. Vuelve a intentarlo con una conexión estable.",
    "profile.dataBackupElapsed": "Tiempo transcurrido: {time}",
    "profile.dataBackupKeepOpen": "Preparando la copia de seguridad. Mantén esta pantalla abierta hasta que se guarde.",
    "profile.dataBackupProgressFiles": "Archivos completados: {current}/{total}",
    "profile.dataBackupDownload": "Descargar copia ZIP completa",
    "profile.dataBackupRestore": "Restaurar copia",
    "profile.dataBackupPending": "Termina de sincronizar los cambios y archivos antes de restaurar la copia.",
    "profile.dataBackupChanged": "Los datos cambiaron durante la copia. Inténtalo de nuevo para guardar una copia coherente.",
    "profile.dataBackupDamaged": "La copia contiene un archivo ausente o alterado. La restauración no se ha iniciado.",
    "profile.dataBackupTooLarge": "La copia supera los límites admitidos: 15 MB por archivo y 2 GB en total.",
    "profile.dataBackupReady": "Copia preparada. Elige dónde guardarla.",
    "profile.dataBackupWorkingCollecting": "Preparando los datos…",
    "profile.dataBackupWorkingAttachments": "Recuperando los archivos adjuntos…",
    "profile.dataBackupWorkingSaving": "Copia lista: elige dónde guardarla…",
    "profile.dataBackupSaved": "Copia de seguridad guardada en el destino elegido.",
    "profile.dataBackupSaveFailed": "No se pudo guardar la copia en el destino seleccionado. Inténtalo de nuevo o elige una carpeta del teléfono.",
    "profile.dataBackupAttachmentsFailed": "No se pudo descargar el archivo adjunto {current} de {total} de la nube. Inténtalo de nuevo con una conexión estable. No se guardó ningún backup incompleto.",
    "profile.dataBackupImportJson": "Importar copia JSON",
    "profile.dataBackupImportZip": "Importar copia ZIP",
    "profile.dataBackupImportConfirmTitle": "Importar copia de seguridad",
    "profile.dataBackupImportConfirmBody": "Revisa el archivo antes de restaurar los datos de tu cuenta.",
    "profile.dataBackupImportContents": "El archivo contiene {trips} viajes, {documents} documentos y {sections} secciones de viaje.",
    "profile.dataBackupEmptyFile": "El archivo seleccionado está vacío. Espera a que termine el guardado o la descarga y selecciona la copia completa.",
    "profile.dataBackupZipPhotos": "Fotos de viajes: {travel}. Fotos personales: {personal}. Portadas: {covers}. Adjuntos verificados: {files}.",
    "profile.dataBackupZipOtherAccount": "Esta copia pertenece a otra cuenta. Los viajes, el perfil, las fotos y los adjuntos se copiarán a tu cuenta. Los permisos de acceso y las opciones de uso compartido originales no se transfieren. Los datos existentes pueden actualizarse.",
    "profile.dataBackupImportZipContents": "Archivo ZIP completo. El contenido y los adjuntos se verificarán antes de restaurarlos.",
    "profile.dataBackupImportWarning": "Los elementos con el mismo identificador se actualizarán. Los datos que no figuren en la copia no se eliminarán. Los adjuntos no incluidos en el JSON deben seguir disponibles en la nube. Esta operación puede cambiar datos existentes.",
    "profile.dataBackupImportConfirm": "Confirmar restauración",
    "profile.dataBackupProgressTitle": "Restauración en curso",
    "profile.dataBackupProgressEstimated": "Progreso real basado en las escrituras confirmadas por el servidor. Mantén la app abierta durante la restauración.",
    "profile.dataBackupProgressScanTitle": "Comprobando la copia",
    "profile.dataBackupProgressScanBody": "Estamos validando el archivo seleccionado y preparando los datos para importarlos.",
    "profile.dataBackupProgressCompareTitle": "Verificando los datos importados",
    "profile.dataBackupProgressCompareBody": "El servidor comprueba que todos los viajes previstos se han guardado correctamente.",
    "profile.dataBackupProgressApplyTitle": "Aplicando los cambios",
    "profile.dataBackupProgressApplyBody": "Los viajes y la configuración compatible se están actualizando de forma segura.",
    "profile.dataBackupProgressFinishTitle": "Finalizando",
    "profile.dataBackupProgressFinishBody": "Estamos completando los últimos pasos y guardando el resultado final.",
    "profile.dataBackupModeMerge": "Integrar",
    "profile.dataBackupModeAdd": "Añadir solo nuevos",
    "profile.dataBackupAddWarning": "Solo añade viajes inexistentes. No modifica viajes, secciones, fotos ni ajustes actuales.",
    "profile.dataBackupFullSourceRequired": "Esta fuente no incluye todos los archivos necesarios para una restauración completa verificada.",
    "profile.dataBackupModeReplace": "Sustituir datos",
    "profile.dataBackupProgressWrites": "Operaciones confirmadas: {current}/{total}",
    "profile.dataBackupEmptyReplaceBlocked": "La copia contiene cero viajes. Sustituir está bloqueado para evitar un borrado accidental.",
    "profile.dataBackupVerificationFailed": "El servidor no ha confirmado el resultado. Comprueba la cuenta antes de reintentar; no se declara ningún éxito.",
    "profile.dataBackupVerifiedResult": "Importación verificada: {total} viajes en tu cuenta ({created} añadidos, {updated} actualizados).",
    "profile.dataBackupLocalRefreshFailed": "El servidor completó la transferencia, pero el teléfono no pudo actualizar la lista local. Vuelve a abrir Viajes y comprueba antes de reintentar.",
    "profile.dataBackupOtherAccount": "Esta copia pertenece a otra cuenta de Mundely. Los viajes se copiarán a tu cuenta sin transferir permisos ni archivos adjuntos de la nube.",
    "profile.dataBackupSameAccount": "Elige cómo transferir esta copia a tu cuenta.",
    "profile.dataBackupTransferFilesWarning": "El JSON contiene referencias a {count} documentos: los archivos no están incluidos y no se copiarán. Los documentos de tu cuenta no cambiarán.",
    "profile.dataBackupDeliveredZipPhotos": "Este ZIP contiene fotos externas a la copia JSON: las imágenes no se subirán a Firebase. Se conservarán las fotos de tu cuenta; revisa las fotos de los viajes nuevos después de importar.",
    "profile.dataBackupReconcileResult": "Copia importada: {created} viajes añadidos, {updated} viajes actualizados sin duplicarlos.",
    "profile.dataBackupExistingDuplicates": "Se han encontrado {count} posibles duplicados anteriores: no se han eliminado automáticamente para proteger tus datos.",
    "profile.dataBackupMergeWarning": "Integrar añade los viajes sin eliminar los actuales; solo se actualizan las preferencias permitidas del perfil.",
    "profile.dataBackupReplaceWarning": "Sustituye viajes y secciones por los datos JSON y elimina los viajes ausentes. Los archivos en la nube no incluidos en el JSON no se importan ni eliminan automáticamente. Los viajes compartidos o vinculados a fAInance bloquean la sustitución.",
    "profile.dataBackupReplaceCheck": "Confirmo que quiero sustituir los datos de mi cuenta con los datos de la copia.",
    "profile.dataBackupTransferTooMany": "La copia contiene demasiados registros para una sustitución atómica segura. No se ha modificado ningún dato.",
    "profile.dataBackupSharedTripBlocked": "No se pueden sustituir viajes compartidos o vinculados a fAInance. No se han modificado los datos. Usa Integrar o desconecta esos viajes primero.",
    "profile.dataBackupRestored": "Copia restaurada: {trips} viajes.",
    "profile.dataBackupInvalid": "El archivo no es una copia de seguridad Mundely válida.",
    "profile.dataTransferError": "No se pudo completar la operación de datos.",
    "profile.deleteAccount": "Eliminar cuenta",
    "profile.deleteInfo": "La eliminación incluye 15 días para cambiar de opinión.",
    "profile.changeUsername": "Cambiar usuario",
    "profile.recoveryPremium": "Papelera e historial de versiones están disponibles con Premium.",
    "profile.connectedDevices": "Dispositivos conectados",
    "profile.signOutOthers": "Cerrar sesión en los demás dispositivos",
    "profile.personalData": "Datos personales",
    "profile.publicProfileSection": "Perfil público",
    "profile.personalDataBody": "Gestiona la información de tu perfil de Mundely.",
    "profile.publicWorldTitle": "Perfil viajero público",
    "profile.publicWorldBody": "Elige qué información de Mi mundo será visible en tu perfil público.",
    "profile.publicShowCountries": "Mostrar países visitados",
    "profile.publicShowCities": "Mostrar ciudades visitadas",
    "profile.publicShowLived": "Mostrar dónde has vivido",
    "profile.publicShowStats": "Mostrar estadísticas de viaje",
    "profile.publicShowReviews": "Mostrar reseñas públicas",
    "profile.publicWorldSaved": "Preferencias del perfil público actualizadas.",
    "profile.publicVisitedCities": "Ciudades visitadas",
    "profile.publicLivedCountries": "Dónde ha vivido",
    "profile.publicReviews": "Reseñas públicas",
    "world.eyebrow": "Perfil viajero",
    "world.infoLabel": "Información",
    "world.title": "Mi mundo",
    "world.subtitle": "Registra los países y ciudades que has visitado o en los que has vivido. El mapa y las estadísticas se actualizan automáticamente.",
    "world.tabsLabel": "Secciones de Mi mundo",
    "world.tabMap": "Mapa del mundo",
    "world.tabCountries": "Países",
    "world.tabCities": "Ciudades",
    "world.tabStats": "Estadísticas",
    "world.countriesShort": "países",
    "world.citiesShort": "ciudades",
    "world.worldShort": "del mundo",
    "world.statusLabel": "Estado de la visita",
    "world.statusVisited": "Visitado",
    "world.statusLived": "Vivido",
    "world.statusNone": "No visitado",
    "world.mapTitle": "Tu mapa del mundo",
    "world.mapBody": "Los países cambian de color según tu experiencia personal.",
    "world.legendLabel": "Leyenda del mapa",
    "world.mapHint": "Toca o haz clic en un país para abrir sus detalles, añadir una opinión y ver las ciudades vinculadas.",
    "world.mapUnavailable": "El mapa del mundo no está disponible ahora mismo. Los países, ciudades y estadísticas siguen accesibles.",
    "world.countriesTitle": "Países",
    "world.countriesBody": "Explora los países por continente, marca los que has visitado o en los que has vivido y guarda una nota personal.",
    "world.chooseCountry": "Elige un país",
    "world.limitedRecognition": "reconocimiento limitado",
    "world.specialStatus": "estatuto especial / territorio autónomo",
    "world.addCountry": "Añadir",
    "world.searchCountries": "Buscar un país",
    "world.noCountries": "Todavía no has añadido países",
    "world.noCountriesBody": "Añade tu primer país o selecciónalo directamente en el mapa.",
    "world.countryDetails": "Detalle del país",
    "world.countryDetailsBody": "Define el estado, guarda tu opinión y consulta las ciudades vinculadas.",
    "world.feedback": "Opinión personal",
    "world.privateNote": "Nota privada",
    "world.privateNotePlaceholder": "Añade un recuerdo o una nota visible solo para ti.",
    "world.publicReview": "Reseña pública",
    "world.saveReview": "Guardar reseña",
    "world.publicReviewBody": "La reseña es pública y otros viajeros pueden encontrarla.",
    "world.communityReviews": "Reseñas de la comunidad",
    "world.communityReviewsBody": "Lee las experiencias de otros viajeros y vota las que te resulten útiles.",
    "world.communitySortLabel": "Ordenar reseñas",
    "world.communityMostHelpful": "Más útiles",
    "world.communityMostRecent": "Más recientes",
    "world.communityHelpful": "Útil",
    "world.communityNotHelpful": "No útil",
    "world.communityOwnReview": "Tu reseña",
    "world.communityNoReviews": "Todavía no hay otras reseñas para este destino.",
    "world.communityTraveller": "Viajero",
    "world.communityVoteFailed": "No se pudo guardar el voto. Inténtalo de nuevo.",
    "community.tripReviews": "Comunidad",
    "community.tripReviewsBody": "{count} reseñas de Mundely para este lugar.",
    "community.yourReview": "Tu reseña",
    "community.yourReviewBody": "Comparte tu experiencia: contribuirá a las recomendaciones de la comunidad y a tu puntuación de viajero.",
    "community.reviewPlaceholder": "¿Qué recomendarías a otros viajeros?",
    "community.deleteReview": "Eliminar reseña",
    "community.noPlaceReviews": "Todavía no hay reseñas de Mundely para este lugar.",
    "community.stats.reviews": "Reseñas",
    "community.stats.average": "Media",
    "community.stats.helpful": "Votos útiles",
    "community.mostHelpfulBadge": "Más útil",
    "community.reviewSaveFailed": "No se pudo guardar la reseña. Inténtalo de nuevo.",
    "world.publicReviewPlaceholder": "Escribe una reseña útil para otros viajeros.",
    "world.rating": "Valoración",
    "world.ratingValue": "{value} estrellas de 5",
    "world.publishReview": "Hacer pública esta reseña",
    "world.countryFeedbackPlaceholder": "¿Qué te gustó? ¿Qué recuerdas de este país?",
    "world.cityCount": "{count} ciudades",
    "world.citiesInCountry": "Ciudades visitadas",
    "world.citiesInCountryBody": "La lista se actualiza automáticamente al añadir o modificar una ciudad.",
    "world.noCitiesForCountry": "Todavía no has añadido ciudades para este país.",
    "world.removeCountry": "Eliminar país",
    "world.removeCountryBlocked": "Antes de eliminar este país debes borrar las ciudades vinculadas.",
    "world.countrySaved": "País actualizado.",
    "world.countryRemoved": "País eliminado.",
    "world.addCity": "Añadir una ciudad",
    "world.editCity": "Editar ciudad",
    "world.cityEditorBody": "Al añadir una ciudad se actualiza automáticamente también su país.",
    "world.cityName": "Nombre de la ciudad",
    "world.country": "País",
    "world.cityFeedbackPlaceholder": "Añade un recuerdo, una valoración o una nota personal sobre la ciudad.",
    "world.cityCountrySyncHint": "Si el país todavía no está presente, Mundely lo añade automáticamente. Una ciudad en la que has vivido marca también el país como vivido.",
    "world.myCities": "Mis ciudades",
    "world.myCitiesBody": "Todas las ciudades visitadas o vividas, vinculadas en tiempo real con sus países.",
    "world.noCities": "Todavía no has añadido ciudades",
    "world.noCitiesBody": "Añade tu primera ciudad para empezar a construir tu historia de viajes.",
    "world.citySaved": "Ciudad actualizada.",
    "world.cityRemoved": "Ciudad eliminada.",
    "world.statsTitle": "Tus estadísticas de viaje",
    "world.statsBody": "Una vista rápida del mundo que has explorado hasta ahora.",
    "world.statCountries": "Países visitados",
    "world.statLived": "Países vividos",
    "world.statLivedBody": "países en los que has vivido",
    "world.statCities": "Ciudades",
    "world.statCitiesBody": "ciudades registradas",
    "world.statTerritory": "Territorio explorado",
    "world.statTerritoryBody": "proporción estimada de la superficie terrestre de los países del mundo",
    "world.statTerritoryLoading": "cálculo disponible cuando se cargan los datos geográficos del mapa",
    "world.worldProgress": "Países del mundo visitados",
    "world.continentAfrica": "África",
    "world.continentAsia": "Asia",
    "world.continentEurope": "Europa",
    "world.continentNorthAmerica": "Norteamérica",
    "world.continentSouthAmerica": "Sudamérica",
    "world.continentOceania": "Oceanía",
    "world.searchCity": "Buscar ciudad",
    "world.citySearchPlaceholder": "Busca o introduce una ciudad",
    "world.citySearchHint": "Usa Buscar ciudad para encontrarla con la misma búsqueda geográfica de los viajes; Mundely completa automáticamente el país cuando el proveedor lo devuelve.",
    "world.exportMap": "Exportar mapa",
    "world.exportCountries": "Exportar países",
    "world.exportCities": "Exportar ciudades",
    "world.exportPng": "PNG",
    "world.exportPdf": "PDF",
    "world.exportExcel": "Excel",
    "world.exportCsv": "CSV",
    "world.exportContinent": "Continente",
    "world.exportCountry": "País",
    "world.exportCity": "Ciudad",
    "world.exportStatus": "Estado",
    "world.exportFeedback": "Feedback",
    "world.exportReady": "Exportación completada.",
    "world.exportFailed": "No se pudo completar la exportación.",
    "world.downloadData": "Descargar Mi mundo",
    "world.downloadShort": "Descargar",
    "world.downloadTitle": "Descargar Mi mundo",
    "world.downloadBody": "Elige uno o varios contenidos para incluirlos y descárgalos juntos en un único PDF o JPEG.",
    "world.downloadIncludeTitle": "¿Qué quieres incluir?",
    "world.downloadIncludeMap": "Mapa",
    "world.downloadIncludeCountries": "Países visitados",
    "world.downloadIncludeCities": "Ciudades",
    "world.downloadIncludeStats": "Estadísticas",
    "world.downloadFormatTitle": "Formato",
    "world.exportJpeg": "JPEG",
    "world.downloadAction": "Descargar Mi mundo",
    "world.downloadSelectAtLeastOne": "Selecciona al menos un contenido para descargar.",
    "world.downloadMapBody": "Descarga el mapa con tus colores y el logotipo de Mundely.",
    "world.downloadCountriesBody": "Exporta la lista completa de países con continente, estado y opinión.",
    "world.downloadCitiesBody": "Exporta las ciudades registradas con país, estado y opinión.",
    "world.exportStats": "Exportar estadísticas",
    "world.downloadStatsBody": "Exporta las estadísticas globales y las de cada continente.",
    "world.continentAccordionHint": "Abre un continente cada vez para consultar sus países. La búsqueda muestra directamente los continentes con resultados.",
    "world.continentSummary": "{visited}/{total} visitados · {cities} ciudades",
    "world.continentStatsTitle": "Estadísticas por continente",
    "world.continentStatsBody": "Compara países visitados, países en los que has vivido, ciudades y territorio explorado en cada continente.",
    "world.exportScope": "Área",
    "world.worldLabel": "Mundo",
    "world.exportVisitedCountries": "Países visitados",
    "world.exportLivedCountries": "Países vividos",
    "world.exportCitiesCount": "Ciudades",
    "world.exportCompletion": "Completado",
    "profile.phone": "Teléfono",
    "profile.phonePrefix": "Prefijo",
    "profile.phoneInvalid": "Número de teléfono no válido.",
    "profile.birthDate": "Fecha de nacimiento",
    "profile.gender": "Sexo",
    "profile.gender.M": "Masculino",
    "profile.gender.F": "Femenino",
    "profile.gender.X": "No especificado",
    "profile.nationality": "Nacionalidad",
    "profile.residenceCountry": "País de residencia",
    "profile.region": "Provincia / Región",
    "profile.city": "Ciudad",
    "profile.address": "Dirección",
    "profile.job": "Trabajo",
    "profile.useReason": "¿Para qué quieres usar principalmente Mundely?",
    "profile.saved": "Perfil actualizado.",
    "profile.changeEmail": "Cambiar email",
    "profile.updateEmail": "Actualizar email",
    "profile.emailVerificationSent": "Se ha enviado un email de verificación a la nueva dirección. Abre el enlace para completar el cambio.",
    "profile.changePassword": "Cambiar contraseña",
    "profile.passwordBody": "Actualiza la contraseña que usas para acceder a Mundely.",
    "profile.currentPassword": "Contraseña actual",
    "profile.newPassword": "Nueva contraseña",
    "profile.updatePassword": "Actualizar contraseña",
    "profile.passwordChanged": "Contraseña actualizada.",
    "profile.recentLogin": "Por seguridad, vuelve a iniciar sesión antes de realizar esta operación.",
    "profile.currentPasswordInvalid": "La contraseña actual no es correcta.",
    "profile.usernameChanged": "Usuario actualizado.",
    "profile.usernameCooldown": "El usuario se ha cambiado recientemente. Inténtalo de nuevo al finalizar el periodo configurado.",
    "profile.devicesBody": "Revisa los dispositivos que tienen acceso a tu cuenta.",
    "profile.noDevices": "No hay dispositivos registrados.",
    "profile.currentDevice": "Este dispositivo",
    "profile.deviceActive": "Activo",
    "profile.deviceRevoked": "Desconectado",
    "profile.disconnect": "Desconectar",
    "profile.exportQueued": "La solicitud de exportación de datos ha sido registrada.",
    "profile.deleteWarning": "Solicitud de eliminación de cuenta",
    "profile.deleteConfirmBody": "La cuenta se desactivará de inmediato y podrás cambiar de opinión durante 15 días. Para confirmar, escribe {keyword}.",
    "profile.deleteKeyword": "ELIMINAR",
    "profile.scheduleDeletion": "Programar eliminación",
    "profile.pendingDeletionTitle": "Cuenta en proceso de eliminación",
    "profile.pendingDeletionBody": "La eliminación está programada. Tienes 15 días desde la solicitud para restaurar tu cuenta y tus datos.",
    "profile.restoreAccount": "Restaurar cuenta",
    "auth.linkRequired": "Ya existe una cuenta con este email. Accede con usuario y contraseña para vincular el nuevo método de acceso.",
    "auth.linkCompleted": "Método de acceso vinculado a tu cuenta.",
    "profile.job.employee": "Empleado",
    "profile.job.manager": "Manager",
    "profile.job.consultant": "Consultor",
    "profile.job.freelancer": "Autónomo",
    "profile.job.entrepreneur": "Emprendedor",
    "profile.job.merchant": "Comerciante",
    "profile.job.artisan": "Artesano",
    "profile.job.education": "Educación / Formación",
    "profile.job.healthcare": "Sanidad",
    "profile.job.technology": "Tecnología / IT",
    "profile.job.finance": "Finanzas / Administración",
    "profile.job.marketing": "Marketing / Comunicación",
    "profile.job.sales": "Ventas",
    "profile.job.student": "Estudiante",
    "profile.job.retired": "Jubilado",
    "profile.job.unemployed": "Sin empleo",
    "profile.job.other": "Otro",
    "profile.reason.planTrips": "Planificar viajes",
    "profile.reason.organizeItinerary": "Organizar itinerarios y etapas",
    "profile.reason.keepBookings": "Guardar las reservas juntas",
    "profile.reason.manageDocuments": "Gestionar documentos de viaje",
    "profile.reason.shareTrips": "Compartir viajes",
    "profile.reason.discoverPlaces": "Descubrir lugares y experiencias",
    "profile.reason.trackExpenses": "Controlar los gastos de viaje",
    "profile.reason.useAi": "Recibir ayuda de la IA",
    "profile.reason.keepMemories": "Guardar fotos y recuerdos",
    "profile.reason.allInOne": "Tenerlo todo en una sola app",
    "profile.reason.other": "Otro",
    "itinerary.subtitle": "Organiza el viaje día a día con horarios, paradas y desplazamientos.",
    "itinerary.collectorBody": "Cada día del viaje reúne automáticamente hoteles, desplazamientos, experiencias, restaurantes, ciudades, lugares, clima, billetes y fotos.",
    "itinerary.twoWayTitle": "Itinerario bidireccional",
    "itinerary.twoWayBody": "Los cambios realizados en otras secciones aparecen aquí; los cambios realizados aquí actualizan la sección de origen.",
    "itinerary.timeline": "Cronología",
    "itinerary.timelineTitle": "Cronología del viaje",
    "itinerary.timelineBody": "Vista cronológica de todos los días y de todo lo planificado.",
    "itinerary.entry": "actividad",
    "itinerary.entries": "actividades",
    "itinerary.sourceType": "Tipo de elemento",
    "itinerary.source.manual": "Actividad",
    "itinerary.source.transfer": "Desplazamiento",
    "itinerary.source.hotel": "Hotel",
    "itinerary.source.restaurant": "Restaurante",
    "itinerary.source.city": "Ciudad",
    "itinerary.source.poi": "Lugar que visitar",
    "itinerary.source.experience": "Experiencia",
    "itinerary.source.event": "Evento",
    "itinerary.source.boardingPass": "Billete de avión",
    "itinerary.source.climate": "Clima",
    "itinerary.dayEmpty": "Todavía no hay nada planificado para este día.",
    "itinerary.photos": "Fotos",
    "itinerary.searchMap": "Buscar en el mapa",
    "itinerary.add": "Añadir etapa",
    "itinerary.mapTitle": "Vincula una ubicación real",
    "itinerary.mapBody": "Completa ciudad y dirección eligiendo un punto en el mapa.",
    "itinerary.chooseMap": "Elegir en el mapa",
    "itinerary.enterManually": "Introducir manualmente",
    "itinerary.freeText": "Texto libre",
    "itinerary.placeName": "Nombre del lugar",
    "itinerary.title": "Título",
    "itinerary.date": "Fecha",
    "itinerary.type": "Tipo",
    "itinerary.startTime": "Hora de inicio",
    "itinerary.endTime": "Hora de fin",
    "itinerary.city": "Ciudad",
    "itinerary.address": "Dirección",
    "itinerary.notes": "Notas",
    "itinerary.type.activity": "Actividad",
    "itinerary.type.transfer": "Desplazamiento",
    "itinerary.type.meal": "Comida",
    "itinerary.type.free": "Tiempo libre",
    "itinerary.type.other": "Otro",
    "itinerary.empty": "Itinerario vacío",
    "itinerary.emptyBody": "Añade la primera etapa para empezar a construir los días del viaje.",
    "itinerary.noDate": "Sin fecha",
    "itinerary.showDetails": "Añadir detalles",
    "itinerary.hideDetails": "Ocultar detalles",
    "itinerary.excel.import": "Importar Excel",
    "itinerary.excel.eyebrow": "Importación del itinerario",
    "itinerary.excel.title": "Cargar itinerario desde Excel",
    "itinerary.excel.body": "Importa en segundos todas las etapas del viaje desde un archivo Excel. Usa la plantilla Mundely para evitar errores de formato.",
    "itinerary.excel.downloadTemplate": "Descargar plantilla Excel",
    "itinerary.excel.templateSaved": "Plantilla guardada en Descargas/Mundely.",
    "itinerary.excel.templateDownloaded": "Plantilla Excel descargada.",
    "itinerary.excel.templateError": "No se pudo guardar la plantilla Excel. Inténtalo de nuevo.",
    "itinerary.excel.chooseFile": "Elegir archivo Excel",
    "itinerary.excel.columns": "Columnas reconocidas: Título, Fecha, Hora de inicio, Hora de fin, Tipo, Ciudad, Dirección, Notas.",
    "itinerary.excel.imported": "Se importaron {count} etapas.",
    "itinerary.excel.error": "No se pudo importar el archivo. Comprueba que contenga al menos una columna Título e inténtalo de nuevo.",
    "itinerary.excel.header.title": "Título",
    "itinerary.excel.header.date": "Fecha",
    "itinerary.excel.header.startTime": "Hora de inicio",
    "itinerary.excel.header.endTime": "Hora de fin",
    "itinerary.excel.header.type": "Tipo",
    "itinerary.excel.header.city": "Ciudad",
    "itinerary.excel.header.address": "Dirección",
    "itinerary.excel.header.notes": "Notas",
    "itinerary.excel.sample.title": "Visita al centro histórico",
    "experiences.subtitle": "Actividades, tours y experiencias que quieres hacer durante el viaje.",
    "experiences.add": "Añadir experiencia",
    "experiences.mapTitle": "Busca la experiencia en el mapa",
    "experiences.mapBody": "Selecciona un lugar real para completar automáticamente ciudad y dirección.",
    "experiences.chooseMap": "Elegir en el mapa",
    "experiences.title": "Nombre de la experiencia",
    "experiences.city": "Ciudad",
    "experiences.address": "Dirección",
    "experiences.date": "Fecha",
    "experiences.time": "Hora",
    "experiences.place": "Lugar",
    "experiences.placePlaceholder": "Ej. Coliseo, operador turístico, playa…",
    "experiences.price": "Precio",
    "experiences.currency": "Moneda",
    "experiences.notes": "Notas",
    "experiences.empty": "Sin experiencias",
    "experiences.emptyBody": "Guarda tours, actividades y cosas que hacer para encontrarlas durante el viaje.",
    "participants.subtitle": "Gestiona las personas que participan en el viaje.",
    "participants.add": "Añadir participante",
    "participants.notesPlaceholder": "Notas opcionales",
    "participants.name": "Nombre",
    "participants.email": "Email",
    "participants.role": "Rol",
    "participants.notes": "Notas",
    "participants.role.owner": "Propietario",
    "participants.role.traveller": "Viajero",
    "participants.role.participant": "Participante",
    "participants.role.viewer": "Visualizador",
    "participants.rolesFixedHint": "Los cuatro roles tienen permisos fijos. Puedes cambiarles el nombre, pero sus permisos no cambian.",
    "participants.rolePower.owner": "Visibilidad y control totales, incluida la gestión de participantes y la eliminación del viaje.",
    "participants.rolePower.traveller": "Visibilidad y control totales salvo gestión de participantes y eliminación del viaje.",
    "participants.rolePower.participant": "Visibilidad completa y permiso para modificar el contenido del viaje, sin acciones administrativas.",
    "participants.rolePower.viewer": "Visibilidad completa en modo de solo lectura.",
    "participants.empty": "Sin participantes",
    "participants.emptyBody": "Añade las personas que participarán en este viaje.",
    "participants.identifier": "Usuario o email",
    "participants.identifierPlaceholder": "Introduce un usuario o email",
    "participants.identifierHint": "Si el usuario ya está en Mundely recibirá una invitación y una notificación en la app. Si el email no está registrado, se preparará una invitación por email.",
    "participants.inviteFlowHint": "El participante deberá aceptar o rechazar la invitación. Recibirás una notificación con el resultado.",
    "participants.sendInvite": "Enviar invitación",
    "participants.sending": "Enviando…",
    "participants.inviteSent": "Invitación enviada en la app.",
    "participants.emailInviteQueued": "Invitación por email preparada. El destinatario la recibirá mediante el servicio de correo configurado para Mundely.",
    "participants.inviteError": "No se pudo enviar la invitación. Inténtalo de nuevo.",
    "participants.userNotFound": "Usuario no encontrado. Para invitar a alguien que no está registrado, usa su dirección de email.",
    "participants.cannotInviteSelf": "No puedes invitar a tu propia cuenta.",
    "participants.refreshStatus": "Actualizar estado",
    "participants.resendEmail": "Reenviar email",
    "participants.removeError": "No se pudo eliminar al participante.",
    "participants.status.pending": "Invitación pendiente",
    "participants.status.accepted": "Aceptada",
    "participants.status.declined": "Rechazada",
    "participants.status.external": "Invitación por email",
    "participants.status.manual": "Participante",
    "participants.status.left": "Salió del viaje",
    "participants.leftSection": "Participantes que salieron",
    "participants.leaveTrip": "Salir del viaje",
    "participants.leaveTripTitle": "¿Salir de este viaje?",
    "participants.leaveTripBody": "Ya no tendrás acceso al viaje. Tu nombre seguirá visible en la lista de participantes que salieron.",
    "participants.leaveTripConfirm": "Salir del viaje",
    "participants.leaveError": "No se pudo salir del viaje. Inténtalo de nuevo.",
    "participants.currentSection": "Participantes",
    "participants.currentEmpty": "Ningún participante ha aceptado aún la invitación.",
    "participants.sentSection": "Invitaciones enviadas",
    "participants.sentEmpty": "No hay invitaciones pendientes.",
    "participants.declinedSection": "Invitaciones rechazadas",
    "participants.declinedEmpty": "No hay invitaciones rechazadas.",
    "share.exportHtml": "Exportar HTML",
    "share.exportJson": "Exportar JSON",
    "share.exportSaved": "Archivo exportado a la carpeta Descargas/Mundely.",
    "share.exportError": "No se pudo exportar el archivo.",
    "notifications.title": "Centro de notificaciones",
    "notifications.empty": "No hay notificaciones.",
    "notifications.markRead": "Marcar como leída",
    "notifications.tripInviteTitle": "Invitación a un viaje",
    "notifications.tripInviteBody": "Has recibido una invitación para participar en un viaje.",
    "notifications.tripInviteAcceptedTitle": "Invitación aceptada",
    "notifications.tripInviteAcceptedBody": "Un participante ha aceptado tu invitación.",
    "notifications.tripInviteDeclinedTitle": "Invitación rechazada",
    "notifications.tripInviteDeclinedBody": "Un participante ha rechazado tu invitación.",
    "notifications.invitedBy": "Invitado por {name}",
    "notifications.acceptInvite": "Aceptar",
    "notifications.declineInvite": "Rechazar",
    "notifications.inviteResponseError": "No se pudo guardar la respuesta a la invitación.",
    "notifications.details": "Detalles",
    "notifications.role": "Rol: {role}",
    "notifications.dates": "Fechas",
    "notifications.acceptedPopup": "Has aceptado la invitación al viaje.",
    "share.eyebrow": "COMPARTIR Y EXPORTAR",
    "share.title": "Elige qué mostrar",
    "share.body": "Antes de crear el enlace o exportar el viaje, elige qué información incluir.",
    "share.exportTitle": "Exportar viaje",
    "share.exportBody": "Elige qué información incluir y descarga el viaje en el formato que prefieras.",
    "share.linkTitle": "Compartir viaje",
    "share.linkBody": "Elige qué información hacer visible y genera un enlace público dedicado.",
    "share.empty": "El enlace es válido, pero actualmente no contiene información que se pueda compartir.",
    "share.tickets": "Billetes",
    "share.documents": "Documentos",
    "share.financials": "Detalles económicos",
    "share.participants": "Participantes",
    "share.notes": "Notas",
    "share.generate": "Generar enlace",
    "share.copy": "Copiar enlace",
    "share.error": "No se pudo crear el enlace.",
    "share.invalid": "Este enlace no es válido o ya no está disponible.",
    "trips.archive": "Archivar",
    "trips.archived": "Viajes archivados",
    "trips.archivedEmpty": "No hay viajes archivados.",
    "trips.archivedReadOnlyTitle": "Viaje archivado · solo lectura",
    "trips.archivedReadOnlyBody": "Puedes consultar todas las secciones, exportar o compartir el viaje. Restáuralo antes de modificarlo o añadir contenido.",
    "trips.activeTitle": "Viajes activos",
    "trips.activeEmpty": "No hay viajes activos. Puedes crear uno nuevo o restaurar un viaje archivado.",
    "trips.status": "Estado del viaje",
    "trips.statusPlanning": "En planificación",
    "trips.statusUpcoming": "Próximo",
    "trips.statusActive": "En curso",
    "trips.statusCompleted": "Completado",
    "trips.sync.idle": "Listo",
    "trips.sync.syncing": "Sincronizando…",
    "trips.sync.synced": "Sincronizado",
    "trips.sync.offline": "Sin conexión · en espera",
    "trips.sync.error": "Error de sincronización",
    "trips.syncRetry": "Toca para reintentar la sincronización",
    "trips.restore": "Restaurar",
    "trips.deleteConfirm": "¿Mover este viaje a la papelera? Podrás restaurarlo durante 30 días.",
    "trips.editTitle": "Editar viaje",
    "trips.archiveConfirm": "¿Archivar este viaje? Podrás restaurarlo en cualquier momento desde los viajes archivados.",
    "trips.restoreConfirm": "¿Restaurar este viaje? Volverá a los viajes activos.",
    "trips.trashTitle": "Papelera de viajes",
    "trips.trashBody": "Los viajes eliminados se pueden recuperar durante 30 días y después se pueden borrar definitivamente.",
    "trips.trashEmpty": "La papelera de viajes está vacía.",
    "trips.trashDays": "Eliminación definitiva en {days} días",
    "trips.restoreFromTrash": "Restaurar",
    "trips.deleteForever": "Eliminar definitivamente",
    "trips.deleteForeverConfirm": "¿Eliminar definitivamente este viaje y todos sus datos? Esta acción no se puede deshacer.",
    "trips.trashSyncError": "No se pudo sincronizar la papelera. Inténtalo de nuevo cuando haya conexión.",
    "trips.historyTitle": "Historial de versiones",
    "trips.historyBody": "Mundely conserva automáticamente las últimas versiones de tus viajes en este dispositivo para que puedas volver a un estado anterior.",
    "trips.historyHint": "Elige un viaje, comprueba la fecha y hora de la versión guardada y pulsa Restaurar cuando quieras volver a ese estado.",
    "trips.historyTrip": "Viaje",
    "trips.historyNoTrips": "No hay viajes disponibles.",
    "trips.historyEmpty": "El historial aparecerá después de los próximos cambios en este viaje.",
    "trips.historyRestore": "Restaurar versión",
    "trips.historyRestoreConfirm": "¿Restaurar esta versión del viaje? Mundely guardará automáticamente el estado actual antes de restaurarla.",
    "trips.historyRestored": "Versión restaurada correctamente.",
    "trips.historyRestoreError": "No se pudo restaurar esta versión.",
    "security.lockTitle": "Desbloquear Mundely",
    "security.unlockBiometric": "Desbloquear con biometría",
    "security.unlockPin": "Desbloquear con PIN",
    "security.pinInvalid": "PIN incorrecto.",
    "security.biometricUnavailable": "La biometría no está disponible para esta app o en este dispositivo.",
    "security.biometricNativeOnly": "La autenticación biométrica solo está disponible en la app instalada en Android o iPhone.",
    "security.biometricNotEnrolled": "No hay huella ni biometría configurada en este dispositivo.",
    "security.deviceCredentialMissing": "Configura primero un PIN, contraseña, patrón o biometría en los ajustes del teléfono.",
    "security.biometricLockout": "Demasiados intentos fallidos. Desbloquea el teléfono manualmente y vuelve a intentarlo.",
    "security.biometricFailed": "La autenticación biométrica ha fallado.",
    "security.biometricSystemCancel": "El sistema ha cancelado la autenticación biométrica.",
    "security.biometricCancelled": "La autenticación biométrica se ha cancelado.",
    "security.biometricTimeout": "La autenticación biométrica no recibió respuesta del sistema. Cierra y vuelve a abrir la app e inténtalo de nuevo.",
    "security.biometricChecking": "Comprobando…",
    "security.lockedTitle": "Mundely está bloqueada",
    "security.lockBody": "Desbloquea la app para ver tus datos.",
    "security.pinPlaceholder": "Introduce el PIN",
    "security.pinNotConfigured": "No hay un PIN configurado. Desbloquea con biometría o con la contraseña de tu cuenta y configura un nuevo PIN.",
    "security.passwordPlaceholder": "Contraseña de la cuenta",
    "security.unlockPassword": "Desbloquear con contraseña",
    "security.passwordUnavailable": "Cuenta no disponible. Vuelve a iniciar sesión.",
    "security.passwordInvalid": "La contraseña de la cuenta es incorrecta o esta cuenta no admite autenticación por contraseña.",
    "security.forgotPin": "¿Has olvidado el PIN? Usa otro método",
    "security.lockHelp": "Si no recuerdas el PIN, desbloquea con biometría o con la contraseña de tu cuenta y configura un nuevo PIN en Seguridad.",
    "errors.generic": "Se ha producido un error. Inténtalo de nuevo.",
    "errors.network": "Sin conexión. Los cambios compatibles se pondrán en cola y se sincronizarán cuando sea posible.",
    "errors.sessionExpired": "La sesión ha caducado. Vuelve a acceder.",
    "errors.limitReached": "Has alcanzado el límite de tu plan.",
    "errors.sync": "La sincronización no se completó. No se eliminó ningún dato local.",
    "errors.upload": "La subida no se completó. Se ha conservado el archivo local.",
    "errors.permission": "No tienes permisos para esta operación.",
    "environment.missing": "Configuración de Firebase incompleta",
    "environment.missingBody": "Completa el archivo .env del entorno antes de conectar el backend.",
    "home.lastTrip": "Último viaje",
    "home.dashboardSubtitle": "Una vista útil de tus viajes, próximas salidas y de lo que ya has organizado.",
    "home.tripInProgress": "Viaje en curso",
    "home.daysUntil": "Faltan {count} días",
    "home.startsToday": "Sales hoy",
    "home.openTrip": "Abrir viaje",
    "home.noTripTitle": "Todavía no hay viajes",
    "home.noTripBody": "Crea tu primer viaje para empezar a organizar itinerario, reservas, experiencias y documentos.",
    "home.statTrips": "Viajes",
    "home.statCompleted": "Viajes finalizados",
    "home.statDestinations": "Destinos visitados",
    "home.statActive": "En curso",
    "home.yourTrips": "Tus viajes",
    "home.yourTripsBody": "Vuelve a abrir rápidamente tus viajes más recientes.",
    "home.viewAll": "Ver todos",
    "home.noTripsYet": "Tus viajes aparecerán aquí.",
    "tripHome.nextStop": "Próxima etapa",
    "tripHome.locationPending": "Lugar por definir",
    "tripHome.openItinerary": "Abrir itinerario",
    "tripHome.noNextStop": "El itinerario está vacío",
    "tripHome.noNextStopBody": "Añade la primera etapa para empezar a construir el viaje.",
    "tripHome.addFirstStop": "Añadir primera etapa",
    "tripHome.hotels": "Hoteles",
    "tripHome.experiences": "Experiencias",
    "tripHome.events": "Eventos",
    "tripHome.documents": "Documentos",
    "tripHome.days": "Días",
    "tripHome.checklist": "Checklist",
    "tripHome.notes": "Notas",
    "tripHome.stops": "Etapas",
    "tripHome.quickAccess": "Acceso rápido",
    "tripHome.quickAccessBody": "Las secciones que más utilizas al organizar el viaje.",
    "tripHome.allSections": "Todas las secciones",
    "tripHome.allSectionsBody": "Abre cualquier área del viaje sin llenar la Home de tarjetas grandes.",
    "aiDiscovery.experiencesTitle": "Busca experiencias con Mundely",
    "aiDiscovery.eventsTitle": "Busca eventos con Mundely",
    "aiDiscovery.experiencesBody": "Describe lo que te interesa: el agente de IA prepara opciones coherentes con el destino y las fechas del viaje.",
    "aiDiscovery.eventsBody": "El agente de IA busca eventos compatibles con las ciudades y fechas del viaje y los prepara para añadirlos.",
    "aiDiscovery.experiencesPlaceholder": "Ej. snorkel, comida local, tours poco turísticos…",
    "aiDiscovery.eventsPlaceholder": "Ej. conciertos, exposiciones, festivales, mercados…",
    "aiDiscovery.city": "Ciudad o zona",
    "aiDiscovery.cityPlaceholder": "Ej. centro de la ciudad",
    "aiDiscovery.request": "Qué quieres encontrar",
    "aiDiscovery.search": "Buscar con IA",
    "aiDiscovery.searching": "Buscando…",
    "aiDiscovery.notAvailable": "La búsqueda con IA está preparada, pero el servicio no está disponible en este entorno.",
    "aiDiscovery.noStructuredResults": "Mundely respondió, pero no devolvió resultados estructurados utilizables.",
    "aiDiscovery.error": "No se pudo completar la búsqueda con IA.",
    "aiDiscovery.addSuggestion": "Usar sugerencia",
    "events.subtitle": "Conciertos, exposiciones, festivales, mercados y eventos temporales durante el viaje.",
    "events.add": "Añadir evento",
    "events.mapTitle": "Vincula el lugar del evento",
    "events.mapBody": "Selecciona el lugar real para completar automáticamente ciudad y dirección.",
    "events.chooseMap": "Elegir en el mapa",
    "events.title": "Nombre del evento",
    "events.venue": "Lugar / recinto",
    "events.city": "Ciudad",
    "events.address": "Dirección",
    "events.date": "Fecha",
    "events.startTime": "Hora de inicio",
    "events.endTime": "Hora de fin",
    "events.category": "Categoría",
    "events.price": "Precio",
    "events.currency": "Moneda",
    "events.url": "Web o entradas",
    "events.notes": "Notas",
    "events.empty": "No hay eventos",
    "events.emptyBody": "Añade eventos manualmente o usa la búsqueda con Mundely.",
    "events.openWebsite": "Abrir web",
    "documents.viewMode": "Modo de visualización de documentos",
    "documents.viewByCategory": "Por categoría",
    "documents.viewByParticipant": "Por participante",
    "notes.chooseIcon": "Elegir icono",
    "notes.removeIcon": "Quitar icono",
    "notes.titlePlaceholder": "Título de la nota",
    "notes.toolbar": "Herramientas de formato",
    "notes.bold": "Negrita",
    "notes.italic": "Cursiva",
    "notes.underline": "Subrayado",
    "notes.strike": "Tachado",
    "notes.toolBoldSymbol": "B",
    "notes.toolItalicSymbol": "I",
    "notes.toolUnderlineSymbol": "U",
    "notes.toolStrikeSymbol": "S",
    "notes.customColor": "Color personalizado",
    "notes.bulletedList": "Lista con viñetas",
    "notes.numberedList": "Lista numerada",
    "dashboard.customize": "Personalizar panel",
    "dashboard.done": "Finalizar edición",
    "dashboard.editWidget": "Editar widget",
    "dashboard.widgetTitle": "Título del widget",
    "dashboard.width": "Anchura",
    "dashboard.height": "Altura",
    "dashboard.background": "Fondo del widget",
    "dashboard.backgroundOption": "Elegir fondo",
    "dashboard.customColor": "Color personalizado",
    "dashboard.opacity": "Transparencia",
    "dashboard.visible": "Mostrar widget",
    "dashboard.moveUp": "Mover antes",
    "dashboard.moveDown": "Mover después",
    "dashboard.restoreDefaults": "Restablecer widgets",
    "dashboard.size.small": "Pequeño",
    "dashboard.size.medium": "Mediano",
    "dashboard.size.large": "Grande",
    "dashboard.size.full": "Ancho completo",
    "dashboard.height.compact": "Compacto",
    "dashboard.height.normal": "Normal",
    "dashboard.height.tall": "Alto",
    "notes.alignment": "Alineación del texto",
    "notes.align.left": "Alinear a la izquierda",
    "notes.align.center": "Centrar",
    "notes.align.right": "Alinear a la derecha",
    "notes.align.justify": "Justificar",
    "notes.color": "Color de la nota",
    "notes.colorOption": "Elegir color",
    "notes.contentPlaceholder": "Escribe tu nota…",
    "notes.update": "Actualizar nota",
    "map.filter.itinerary": "Itinerario",
    "map.filter.experiences": "Experiencias",
    "map.filter.events": "Eventos",
    "map.days": "Días del viaje",
    "map.allDays": "Todo el viaje",
    "map.zoomIn": "Acercar",
    "map.zoomOut": "Alejar",
    "map.zoomControls": "Controles de zoom",
    "map.day": "Día",
    "map.allTrip": "Todo el viaje",
    "map.style": "Tipo de mapa",
    "map.styleClassic": "Mapa clásico",
    "map.styleSatellite": "Mapa satélite",
    "map.itineraryOnlyBody": "El mapa se construye exclusivamente a partir del itinerario del viaje.",
    "map.infoTitle": "Cómo funciona el mapa",
    "map.clusterTitle": "{count} lugares en esta zona",
    "app.backExitWarning": "Pulsa Atrás una vez más para salir de la app.",
    "map.itineraryOnlyBadge": "Itinerario → Mapa",
    "map.itineraryEmpty": "Añade elementos del itinerario con ubicación para construir el mapa.",
    "map.itineraryFilter.transfers": "Desplazamientos",
    "map.itineraryFilter.hotels": "Hoteles",
    "map.itineraryFilter.food": "Restaurantes",
    "map.itineraryFilter.cities": "Ciudades",
    "map.itineraryFilter.places": "Lugares",
    "map.itineraryFilter.experiences": "Experiencias",
    "map.itineraryFilter.events": "Eventos",
    "map.dayLabel": "Día {number}",
    "map.autoBuildTitle": "Mapa automático",
    "map.autoBuildBody": "{points} puntos · {photos} fotos listas",
    "map.photoStoryTitle": "El viaje en fotos",
    "map.photoStoryBody": "Mundely crea automáticamente la secuencia de fotos usando ciudades, restaurantes, lugares de interés, experiencias y eventos ya añadidos.",
    "map.photoCount": "{count} fotos",
    "map.noPhotos": "Las fotos aparecerán automáticamente cuando haya imágenes disponibles de los lugares del viaje.",
    "map.photoBy": "Foto de",
    "album.autoTitle": "Álbum automático",
    "album.autoBody": "Las fotos del viaje se organizan automáticamente a partir de los lugares ya incluidos en el mapa.",
    "album.userOnlyBody": "Aquí aparecen únicamente las fotos subidas por los participantes del viaje.",
    "album.userOnlyTitle": "Solo fotos reales del viaje",
    "album.userOnlyDescription": "Mundely ya no inserta fotos predeterminadas de Google Maps ni otras imágenes automáticas en esta sección.",
    "album.userOnlyEmpty": "Añade tus fotos y vincúlalas a un día o a un punto del itinerario.",
    "album.addPhoto": "Añadir foto",
    "album.uploadBody": "Sube una foto y vincúlala al día, ciudad, experiencia o punto del itinerario correcto.",
    "album.file": "Foto",
    "album.date": "Día",
    "album.linkTo": "Vincular a",
    "album.noLink": "Solo al día",
    "album.caption": "Descripción",
    "album.pending": "Carga en curso",
    "album.uploadError": "No se pudo subir la foto. Se conserva la copia local y puedes volver a intentarlo.",
    "album.autoDescription": "Mundely recupera las imágenes disponibles de los lugares y las ordena por día. Las fotos personalizadas elegidas para las ciudades siempre tienen prioridad.",
    "album.photosBuilt": "fotos disponibles",
    "album.undated": "Sin fecha",
    "album.empty": "No hay fotos disponibles",
    "album.emptyBody": "Añade ciudades, restaurantes, lugares de interés, experiencias o eventos mediante la búsqueda del mapa. Mundely creará automáticamente el álbum.",
    "album.withoutDate": "Sin fecha",
    "album.photoCount": "{count} fotos",
    "climate.sectionBody": "Añade o actualiza las condiciones previstas para cada día. Estos datos aparecen automáticamente en el itinerario.",
    "climate.saved": "Clima añadido",
    "climate.add": "Añadir clima",
    "climate.editTitle": "Clima del día",
    "climate.editBody": "La información guardada aquí se recoge automáticamente en el itinerario.",
    "climate.autoBody": "Las previsiones se obtienen automáticamente según las ubicaciones del viaje. No tienes que introducir nada manualmente.",
    "climate.loading": "Actualizando previsiones…",
    "climate.autoError": "Las previsiones no est\u00e1n disponibles en este momento. Puedes volver a intentarlo.",
    "climate.autoUnavailable": "Previsión no disponible para esta fecha.",
    "climate.source": "Datos meteorológicos: Open-Meteo",
    "climate.location": "Ubicación: {location}",
    "climate.weather.clear": "Despejado",
    "climate.weather.partlyCloudy": "Parcialmente nublado",
    "climate.weather.fog": "Niebla",
    "climate.weather.drizzle": "Llovizna",
    "climate.weather.rain": "Lluvia",
    "climate.weather.snow": "Nieve",
    "climate.weather.showers": "Chubascos",
    "climate.weather.thunderstorm": "Tormentas",
    "climate.weather.unknown": "Condiciones variables",
    "climate.conditions": "Condiciones",
    "climate.minTemp": "Temperatura mínima",
    "climate.maxTemp": "Temperatura máxima",
    "climate.summary": "Resumen",
    "climate.notes": "Notas",
      "itinerary.startDate": "Fecha de inicio",
    "itinerary.endDate": "Fecha de fin",
    "itinerary.originCity": "Ciudad de salida",
    "itinerary.destinationCity": "Ciudad de llegada",
    "itinerary.transportMode": "Medio de transporte",
    "itinerary.transport.car": "Coche",
    "itinerary.transport.bus": "Autobús",
    "itinerary.transport.plane": "Avión",
    "itinerary.transport.train": "Tren",
    "itinerary.transport.ferry": "Ferry",
    "settings.sectionsTransfers": "Desplazamientos",
    "settings.sectionsTransfersBody": "Configura los medios de transporte disponibles en los desplazamientos del itinerario.",
    "settings.sectionsTransferModes": "Medios de transporte",
    "album.folder": "Carpeta",
    "album.newFolder": "Nueva carpeta",
    "album.defaultFolder": "Fotos del viaje",
    "album.massUpload": "Puedes seleccionar varias fotos a la vez. Cada foto se optimiza hasta un máximo de 1 MB.",
    "album.fileTooLarge": "El archivo supera el límite máximo de 1 MB.",
    "profile.publicLink": "Perfil público",
    "profile.publicLinkBody": "Comparte fotos, presentación, países visitados y viajes activos con un enlace público.",
    "profile.copyPublicLink": "Copiar enlace público",
    "profile.publicLinkCopied": "Enlace del perfil copiado.",
    "profile.publicNotFound": "Perfil no disponible",
    "profile.publicTrips": "Viajes",
    "profile.publicCountries": "Países visitados",
    "profile.publicActiveTrips": "Viajes activos",
    "profile.publicVisitedCountries": "Países visitados",
}
} as const;




